import * as i0 from '@angular/core';
import { Injectable, Component, NgModule, ViewChild, Input, Directive, EventEmitter, Output, HostListener, Pipe, ViewChildren, SecurityContext, forwardRef, ContentChild } from '@angular/core';
import { BehaviorSubject, of, Subject, Observable, fromEvent, throwError, timer } from 'rxjs';
import { tap, switchMap, map, catchError, delay, debounceTime, distinctUntilChanged, takeUntil, takeLast } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$2 from '@angular/forms';
import { ReactiveFormsModule, Validators, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as Bowser from 'bowser';
import moment from 'moment';
import * as i1$3 from '@angular/platform-browser';

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
function RpConfigComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 9);
    i0.ɵɵtext(3, " Klient ID ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 8)(7, "div", 9);
    i0.ɵɵtext(8, " Openid konfiguration URL ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 8)(12, "div", 9);
    i0.ɵɵtext(13, " JWK URL ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 10);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 8)(17, "div", 9);
    i0.ɵɵtext(18, " Redirect URL ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 10);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 8)(22, "div", 9);
    i0.ɵɵtext(23, " Logout Redirect URL ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 10);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 8)(27, "div", 9);
    i0.ɵɵtext(28, " Nyckelgrupp ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 10);
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 8)(32, "div", 9);
    i0.ɵɵtext(33, " Nyckel finns ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 10);
    i0.ɵɵtext(35);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config.clientId, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config.discoveryUrl, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config.jwkUrl, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config.redirectUrl, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config.postLogoutRedirect, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config.certGroup, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config.existsKeyGroup ? "Ja" : "Nej", " ");
  }
}
const _c0 = ["autologin"];
function PasswordLoginComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1, " Ogiltligt anv\xE4ndarnamn eller l\xF6senord. ");
    i0.ɵɵelementEnd();
  }
}
function LogoutComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵelement(1, "span", 3);
    i0.ɵɵelementEnd();
  }
}
const _c1 = ["uploadInput"];
function UploadComponent_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function UploadComponent_button_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onImport());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is-small", ctx_r2.options.small)("is-static", !ctx_r2.file)("is-primary", ctx_r2.file);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.name);
  }
}
const _c2 = ["upload"];
function IdentityFormComponent_option_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.GROUP_HEADER);
  }
}
function IdentityFormComponent_option_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(group_r5.groupName);
  }
}
function IdentityTableComponent_div_14_span_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵelement(1, "span", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const identity_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-tooltip", ctx_r1.getWarnTooltip(identity_r1.validTo));
  }
}
function IdentityTableComponent_div_14_span_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "div")(2, "button", 15);
    i0.ɵɵlistener("click", function IdentityTableComponent_div_14_span_14_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const identity_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChangeIdentity(identity_r1));
    });
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Aktiv");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 16);
    i0.ɵɵlistener("click", function IdentityTableComponent_div_14_span_14_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r3);
      const identity_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDownload(identity_r1));
    });
    i0.ɵɵelement(6, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 18);
    i0.ɵɵelement(8, "span", 19);
    i0.ɵɵelementEnd()()();
  }
}
function IdentityTableComponent_div_14_span_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 20);
    i0.ɵɵlistener("click", function IdentityTableComponent_div_14_span_15_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const identity_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChangeIdentity(identity_r1));
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "S\xE4tt aktiv");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "button", 16);
    i0.ɵɵlistener("click", function IdentityTableComponent_div_14_span_15_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r4);
      const identity_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDownload(identity_r1));
    });
    i0.ɵɵelement(5, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 21);
    i0.ɵɵlistener("click", function IdentityTableComponent_div_14_span_15_Template_button_click_6_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const identity_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDelete($event, identity_r1));
    });
    i0.ɵɵelement(7, "span", 19);
    i0.ɵɵelementEnd()();
  }
}
function IdentityTableComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 9)(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, IdentityTableComponent_div_14_span_12_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 11);
    i0.ɵɵtemplate(14, IdentityTableComponent_div_14_span_14_Template, 9, 0, "span", 12)(15, IdentityTableComponent_div_14_span_15_Template, 8, 0, "span", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const identity_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", identity_r1.state === "Active");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", identity_r1.subjectCN, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", identity_r1.issuerCN, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", identity_r1.thumbPrint, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", identity_r1.type, " ");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("needs-renewal", ctx_r1.needsRenewal(identity_r1.validTo))("expired", ctx_r1.isExpired(identity_r1.validTo));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(identity_r1.validTo);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.needsRenewal(identity_r1.validTo));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", identity_r1.state === "Active");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", identity_r1.state !== "Active");
  }
}
const _c3 = ["identityForm"];
function CertificateManagerComponent_a_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function CertificateManagerComponent_a_4_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.importIdentity());
    });
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵelement(2, "span", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "L\xE4gg till");
    i0.ɵɵelementEnd()();
  }
}
function CertificateManagerComponent_identity_form_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "identity-form", 10, 0);
    i0.ɵɵlistener("identityRequest", function CertificateManagerComponent_identity_form_5_Template_identity_form_identityRequest_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitIdentity($event));
    })("cancel", function CertificateManagerComponent_identity_form_5_Template_identity_form_cancel_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("groups", ctx_r1.groups$);
  }
}
function CertificateManagerComponent_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "identity-table", 13);
    i0.ɵɵlistener("delete", function CertificateManagerComponent_div_6_div_1_Template_identity_table_delete_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteIdentity($event));
    })("download", function CertificateManagerComponent_div_6_div_1_Template_identity_table_download_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.downloadIdentity($event));
    })("changeActive", function CertificateManagerComponent_div_6_div_1_Template_identity_table_changeActive_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changeActiveIdentity($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 14)(5, "button", 15);
    i0.ɵɵlistener("click", function CertificateManagerComponent_div_6_div_1_Template_button_click_5_listener() {
      const group_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteGroup(group_r5));
    });
    i0.ɵɵelementStart(6, "span", 8);
    i0.ɵɵelement(7, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "Ta bort grupp");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const group_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(group_r5.groupName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", group_r5);
  }
}
function CertificateManagerComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CertificateManagerComponent_div_6_div_1_Template, 10, 2, "div", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.groups$));
  }
}
const _c4 = ["rightButton"];
const _c5 = ["leftButton"];
const _c6 = ["*"];
function ModalComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "button", 13);
    i0.ɵɵlistener("click", function ModalComponent_div_7_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeAction());
    });
    i0.ɵɵelementEnd()();
  }
}
function ModalComponent_footer_11_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16, 0);
    i0.ɵɵlistener("click", function ModalComponent_footer_11_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.leftAction());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.internalOptions.leftButtonText, " ");
  }
}
function ModalComponent_footer_11_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16, 1);
    i0.ɵɵlistener("click", function ModalComponent_footer_11_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.rightAction());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.internalOptions.rightButtonText, " ");
  }
}
function ModalComponent_footer_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "footer", 14);
    i0.ɵɵtemplate(1, ModalComponent_footer_11_button_1_Template, 3, 1, "button", 15)(2, ModalComponent_footer_11_button_2_Template, 3, 1, "button", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.internalOptions.showLeftButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.internalOptions.showRightButton);
  }
}
function PaginationComponent_nav_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 5);
    i0.ɵɵelement(3, "i", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "a", 5);
    i0.ɵɵelement(6, "i", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function PaginationComponent_nav_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 8);
    i0.ɵɵlistener("click", function PaginationComponent_nav_0_ng_container_3_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.first(ctx_r1.data, ctx_r1.options, ctx_r1.dataSize));
    });
    i0.ɵɵelement(3, "i", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "a", 8);
    i0.ɵɵlistener("click", function PaginationComponent_nav_0_ng_container_3_Template_a_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.previous(ctx_r1.data, ctx_r1.options, ctx_r1.dataSize));
    });
    i0.ɵɵelement(6, "i", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function PaginationComponent_nav_0_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 8);
    i0.ɵɵlistener("click", function PaginationComponent_nav_0_li_4_Template_a_click_1_listener() {
      const page_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectPage(page_r4 - 1, ctx_r1.data, ctx_r1.options, ctx_r1.dataSize));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const page_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-current", page_r4 === ctx_r1.activePage + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", page_r4, " ");
  }
}
function PaginationComponent_nav_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 5);
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "a", 5);
    i0.ɵɵelement(6, "i", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function PaginationComponent_nav_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 8);
    i0.ɵɵlistener("click", function PaginationComponent_nav_0_ng_container_6_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.next(ctx_r1.data, ctx_r1.options, ctx_r1.dataSize));
    });
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "a", 8);
    i0.ɵɵlistener("click", function PaginationComponent_nav_0_ng_container_6_Template_a_click_5_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.last(ctx_r1.data, ctx_r1.options, ctx_r1.dataSize));
    });
    i0.ɵɵelement(6, "i", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function PaginationComponent_nav_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 1)(1, "ul", 2);
    i0.ɵɵtemplate(2, PaginationComponent_nav_0_ng_container_2_Template, 7, 0, "ng-container", 3)(3, PaginationComponent_nav_0_ng_container_3_Template, 7, 0, "ng-container", 3)(4, PaginationComponent_nav_0_li_4_Template, 3, 3, "li", 4)(5, PaginationComponent_nav_0_ng_container_5_Template, 7, 0, "ng-container", 3)(6, PaginationComponent_nav_0_ng_container_6_Template, 7, 0, "ng-container", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.activePages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isLastPage);
  }
}
function CertificateFormComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "label", 11)(3, "span");
    i0.ɵɵtext(4, "Namn");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "div", 12)(6, "div", 13)(7, "div", 14);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.name, " ");
  }
}
function CertificateFormComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "label", 11)(3, "span");
    i0.ɵɵtext(4, "Id");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "div", 12)(6, "div", 13)(7, "div", 14);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.thumbPrint, " ");
  }
}
function CertificateFormComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "label", 11)(3, "span");
    i0.ɵɵtext(4, "Giltig till");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "div", 12)(6, "div", 13)(7, "div", 14);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "date");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", (tmp_1_0 = i0.ɵɵpipeBind2(9, 1, ctx_r0.validTo, "YYYY-MM-dd")) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "Ej angivet", " ");
  }
}
function CertificateFormComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "label", 11)(3, "span");
    i0.ɵɵtext(4, "Certifikat-fil");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "div", 12)(6, "div", 13)(7, "div", 14)(8, "div", 15);
    i0.ɵɵlistener("filesOutput", function CertificateFormComponent_div_4_Template_div_filesOutput_8_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const fileupload_r3 = i0.ɵɵreference(10);
      return i0.ɵɵresetView(fileupload_r3.uploadFileList($event));
    });
    i0.ɵɵelementStart(9, "file-upload", 16, 0);
    i0.ɵɵlistener("uploaded", function CertificateFormComponent_div_4_Template_file_upload_uploaded_9_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.fileUploaded($event));
    });
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("options", ctx_r0.options);
  }
}
function TrustManagerComponent_div_0_span_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("fa-sort-down", !ctx_r1.sortReverse)("fa-sort-up", ctx_r1.sortReverse);
  }
}
function TrustManagerComponent_div_0_span_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("fa-sort-down", !ctx_r1.sortReverse)("fa-sort-up", ctx_r1.sortReverse);
  }
}
function TrustManagerComponent_div_0_span_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("fa-sort-down", !ctx_r1.sortReverse)("fa-sort-up", ctx_r1.sortReverse);
  }
}
function TrustManagerComponent_div_0_div_26_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵelement(1, "span", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entity_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-tooltip", ctx_r1.getWarnTooltip(entity_r4.validTo));
  }
}
function TrustManagerComponent_div_0_div_26_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_div_26_Template_div_click_1_listener() {
      const entity_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.select(entity_r4));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_div_26_Template_div_click_3_listener() {
      const entity_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.select(entity_r4));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_div_26_Template_div_click_5_listener() {
      const entity_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.select(entity_r4));
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "date");
    i0.ɵɵtemplate(8, TrustManagerComponent_div_0_div_26_span_8_Template, 2, 1, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 27)(10, "button", 28);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_div_26_Template_button_click_10_listener() {
      const entity_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.export(entity_r4));
    });
    i0.ɵɵelement(11, "span", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 30);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_div_26_Template_button_click_12_listener() {
      const entity_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDelete(entity_r4));
    });
    i0.ɵɵelement(13, "span", 31);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_7_0;
    const entity_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", entity_r4.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", entity_r4.thumbPrint, " ");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("needs-renewal", ctx_r1.needsRenewal(entity_r4.validTo))("expired", ctx_r1.isExpired(entity_r4.validTo));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_7_0 = i0.ɵɵpipeBind2(7, 8, entity_r4.validTo, "YYYY-MM-dd")) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "Ej angivet", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.needsRenewal(entity_r4.validTo));
  }
}
function TrustManagerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
    i0.ɵɵtext(3, "Utf\xE4rdare");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "a", 6);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_Template_a_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.add());
    });
    i0.ɵɵelementStart(7, "span", 7);
    i0.ɵɵelement(8, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10, "L\xE4gg till");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "div", 9)(12, "input", 10);
    i0.ɵɵlistener("keyup", function TrustManagerComponent_div_0_Template_input_keyup_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFilterChange($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "div", 11)(14, "div", 12)(15, "div", 13);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_Template_div_click_15_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("name"));
    });
    i0.ɵɵtext(16, " Namn ");
    i0.ɵɵtemplate(17, TrustManagerComponent_div_0_span_17_Template, 1, 4, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 15);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_Template_div_click_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("thumbPrint"));
    });
    i0.ɵɵtext(19, " Id ");
    i0.ɵɵtemplate(20, TrustManagerComponent_div_0_span_20_Template, 1, 4, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 16);
    i0.ɵɵlistener("click", function TrustManagerComponent_div_0_Template_div_click_21_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("expiration"));
    });
    i0.ɵɵtext(22, " Giltig till ");
    i0.ɵɵtemplate(23, TrustManagerComponent_div_0_span_23_Template, 1, 4, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 17);
    i0.ɵɵelement(25, "span", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(26, TrustManagerComponent_div_0_div_26_Template, 14, 11, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "pagination", 20);
    i0.ɵɵlistener("paginatedData", function TrustManagerComponent_div_0_Template_pagination_paginatedData_27_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setPagination($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("value", ctx_r1.filterInput)("disabled", !ctx_r1.trusts);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.sortOrderBy === "name");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.sortOrderBy === "thumbPrint");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.sortOrderBy === "expiration");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.paginatedData);
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.paginationOptions)("data", ctx_r1.filteredData);
  }
}
function TrustManagerComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
    i0.ɵɵtext(3, "Certifikat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "certificate-form", 34);
    i0.ɵɵlistener("cancel", function TrustManagerComponent_div_1_Template_certificate_form_cancel_4_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancel());
    })("save", function TrustManagerComponent_div_1_Template_certificate_form_save_4_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.save($event));
    })("update", function TrustManagerComponent_div_1_Template_certificate_form_update_4_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.update($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("certificate", ctx_r1.selectedCertificate);
  }
}
function AsyncPaginationComponent_nav_0_ul_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 6);
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "a", 6);
    i0.ɵɵelement(6, "i", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function AsyncPaginationComponent_nav_0_ul_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 9);
    i0.ɵɵlistener("click", function AsyncPaginationComponent_nav_0_ul_1_ng_container_2_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const asyncData_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.first(asyncData_r2, ctx_r2.options, ctx_r2.dataSize));
    });
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "a", 9);
    i0.ɵɵlistener("click", function AsyncPaginationComponent_nav_0_ul_1_ng_container_2_Template_a_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const asyncData_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.previous(asyncData_r2, ctx_r2.options, ctx_r2.dataSize));
    });
    i0.ɵɵelement(6, "i", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function AsyncPaginationComponent_nav_0_ul_1_li_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 9);
    i0.ɵɵlistener("click", function AsyncPaginationComponent_nav_0_ul_1_li_3_Template_a_click_1_listener() {
      const page_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const asyncData_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.selectPage(page_r5 - 1, asyncData_r2, ctx_r2.options, ctx_r2.dataSize));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const page_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-current", page_r5 === ctx_r2.activePage + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", page_r5, " ");
  }
}
function AsyncPaginationComponent_nav_0_ul_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 6);
    i0.ɵɵelement(3, "i", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "a", 6);
    i0.ɵɵelement(6, "i", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function AsyncPaginationComponent_nav_0_ul_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li")(2, "a", 9);
    i0.ɵɵlistener("click", function AsyncPaginationComponent_nav_0_ul_1_ng_container_5_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const asyncData_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.next(asyncData_r2, ctx_r2.options, ctx_r2.dataSize));
    });
    i0.ɵɵelement(3, "i", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "li")(5, "a", 9);
    i0.ɵɵlistener("click", function AsyncPaginationComponent_nav_0_ul_1_ng_container_5_Template_a_click_5_listener() {
      i0.ɵɵrestoreView(_r6);
      const asyncData_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.last(asyncData_r2, ctx_r2.options, ctx_r2.dataSize));
    });
    i0.ɵɵelement(6, "i", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function AsyncPaginationComponent_nav_0_ul_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 3);
    i0.ɵɵtemplate(1, AsyncPaginationComponent_nav_0_ul_1_ng_container_1_Template, 7, 0, "ng-container", 4)(2, AsyncPaginationComponent_nav_0_ul_1_ng_container_2_Template, 7, 0, "ng-container", 4)(3, AsyncPaginationComponent_nav_0_ul_1_li_3_Template, 3, 3, "li", 5)(4, AsyncPaginationComponent_nav_0_ul_1_ng_container_4_Template, 7, 0, "ng-container", 4)(5, AsyncPaginationComponent_nav_0_ul_1_ng_container_5_Template, 7, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isFirstPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.activePages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isLastPage);
  }
}
function AsyncPaginationComponent_nav_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav", 1);
    i0.ɵɵtemplate(1, AsyncPaginationComponent_nav_0_ul_1_Template, 6, 5, "ul", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.data));
  }
}
const _c7 = ".pagination-link.is-current[_ngcontent-%COMP%]{background-color:#00a9a7;border-color:#00a9a7}.pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none}";
function CollapsibleButtonComponent_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 4);
  }
}
function CollapsibleButtonComponent_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
  }
}
function TrustHolderFormComponent_p_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 31);
    i0.ɵɵtext(1, " Namn m\xE5ste anges. ");
    i0.ɵɵelementEnd();
  }
}
function TrustHolderFormComponent_p_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 31);
    i0.ɵɵtext(1, " Beskrivning m\xE5ste anges. ");
    i0.ɵɵelementEnd();
  }
}
function TrustHolderFormComponent_option_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const trust_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", trust_r1.thumbPrint);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", trust_r1.name, " ");
  }
}
function TrustHolderFormComponent_p_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 31);
    i0.ɵɵtext(1, " Certifikatsutf\xE4rdare m\xE5ste v\xE4ljas. ");
    i0.ɵɵelementEnd();
  }
}
function TrustHolderFormComponent_div_50_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32)(1, "div", 33);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 34);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 35)(6, "input", 36);
    i0.ɵɵlistener("change", function TrustHolderFormComponent_div_50_Template_input_change_6_listener() {
      const trust_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onChangeStatus(trust_r3));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 35)(8, "button", 37);
    i0.ɵɵlistener("click", function TrustHolderFormComponent_div_50_Template_button_click_8_listener() {
      const trust_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onDelete(trust_r3));
    });
    i0.ɵɵelement(9, "span", 38);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const trust_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", trust_r3.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", trust_r3.thumbPrint, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", trust_r3.active);
  }
}
function TrustHolderTableComponent_div_10_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵelement(1, "span", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const trust_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-tooltip", ctx_r1.getWarnTooltip(trust_r1.validTo));
  }
}
function TrustHolderTableComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "date");
    i0.ɵɵtemplate(8, TrustHolderTableComponent_div_10_span_8_Template, 2, 1, "span", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 12);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_6_0;
    const trust_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", trust_r1.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", trust_r1.thumbPrint, " ");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("needs-renewal", ctx_r1.needsRenewal(trust_r1.validTo))("expired", ctx_r1.isExpired(trust_r1.validTo));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_6_0 = i0.ɵɵpipeBind2(7, 9, trust_r1.validTo, "YYYY-MM-dd")) !== null && tmp_6_0 !== undefined ? tmp_6_0 : "Ej angivet", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.needsRenewal(trust_r1.validTo));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", trust_r1.active ? "Ja" : "Nej", " ");
  }
}
const _c8 = ".needs-renewal[_ngcontent-%COMP%]{background-color:#f6a519;color:#fff;padding-right:10px}.expired[_ngcontent-%COMP%]{background-color:#e81d38!important;color:#fff;padding-right:10px}";
const _c9 = ["collapsibleItem"];
function TrustHolderManagerComponent_a_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function TrustHolderManagerComponent_a_4_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.doEdit(null));
    });
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵelement(2, "span", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "L\xE4gg till");
    i0.ɵɵelementEnd()();
  }
}
function TrustHolderManagerComponent_trust_holder_form_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "trust-holder-form", 10);
    i0.ɵɵlistener("trustHolderRequest", function TrustHolderManagerComponent_trust_holder_form_5_Template_trust_holder_form_trustHolderRequest_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.saveTrustHolder($event));
    })("cancel", function TrustHolderManagerComponent_trust_holder_form_5_Template_trust_holder_form_cancel_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("trusts", ctx_r1.allTrusts)("trustHolder", ctx_r1.trustHolderToEdit);
  }
}
function TrustHolderManagerComponent_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 1)(2, "div", 13)(3, "div", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 13)(6, "div", 14)(7, "button", 15);
    i0.ɵɵlistener("click", function TrustHolderManagerComponent_div_6_div_1_Template_button_click_7_listener() {
      const trustHolder_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.doEdit(trustHolder_r5));
    });
    i0.ɵɵelementStart(8, "span", 8);
    i0.ɵɵelement(9, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11, "Editera");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "button", 15);
    i0.ɵɵlistener("click", function TrustHolderManagerComponent_div_6_div_1_Template_button_click_12_listener() {
      const trustHolder_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteTrustHolder(trustHolder_r5));
    });
    i0.ɵɵelementStart(13, "span", 8);
    i0.ɵɵelement(14, "span", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span");
    i0.ɵɵtext(16, "Ta bort f\xF6rtroendek\xE4lla");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "collapsible-button", 18);
    i0.ɵɵlistener("hiddenEvent", function TrustHolderManagerComponent_div_6_div_1_Template_collapsible_button_hiddenEvent_17_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleHiddenEvent($event));
    });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(18, "div", 19);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "collapsible", 20, 0);
    i0.ɵɵelement(22, "trust-holder-table", 21);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const trustHolder_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", trustHolder_r5.trustHolderName, " ");
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("collapsibleId", "collapsible-" + i_r6)("hidden", ctx_r1.hidden);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(trustHolder_r5.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("collapsibleId", "collapsible-" + i_r6)("hidden", ctx_r1.hidden);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("trustHolder", trustHolder_r5);
  }
}
function TrustHolderManagerComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, TrustHolderManagerComponent_div_6_div_1_Template, 23, 7, "div", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.trustHolders$));
  }
}
function CertificateMonitorComponent_div_4_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 13);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 14)(10, "span", 15);
    i0.ɵɵelement(11, "em", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const monitoredCertificate_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", monitoredCertificate_r3.subjectCN, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", monitoredCertificate_r3.issuerCN, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", monitoredCertificate_r3.validFrom, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", monitoredCertificate_r3.validTo, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.determineIconColor(monitoredCertificate_r3.validStatus));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hasExpired(monitoredCertificate_r3.validStatus) ? "Utg\xE5nget" : ctx_r1.formatDuration(monitoredCertificate_r3.timeToExpiration), " ");
  }
}
function CertificateMonitorComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div", 7);
    i0.ɵɵlistener("click", function CertificateMonitorComponent_div_4_Template_div_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("subjectCN"));
    });
    i0.ɵɵtext(3, " Namn ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 7);
    i0.ɵɵlistener("click", function CertificateMonitorComponent_div_4_Template_div_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("issuerCN"));
    });
    i0.ɵɵtext(5, " Utf\xE4rdare ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵlistener("click", function CertificateMonitorComponent_div_4_Template_div_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("validFrom"));
    });
    i0.ɵɵtext(7, " Giltigt fr\xE5n ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 8);
    i0.ɵɵlistener("click", function CertificateMonitorComponent_div_4_Template_div_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("validTo"));
    });
    i0.ɵɵtext(9, " Giltigt till ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 9);
    i0.ɵɵlistener("click", function CertificateMonitorComponent_div_4_Template_div_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("validTo"));
    });
    i0.ɵɵtext(11, " Tid till utg\xE5ngsdatum ");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, CertificateMonitorComponent_div_4_div_12_Template, 13, 6, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngForOf", ctx_r1.monitoredCertificates);
  }
}
function CertificateMonitorComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p");
    i0.ɵɵtext(2, "Inga certifikat tillagda f\xF6r \xF6vervakning.");
    i0.ɵɵelementEnd()();
  }
}
function MailReceiverFormComponent_p_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1, " Mailadress m\xE5ste anges. ");
    i0.ɵɵelementEnd();
  }
}
const _c10 = ["confirmationModal"];
function MailReceiverManagerComponent_a_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function MailReceiverManagerComponent_a_4_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addMailReceiver(null));
    });
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵelement(2, "span", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "L\xE4gg till");
    i0.ɵɵelementEnd()();
  }
}
function MailReceiverManagerComponent_mail_receiver_form_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mail-receiver-form", 10);
    i0.ɵɵlistener("mailReceiverRequest", function MailReceiverManagerComponent_mail_receiver_form_5_Template_mail_receiver_form_mailReceiverRequest_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.saveMailReceiver($event));
    })("cancel", function MailReceiverManagerComponent_mail_receiver_form_5_Template_mail_receiver_form_cancel_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancel());
    });
    i0.ɵɵelementEnd();
  }
}
function MailReceiverManagerComponent_div_6_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("fa-sort-down", !ctx_r1.sortReverse)("fa-sort-up", ctx_r1.sortReverse);
  }
}
function MailReceiverManagerComponent_div_6_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21)(4, "button", 22);
    i0.ɵɵlistener("click", function MailReceiverManagerComponent_div_6_div_7_Template_button_click_4_listener() {
      const mailReceiver_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deleteMailReceiver(mailReceiver_r6));
    });
    i0.ɵɵelement(5, "span", 23);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const mailReceiver_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", mailReceiver_r6.mailAddress, " ");
  }
}
function MailReceiverManagerComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "div", 13);
    i0.ɵɵlistener("click", function MailReceiverManagerComponent_div_6_Template_div_click_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderBy("mailAddress"));
    });
    i0.ɵɵtext(3, " Mailadress ");
    i0.ɵɵtemplate(4, MailReceiverManagerComponent_div_6_span_4_Template, 1, 4, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵelement(6, "span", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, MailReceiverManagerComponent_div_6_div_7_Template, 6, 1, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.sortOrderBy === "mailAddress");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.mailReceivers);
  }
}
function MailReceiverManagerComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p");
    i0.ɵɵtext(2, "Inga kontakter tillagda.");
    i0.ɵɵelementEnd()();
  }
}
const _c11 = "[_nghost-%COMP%]   .has-margin[_ngcontent-%COMP%]{margin:.75rem 0}[_nghost-%COMP%]   .has-bottom-padding[_ngcontent-%COMP%]{padding-bottom:18px}";
const _c12 = ["promptContainer"];
const _c13 = ["promptEl"];
function CliComponent_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 7);
    i0.ɵɵpipe(1, "sanitizeHtml");
  }
  if (rf & 2) {
    const line_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", ctx_r2.opts.cmdColor);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 3, line_r2), i0.ɵɵsanitizeHtml);
  }
}
function CliComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.opts.prompt);
  }
}
function CliComponent_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.progressLoader);
  }
}
const _c14 = ["calendarContainer"];
function DatepickerComponent_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
  }
}
function DatepickerComponent_div_5_div_12_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", day_r3, " ");
  }
}
function DatepickerComponent_div_5_div_12_div_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_div_12_div_4_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const date_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectDate(date_r5));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const date_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("is-active", date_r5.date.format("YYYY-MM-DD") === ctx_r1.dateObj.format("YYYY-MM-DD"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(date_r5.date.format("D"));
  }
}
function DatepickerComponent_div_5_div_12_div_4_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_div_12_div_4_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const date_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectDate(date_r5));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const date_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(date_r5.date.format("D"));
  }
}
function DatepickerComponent_div_5_div_12_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, DatepickerComponent_div_5_div_12_div_4_button_1_Template, 2, 3, "button", 25)(2, DatepickerComponent_div_5_div_12_div_4_button_2_Template, 2, 1, "button", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const date_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("is-disabled", !date_r5.inMonth || ctx_r1.isOutOfMinMaxDateRange(date_r5.date));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dateObj);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.dateObj);
  }
}
function DatepickerComponent_div_5_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵtemplate(2, DatepickerComponent_div_5_div_12_div_2_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵtemplate(4, DatepickerComponent_div_5_div_12_div_4_Template, 3, 4, "div", 23);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.weekDays);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.monthDates);
  }
}
function DatepickerComponent_div_5_div_13_div_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_div_13_div_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const monthDate_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectMonth(monthDate_r8));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const monthDate_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("is-active", monthDate_r8.format("MMM") === ctx_r1.dateObj.format("MMM"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(monthDate_r8.format("MMM"));
  }
}
function DatepickerComponent_div_5_div_13_div_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_div_13_div_2_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const monthDate_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectMonth(monthDate_r8));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const monthDate_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(monthDate_r8.format("MMM"));
  }
}
function DatepickerComponent_div_5_div_13_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, DatepickerComponent_div_5_div_13_div_2_button_1_Template, 2, 3, "button", 30)(2, DatepickerComponent_div_5_div_13_div_2_button_2_Template, 2, 1, "button", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dateObj);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.dateObj);
  }
}
function DatepickerComponent_div_5_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 22);
    i0.ɵɵtemplate(2, DatepickerComponent_div_5_div_13_div_2_Template, 3, 2, "div", 28);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.yearDates);
  }
}
function DatepickerComponent_div_5_div_14_div_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_div_14_div_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const year_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectYear(year_r11));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const year_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("is-active", year_r11.format("YYYY") === ctx_r1.dateObj.format("YYYY"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(year_r11.format("YYYY"));
  }
}
function DatepickerComponent_div_5_div_14_div_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_div_14_div_2_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const year_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectYear(year_r11));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const year_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(year_r11.format("YYYY"));
  }
}
function DatepickerComponent_div_5_div_14_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, DatepickerComponent_div_5_div_14_div_2_button_1_Template, 2, 3, "button", 30)(2, DatepickerComponent_div_5_div_14_div_2_button_2_Template, 2, 1, "button", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dateObj);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.dateObj);
  }
}
function DatepickerComponent_div_5_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 22);
    i0.ɵɵtemplate(2, DatepickerComponent_div_5_div_14_div_2_Template, 3, 2, "div", 28);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.yearSpanDates);
  }
}
function DatepickerComponent_div_5_div_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 33);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_div_15_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearDate());
    });
    i0.ɵɵelement(2, "span", 34);
    i0.ɵɵelementEnd()();
  }
}
function DatepickerComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, DatepickerComponent_div_5_div_1_Template, 1, 0, "div", 7);
    i0.ɵɵelementStart(2, "div", 8, 0)(4, "div", 9)(5, "div", 10)(6, "button", 11);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.previous());
    });
    i0.ɵɵelement(7, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 13);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_Template_div_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextView());
    });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 14);
    i0.ɵɵlistener("click", function DatepickerComponent_div_5_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.next());
    });
    i0.ɵɵelement(11, "span", 15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(12, DatepickerComponent_div_5_div_12_Template, 5, 2, "div", 16)(13, DatepickerComponent_div_5_div_13_Template, 3, 1, "div", 16)(14, DatepickerComponent_div_5_div_14_Template, 3, 1, "div", 16)(15, DatepickerComponent_div_5_div_15_Template, 3, 0, "div", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("modal", ctx_r1.overlay)("is-small", ctx_r1.options.small);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.overlay);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("fixed", ctx_r1.options.fixed);
    i0.ɵɵadvance(6);
    i0.ɵɵclassProp("clickable", ctx_r1.headerIsClickable());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.header);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.activeView === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.activeView === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.activeView === 2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.options.nullable);
  }
}
const _c15 = ["dialogModal"];
function ErrorComponent_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.message, " ");
  }
}
function ErrorComponent_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function ErrorComponent_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.return());
    });
    i0.ɵɵtext(1, "\xC5terg\xE5 till start");
    i0.ɵɵelementEnd();
  }
}
function InfoMessageComponent_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("fa-info-circle", ctx_r0.options.messageType === "info")("fa-check-circle", ctx_r0.options.messageType === "success")("fa-exclamation-circle", ctx_r0.options.messageType === "warning")("fa-exclamation-triangle", ctx_r0.options.messageType === "error");
  }
}
function InfoMessageComponent_div_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "i", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.evaluateMaterialIcon());
  }
}
function InfoMessageComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, InfoMessageComponent_div_2_div_1_Template, 2, 8, "div", 4)(2, InfoMessageComponent_div_2_div_2_Template, 3, 1, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.options.useFaIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.options.useMaterialIcon);
  }
}
function IntegrationHealthCheckComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelement(4, "info-message", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", ctx_r0.options == null ? null : ctx_r0.options.width)("max-width", ctx_r0.options == null ? null : ctx_r0.options.maxWidth);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.setInfoMessage(ctx_r0.getServiceNames(i0.ɵɵpipeBind1(3, 6, ctx_r0.healthCheckStatuses))), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("options", ctx_r0.externalSystemsInfoMessageOptions);
  }
}
function JobStatusComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
  }
}
function JobStatusComponent_div_11_div_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const information_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", information_r1.key, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", information_r1.value, " ");
  }
}
function JobStatusComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 11)(4, "div", 12)(5, "div", 13);
    i0.ɵɵtext(6, " Jobb aktivt ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 14);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 12)(10, "div", 13);
    i0.ɵɵtext(11, " Tidsintervall ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 14);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 12)(15, "div", 13);
    i0.ɵɵtext(16, " Senaste jobbk\xF6rning ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 14);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 12)(21, "div", 13);
    i0.ɵɵtext(22, " Status vid senaste jobbk\xF6rning ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 14);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(25, JobStatusComponent_div_11_div_25_Template, 5, 2, "div", 15);
    i0.ɵɵpipe(26, "keyvalue");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const jobStatus_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(jobStatus_r2.name);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", jobStatus_r2.active ? "Ja" : "Nej", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", jobStatus_r2.interval ? jobStatus_r2.interval : "N/A", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", jobStatus_r2.lastTimestamp ? i0.ɵɵpipeBind2(19, 6, jobStatus_r2.lastTimestamp, "yyyy-MM-dd HH:mm") : "N/A", " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", jobStatus_r2.lastStatus ? jobStatus_r2.lastStatus : "N/A", " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(26, 9, jobStatus_r2.customInformation));
  }
}
const _c16 = ["newValueInput"];
function ListComponent_div_0_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function ListComponent_div_0_button_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.editDisabledState($event, false));
    });
    i0.ɵɵelementEnd();
  }
}
function ListComponent_div_0_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function ListComponent_div_0_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const item_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.delete(item_r6));
    });
    i0.ɵɵelementEnd();
  }
}
function ListComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "input", 5);
    i0.ɵɵlistener("dblclick", function ListComponent_div_0_Template_input_dblclick_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editDisabledState($event, false));
    })("keydown.enter", function ListComponent_div_0_Template_input_keydown_enter_1_listener($event) {
      const i_r3 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onListItemChange(i_r3, $event));
    })("blur", function ListComponent_div_0_Template_input_blur_1_listener($event) {
      const i_r3 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onListItemChange(i_r3, $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, ListComponent_div_0_button_2_Template, 1, 0, "button", 6)(3, ListComponent_div_0_button_3_Template, 1, 0, "button", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("enabled", !ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.disabled)("value", item_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.disabled);
  }
}
function ListComponent_input_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 10, 0);
    i0.ɵɵlistener("blur", function ListComponent_input_2_Template_input_blur_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.add(ctx_r1.newValue);
      return i0.ɵɵresetView(ctx_r1.onTouched());
    });
    i0.ɵɵtwoWayListener("ngModelChange", function ListComponent_input_2_Template_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.newValue, $event) || (ctx_r1.newValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keydown.enter", function ListComponent_input_2_Template_input_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addWithEnter(ctx_r1.newValue));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.newValue);
  }
}
function LoaRuleFormComponent_option_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const level_r1 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", level_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(level_r1);
  }
}
function LoaRuleFormComponent_option_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const value_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", value_r2.oid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", value_r2.name, " (", value_r2.oid, ") ");
  }
}
function LoaRuleFormComponent_p_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 29);
    i0.ɵɵtext(1, " F\xE4ltet m\xE5ste vara ifyllt. ");
    i0.ɵɵelementEnd();
  }
}
function LoaRuleFormComponent_div_31_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const level_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", level_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(level_r4);
  }
}
function LoaRuleFormComponent_div_31_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 30)(2, "div", 31);
    i0.ɵɵelement(3, "input", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 33)(5, "select", 34);
    i0.ɵɵtemplate(6, LoaRuleFormComponent_div_31_option_6_Template, 2, 2, "option", 35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 8)(8, "a", 36);
    i0.ɵɵlistener("click", function LoaRuleFormComponent_div_31_Template_a_click_8_listener() {
      const i_r5 = i0.ɵɵrestoreView(_r3).index;
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.removeValueRow(i_r5));
    });
    i0.ɵɵelementStart(9, "span", 22);
    i0.ɵɵelement(10, "span", 37);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const i_r5 = ctx.index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroupName", i_r5);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r5.levelOfAssuranceValues);
  }
}
function LoaRuleFormComponent_button_38_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵlistener("click", function LoaRuleFormComponent_button_38_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.cancelEdit());
    });
    i0.ɵɵtext(1, "Avbryt");
    i0.ɵɵelementEnd();
  }
}
const _c17 = ["loaRuleForm"];
function LoaCertificateComponent_div_0_div_9_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rule_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", rule_r3.levelOfAssurance, " => ", rule_r3.value, "");
  }
}
function LoaCertificateComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵtemplate(4, LoaCertificateComponent_div_0_div_9_div_4_Template, 2, 2, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13)(6, "button", 14);
    i0.ɵɵlistener("click", function LoaCertificateComponent_div_0_div_9_Template_button_click_6_listener() {
      const loaRule_r4 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.editRule(loaRule_r4));
    });
    i0.ɵɵelement(7, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 16);
    i0.ɵɵlistener("click", function LoaCertificateComponent_div_0_div_9_Template_button_click_8_listener() {
      const loaRule_r4 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.removeRule(loaRule_r4));
    });
    i0.ɵɵelement(9, "span", 17);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const loaRule_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", loaRule_r4.field, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", loaRule_r4.rules);
  }
}
function LoaCertificateComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 5)(2, "div", 6)(3, "div", 7);
    i0.ɵɵtext(4, " F\xE4ltregler ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtext(6, " Level of Assurance:Regex/V\xE4rde ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵelement(8, "span", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, LoaCertificateComponent_div_0_div_9_Template, 10, 2, "div", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r4.loaRules);
  }
}
const _c18 = (a0, a1, a2) => ({
  $implicit: a0,
  node: a1,
  context: a2
});
function NodeNameComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r0.active);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.state.nodeItem.name);
  }
}
function NodeNameComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c19 = (a0, a1) => ({
  expanded: a0,
  context: a1
});
function NodeIconWrapperComponent_ng_container_1_ng_container_1_i_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 4);
  }
}
function NodeIconWrapperComponent_ng_container_1_ng_container_1_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
  }
}
function NodeIconWrapperComponent_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NodeIconWrapperComponent_ng_container_1_ng_container_1_i_1_Template, 1, 0, "i", 2)(2, NodeIconWrapperComponent_ng_container_1_ng_container_1_i_2_Template, 1, 0, "i", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.state.expanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.state.expanded);
  }
}
function NodeIconWrapperComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NodeIconWrapperComponent_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.state.nodeItem == null ? null : ctx_r0.state.nodeItem.children == null ? null : ctx_r0.state.nodeItem.children.length) > 0);
  }
}
function NodeIconWrapperComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NodeIconWrapperComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NodeIconWrapperComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.nodeCollapsibleTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c19, ctx_r0.state.expanded, ctx_r0._this));
  }
}
const _c20 = ["nodeCheckbox"];
function NodeComponent_input_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 8, 0);
    i0.ɵɵlistener("click", function NodeComponent_input_3_Template_input_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleSelected());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "chkbx", ctx_r1.id, "");
    i0.ɵɵproperty("disabled", ctx_r1.state.disabled)("checked", ctx_r1.state.selected);
  }
}
function NodeComponent_div_6_node_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "node", 12);
  }
  if (rf & 2) {
    const child_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("state", child_r3)("selectedState", child_r3.selectedState)("nodeCollapsibleTemplate", ctx_r1.nodeCollapsibleTemplate)("nodeNameTemplate", ctx_r1.nodeNameTemplate);
  }
}
function NodeComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtemplate(2, NodeComponent_div_6_node_2_Template, 1, 4, "node", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("collapsed", !ctx_r1.state.expanded && ctx_r1.state.nodeItem.children.length > 0 && ctx_r1.state.filteredChildren.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.state.filteredChildren);
  }
}
const _c21 = ["nodeNameTemplate"];
const _c22 = ["nodeCollapsibleTemplate"];
function TreeNgxComponent_ng_container_1_node_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "node", 3);
  }
  if (rf & 2) {
    const state_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("state", state_r1)("selectedState", state_r1.selectedState)("nodeCollapsibleTemplate", ctx_r1.nodeCollapsibleTemplate)("nodeNameTemplate", ctx_r1.nodeNameTemplate);
  }
}
function TreeNgxComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TreeNgxComponent_ng_container_1_node_1_Template, 1, 4, "node", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const state_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", state_r1.hasFilteredChildren);
  }
}
const _c23 = ["resourceTree"];
function LoaRulesComponent_ng_template_8_i_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 11);
  }
}
function LoaRulesComponent_ng_template_8_i_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 12);
  }
}
function LoaRulesComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LoaRulesComponent_ng_template_8_i_0_Template, 1, 0, "i", 9)(1, LoaRulesComponent_ng_template_8_i_1_Template, 1, 0, "i", 10);
  }
  if (rf & 2) {
    const expanded_r2 = ctx.expanded;
    i0.ɵɵproperty("ngIf", !expanded_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", expanded_r2);
  }
}
function LoaRulesComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "loa-certificate", 13);
    i0.ɵɵlistener("loaRulesChanged", function LoaRulesComponent_div_13_Template_loa_certificate_loaRulesChanged_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.refreshCertificates());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("certificate", ctx_r3.selected.item);
  }
}
function MultiSelectComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 3);
    i0.ɵɵlistener("change", function MultiSelectComponent_div_1_Template_input_change_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleSelectAll());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 4);
    i0.ɵɵtext(3, "V\xE4lj alla");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-small", ctx_r1.internalOptions.small);
    i0.ɵɵpropertyInterpolate1("id", "selectAll", ctx_r1.id, "");
    i0.ɵɵproperty("checked", ctx_r1.allSelected)("disabled", ctx_r1.disableAllSelected);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "selectAll", ctx_r1.id, "");
  }
}
function MultiSelectComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 3);
    i0.ɵɵlistener("change", function MultiSelectComponent_div_2_Template_input_change_1_listener() {
      const item_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.select(item_r4.item));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-small", ctx_r1.internalOptions.small);
    i0.ɵɵpropertyInterpolate2("id", "id", ctx_r1.id, "ind", i_r5, "");
    i0.ɵɵproperty("checked", ctx_r1.selectedItems.indexOf(item_r4.item) !== -1)("disabled", item_r4.disabled);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(item_r4.customstyle);
    i0.ɵɵpropertyInterpolate2("for", "id", ctx_r1.id, "ind", i_r5, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r4.name);
  }
}
function ValueComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "div", 3)(3, "input", 8);
    i0.ɵɵlistener("keyup", function ValueComponent_ng_container_1_Template_input_keyup_3_listener($event) {
      const index_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.update(ctx_r2.condition, index_r2, $event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 9)(5, "a", 10);
    i0.ɵɵlistener("click", function ValueComponent_ng_container_1_Template_a_click_5_listener() {
      const value_r4 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.delete(value_r4));
    });
    i0.ɵɵelementStart(6, "span", 5);
    i0.ɵɵelement(7, "span", 11);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const value_r4 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", value_r4.name);
  }
}
function ConditionComponent_ng_container_0_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const condition_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(condition_r2.name);
  }
}
function ConditionComponent_ng_container_0_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 13);
    i0.ɵɵtext(1, "Villkor");
    i0.ɵɵelementEnd();
  }
}
function ConditionComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConditionComponent_ng_container_0_label_1_Template, 2, 1, "label", 6)(2, ConditionComponent_ng_container_0_label_2_Template, 2, 0, "label", 6);
    i0.ɵɵelementStart(3, "div", 7)(4, "div", 2)(5, "input", 8);
    i0.ɵɵlistener("keyup", function ConditionComponent_ng_container_0_Template_input_keyup_5_listener($event) {
      const condition_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.update(condition_r2, $event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 9)(7, "a", 10);
    i0.ɵɵlistener("click", function ConditionComponent_ng_container_0_Template_a_click_7_listener() {
      const condition_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.delete(condition_r2));
    });
    i0.ɵɵelementStart(8, "span", 4);
    i0.ɵɵelement(9, "span", 11);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(10, "value-row", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const condition_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", condition_r2.name !== "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", condition_r2.name === "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", condition_r2.name);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("condition", condition_r2);
  }
}
const _c24 = ".add-row[_ngcontent-%COMP%]{display:flex;justify-content:center;font-size:16px}.add-row[_ngcontent-%COMP%]:hover{color:#f6a519}.cursor[_ngcontent-%COMP%]{cursor:auto}.expandable[_ngcontent-%COMP%]{font-size:12px}[_nghost-%COMP%]{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.privilege-button[_ngcontent-%COMP%]{cursor:pointer;width:100%}.box[_ngcontent-%COMP%]:not(:last-child){margin-bottom:5px}.column[_ngcontent-%COMP%]{height:100%;overflow-y:auto}.column-bottom[_ngcontent-%COMP%]{height:51px;margin-top:10px}.box-button[_ngcontent-%COMP%]{margin-top:-2px}.box-title[_ngcontent-%COMP%]{display:flex;flex:1 1}.filter[_ngcontent-%COMP%]{margin-top:10px}.margin-top[_ngcontent-%COMP%]{margin-top:5px}.margin-right[_ngcontent-%COMP%]{margin-right:10px}.field-margin-bottom[_ngcontent-%COMP%]{margin-bottom:.75rem}.divider[_ngcontent-%COMP%]{margin:.75rem 0;background-color:#f5f5f5}.inform-if-missing-checkbox[_ngcontent-%COMP%]{margin-bottom:.5em}";
function ActionComponent_ng_container_0_option_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(action_r4);
  }
}
function ActionComponent_ng_container_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "a", 16);
    i0.ɵɵlistener("click", function ActionComponent_ng_container_0_div_11_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const action_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.delete(action_r2));
    });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵelement(3, "span", 17);
    i0.ɵɵelementEnd()()();
  }
}
function ActionComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7)(4, "input", 8);
    i0.ɵɵlistener("change", function ActionComponent_ng_container_0_Template_input_change_4_listener() {
      const action_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleInformIfMissing(action_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 9);
    i0.ɵɵtext(6, "Informera anv\xE4ndare om beh\xF6righet saknas");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 10)(8, "div", 11)(9, "select", 12);
    i0.ɵɵlistener("change", function ActionComponent_ng_container_0_Template_select_change_9_listener($event) {
      const action_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.update(action_r2, $event));
    });
    i0.ɵɵtemplate(10, ActionComponent_ng_container_0_option_10_Template, 2, 1, "option", 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, ActionComponent_ng_container_0_div_11_Template, 4, 0, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "condition", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r2 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(action_r2.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "action.name" + i_r6)("name", "action.name" + i_r6)("checked", ctx_r2.getInformIfMissing(action_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", "action.name" + i_r6);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("value", action_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.actions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.privilege.children.length > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("action", action_r2);
  }
}
function PrivilegeComponent_a_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵlistener("click", function PrivilegeComponent_a_5_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.addResource());
    });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵelement(2, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " \xA0 Ny resurs ");
    i0.ɵɵelementEnd();
  }
}
function PrivilegeComponent_ng_container_6_ng_template_9_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 23);
  }
}
function PrivilegeComponent_ng_container_6_ng_template_9_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 24);
  }
}
function PrivilegeComponent_ng_container_6_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PrivilegeComponent_ng_container_6_ng_template_9_span_0_Template, 1, 0, "span", 21)(1, PrivilegeComponent_ng_container_6_ng_template_9_span_1_Template, 1, 0, "span", 22);
  }
  if (rf & 2) {
    const expanded_r6 = ctx.expanded;
    i0.ɵɵproperty("ngIf", !expanded_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", expanded_r6);
  }
}
function PrivilegeComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 17);
    i0.ɵɵlistener("keyup", function PrivilegeComponent_ng_container_6_Template_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.filterChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵlistener("click", function PrivilegeComponent_ng_container_6_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const resourceTree_r5 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(resourceTree_r5.expandAll());
    });
    i0.ɵɵtext(3, "Expandera");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 19);
    i0.ɵɵlistener("click", function PrivilegeComponent_ng_container_6_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r4);
      const resourceTree_r5 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(resourceTree_r5.collapseAll());
    });
    i0.ɵɵtext(5, "Kollapsa");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "tree-ngx", 20, 1);
    i0.ɵɵpipe(8, "sortPrivileges");
    i0.ɵɵtemplate(9, PrivilegeComponent_ng_container_6_ng_template_9_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("filter", ctx_r2.filter)("callbacks", ctx_r2.callbacks)("options", ctx_r2.options)("nodeItems", i0.ɵɵpipeBind1(8, 4, ctx_r2.items));
  }
}
function PrivilegeComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "span", 26);
    i0.ɵɵelementEnd();
  }
}
function PrivilegeComponent_a_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵlistener("click", function PrivilegeComponent_a_12_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.deleteResource(ctx_r2.selected));
    });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵelement(2, "span", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, " \xA0 Ta bort ");
    i0.ɵɵelementEnd();
  }
}
function PrivilegeComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 28)(2, "label", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 30)(5, "input", 31);
    i0.ɵɵlistener("keyup", function PrivilegeComponent_div_13_Template_input_keyup_5_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.updateName(ctx_r2.selected, $event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(6, "action", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.selected.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", ctx_r2.selected.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("actions", ctx_r2.actions)("privilege", ctx_r2.selected);
  }
}
function PrivilegeComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 33)(4, "input", 34);
    i0.ɵɵlistener("change", function PrivilegeComponent_div_14_Template_input_change_4_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleInformIfMissing(ctx_r2.selected));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 35);
    i0.ɵɵtext(6, "Informera anv\xE4ndare om beh\xF6righet saknas");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "condition", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.selected.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "selected.name")("name", "selected.name")("checked", ctx_r2.getInformIfMissing(ctx_r2.selected));
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", "selected.name");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("action", ctx_r2.selected);
  }
}
function PrivilegeComponent_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "value-row", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.selected.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("condition", ctx_r2.selected);
  }
}
const _c25 = ["timepickerContainer"];
function TimepickerComponent_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
  }
}
function TimepickerComponent_div_5_div_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 18);
    i0.ɵɵlistener("click", function TimepickerComponent_div_5_div_22_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearTime());
    });
    i0.ɵɵelement(2, "span", 19);
    i0.ɵɵelementEnd()();
  }
}
function TimepickerComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, TimepickerComponent_div_5_div_1_Template, 1, 0, "div", 7);
    i0.ɵɵelementStart(2, "div", 8, 0)(4, "div", 9)(5, "div", 10)(6, "button", 11);
    i0.ɵɵlistener("click", function TimepickerComponent_div_5_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeHours(1));
    });
    i0.ɵɵelement(7, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 11);
    i0.ɵɵlistener("click", function TimepickerComponent_div_5_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeMinutes(1));
    });
    i0.ɵɵelement(9, "span", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 13)(11, "p");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "p");
    i0.ɵɵtext(14, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "p");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 14)(18, "button", 11);
    i0.ɵɵlistener("click", function TimepickerComponent_div_5_Template_button_click_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeHours(-1));
    });
    i0.ɵɵelement(19, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "button", 11);
    i0.ɵɵlistener("click", function TimepickerComponent_div_5_Template_button_click_20_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeMinutes(-1));
    });
    i0.ɵɵelement(21, "span", 15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(22, TimepickerComponent_div_5_div_22_Template, 3, 0, "div", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("modal", ctx_r1.overlay)("is-small", ctx_r1.options.small);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.overlay);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("fixed", ctx_r1.options.fixed);
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate(ctx_r1.getHoursValue());
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.getMinutesValue());
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r1.options.nullable);
  }
}
function ToastComponent_div_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const toast_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", toast_r2.message, " ");
  }
}
function ToastComponent_div_0_ng_container_8_ul_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul")(1, "li")(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const msg_r4 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(msg_r4);
  }
}
function ToastComponent_div_0_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ToastComponent_div_0_ng_container_8_ul_1_Template, 4, 1, "ul", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const toast_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", toast_r2.message);
  }
}
function ToastComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("swipes", function ToastComponent_div_0_Template_div_swipes_0_listener($event) {
      const toast_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.swipeAction($event, toast_r2));
    })("hoverState", function ToastComponent_div_0_Template_div_hoverState_0_listener($event) {
      const toast_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleHover($event, toast_r2));
    });
    i0.ɵɵelement(1, "i", 2);
    i0.ɵɵelementStart(2, "button", 3);
    i0.ɵɵlistener("click", function ToastComponent_div_0_Template_button_click_2_listener() {
      const toast_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dismissToast(toast_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div")(4, "p")(5, "strong");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, ToastComponent_div_0_ng_container_7_Template, 3, 1, "ng-container", 4)(8, ToastComponent_div_0_ng_container_8_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const toast_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is-primary", toast_r2.type === "primary")("is-info", toast_r2.type === "info")("is-success", toast_r2.type === "success")("is-link", toast_r2.type === "link")("is-warning", toast_r2.type === "warning")("is-danger", toast_r2.type === "danger")("destroy", toast_r2.destroy);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("fa-info-circle", toast_r2.type === "info")("fa-check-circle", toast_r2.type === "success")("fa-link", toast_r2.type === "link")("fa-exclamation-circle", toast_r2.type === "warning")("fa-exclamation-triangle", toast_r2.type === "danger");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(toast_r2.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isSingle(toast_r2.message));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isSingle(toast_r2.message));
  }
}
function UserInfoComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "info-message", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r0.noPrivilegesInfoMessageOptions);
  }
}
function UserInfoComponent_div_1_ng_container_16_tr_6_ul_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul")(1, "li");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const value_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", value_r2, " ");
  }
}
function UserInfoComponent_div_1_ng_container_16_tr_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, UserInfoComponent_div_1_ng_container_16_tr_6_ul_4_Template, 3, 1, "ul", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const condition_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(condition_r3.attribute);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", condition_r3.values);
  }
}
function UserInfoComponent_div_1_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr")(2, "td");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, UserInfoComponent_div_1_ng_container_16_tr_6_Template, 5, 2, "tr", 17);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const missingPrivilege_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("rowspan", missingPrivilege_r4.conditions.length + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(missingPrivilege_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵattribute("rowspan", missingPrivilege_r4.conditions.length + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(missingPrivilege_r4.action);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", missingPrivilege_r4.conditions);
  }
}
function UserInfoComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 14);
    i0.ɵɵtext(3, "Saknade beh\xF6righeter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 15)(5, "thead")(6, "tr")(7, "th", 16);
    i0.ɵɵtext(8, " Beh\xF6righet ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 16);
    i0.ɵɵtext(10, " Aktion ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 16);
    i0.ɵɵtext(12, " Villkor ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th", 16);
    i0.ɵɵtext(14, " V\xE4rden ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "tbody");
    i0.ɵɵtemplate(16, UserInfoComponent_div_1_ng_container_16_Template, 7, 5, "ng-container", 17);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(16);
    i0.ɵɵproperty("ngForOf", ctx_r0.user.missingPrivileges);
  }
}
function UserInfoComponent_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2, " Namn ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.user.name, " ");
  }
}
function UserInfoComponent_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2, " Id ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.user.employeeHsaId, " ");
  }
}
function UserInfoComponent_div_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2, " Utf\xE4rdare ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.user.issuer, " ");
  }
}
function UserInfoComponent_div_6_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2, " Organisation ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.user.organizationName, " ");
  }
}
function UserInfoComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, UserInfoComponent_div_6_div_1_Template, 5, 1, "div", 19)(2, UserInfoComponent_div_6_div_2_Template, 5, 1, "div", 19)(3, UserInfoComponent_div_6_div_3_Template, 5, 1, "div", 19)(4, UserInfoComponent_div_6_div_4_Template, 5, 1, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.user.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.user.employeeHsaId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.user.issuer);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.user.organizationName);
  }
}
function UserInfoComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const attribute_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", attribute_r5.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", attribute_r5.value, " ");
  }
}
function CertPinningFormComponent_file_upload_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "file-upload", 12, 0);
    i0.ɵɵlistener("import", function CertPinningFormComponent_file_upload_4_Template_file_upload_import_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.importFile());
    })("uploaded", function CertPinningFormComponent_file_upload_4_Template_file_upload_uploaded_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.fileUploaded($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("options", ctx_r1.options);
  }
}
function CertPinningFormComponent_div_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "span", 13);
    i0.ɵɵelementEnd();
  }
}
function CertPinningFormComponent_div_16_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "button", 20);
    i0.ɵɵlistener("click", function CertPinningFormComponent_div_16_div_9_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const certPin_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDelete(certPin_r4));
    });
    i0.ɵɵelement(2, "span", 21);
    i0.ɵɵelementEnd()();
  }
}
function CertPinningFormComponent_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 16);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 17);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CertPinningFormComponent_div_16_div_9_Template, 3, 0, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const certPin_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", certPin_r4.subject, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", certPin_r4.notAfter, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", certPin_r4.lastUsed, " ");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-7", ctx_r1.readOnly)("is-6", !ctx_r1.readOnly);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", certPin_r4.sha256Thumbprint, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.readOnly);
  }
}
function WSClientFormComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, "Redigera WS klient");
    i0.ɵɵelementEnd();
  }
}
function WSClientFormComponent_p_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 26);
    i0.ɵɵtext(1, " System ID m\xE5ste anges. ");
    i0.ɵɵelementEnd();
  }
}
function WSClientFormComponent_p_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 26);
    i0.ɵɵtext(1, " Systemnamn m\xE5ste anges. ");
    i0.ɵɵelementEnd();
  }
}
function WSClientFormComponent_div_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "span", 28);
    i0.ɵɵelementEnd();
  }
}
function WSClientFormComponent_th_41_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 29);
    i0.ɵɵelement(1, "span", 30);
    i0.ɵɵelementEnd();
  }
}
function WSClientFormComponent_tr_43_td_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 36)(1, "button", 37);
    i0.ɵɵlistener("click", function WSClientFormComponent_tr_43_td_10_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeContact(i_r2));
    });
    i0.ɵɵelement(2, "span", 38);
    i0.ɵɵelementEnd()();
  }
}
function WSClientFormComponent_tr_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 31)(1, "td")(2, "div", 11);
    i0.ɵɵelement(3, "input", 32);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td")(5, "div", 11);
    i0.ɵɵelement(6, "input", 33);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "td")(8, "div", 11);
    i0.ɵɵelement(9, "input", 34);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, WSClientFormComponent_tr_43_td_10_Template, 3, 0, "td", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroupName", i_r2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r2.readOnly);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r2.readOnly);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r2.readOnly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.readOnly);
  }
}
function WSClientFormComponent_div_44_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 39);
    i0.ɵɵlistener("click", function WSClientFormComponent_div_44_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.addContact());
    });
    i0.ɵɵelement(2, "span", 40);
    i0.ɵɵelementEnd()();
  }
}
function WSClientFormComponent_div_49_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelement(1, "span", 28);
    i0.ɵɵelementEnd();
  }
}
function WSClientFormComponent_th_57_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 29);
    i0.ɵɵelement(1, "span", 30);
    i0.ɵɵelementEnd();
  }
}
function WSClientFormComponent_tr_59_td_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 36)(1, "button", 37);
    i0.ɵɵlistener("click", function WSClientFormComponent_tr_59_td_7_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const i_r6 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.removeAttribute(i_r6));
    });
    i0.ɵɵelement(2, "span", 38);
    i0.ɵɵelementEnd()();
  }
}
function WSClientFormComponent_tr_59_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 31)(1, "td")(2, "div", 11);
    i0.ɵɵelement(3, "input", 42);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td")(5, "div", 11);
    i0.ɵɵelement(6, "input", 43);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, WSClientFormComponent_tr_59_td_7_Template, 3, 0, "td", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r6 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroupName", i_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r2.readOnly);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r2.readOnly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.readOnly);
  }
}
function WSClientFormComponent_div_60_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 39);
    i0.ɵɵlistener("click", function WSClientFormComponent_div_60_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.addAttribute());
    });
    i0.ɵɵelement(2, "span", 40);
    i0.ɵɵelementEnd()();
  }
}
function WSClientFormComponent_div_61_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 9)(2, "button", 44);
    i0.ɵɵlistener("click", function WSClientFormComponent_div_61_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.cancelForm());
    });
    i0.ɵɵtext(3, "\xC5ngra");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 9)(5, "button", 45);
    i0.ɵɵlistener("click", function WSClientFormComponent_div_61_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.submitForm());
    });
    i0.ɵɵtext(6, "Spara");
    i0.ɵɵelementEnd()()();
  }
}
const _c26 = ["addServiceConsumerModal"];
const _c27 = ["wsClientDetailsModal"];
function ServicePlatformClientComponent_p_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 35);
    i0.ɵɵtext(1, " System ID m\xE5ste anges. ");
    i0.ɵɵelementEnd();
  }
}
function ServicePlatformClientComponent_p_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 35);
    i0.ɵɵtext(1, " Systemnamn m\xE5ste anges. ");
    i0.ɵɵelementEnd();
  }
}
function ServicePlatformClientComponent_tr_38_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 36)(1, "td")(2, "div", 9);
    i0.ɵɵelement(3, "input", 37);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td")(5, "div", 9);
    i0.ɵɵelement(6, "input", 38);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "td", 39)(8, "button", 40);
    i0.ɵɵlistener("click", function ServicePlatformClientComponent_tr_38_Template_button_click_8_listener() {
      const metadata_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.setSelectedWSClient(metadata_r3));
    });
    i0.ɵɵelement(9, "i", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 40);
    i0.ɵɵlistener("click", function ServicePlatformClientComponent_tr_38_Template_button_click_10_listener() {
      const ctx_r4 = i0.ɵɵrestoreView(_r2);
      const metadata_r3 = ctx_r4.$implicit;
      const i_r6 = ctx_r4.index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.removeServiceConsumer(i_r6, metadata_r3));
    });
    i0.ɵɵelement(11, "i", 42);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const i_r6 = ctx.index;
    i0.ɵɵproperty("formGroupName", i_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", true);
  }
}
function ServicePlatformClientComponent_tr_57_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 36)(1, "td")(2, "div", 9);
    i0.ɵɵelement(3, "input", 43);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td")(5, "div", 9);
    i0.ɵɵelement(6, "input", 44);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "td", 39)(8, "button", 40);
    i0.ɵɵlistener("click", function ServicePlatformClientComponent_tr_57_Template_button_click_8_listener() {
      const i_r9 = i0.ɵɵrestoreView(_r8).index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.removeAttribute(i_r9));
    });
    i0.ɵɵelement(9, "i", 42);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const i_r9 = ctx.index;
    i0.ɵɵproperty("formGroupName", i_r9);
  }
}
function ServicePlatformClientComponent_option_74_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const metadata_r10 = ctx.$implicit;
    i0.ɵɵproperty("value", metadata_r10.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", metadata_r10.systemName, " ");
  }
}
function ServicePlatformClientComponent_div_77_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "ws-client-form", 45);
    i0.ɵɵlistener("cancel", function ServicePlatformClientComponent_div_77_Template_ws_client_form_cancel_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.closeWSDetails());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("metadata", ctx_r3.selectedWSClient)("readOnly", true);
  }
}
const _c28 = "[_nghost-%COMP%]{background-color:#000}[_nghost-%COMP%]   .is-table-button[_ngcontent-%COMP%]{font-size:1em;padding:1px .7em;height:2em;margin-left:.2em}[_nghost-%COMP%]   .is-table-button[_ngcontent-%COMP%]:last-child{margin-right:0}[_nghost-%COMP%]   .is-actions-column[_ngcontent-%COMP%]{width:120px}[_nghost-%COMP%]   .is-small-actions-column[_ngcontent-%COMP%]{width:60px}[_nghost-%COMP%]   .has-add-button[_ngcontent-%COMP%]{margin-bottom:0}[_nghost-%COMP%]   .button-icon-margin[_ngcontent-%COMP%]{margin-left:.5em}";
function ServicePlatformComponent_div_0_tr_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 12)(6, "button", 13);
    i0.ɵɵlistener("click", function ServicePlatformComponent_div_0_tr_14_Template_button_click_6_listener() {
      const servicePlatform_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onSelect(servicePlatform_r3));
    });
    i0.ɵɵelement(7, "i", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 13);
    i0.ɵɵlistener("click", function ServicePlatformComponent_div_0_tr_14_Template_button_click_8_listener() {
      const servicePlatform_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDelete(servicePlatform_r3));
    });
    i0.ɵɵelement(9, "i", 15);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const servicePlatform_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(servicePlatform_r3.systemId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(servicePlatform_r3.systemName);
  }
}
function ServicePlatformComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
    i0.ɵɵtext(3, "Metadata f\xF6r tj\xE4nsteplattformar");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 4)(5, "thead")(6, "tr")(7, "th", 5);
    i0.ɵɵtext(8, "System ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 5);
    i0.ɵɵtext(10, "Systemnamn");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 6);
    i0.ɵɵelement(12, "i", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "tbody");
    i0.ɵɵtemplate(14, ServicePlatformComponent_div_0_tr_14_Template, 10, 2, "tr", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 1)(16, "div", 9)(17, "button", 10);
    i0.ɵɵlistener("click", function ServicePlatformComponent_div_0_Template_button_click_17_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.addServicePlatform());
    });
    i0.ɵɵtext(18, " L\xE4gg till ");
    i0.ɵɵelement(19, "i", 11);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngForOf", ctx_r3.servicePlatforms);
  }
}
function ServicePlatformComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 9)(2, "service-platform-client-form", 16);
    i0.ɵɵlistener("cancel", function ServicePlatformComponent_div_1_Template_service_platform_client_form_cancel_2_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.cancelServicePlatform());
    })("formSubmitted", function ServicePlatformComponent_div_1_Template_service_platform_client_form_formSubmitted_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.saveServicePlatform($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("metadata", ctx_r3.selectedServicePlatform)("metadatas", ctx_r3.wsClients);
  }
}
function WSClientComponent_div_0_tr_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 12)(8, "button", 13);
    i0.ɵɵlistener("click", function WSClientComponent_div_0_tr_16_Template_button_click_8_listener() {
      const client_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.selectClient(client_r3));
    });
    i0.ɵɵelement(9, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 13);
    i0.ɵɵlistener("click", function WSClientComponent_div_0_tr_16_Template_button_click_10_listener() {
      const client_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.onDelete(client_r3));
    });
    i0.ɵɵelement(11, "span", 15);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const client_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(client_r3.systemId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(client_r3.systemName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.isActive(client_r3));
  }
}
function WSClientComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
    i0.ɵɵtext(3, "Metadata f\xF6r webbserviceklienter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 4)(5, "thead")(6, "tr")(7, "th", 5);
    i0.ɵɵtext(8, "System ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 5);
    i0.ɵɵtext(10, "Systemnamn");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 5);
    i0.ɵɵtext(12, "Till\xE5ts direktanrop");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th", 6);
    i0.ɵɵelement(14, "span", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "tbody");
    i0.ɵɵtemplate(16, WSClientComponent_div_0_tr_16_Template, 12, 3, "tr", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 1)(18, "div", 9)(19, "button", 10);
    i0.ɵɵlistener("click", function WSClientComponent_div_0_Template_button_click_19_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.addClient());
    });
    i0.ɵɵtext(20, " L\xE4gg till ");
    i0.ɵɵelement(21, "span", 11);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(16);
    i0.ɵɵproperty("ngForOf", ctx_r3.clients);
  }
}
function WSClientComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 9)(2, "ws-client-form", 16);
    i0.ɵɵlistener("cancel", function WSClientComponent_div_1_Template_ws_client_form_cancel_2_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.cancelClient());
    })("formSubmitted", function WSClientComponent_div_1_Template_ws_client_form_formSubmitted_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.saveClient($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("metadata", ctx_r3.selectedWSClient)("readOnly", false);
  }
}
var ContentType;
(function (ContentType) {
  ContentType["XML"] = "application/xml";
  ContentType["JSON"] = "application/json";
  ContentType["OCTET_STREAM"] = "octet/stream";
})(ContentType || (ContentType = {}));
class Util {
  static exportJson(object, filename) {
    const userString = JSON.stringify(object);
    const fileName = filename + '.json';
    this.exportFile(userString, fileName, ContentType.JSON);
  }
  static exportXml(xml, filename) {
    const fileName = filename + '.xml';
    this.exportFile(xml, fileName, ContentType.XML);
  }
  static exportPdf(pdf, filename) {
    const fileName = filename + '.pdf';
    this.exportFile(pdf, fileName, ContentType.OCTET_STREAM);
  }
  static exportFile(file, completeFileName, type) {
    const blob = new Blob([file], {
      type: type
    });
    const blobUrl = window.URL.createObjectURL(blob);
    this.download(blob, completeFileName, blobUrl);
  }
  static getSubset(name, divider) {
    const parts = name.split(divider);
    const subSet = [];
    let tempPart = '';
    for (const part of parts) {
      tempPart += part;
      subSet.push(tempPart);
      tempPart += '.';
    }
    return subSet;
  }
  static download(blob, fileName, blobUrl) {
    const downloadLink = document.createElement('a');
    downloadLink.download = fileName;
    downloadLink.innerHTML = 'Download File';
    downloadLink.href = blobUrl;
    downloadLink.onclick = this.destroyClickedElement;
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
  static destroyClickedElement(event) {
    document.body.removeChild(event.target);
  }
}

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class RpConfigService {
  http;
  apiUrl = '/api/rp/config';
  constructor(http) {
    this.http = http;
  }
  getConfig() {
    return this.http.get(this.apiUrl);
  }
  saveConfig(config) {
    return this.http.put(this.apiUrl, config);
  }
  static ɵfac = function RpConfigService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RpConfigService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RpConfigService,
    factory: RpConfigService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RpConfigService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class RpConfigDataSourceService {
  rpConfigService;
  rpConfig$ = new BehaviorSubject(null);
  constructor(rpConfigService) {
    this.rpConfigService = rpConfigService;
    this.fetch();
  }
  fetch() {
    this.rpConfigService.getConfig().subscribe(it => {
      this.rpConfig$.next(it);
    });
  }
  connect() {
    return this.rpConfig$.asObservable();
  }
  save(config) {
    this.rpConfigService.saveConfig(config).pipe(tap(it => this.rpConfig$.next(it))).subscribe();
  }
  static ɵfac = function RpConfigDataSourceService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RpConfigDataSourceService)(i0.ɵɵinject(RpConfigService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RpConfigDataSourceService,
    factory: RpConfigDataSourceService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RpConfigDataSourceService, [{
    type: Injectable
  }], () => [{
    type: RpConfigService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class RpConfigComponent {
  rpConfigDatasourceService;
  config;
  constructor(rpConfigDatasourceService) {
    this.rpConfigDatasourceService = rpConfigDatasourceService;
  }
  ngOnInit() {
    this.rpConfigDatasourceService.connect().subscribe(it => {
      this.config = it;
    });
  }
  exportRpClient() {
    if (this.config !== null) {
      Util.exportJson(this.createClientObject(), 'rp-client');
    }
  }
  createClientObject() {
    return [{
      /* eslint-disable camelcase */
      client_id: this.config.clientId,
      client_secret: '',
      jwks_uri: this.config.jwkUrl,
      token_endpoint_auth_method: 'private_key_jwt',
      redirect_uris: [this.config.redirectUrl],
      post_logout_redirect_uris: [this.config.postLogoutRedirect]
      /* eslint-enable camelcase */
    }];
  }
  static ɵfac = function RpConfigComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RpConfigComponent)(i0.ɵɵdirectiveInject(RpConfigDataSourceService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: RpConfigComponent,
    selectors: [["rp-config"]],
    standalone: false,
    decls: 9,
    vars: 1,
    consts: [[1, "columns"], [1, "box", "column"], [1, "box-title"], ["class", "columns-table table-spaced-top", 4, "ngIf"], [1, "columns", "column-bottom"], [1, "column", "box"], [1, "is-primary", "button", "is-small", "is-pulled-right", 3, "click"], [1, "columns-table", "table-spaced-top"], [1, "columns-table-body", "columns", "is-multiline", "is-tablet"], [1, "column", "is-4"], [1, "column", "is-8", "info-value"]],
    template: function RpConfigComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, "RP Information");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, RpConfigComponent_div_4_Template, 36, 7, "div", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "button", 6);
        i0.ɵɵlistener("click", function RpConfigComponent_Template_button_click_7_listener() {
          return ctx.exportRpClient();
        });
        i0.ɵɵtext(8, "Exportera RP klient");
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.config);
      }
    },
    dependencies: [i2.NgIf],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RpConfigComponent, [{
    type: Component,
    args: [{
      selector: 'rp-config',
      template: "<div class=\"columns\">\n  <div class=\"box column\">\n    <div class=\"box-title\">RP Information</div>\n    <div class=\"columns-table table-spaced-top\" *ngIf=\"config\">\n      <div class=\"columns-table-body columns is-multiline is-tablet\">\n        <div class=\"column is-4\">\n          Klient ID\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ config.clientId }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\">\n        <div class=\"column is-4\">\n          Openid konfiguration URL\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ config.discoveryUrl }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\">\n        <div class=\"column is-4\">\n          JWK URL\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ config.jwkUrl }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\">\n        <div class=\"column is-4\">\n          Redirect URL\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ config.redirectUrl }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\">\n        <div class=\"column is-4\">\n          Logout Redirect URL\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ config.postLogoutRedirect }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\">\n        <div class=\"column is-4\">\n          Nyckelgrupp\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ config.certGroup }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\">\n        <div class=\"column is-4\">\n          Nyckel finns\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ config.existsKeyGroup ? 'Ja':'Nej' }}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"columns column-bottom\">\n  <div class=\"column box\">\n    <button class=\"is-primary button is-small is-pulled-right\" (click)=\"exportRpClient()\">Exportera RP klient</button>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: RpConfigDataSourceService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class RpConfigModule {
  static ɵfac = function RpConfigModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RpConfigModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: RpConfigModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [RpConfigService, RpConfigDataSourceService],
    imports: [CommonModule, ReactiveFormsModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RpConfigModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule],
      declarations: [RpConfigComponent],
      exports: [RpConfigComponent],
      providers: [RpConfigService, RpConfigDataSourceService]
    }]
  }], null, null);
})();
class LoginService {
  httpClient;
  apiUrl = '/api/authentication';
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  createRequest(forced) {
    return this.httpClient.get(`${this.apiUrl}/createRequest?forced=${forced}`);
  }
  createLogoutRequest() {
    return this.httpClient.get(this.apiUrl + '/createLogoutRequest');
  }
  logout() {
    return this.httpClient.get(this.apiUrl + '/logout');
  }
  static ɵfac = function LoginService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoginService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LoginService,
    factory: LoginService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LoginComponent {
  loginService;
  route;
  ngZone;
  form;
  authEndpoint;
  authRequest;
  constructor(loginService, route, ngZone) {
    this.loginService = loginService;
    this.route = route;
    this.ngZone = ngZone;
  }
  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      let forced = false;
      if (fragment && fragment === 'forced') {
        forced = true;
      }
      this.loginService.createRequest(forced).subscribe(it => {
        this.authEndpoint = it.endpoint;
        this.authRequest = {
          /* eslint-disable camelcase */
          client_id: it.authenticationRequest.client_id,
          scope: it.authenticationRequest.scope,
          response_type: it.authenticationRequest.response_type,
          state: it.authenticationRequest.state,
          request: it.authenticationRequest.request,
          nonce: it.authenticationRequest.nonce
          /* eslint-enable camelcase */
        };
        this.ngZone.onStable.subscribe(() => {
          this.form.nativeElement.submit();
        });
      });
    });
  }
  static ɵfac = function LoginComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoginComponent)(i0.ɵɵdirectiveInject(LoginService), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LoginComponent,
    selectors: [["login"]],
    viewQuery: function LoginComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.form = _t.first);
      }
    },
    standalone: false,
    decls: 10,
    vars: 7,
    consts: [["autologin", ""], [1, "centered", 2, "width", "100%"], [1, "loading-indicator-large"], ["ngNoForm", "", "method", "POST", 3, "action"], ["type", "hidden", "name", "client_id", 3, "value"], ["type", "hidden", "name", "scope", 3, "value"], ["type", "hidden", "name", "response_type", 3, "value"], ["type", "hidden", "name", "state", 3, "value"], ["type", "hidden", "name", "request", 3, "value"], ["type", "hidden", "name", "nonce", 3, "value"]],
    template: function LoginComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵelement(1, "div", 2);
        i0.ɵɵelementStart(2, "form", 3, 0);
        i0.ɵɵelement(4, "input", 4)(5, "input", 5)(6, "input", 6)(7, "input", 7)(8, "input", 8)(9, "input", 9);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("action", ctx.authEndpoint, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("value", ctx.authRequest == null ? null : ctx.authRequest.client_id);
        i0.ɵɵadvance();
        i0.ɵɵproperty("value", ctx.authRequest == null ? null : ctx.authRequest.scope);
        i0.ɵɵadvance();
        i0.ɵɵproperty("value", ctx.authRequest == null ? null : ctx.authRequest.response_type);
        i0.ɵɵadvance();
        i0.ɵɵproperty("value", ctx.authRequest == null ? null : ctx.authRequest.state);
        i0.ɵɵadvance();
        i0.ɵɵproperty("value", ctx.authRequest == null ? null : ctx.authRequest.request);
        i0.ɵɵadvance();
        i0.ɵɵproperty("value", ctx.authRequest == null ? null : ctx.authRequest.nonce);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginComponent, [{
    type: Component,
    args: [{
      selector: 'login',
      template: "<div class=\"centered\" style=\"width: 100%\">\n  <div class=\"loading-indicator-large\"></div>\n  <form #autologin ngNoForm [action]=\"authEndpoint\" method=\"POST\">\n    <input type=\"hidden\" name=\"client_id\" [value]=\"authRequest?.client_id\">\n    <input type=\"hidden\" name=\"scope\" [value]=\"authRequest?.scope\">\n    <input type=\"hidden\" name=\"response_type\" [value]=\"authRequest?.response_type\">\n    <input type=\"hidden\" name=\"state\" [value]=\"authRequest?.state\">\n    <input type=\"hidden\" name=\"request\" [value]=\"authRequest?.request\">\n    <input type=\"hidden\" name=\"nonce\" [value]=\"authRequest?.nonce\">\n  </form>\n</div>"
    }]
  }], () => [{
    type: LoginService
  }, {
    type: i1$1.ActivatedRoute
  }, {
    type: i0.NgZone
  }], {
    form: [{
      type: ViewChild,
      args: ['autologin']
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class PasswordLoginComponent {
  route;
  title = document.title;
  error;
  constructor(route) {
    this.route = route;
    this.route.queryParams.subscribe(params => {
      this.error = params.error;
    });
  }
  static ɵfac = function PasswordLoginComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PasswordLoginComponent)(i0.ɵɵdirectiveInject(i1$1.ActivatedRoute));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PasswordLoginComponent,
    selectors: [["password-login"]],
    standalone: false,
    decls: 24,
    vars: 2,
    consts: [[1, "base-container"], [1, "navbar", "login-navbar"], [1, "container", "level"], [1, "level-item"], [1, "flex", "flex-start"], [1, "is-size-3", "has-text-weight-semibold"], [1, "container"], [1, "columns", "is-centered"], [1, "card", "is-rounded", "login"], [1, "card-content"], [1, "title", "login-title"], ["class", "notification is-danger", 4, "ngIf"], ["ngNoForm", "", "method", "POST", "action", "/api/authentication/passwordlogin"], [1, "control", "has-icon", "login-input"], ["type", "username", "placeholder", "Anv\xE4ndare", "name", "username", 1, "input"], [1, "icon", "fa", "fa-user"], ["type", "password", "placeholder", "L\xF6senord", "name", "password", 1, "input"], [1, "icon", "fa", "fa-lock"], [1, "control", "login-input"], ["submit", "", 1, "button", "is-primary", "is-medium", "is-fullwidth"], [1, "notification", "is-danger"]],
    template: function PasswordLoginComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "nav", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "h1", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "article", 8)(10, "div", 9)(11, "h1", 10);
        i0.ɵɵtext(12, " Logga in ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, PasswordLoginComponent_div_13_Template, 2, 0, "div", 11);
        i0.ɵɵelementStart(14, "form", 12)(15, "p", 13);
        i0.ɵɵelement(16, "input", 14)(17, "span", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "p", 13);
        i0.ɵɵelement(19, "input", 16)(20, "span", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "p", 18)(22, "button", 19);
        i0.ɵɵtext(23, " Logga in ");
        i0.ɵɵelementEnd()()()()()()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.error);
      }
    },
    dependencies: [i2.NgIf],
    styles: [".login[_ngcontent-%COMP%]{margin-top:10%;width:270px}.login-input[_ngcontent-%COMP%]{margin:5px 0}.login-input[_ngcontent-%COMP%]:last-child{margin:15px 0}.login-title[_ngcontent-%COMP%]{text-align:center}.login-navbar[_ngcontent-%COMP%]{display:flex;flex:0 0 52px;flex-direction:column;box-shadow:0 0 5px #000000a8;position:relative}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordLoginComponent, [{
    type: Component,
    args: [{
      selector: 'password-login',
      template: "<div class=\"base-container\">\n  <nav class=\"navbar login-navbar\">\n    <div class=\"container level\">\n      <div class=\"level-item\">\n        <div class=\"flex flex-start\">\n          <h1 class=\"is-size-3 has-text-weight-semibold\">{{title}}</h1>\n        </div>\n      </div>\n    </div>\n  </nav>\n  <div class=\"container\">\n    <div class=\"columns is-centered\">\n      <article class=\" card is-rounded login\">\n        <div class=\"card-content\">\n          <h1 class=\"title login-title\">\n            Logga in\n          </h1>\n\n          <div *ngIf=\"error\" class=\"notification is-danger\">\n            Ogiltligt anv\u00E4ndarnamn eller l\u00F6senord.\n          </div>\n\n          <form ngNoForm method=\"POST\" action=\"/api/authentication/passwordlogin\">\n            <p class=\"control has-icon login-input\">\n              <input class=\"input\" type=\"username\" placeholder=\"Anv\u00E4ndare\" name=\"username\">\n              <span class=\"icon fa fa-user\"></span>\n            </p>\n            <p class=\"control has-icon login-input\">\n              <input class=\"input\" type=\"password\" placeholder=\"L\u00F6senord\" name=\"password\">\n              <span class=\"icon fa fa-lock\"></span>\n            </p>\n            <p class=\"control login-input\">\n              <button submit class=\"button is-primary is-medium is-fullwidth\">\n                Logga in\n              </button>\n            </p>\n          </form>\n        </div>\n      </article>\n    </div>\n  </div>\n</div>",
      styles: [".login{margin-top:10%;width:270px}.login-input{margin:5px 0}.login-input:last-child{margin:15px 0}.login-title{text-align:center}.login-navbar{display:flex;flex:0 0 52px;flex-direction:column;box-shadow:0 0 5px #000000a8;position:relative}\n"]
    }]
  }], () => [{
    type: i1$1.ActivatedRoute
  }], null);
})();
class UserInformationUtil {
  static MAX_LENGTH = 150;
  static getUserInformationString(user) {
    let userInformation = '';
    if (!user) {
      return userInformation;
    }
    if (user.name) {
      userInformation += user.name;
      userInformation += '\n';
    }
    if (user.commissionName) {
      const userInformationLength = this.getUserInformationLength(user);
      if (userInformationLength < this.MAX_LENGTH) {
        userInformation += user.commissionName;
      } else {
        const diffInLength = userInformationLength - this.MAX_LENGTH;
        userInformation += this.truncate(user.commissionName, user.commissionName.length - diffInLength);
      }
    }
    if (user.healthCareProviderName) {
      if (userInformation.length) {
        userInformation += ' för ';
      }
      userInformation += user.healthCareProviderName;
    }
    return userInformation;
  }
  static getUserInformationLength(user) {
    let userInformationLength = 0;
    userInformationLength += user.name.length;
    userInformationLength += ', '.length;
    userInformationLength += (user.commissionName ? user.commissionName : '').length;
    userInformationLength += ' för '.length;
    userInformationLength += (user.healthCareProviderName ? user.healthCareProviderName : '').length;
    return userInformationLength;
  }
  static truncate(text, maxLength) {
    let adjustedLength = 0;
    if (maxLength > text.length) {
      adjustedLength = text.length;
    } else if (maxLength < 10) {
      adjustedLength = 10;
    } else {
      adjustedLength = maxLength;
    }
    return text.length > maxLength ? text.substring(0, adjustedLength) + '...' : text;
  }
}

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class UserService {
  httpClient;
  apiUrl = '/api/user';
  user = new BehaviorSubject(null);
  userInformationString = new BehaviorSubject('');
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  getUser() {
    if (this.user.getValue()) {
      return of(this.user.getValue());
    } else {
      return this.get().pipe(tap(user => {
        this.setUser(user);
      }));
    }
  }
  getUserSnapshot() {
    return this.user.value;
  }
  setUser(user) {
    this.user.next(user);
    this.userInformationString.next(UserInformationUtil.getUserInformationString(user));
  }
  ensureUserFetched(handler) {
    const user = this.getUserSnapshot();
    if (user) {
      return of(true);
    }
    const httpClient = new HttpClient(handler);
    return httpClient.get(this.apiUrl).pipe(switchMap(user => {
      this.setUser(user);
      return of(true);
    }));
  }
  connect() {
    return this.user.asObservable();
  }
  connectUserInformationString() {
    return this.userInformationString.asObservable();
  }
  get() {
    return this.httpClient.get(this.apiUrl);
  }
  static ɵfac = function UserService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UserService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserService,
    factory: UserService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
class GeneralConfigService {
  http;
  config = null;
  apiUrl = 'api/general/config';
  constructor(http) {
    this.http = http;
  }
  isSecured() {
    if (this.config) {
      return this.config.secured;
    }
    return undefined;
  }
  getTitle() {
    if (this.config) {
      return this.config.title;
    }
    return undefined;
  }
  getConfig() {
    if (this.config === null) {
      return this.http.get(this.apiUrl).pipe(tap(it => this.config = it), map(it => it));
    } else {
      return of(this.config);
    }
  }
  static ɵfac = function GeneralConfigService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GeneralConfigService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GeneralConfigService,
    factory: GeneralConfigService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GeneralConfigService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
class AuthenticateGuard {
  router;
  userService;
  generalConfigService;
  handler;
  constructor(router, userService, generalConfigService, handler) {
    this.router = router;
    this.userService = userService;
    this.generalConfigService = generalConfigService;
    this.handler = handler;
  }
  canActivate(route) {
    let redirect = route.data['redirect'];
    const onError = route.data['onError'];
    if (!redirect) {
      redirect = 'login';
    }
    return this.generalConfigService.getConfig().pipe(switchMap(config => {
      if (config.secured) {
        return this.userService.ensureUserFetched(this.handler).pipe(catchError(err => {
          if (onError) {
            onError(err, this.router);
          } else {
            this.router.navigate([redirect]);
          }
          return of(false);
        }));
      } else {
        return of(true);
      }
    }), catchError(() => of(false)));
  }
  static ɵfac = function AuthenticateGuard_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthenticateGuard)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(UserService), i0.ɵɵinject(GeneralConfigService), i0.ɵɵinject(i1.HttpBackend));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AuthenticateGuard,
    factory: AuthenticateGuard.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthenticateGuard, [{
    type: Injectable
  }], () => [{
    type: i1$1.Router
  }, {
    type: UserService
  }, {
    type: GeneralConfigService
  }, {
    type: i1.HttpBackend
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
var SecurityLevel;
(function (SecurityLevel) {
  SecurityLevel["OIDC"] = "OIDC";
  SecurityLevel["PASSWORD"] = "PASSWORD";
  SecurityLevel["NONE"] = "NONE";
})(SecurityLevel || (SecurityLevel = {}));
class PasswordLoginGuard {
  router;
  generalConfigService;
  constructor(router, generalConfigService) {
    this.router = router;
    this.generalConfigService = generalConfigService;
  }
  canActivate(route, state) {
    return this.generalConfigService.getConfig().pipe(map(config => {
      if (config.securityLevel === SecurityLevel.PASSWORD) {
        return true;
      }
      this.router.navigate(['']);
      return false;
    }));
  }
  static ɵfac = function PasswordLoginGuard_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PasswordLoginGuard)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(GeneralConfigService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PasswordLoginGuard,
    factory: PasswordLoginGuard.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordLoginGuard, [{
    type: Injectable
  }], () => [{
    type: i1$1.Router
  }, {
    type: GeneralConfigService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LoginModule {
  static ɵfac = function LoginModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoginModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: LoginModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [AuthenticateGuard, PasswordLoginGuard],
    imports: [CommonModule, RouterModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule],
      declarations: [LoginComponent, PasswordLoginComponent],
      exports: [LoginComponent, PasswordLoginComponent],
      providers: [AuthenticateGuard, PasswordLoginGuard]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
var LevelOfAssurance;
(function (LevelOfAssurance) {
  LevelOfAssurance["LOA_2"] = "http://id.sambi.se/loa/loa2";
  LevelOfAssurance["LOA_3"] = "http://id.sambi.se/loa/loa3";
  LevelOfAssurance["LOA_4"] = "http://id.sambi.se/loa/loa4";
})(LevelOfAssurance || (LevelOfAssurance = {}));

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LogoutComponent {
  router;
  loginService;
  generalConfigService;
  options;
  name = 'Logga ut';
  internalOptions = {
    smallButton: true,
    disabled: false
  };
  constructor(router, loginService, generalConfigService) {
    this.router = router;
    this.loginService = loginService;
    this.generalConfigService = generalConfigService;
  }
  ngOnChanges(changes) {
    if (changes['options']) {
      this.internalOptions = Object.assign(this.internalOptions, changes['options'].currentValue);
    }
  }
  logout() {
    if (this.generalConfigService.isSecured()) {
      this.loginService.createLogoutRequest().subscribe(it => {
        this.idpLogout(it.logoutRequestUrl);
        this.loginService.logout().subscribe(() => {
          // do nothing
        });
      }, err => {
        this.unSecuredLogout();
      });
    } else {
      this.unSecuredLogout();
    }
  }
  unSecuredLogout() {
    this.loginService.logout().subscribe(() => {
      this.router.navigate(['/loggedout']);
    }, err => {
      this.router.navigate(['/loggedout']);
    });
  }
  idpLogout(request) {
    window.location.href = request;
  }
  static ɵfac = function LogoutComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LogoutComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(LoginService), i0.ɵɵdirectiveInject(GeneralConfigService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LogoutComponent,
    selectors: [["logout"]],
    inputs: {
      options: "options",
      name: "name"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 9,
    consts: [[1, "button", 3, "click", "disabled"], ["class", "logout-icon", 4, "ngIf"], [1, "logout-icon"], [1, "fas", "fa-sign-out-alt"]],
    template: function LogoutComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function LogoutComponent_Template_button_click_0_listener() {
          return ctx.logout();
        });
        i0.ɵɵtemplate(1, LogoutComponent_span_1_Template, 2, 0, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("is-small", ctx.internalOptions.smallButton)("text-button", ctx.internalOptions.textButton)("is-primary", !ctx.internalOptions.textButton);
        i0.ɵɵproperty("disabled", ctx.internalOptions.disabled);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.internalOptions.textButton);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.name, "\n");
      }
    },
    dependencies: [i2.NgIf],
    styles: [".logout-icon[_ngcontent-%COMP%]{margin-right:5px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutComponent, [{
    type: Component,
    args: [{
      selector: 'logout',
      template: "<button class=\"button\" [class.is-small]=\"internalOptions.smallButton\" [class.text-button]=\"internalOptions.textButton\"\n  [class.is-primary]=\"!internalOptions.textButton\" [disabled]=\"internalOptions.disabled\" (click)=\"logout()\">\n  <span class=\"logout-icon\" *ngIf=\"!internalOptions.textButton\">\n    <span class=\"fas fa-sign-out-alt\"></span>\n  </span>\n  {{ name }}\n</button>",
      styles: [".logout-icon{margin-right:5px}\n"]
    }]
  }], () => [{
    type: i1$1.Router
  }, {
    type: LoginService
  }, {
    type: GeneralConfigService
  }], {
    options: [{
      type: Input
    }],
    name: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LogoutModule {
  static ɵfac = function LogoutModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LogoutModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: LogoutModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [LogoutComponent],
      exports: [LogoutComponent],
      providers: []
    }]
  }], null, null);
})();
class AuthorizeContextDirective {
  userService;
  generalConfigService;
  resource;
  multiresource;
  resources;
  validActions = [];
  validActionChanges = new BehaviorSubject([]);
  invalidActions = [];
  invalidActionChanges = new BehaviorSubject([]);
  privileges = null;
  constructor(userService, generalConfigService) {
    this.userService = userService;
    this.generalConfigService = generalConfigService;
  }
  ngOnInit() {
    this.userService.connect().subscribe(it => {
      if (it) {
        this.privileges = it.privileges;
        this.evaluate();
      }
    });
  }
  ngOnChanges(changes) {
    if (changes.resource) {
      this.resources = Util.getSubset(this.resource, '.');
      this.evaluate();
    } else if (changes.multiresource) {
      this.resources = [];
      for (const res of this.multiresource) {
        this.resources.push(...Util.getSubset(res, '.'));
      }
      this.evaluate();
    }
  }
  isSecured() {
    return this.generalConfigService.isSecured();
  }
  connectValid() {
    return this.validActionChanges.asObservable();
  }
  connectInvalid() {
    return this.invalidActionChanges.asObservable();
  }
  evaluate() {
    if ((this.resource || this.multiresource) && this.privileges) {
      this.validActions = this.evaluateValidActions();
      this.validActionChanges.next(this.validActions);
      this.invalidActions = this.evaluateInvalidActions();
      this.invalidActionChanges.next(this.invalidActions);
    }
  }
  evaluateValidActions() {
    return this.privileges.filter(it => this.resources.indexOf(it.name) !== -1).map(it => it.action);
  }
  evaluateInvalidActions() {
    if (this.validActions.includes('READ') && this.validActions.includes('WRITE')) {
      return [];
    } else if (this.validActions.includes('READ') && !this.validActions.includes('WRITE')) {
      return ['WRITE'];
    } else if (!this.validActions.includes('READ') && this.validActions.includes('WRITE')) {
      return ['READ'];
    } else {
      return ['READ', 'WRITE'];
    }
  }
  static ɵfac = function AuthorizeContextDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeContextDirective)(i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(GeneralConfigService));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeContextDirective,
    selectors: [["", "authorize-context", ""]],
    inputs: {
      resource: "resource",
      multiresource: "multiresource"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeContextDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-context]'
    }]
  }], () => [{
    type: UserService
  }, {
    type: GeneralConfigService
  }], {
    resource: [{
      type: Input
    }],
    multiresource: [{
      type: Input
    }]
  });
})();
class PrivilegeGuard {
  router;
  userService;
  generalConfigService;
  constructor(router, userService, generalConfigService) {
    this.router = router;
    this.userService = userService;
    this.generalConfigService = generalConfigService;
  }
  canActivate(route, state) {
    const privilege = route.data['privilege'];
    const privileges = route.data['privileges'];
    const redirect = route.data['redirect'];
    return this.generalConfigService.getConfig().pipe(switchMap(config => {
      if (config.secured) {
        return this.userService.getUser().pipe(switchMap(user => {
          if (user) {
            const subSet = this.getPrivilegeSubset(privilege, privileges);
            for (const priv of user.privileges) {
              for (const privilegeSet of subSet) {
                if (privilegeSet.subSet.includes(priv.name) && privilegeSet.privilege.actions.includes(priv.action)) {
                  return of(true);
                }
              }
            }
          }
          return this.reject(redirect);
        }), catchError(() => this.reject(redirect)));
      } else {
        return of(true);
      }
    }), catchError(() => of(false)));
  }
  reject(redirect) {
    this.router.navigate([redirect]);
    return of(false);
  }
  getPrivilegeSubset(privilege, privileges) {
    const subset = [];
    if (privilege) {
      subset.push({
        privilege: privilege,
        subSet: Util.getSubset(privilege.name, '.')
      });
    } else {
      for (const priv of privileges) {
        subset.push({
          privilege: priv,
          subSet: Util.getSubset(priv.name, '.')
        });
      }
    }
    return subset;
  }
  static ɵfac = function PrivilegeGuard_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PrivilegeGuard)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(UserService), i0.ɵɵinject(GeneralConfigService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PrivilegeGuard,
    factory: PrivilegeGuard.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrivilegeGuard, [{
    type: Injectable
  }], () => [{
    type: i1$1.Router
  }, {
    type: UserService
  }, {
    type: GeneralConfigService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeValidBase {
  context;
  validActions = [];
  constructor(context) {
    this.context = context;
  }
  ngOnInit() {
    this.context.connectValid().subscribe(it => {
      this.validActions = it;
      this.evaluateValidActions();
    });
    this.evaluateValidActions();
  }
  evaluateValidActions() {
    let authorized = false;
    for (let i = 0; i < this.validActions.length; i++) {
      const action = this.validActions[i];
      if (this.evaluateValidAction(action)) {
        authorized = true;
        break;
      }
    }
    this.applyValidResult(authorized);
  }
  static ɵfac = function AuthorizeValidBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeValidBase)(i0.ɵɵdirectiveInject(AuthorizeContextDirective));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeValidBase,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeValidBase, [{
    type: Directive
  }], () => [{
    type: AuthorizeContextDirective
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class Authorize extends AuthorizeValidBase {
  context;
  templateRef;
  viewContainer;
  hasView = false;
  constructor(context, templateRef, viewContainer) {
    super(context);
    this.context = context;
    this.templateRef = templateRef;
    this.viewContainer = viewContainer;
  }
  applyValidResult(render) {
    const secured = this.context.isSecured();
    if (secured === false) {
      if (!this.hasView) {
        this.renderTemplate();
      }
    } else {
      if (render && !this.hasView && secured !== null) {
        this.renderTemplate();
      } else if (!render && this.hasView) {
        this.clear();
      }
    }
  }
  renderTemplate() {
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.hasView = true;
  }
  clear() {
    this.viewContainer.clear();
    this.hasView = false;
  }
  static ɵfac = function Authorize_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || Authorize)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: Authorize,
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Authorize, [{
    type: Directive
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeReadDirective extends Authorize {
  constructor(context, templateRef, viewContainer) {
    super(context, templateRef, viewContainer);
  }
  evaluateValidAction(action) {
    return action.indexOf('READ') !== -1;
  }
  static ɵfac = function AuthorizeReadDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeReadDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeReadDirective,
    selectors: [["", "authorize-read", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeReadDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-read]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeWriteDirective extends Authorize {
  constructor(context, templateRef, viewContainer) {
    super(context, templateRef, viewContainer);
  }
  evaluateValidAction(action) {
    return action.indexOf('WRITE') !== -1;
  }
  static ɵfac = function AuthorizeWriteDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeWriteDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeWriteDirective,
    selectors: [["", "authorize-write", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeWriteDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-write]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeReadWriteDirective extends Authorize {
  constructor(context, templateRef, viewContainer) {
    super(context, templateRef, viewContainer);
  }
  evaluateValidAction(action) {
    return action.indexOf('READ') !== -1 || action.indexOf('WRITE') !== -1;
  }
  static ɵfac = function AuthorizeReadWriteDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeReadWriteDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeReadWriteDirective,
    selectors: [["", "authorize-read-write", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeReadWriteDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-read-write]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeInvalidBase {
  context;
  invalidActions = [];
  constructor(context) {
    this.context = context;
  }
  ngOnInit() {
    this.context.connectInvalid().subscribe(it => {
      this.invalidActions = it;
      this.evaluateInvalidActions();
    });
    this.evaluateInvalidActions();
  }
  evaluateInvalidActions() {
    let unauthorized = false;
    for (let i = 0; i < this.invalidActions.length; i++) {
      const action = this.invalidActions[i];
      if (this.evaluateInvalidAction(action)) {
        unauthorized = true;
        break;
      }
    }
    this.applyInvalidResult(unauthorized);
  }
  static ɵfac = function AuthorizeInvalidBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeInvalidBase)(i0.ɵɵdirectiveInject(AuthorizeContextDirective));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeInvalidBase,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeInvalidBase, [{
    type: Directive
  }], () => [{
    type: AuthorizeContextDirective
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeInfo extends AuthorizeInvalidBase {
  context;
  templateRef;
  viewContainer;
  hasView = false;
  constructor(context, templateRef, viewContainer) {
    super(context);
    this.context = context;
    this.templateRef = templateRef;
    this.viewContainer = viewContainer;
  }
  applyInvalidResult(unauthorized) {
    const secured = this.context.isSecured();
    if (secured === false) {
      if (this.hasView) {
        this.clear();
      }
    } else {
      if (unauthorized && !this.hasView && secured !== null) {
        this.renderTemplate();
      } else if (!unauthorized && this.hasView) {
        this.clear();
      }
    }
  }
  renderTemplate() {
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.hasView = true;
  }
  clear() {
    this.viewContainer.clear();
    this.hasView = false;
  }
  static ɵfac = function AuthorizeInfo_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeInfo)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeInfo,
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeInfo, [{
    type: Directive
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeInfoReadDirective extends AuthorizeInfo {
  constructor(context, templateRef, viewContainer) {
    super(context, templateRef, viewContainer);
  }
  evaluateInvalidAction(action) {
    return action.indexOf('READ') !== -1;
  }
  static ɵfac = function AuthorizeInfoReadDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeInfoReadDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeInfoReadDirective,
    selectors: [["", "authorize-info-read", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeInfoReadDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-info-read]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeInfoWriteDirective extends AuthorizeInfo {
  constructor(context, templateRef, viewContainer) {
    super(context, templateRef, viewContainer);
  }
  evaluateInvalidAction(action) {
    return action.indexOf('WRITE') !== -1;
  }
  static ɵfac = function AuthorizeInfoWriteDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeInfoWriteDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeInfoWriteDirective,
    selectors: [["", "authorize-info-write", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeInfoWriteDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-info-write]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeInfoReadWriteDirective extends AuthorizeInfo {
  constructor(context, templateRef, viewContainer) {
    super(context, templateRef, viewContainer);
  }
  evaluateInvalidAction(action) {
    return action.indexOf('READ') !== -1 || action.indexOf('WRITE') !== -1;
  }
  static ɵfac = function AuthorizeInfoReadWriteDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeInfoReadWriteDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeInfoReadWriteDirective,
    selectors: [["", "authorize-info-read-write", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeInfoReadWriteDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-info-read-write]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.TemplateRef
  }, {
    type: i0.ViewContainerRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeDisable extends AuthorizeValidBase {
  context;
  elementRef;
  forceDisable = false;
  constructor(context, elementRef) {
    super(context);
    this.context = context;
    this.elementRef = elementRef;
  }
  ngOnChanges(changes) {
    if (changes['forceDisable']) {
      super.evaluateValidActions();
    }
  }
  applyValidResult(authorized) {
    const secured = this.context.isSecured();
    if (secured === false) {
      this.enableElement();
    } else {
      if (authorized && secured !== null) {
        this.enableElement();
      } else {
        this.disableElement();
      }
      if (this.forceDisable) {
        this.disableElement();
      }
    }
  }
  enableElement() {
    this.elementRef.nativeElement.disabled = false;
  }
  disableElement() {
    this.elementRef.nativeElement.disabled = true;
  }
  static ɵfac = function AuthorizeDisable_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeDisable)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeDisable,
    inputs: {
      forceDisable: "forceDisable"
    },
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeDisable, [{
    type: Directive
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.ElementRef
  }], {
    forceDisable: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeDisableReadDirective extends AuthorizeDisable {
  constructor(context, elementRef) {
    super(context, elementRef);
  }
  evaluateValidAction(action) {
    return action.indexOf('READ') !== -1;
  }
  static ɵfac = function AuthorizeDisableReadDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeDisableReadDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeDisableReadDirective,
    selectors: [["", "authorize-disable-read", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeDisableReadDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-disable-read]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.ElementRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeDisableWriteDirective extends AuthorizeDisable {
  constructor(context, elementRef) {
    super(context, elementRef);
  }
  evaluateValidAction(action) {
    return action.indexOf('WRITE') !== -1;
  }
  static ɵfac = function AuthorizeDisableWriteDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeDisableWriteDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeDisableWriteDirective,
    selectors: [["", "authorize-disable-write", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeDisableWriteDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-disable-write]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.ElementRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeDisableReadWriteDirective extends AuthorizeDisable {
  constructor(context, elementRef) {
    super(context, elementRef);
  }
  evaluateValidAction(action) {
    return action.indexOf('READ') !== -1 || action.indexOf('WRITE') !== -1;
  }
  static ɵfac = function AuthorizeDisableReadWriteDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeDisableReadWriteDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeDisableReadWriteDirective,
    selectors: [["", "authorize-disable-read-write", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeDisableReadWriteDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-disable-read-write]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.ElementRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeStyle extends AuthorizeValidBase {
  context;
  elementRef;
  classes = ['authorized', 'unauthorized'];
  forceAuthorize = false;
  forceUnauthorize = false;
  constructor(context, elementRef) {
    super(context);
    this.context = context;
    this.elementRef = elementRef;
  }
  ngOnChanges(changes) {
    if (changes['forceAuthorize'] || changes['forceUnauthorize']) {
      super.evaluateValidActions();
    }
  }
  applyValidResult(authorized) {
    const secured = this.context.isSecured();
    if (secured === false) {
      this.applyAuthorizedStyle();
    } else {
      if (authorized && secured !== null) {
        this.applyAuthorizedStyle();
      } else {
        this.applyUnAuthorizedStyle();
      }
      if (this.forceAuthorize && !this.forceUnauthorize) {
        this.applyAuthorizedStyle();
      } else if (this.forceUnauthorize && !this.forceAuthorize) {
        this.applyUnAuthorizedStyle();
      }
    }
  }
  applyAuthorizedStyle() {
    this.elementRef.nativeElement.classList.add(this.classes[0]);
    this.elementRef.nativeElement.classList.remove(this.classes[1]);
  }
  applyUnAuthorizedStyle() {
    this.elementRef.nativeElement.classList.add(this.classes[1]);
    this.elementRef.nativeElement.classList.remove(this.classes[0]);
  }
  static ɵfac = function AuthorizeStyle_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeStyle)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeStyle,
    inputs: {
      classes: "classes",
      forceAuthorize: "forceAuthorize",
      forceUnauthorize: "forceUnauthorize"
    },
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeStyle, [{
    type: Directive
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.ElementRef
  }], {
    classes: [{
      type: Input
    }],
    forceAuthorize: [{
      type: Input
    }],
    forceUnauthorize: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeStyleReadDirective extends AuthorizeStyle {
  constructor(context, elementRef) {
    super(context, elementRef);
  }
  evaluateValidAction(action) {
    return action.indexOf('READ') !== -1;
  }
  static ɵfac = function AuthorizeStyleReadDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeStyleReadDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeStyleReadDirective,
    selectors: [["", "authorize-style-read", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeStyleReadDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-style-read]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.ElementRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeStyleWriteDirective extends AuthorizeStyle {
  constructor(context, elementRef) {
    super(context, elementRef);
  }
  evaluateValidAction(action) {
    return action.indexOf('WRITE') !== -1;
  }
  static ɵfac = function AuthorizeStyleWriteDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeStyleWriteDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeStyleWriteDirective,
    selectors: [["", "authorize-style-write", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeStyleWriteDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-style-write]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.ElementRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeStyleReadWriteDirective extends AuthorizeStyle {
  constructor(context, elementRef) {
    super(context, elementRef);
  }
  evaluateValidAction(action) {
    return action.indexOf('READ') !== -1 || action.indexOf('WRITE') !== -1;
  }
  static ɵfac = function AuthorizeStyleReadWriteDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeStyleReadWriteDirective)(i0.ɵɵdirectiveInject(AuthorizeContextDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AuthorizeStyleReadWriteDirective,
    selectors: [["", "authorize-style-read-write", ""]],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeStyleReadWriteDirective, [{
    type: Directive,
    args: [{
      selector: '[authorize-style-read-write]'
    }]
  }], () => [{
    type: AuthorizeContextDirective
  }, {
    type: i0.ElementRef
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AuthorizeModule {
  static ɵfac = function AuthorizeModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthorizeModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: AuthorizeModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [PrivilegeGuard],
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizeModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [AuthorizeContextDirective, AuthorizeReadDirective, AuthorizeWriteDirective, AuthorizeReadWriteDirective, AuthorizeInfoReadDirective, AuthorizeInfoWriteDirective, AuthorizeInfoReadWriteDirective, AuthorizeDisableReadDirective, AuthorizeDisableWriteDirective, AuthorizeDisableReadWriteDirective, AuthorizeStyleReadDirective, AuthorizeStyleWriteDirective, AuthorizeStyleReadWriteDirective],
      exports: [AuthorizeContextDirective, AuthorizeReadDirective, AuthorizeWriteDirective, AuthorizeReadWriteDirective, AuthorizeInfoReadDirective, AuthorizeInfoWriteDirective, AuthorizeInfoReadWriteDirective, AuthorizeDisableReadDirective, AuthorizeDisableWriteDirective, AuthorizeDisableReadWriteDirective, AuthorizeStyleReadDirective, AuthorizeStyleWriteDirective, AuthorizeStyleReadWriteDirective],
      providers: [PrivilegeGuard]
    }]
  }], null, null);
})();
class BrowserConfigService {
  http;
  apiUrl = '/api';
  constructor(http) {
    this.http = http;
  }
  getConfig() {
    return this.http.get(`${this.apiUrl}/browser-config`);
  }
  static ɵfac = function BrowserConfigService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BrowserConfigService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BrowserConfigService,
    factory: BrowserConfigService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BrowserConfigService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
class BrowserGuard {
  router;
  browserConfigService;
  constructor(router, browserConfigService) {
    this.router = router;
    this.browserConfigService = browserConfigService;
  }
  canActivate(route, state) {
    const userBrowser = Bowser.getParser(window.navigator.userAgent);
    return this.browserConfigService.getConfig().pipe(map(browsers => {
      const matchingBrowser = browsers.find(unsupportedBrowser => unsupportedBrowser.name === userBrowser.getBrowserName());
      if (matchingBrowser) {
        const lessThanOrEqual = '<=';
        const browserIsUnsupported = userBrowser.satisfies({
          [matchingBrowser.name]: lessThanOrEqual + matchingBrowser.version
        });
        if (browserIsUnsupported) {
          this.router.navigate(['unsupportedpage']);
          return false;
        }
      }
      return true;
    }));
  }
  static ɵfac = function BrowserGuard_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BrowserGuard)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(BrowserConfigService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BrowserGuard,
    factory: BrowserGuard.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BrowserGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.Router
  }, {
    type: BrowserConfigService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TlsService {
  http;
  apiUrl;
  constructor(http) {
    this.http = http;
    this.apiUrl = '/api/pkix';
  }
  getTrusts() {
    return this.http.get(`${this.apiUrl}/trusts`);
  }
  importCertificate(certificate) {
    const formData = new FormData();
    formData.append('caCertFile', certificate.caCertFile);
    return this.http.post(`${this.apiUrl}/add-ca`, formData);
  }
  updateCertificate(certificate) {
    return this.http.post(`${this.apiUrl}/update-ca`, certificate);
  }
  deleteCertificate(thumbPrint) {
    return this.http.delete(`${this.apiUrl}/delete-ca?thumbPrint=${thumbPrint}`);
  }
  exportCertificate(thumbPrint) {
    window.location.href = `${this.apiUrl}/download-ca?thumbPrint=${thumbPrint}`;
  }
  downLoadIdentity(group, thumbPrint) {
    window.location.href = `${this.apiUrl}/download-identity-ca?group=${group}&thumbPrint=${thumbPrint}`;
  }
  getGroups() {
    return this.http.get(`${this.apiUrl}/groups`);
  }
  deleteGroup(group) {
    return this.http.delete(`${this.apiUrl}/delete-group?group=${group}`);
  }
  getTrustHolders() {
    return this.http.get(`${this.apiUrl}/trustholders`);
  }
  addTrustHolder(trustHolder) {
    return this.http.post(`${this.apiUrl}/add-trustholder`, trustHolder);
  }
  deleteTrustHolder(trustHolderEntityId) {
    return this.http.delete(`${this.apiUrl}/delete-trustholder?trustHolderEntityId=${trustHolderEntityId}`);
  }
  addIdentity(identity) {
    const form = new FormData();
    form.append('file', identity.file);
    form.append('group', identity.group);
    form.append('type', identity.type);
    form.append('storePwd', identity.storePassword);
    form.append('keyPwd', identity.keyPassword);
    return this.http.post(`${this.apiUrl}/add-identity`, form);
  }
  deleteIdentity(groupName, thumbPrint) {
    return this.http.delete(`${this.apiUrl}/delete-identity?group=${groupName}&thumbPrint=${thumbPrint}`);
  }
  changeActiveIdentity(groupName, thumbPrint) {
    return this.http.put(`${this.apiUrl}/change-identity?group=${groupName}&thumbPrint=${thumbPrint}`, {});
  }
  static ɵfac = function TlsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TlsService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TlsService,
    factory: TlsService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TlsService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DialogService {
  dialog = new Subject();
  dialogSelection$;
  connect() {
    return this.dialog.asObservable();
  }
  open(dialog) {
    this.dialogSelection$ = new Subject();
    this.dialog.next(dialog);
    return this.dialogSelection$;
  }
  static ɵfac = function DialogService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DialogService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DialogService,
    factory: DialogService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogService, [{
    type: Injectable
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class IdentityDataSource {
  tlsService;
  groups = new BehaviorSubject([]);
  constructor(tlsService) {
    this.tlsService = tlsService;
    this.fetch();
  }
  fetch() {
    this.tlsService.getGroups().subscribe(result => {
      this.groups.next(result);
    });
  }
  connect() {
    return this.groups.asObservable();
  }
  static ɵfac = function IdentityDataSource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IdentityDataSource)(i0.ɵɵinject(TlsService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IdentityDataSource,
    factory: IdentityDataSource.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdentityDataSource, [{
    type: Injectable
  }], () => [{
    type: TlsService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class UploadComponent {
  uploadElement;
  options = {
    showImport: false,
    small: false,
    validFileTypes: []
  };
  name = 'Importera';
  import = new EventEmitter();
  importRaw = new EventEmitter();
  uploaded = new EventEmitter();
  type = new EventEmitter();
  fileName = 'Ingen fil har valts';
  fileType = '';
  file;
  upload(event) {
    const files = event.target['files'];
    this.uploadFileList(files);
  }
  uploadFileList(files) {
    if (files.length > 0) {
      this.file = files[0];
      this.fileName = this.file.name;
      this.fileType = this.getFileExtension(this.fileName);
      this.type.emit(this.fileType);
      this.uploaded.emit(this.file);
    }
  }
  onImport() {
    this.importRaw.emit(this.file);
    this.convertFileToString(this.file).subscribe(result => {
      this.import.emit(result);
    });
    this.clear();
  }
  clear() {
    this.fileName = 'Ingen fil har valts';
    this.uploadElement.nativeElement.value = '';
    this.file = null;
  }
  getFileExtension(fileName) {
    const regex = new RegExp('.[0-9a-z]+$', 'i');
    return regex[Symbol.match](fileName)[0];
  }
  convertFileToString(file) {
    return new Observable(obs => {
      const fileReader = new FileReader();
      try {
        fileReader.onload = () => {
          obs.next(fileReader.result);
          obs.complete();
        };
      } catch (err) {
        obs.error(err);
        obs.complete();
      }
      fileReader.readAsText(file);
    });
  }
  static ɵfac = function UploadComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UploadComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: UploadComponent,
    selectors: [["file-upload"]],
    viewQuery: function UploadComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c1, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.uploadElement = _t.first);
      }
    },
    inputs: {
      options: "options",
      name: "name"
    },
    outputs: {
      import: "import",
      importRaw: "importRaw",
      uploaded: "uploaded",
      type: "type"
    },
    standalone: false,
    decls: 13,
    vars: 7,
    consts: [["uploadInput", ""], [1, "file-container"], [1, "file", "has-name"], [1, "file-label"], ["type", "file", "name", "resume", 1, "file-input", 3, "change", "accept"], [1, "file-cta"], [1, "file-icon"], [1, "fas", "fa-upload"], [1, "file-name"], ["class", "button", 3, "is-small", "is-static", "is-primary", "click", 4, "ngIf"], [1, "button", 3, "click"]],
    template: function UploadComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "label", 3)(3, "input", 4, 0);
        i0.ɵɵlistener("change", function UploadComponent_Template_input_change_3_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.upload($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 5)(6, "span", 6);
        i0.ɵɵelement(7, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span", 3);
        i0.ɵɵtext(9, " V\xE4lj en fil ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "span", 8);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(12, UploadComponent_button_12_Template, 2, 7, "button", 9);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("spacebetween", ctx.options.spacebetween);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("is-small", ctx.options.small);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("accept", ctx.options.validFileTypes);
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate1(" ", ctx.fileName, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.options.showImport);
      }
    },
    dependencies: [i2.NgIf],
    styles: [".file-container[_ngcontent-%COMP%]{display:flex}.file-container.spacebetween[_ngcontent-%COMP%]{justify-content:space-between}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadComponent, [{
    type: Component,
    args: [{
      selector: 'file-upload',
      template: "<div class=\"file-container\" [class.spacebetween]=\"options.spacebetween\">\n  <div class=\"file has-name\" [class.is-small]=\"options.small\">\n    <label class=\"file-label\">\n      <input #uploadInput class=\"file-input\" type=\"file\" [accept]=\"options.validFileTypes\" name=\"resume\" (change)=\"upload($event)\">\n      <span class=\"file-cta\">\n        <span class=\"file-icon\">\n          <span class=\"fas fa-upload\"></span>\n        </span>\n        <span class=\"file-label\">\n          V\u00E4lj en fil\n        </span>\n      </span>\n      <span class=\"file-name\">\n        {{ fileName }}\n      </span>\n    </label>\n  </div>\n\n  <button *ngIf=\"options.showImport\" class=\"button\" [class.is-small]=\"options.small\" [class.is-static]=\"!file\" [class.is-primary]=\"file\"\n    (click)=\"onImport()\">{{name}}</button>\n</div>\n",
      styles: [".file-container{display:flex}.file-container.spacebetween{justify-content:space-between}\n"]
    }]
  }], null, {
    uploadElement: [{
      type: ViewChild,
      args: ['uploadInput']
    }],
    options: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    import: [{
      type: Output
    }],
    importRaw: [{
      type: Output
    }],
    uploaded: [{
      type: Output
    }],
    type: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DropzoneDirective {
  el;
  filesOutput = new EventEmitter();
  onDragEnter(event) {
    event.stopPropagation();
    event.preventDefault();
    const elem = this.el.nativeElement;
    elem.classList.add('dnd-active');
  }
  onDragLeave(event) {
    const elem = this.el.nativeElement;
    elem.classList.remove('dnd-active');
  }
  onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
  }
  onDrop(event) {
    event.stopPropagation();
    event.preventDefault();
    const dataTransfer = event.dataTransfer;
    const files = dataTransfer.files;
    const elem = this.el.nativeElement;
    elem.classList.remove('dnd-active');
    this.filesOutput.emit(files);
  }
  constructor(el) {
    this.el = el;
  }
  static ɵfac = function DropzoneDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropzoneDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropzoneDirective,
    selectors: [["", "dropzone", ""]],
    hostBindings: function DropzoneDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("dragenter", function DropzoneDirective_dragenter_HostBindingHandler($event) {
          return ctx.onDragEnter($event);
        })("dragend", function DropzoneDirective_dragend_HostBindingHandler($event) {
          return ctx.onDragLeave($event);
        })("dragover", function DropzoneDirective_dragover_HostBindingHandler($event) {
          return ctx.onDragOver($event);
        })("drop", function DropzoneDirective_drop_HostBindingHandler($event) {
          return ctx.onDrop($event);
        });
      }
    },
    outputs: {
      filesOutput: "filesOutput"
    },
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropzoneDirective, [{
    type: Directive,
    args: [{
      selector: '[dropzone]'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    filesOutput: [{
      type: Output
    }],
    onDragEnter: [{
      type: HostListener,
      args: ['dragenter', ['$event']]
    }],
    onDragLeave: [{
      type: HostListener,
      args: ['dragend', ['$event']]
    }],
    onDragOver: [{
      type: HostListener,
      args: ['dragover', ['$event']]
    }],
    onDrop: [{
      type: HostListener,
      args: ['drop', ['$event']]
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class IdentityFormComponent {
  formBuilder;
  upload;
  groups;
  identityRequest = new EventEmitter();
  cancel = new EventEmitter();
  options = {
    validFileTypes: ['.p12'],
    showImport: false,
    small: true
  };
  identityForm;
  showGroupName = false;
  NEW_GROUP = 'Ny grupp';
  GROUP_HEADER = '-- Välj grupp --';
  type = '';
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
  }
  ngOnInit() {
    this.createForm();
  }
  ngOnChanges() {
    this.createForm();
  }
  createForm() {
    this.identityForm = this.formBuilder.group({
      group: [null, Validators.required],
      groupName: ['', Validators.required],
      storePassword: ['', Validators.required],
      keyPassword: ['', Validators.required],
      file: [null, Validators.required]
    });
  }
  selectGroup(groupName) {
    if (groupName.match(this.NEW_GROUP) || groupName == null || groupName === 'null') {
      this.showGroupName = true;
    } else {
      this.identityForm.get('groupName').setValue(groupName);
      this.showGroupName = false;
    }
  }
  getFileType(fileType) {
    const JKS = '.jks';
    const PKCS12 = '.p12';
    const PFX = '.pfx';
    if (fileType.match(JKS)) {
      this.type = 'JKS';
    }
    if (fileType.match(PKCS12) || fileType.match(PFX)) {
      this.type = 'PKCS12';
    }
  }
  fileUploaded(file) {
    this.identityForm.get('file').setValue(file);
  }
  onSave() {
    let groupValue = this.identityForm.get('group').value;
    if (groupValue === this.NEW_GROUP) {
      groupValue = this.identityForm.get('groupName').value;
    }
    const identity = {
      group: groupValue,
      type: this.type,
      storePassword: this.identityForm.get('storePassword').value,
      keyPassword: this.identityForm.get('keyPassword').value,
      file: this.identityForm.get('file').value
    };
    this.identityRequest.emit(identity);
  }
  onCancel() {
    this.cancel.emit();
    this.identityForm.disable();
  }
  clearForm() {
    this.showGroupName = false;
    this.upload.clear();
    this.identityForm.reset();
    this.identityForm.clearValidators();
  }
  showError(field, error) {
    const control = this.identityForm.get(field);
    if (control) {
      return control.hasError(error) && this.identityForm.get(field).touched;
    }
    return false;
  }
  static ɵfac = function IdentityFormComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IdentityFormComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IdentityFormComponent,
    selectors: [["identity-form"]],
    viewQuery: function IdentityFormComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.upload = _t.first);
      }
    },
    inputs: {
      groups: "groups"
    },
    outputs: {
      identityRequest: "identityRequest",
      cancel: "cancel"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 70,
    vars: 19,
    consts: [["fileupload", ""], ["group", ""], [3, "formGroup"], [1, "field", "is-horizontal", "is-grouped"], [1, "field-label"], [1, "label"], [1, "field-body"], [1, "field"], [1, "control"], ["dropzone", "", 1, "dropzone", 3, "filesOutput"], ["id", "key-upload", 3, "uploaded", "type", "options"], [1, "select", "is-primary", "is-small"], ["id", "group-select", "formControlName", "group", 3, "change"], [3, "value", 4, "ngIf"], [3, "ngValue"], [4, "ngFor", "ngForOf"], ["id", "group-name", "type", "text", "name", "groupName", "formControlName", "groupName", 1, "input", "is-small", 3, "placeholder"], [1, "control", "has-icons-right", "has-icons-left"], ["id", "password-input", "type", "password", "name", "storePassword", "formControlName", "storePassword", 1, "input", "is-small"], [1, "icon", "is-small", "is-left"], [1, "fas", "fa-lock"], ["id", "private-password-input", "type", "password", "name", "keyPassword", "formControlName", "keyPassword", 1, "input", "is-small"], [1, "flex", "flex-row", "flex-end", 2, "margin-top", "20px"], ["id", "cancel-keygroup", "type", "button", 1, "button", "is-small", "margin-right", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-times"], ["id", "save-keygroup", "type", "button", 1, "button", "is-small", "is-primary", 3, "click"], [1, "fas", "fa-save"], [3, "value"]],
    template: function IdentityFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "form", 2)(1, "div", 3)(2, "div", 4)(3, "label", 5)(4, "span");
        i0.ɵɵtext(5, "Keystore fil");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 6)(7, "div", 7)(8, "div", 8)(9, "div", 9);
        i0.ɵɵlistener("filesOutput", function IdentityFormComponent_Template_div_filesOutput_9_listener($event) {
          i0.ɵɵrestoreView(_r1);
          const fileupload_r2 = i0.ɵɵreference(11);
          return i0.ɵɵresetView(fileupload_r2.uploadFileList($event));
        });
        i0.ɵɵelementStart(10, "file-upload", 10, 0);
        i0.ɵɵlistener("uploaded", function IdentityFormComponent_Template_file_upload_uploaded_10_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.fileUploaded($event));
        })("type", function IdentityFormComponent_Template_file_upload_type_10_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.getFileType($event));
        });
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementStart(12, "div", 3)(13, "div", 4)(14, "label", 5)(15, "span");
        i0.ɵɵtext(16, "Grupp");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(17, "div", 6)(18, "div", 7)(19, "div", 8)(20, "div", 11)(21, "select", 12, 1);
        i0.ɵɵlistener("change", function IdentityFormComponent_Template_select_change_21_listener() {
          i0.ɵɵrestoreView(_r1);
          const group_r3 = i0.ɵɵreference(22);
          return i0.ɵɵresetView(ctx.selectGroup(group_r3.value));
        });
        i0.ɵɵtemplate(23, IdentityFormComponent_option_23_Template, 2, 2, "option", 13);
        i0.ɵɵelementStart(24, "option", 14);
        i0.ɵɵtext(25);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, IdentityFormComponent_option_26_Template, 2, 1, "option", 15);
        i0.ɵɵpipe(27, "async");
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementStart(28, "div", 3)(29, "div", 4)(30, "label", 5)(31, "span");
        i0.ɵɵtext(32, "Gruppnamn");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(33, "div", 6)(34, "div", 7)(35, "div", 8);
        i0.ɵɵelement(36, "input", 16);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(37, "div", 3)(38, "div", 4)(39, "label", 5)(40, "span");
        i0.ɵɵtext(41, "L\xF6senord f\xF6r keystore");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(42, "div", 6)(43, "div", 7)(44, "div", 17);
        i0.ɵɵelement(45, "input", 18);
        i0.ɵɵelementStart(46, "span", 19);
        i0.ɵɵelement(47, "span", 20);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(48, "div", 3)(49, "div", 4)(50, "label", 5)(51, "span");
        i0.ɵɵtext(52, "L\xF6senord f\xF6r private key");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(53, "div", 6)(54, "div", 7)(55, "div", 17);
        i0.ɵɵelement(56, "input", 21);
        i0.ɵɵelementStart(57, "span", 19);
        i0.ɵɵelement(58, "span", 20);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(59, "div", 22)(60, "button", 23);
        i0.ɵɵlistener("click", function IdentityFormComponent_Template_button_click_60_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onCancel());
        });
        i0.ɵɵelementStart(61, "span", 24);
        i0.ɵɵelement(62, "span", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(63, "span");
        i0.ɵɵtext(64, "Avbryt");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(65, "button", 26);
        i0.ɵɵlistener("click", function IdentityFormComponent_Template_button_click_65_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onSave());
        });
        i0.ɵɵelementStart(66, "span", 24);
        i0.ɵɵelement(67, "span", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(68, "span");
        i0.ɵɵtext(69, "Spara");
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.identityForm);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("options", ctx.options);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("ngIf", (ctx.identityForm.value == null ? null : ctx.identityForm.value.group) === null);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngValue", ctx.NEW_GROUP);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.NEW_GROUP);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(27, 17, ctx.groups));
        i0.ɵɵadvance(10);
        i0.ɵɵclassProp("is-danger", ctx.showError("groupName", "required"));
        i0.ɵɵproperty("placeholder", "Gruppnamn");
        i0.ɵɵadvance(9);
        i0.ɵɵclassProp("is-danger", ctx.showError("storePassword", "required"));
        i0.ɵɵadvance(11);
        i0.ɵɵclassProp("is-danger", ctx.showError("keyPassword", "required"));
        i0.ɵɵadvance(9);
        i0.ɵɵclassProp("is-static", !ctx.identityForm.valid)("is-primary", ctx.identityForm.valid);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i1$2.ɵNgNoValidate, i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption, i1$2.DefaultValueAccessor, i1$2.SelectControlValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i1$2.FormControlName, UploadComponent, DropzoneDirective, i2.AsyncPipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdentityFormComponent, [{
    type: Component,
    args: [{
      selector: 'identity-form',
      template: "<form [formGroup]=\"identityForm\">\n\n  <div class=\"field is-horizontal is-grouped\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>Keystore fil</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control\">\n          <div dropzone (filesOutput)=\"fileupload.uploadFileList($event)\" class=\"dropzone\">\n            <file-upload id=\"key-upload\" [options]=\"options\" (uploaded)=\"fileUploaded($event)\" (type)=\"getFileType($event)\" #fileupload>\n            </file-upload>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"field is-horizontal is-grouped\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>Grupp</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control\">\n          <div class=\"select is-primary is-small\">\n            <select id=\"group-select\" formControlName=\"group\" #group (change)=\"selectGroup(group.value)\">\n              <option *ngIf=\"identityForm.value?.group === null\" [value]=\"null\">{{ GROUP_HEADER }}</option>\n              <option [ngValue]=\"NEW_GROUP\">{{ NEW_GROUP }}</option>\n              <option *ngFor=\"let group of groups | async\">{{ group.groupName }}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"field is-horizontal is-grouped\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>Gruppnamn</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control\">\n          <input id=\"group-name\" type=\"text\" class=\"input is-small\" [class.is-danger]=\"showError('groupName', 'required')\" name=\"groupName\"\n            formControlName=\"groupName\" [placeholder]=\"'Gruppnamn'\">\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"field is-horizontal is-grouped\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>L\u00F6senord f\u00F6r keystore</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control has-icons-right has-icons-left\">\n          <input id=\"password-input\" type=\"password\" class=\"input is-small\" [class.is-danger]=\"showError('storePassword', 'required')\"\n            name=\"storePassword\" formControlName=\"storePassword\">\n          <span class=\"icon is-small is-left\">\n            <span class=\"fas fa-lock\"></span>\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"field is-horizontal is-grouped\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>L\u00F6senord f\u00F6r private key</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control has-icons-right has-icons-left\">\n          <input id=\"private-password-input\" type=\"password\" class=\"input is-small\" [class.is-danger]=\"showError('keyPassword', 'required')\"\n            name=\"keyPassword\" formControlName=\"keyPassword\">\n          <span class=\"icon is-small is-left\">\n            <span class=\"fas fa-lock\"></span>\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"flex flex-row flex-end\" style=\"margin-top: 20px;\">\n    <button id=\"cancel-keygroup\" type=\"button\" (click)=\"onCancel()\" class=\"button is-small margin-right\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-times\"></span>\n      </span>\n      <span>Avbryt</span>\n    </button>\n    <button id=\"save-keygroup\" type=\"button\" (click)=\"onSave()\" class=\"button is-small is-primary\" [class.is-static]=\"!identityForm.valid\"\n      [class.is-primary]=\"identityForm.valid\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-save\"></span>\n      </span>\n      <span>Spara</span>\n    </button>\n  </div>\n\n</form>"
    }]
  }], () => [{
    type: i1$2.FormBuilder
  }], {
    upload: [{
      type: ViewChild,
      args: ['upload']
    }],
    groups: [{
      type: Input
    }],
    identityRequest: [{
      type: Output
    }],
    cancel: [{
      type: Output
    }]
  });
})();
class DateUtil {
  static needsRenewal(validTo) {
    const dateToWarn = new Date();
    dateToWarn.setDate(dateToWarn.getDate() + 90);
    return dateToWarn > new Date(validTo);
  }
  static isExpired(validTo) {
    return new Date() > new Date(validTo);
  }
  static getWarnTooltip(validTo) {
    return this.isExpired(validTo) ? 'Certifikatet är utgånget och måste förnyas eller bytas ut om det ska användas i framtiden.' : 'Certifikatet är påväg att gå ut och måste förnyas eller bytas ut om det ska användas i framtiden.';
  }
}

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class IdentityTableComponent {
  dialogService;
  group;
  delete = new EventEmitter();
  download = new EventEmitter();
  changeActive = new EventEmitter();
  constructor(dialogService) {
    this.dialogService = dialogService;
  }
  onDelete(event, identity) {
    event.stopPropagation();
    this.dialogService.open({
      title: 'Radera',
      message: 'Vill du ta bort keystore ' + identity.subjectCN + '?'
    }).subscribe(confirmed => {
      if (confirmed) {
        this.delete.emit(identity);
      }
    });
  }
  onDownload(identity) {
    this.download.emit({
      group: this.group.groupName,
      identity: identity
    });
  }
  onChangeIdentity(selectedIdentity) {
    const ACTIVE = 'Active';
    if (selectedIdentity.state !== ACTIVE) {
      this.dialogService.open({
        title: 'Byt aktiv keystore',
        message: 'Vill du sätta keystore ' + selectedIdentity.subjectCN + ' aktiv för denna grupp?'
      }).subscribe(confirmed => {
        if (confirmed) {
          this.changeActive.emit(selectedIdentity);
        }
      });
    }
  }
  needsRenewal(validTo) {
    return DateUtil.needsRenewal(validTo);
  }
  isExpired(validTo) {
    return DateUtil.isExpired(validTo);
  }
  getWarnTooltip(validTo) {
    return DateUtil.getWarnTooltip(validTo);
  }
  static ɵfac = function IdentityTableComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IdentityTableComponent)(i0.ɵɵdirectiveInject(DialogService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IdentityTableComponent,
    selectors: [["identity-table"]],
    inputs: {
      group: "group"
    },
    outputs: {
      delete: "delete",
      download: "download",
      changeActive: "changeActive"
    },
    standalone: false,
    decls: 15,
    vars: 1,
    consts: [[1, "columns-table"], [1, "columns", "column-table-head", "is-mobile"], [1, "column", "is-hidden-mobile", "is-clickable", "is-2"], [1, "column", "is-hidden-mobile", "is-clickable", "has-text-centered", "is-2"], [1, "fas", "fa-cog"], ["id", "identity-table-row", "class", "columns-table-body columns is-multiline is-tablet", 3, "active", 4, "ngFor", "ngForOf"], ["id", "identity-table-row", 1, "columns-table-body", "columns", "is-multiline", "is-tablet"], ["id", "identity-table-name", 1, "column", "is-2"], [1, "column", "is-2"], [1, "column", "is-2", "flex", "flex-column"], ["class", "tooltip is-tooltip-left is-tooltip-multiline", "style", "float: right;", 4, "ngIf"], [1, "column", "is-2", "has-text-centered"], [4, "ngIf"], [1, "tooltip", "is-tooltip-left", "is-tooltip-multiline", 2, "float", "right"], [1, "fas", "fa-exclamation-triangle"], ["id", "identitty-table-set-active", "disabled", "", 1, "button", "is-small", "table-button", "active-button", 2, "margin-right", "5px", 3, "click"], ["type", "button", "id", "table-export", "title", "Exportera", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-download"], ["disabled", "", "id", "identity-table-remove-key", 1, "button", "is-small"], ["title", "Ta bort", 1, "fas", "fa-trash"], ["id", "identitty-table-set-active", 1, "button", "is-small", "table-button", 2, "margin-right", "5px", 3, "click"], ["id", "identity-table-remove-key", 1, "button", "is-small", 3, "click"]],
    template: function IdentityTableComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, " Namn ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtext(5, " Utf\xE4rdare ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 2);
        i0.ɵɵtext(7, " Id ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 2);
        i0.ɵɵtext(9, " Typ ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 2);
        i0.ɵɵtext(11, " Giltig till ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 3);
        i0.ɵɵelement(13, "span", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(14, IdentityTableComponent_div_14_Template, 16, 14, "div", 5);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(14);
        i0.ɵɵproperty("ngForOf", ctx.group.identities);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf],
    styles: [".needs-renewal[_ngcontent-%COMP%]{background-color:#f6a519;color:#fff;padding-right:10px}.expired[_ngcontent-%COMP%]{background-color:#e81d38!important;color:#fff;padding-right:10px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdentityTableComponent, [{
    type: Component,
    args: [{
      selector: 'identity-table',
      template: "<div class=\"columns-table\">\n  <div class=\"columns column-table-head is-mobile\">\n    <div class=\"column is-hidden-mobile is-clickable is-2\">\n      Namn\n    </div>\n    <div class=\"column is-hidden-mobile is-clickable is-2\">\n      Utf\u00E4rdare\n    </div>\n    <div class=\"column is-hidden-mobile is-clickable is-2\">\n      Id\n    </div>\n    <div class=\"column is-hidden-mobile is-clickable is-2\">\n      Typ\n    </div>\n    <div class=\"column is-hidden-mobile is-clickable is-2\">\n      Giltig till\n    </div>\n    <div class=\"column is-hidden-mobile is-clickable has-text-centered is-2\">\n      <span class=\"fas fa-cog\"></span>\n    </div>\n  </div>\n  <div id=\"identity-table-row\" class=\"columns-table-body columns is-multiline is-tablet\" [class.active]=\"identity.state === 'Active'\"\n    *ngFor=\"let identity of group.identities\">\n    <div id=\"identity-table-name\" class=\"column is-2\">\n      {{ identity.subjectCN }}\n    </div>\n    <div class=\"column is-2\">\n      {{ identity.issuerCN }}\n    </div>\n    <div class=\"column is-2\">\n      {{ identity.thumbPrint }}\n    </div>\n    <div class=\"column is-2\">\n      {{ identity.type }}\n    </div>\n\n    <div class=\"column is-2 flex flex-column\" [class.needs-renewal]=\"needsRenewal(identity.validTo)\"\n      [class.expired]=\"isExpired(identity.validTo)\">\n      <span>{{ identity.validTo }}</span>\n      <span *ngIf=\"needsRenewal(identity.validTo)\" class=\"tooltip is-tooltip-left is-tooltip-multiline\"\n        [attr.data-tooltip]=\"getWarnTooltip(identity.validTo)\" style=\"float: right;\">\n        <span class=\"fas fa-exclamation-triangle\"></span>\n      </span>\n    </div>\n\n    <div class=\"column is-2 has-text-centered\">\n      <span *ngIf=\"identity.state === 'Active'\">\n        <div>\n          <button id=\"identitty-table-set-active\" disabled class=\"button is-small table-button active-button\"\n            (click)=\"onChangeIdentity(identity)\" style=\"margin-right:5px;\">\n            <span>Aktiv</span>\n          </button>\n          <button type=\"button\" id=\"table-export\" class=\"button is-small\" (click)=\"onDownload(identity)\" title=\"Exportera\">\n            <span class=\"fas fa-download\"></span>\n          </button>\n          <button disabled id=\"identity-table-remove-key\" class=\"button is-small\">\n            <span class=\"fas fa-trash\" title=\"Ta bort\"></span>\n          </button>\n        </div>\n      </span>\n\n      <span *ngIf=\"identity.state !== 'Active'\">\n        <button id=\"identitty-table-set-active\" class=\"button is-small table-button\" (click)=\"onChangeIdentity(identity)\"\n          style=\"margin-right:5px;\">\n          <span>S\u00E4tt aktiv</span>\n        </button>\n        <button type=\"button\" id=\"table-export\" class=\"button is-small\" (click)=\"onDownload(identity)\" title=\"Exportera\">\n          <span class=\"fas fa-download\"></span>\n        </button>\n        <button id=\"identity-table-remove-key\" class=\"button is-small\" (click)=\"onDelete($event, identity)\">\n          <span class=\"fas fa-trash\" title=\"Ta bort\"></span>\n        </button>\n      </span>\n    </div>\n  </div>\n</div>",
      styles: [".needs-renewal{background-color:#f6a519;color:#fff;padding-right:10px}.expired{background-color:#e81d38!important;color:#fff;padding-right:10px}\n"]
    }]
  }], () => [{
    type: DialogService
  }], {
    group: [{
      type: Input
    }],
    delete: [{
      type: Output
    }],
    download: [{
      type: Output
    }],
    changeActive: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CertificateManagerComponent {
  dialogService;
  datasource;
  tlsService;
  identityForm;
  identityDeleted = new EventEmitter();
  changeActive = new EventEmitter();
  identityAdded = new EventEmitter();
  groupDeleted = new EventEmitter();
  groups$;
  fileStr = '';
  storePassword;
  keyPassword;
  fileType = ['.jks', '.p12'];
  edit = false;
  constructor(dialogService, datasource, tlsService) {
    this.dialogService = dialogService;
    this.datasource = datasource;
    this.tlsService = tlsService;
  }
  ngOnInit() {
    this.groups$ = this.datasource.connect();
  }
  deleteGroup(group) {
    this.dialogService.open({
      title: 'Ta bort grupp',
      message: 'Vill du ta bort hela gruppen ' + group.groupName
    }).subscribe(confirmed => {
      if (confirmed) {
        this.tlsService.deleteGroup(group.groupName).subscribe(() => {
          this.groupDeleted.emit(['Gruppen togs bort', 'Borttagen']);
          this.datasource.fetch();
        });
      }
    });
  }
  deleteIdentity(identity) {
    this.tlsService.deleteIdentity(identity.groupName, identity.thumbPrint).subscribe(() => {
      this.identityDeleted.emit(['Keystore togs bort', 'Borttagen']);
      this.datasource.fetch();
    });
  }
  downloadIdentity(identityDownload) {
    this.tlsService.downLoadIdentity(identityDownload.group, identityDownload.identity.thumbPrint);
  }
  changeActiveIdentity(identity) {
    this.tlsService.changeActiveIdentity(identity.groupName, identity.thumbPrint).subscribe(() => {
      this.changeActive.emit(['Aktiv keystore är ändrad', 'Ändrad']);
      this.datasource.fetch();
    });
  }
  importIdentity() {
    this.edit = true;
  }
  cancel() {
    this.edit = false;
  }
  submitIdentity(identity) {
    this.edit = false;
    this.tlsService.addIdentity(identity).subscribe(() => {
      this.identityAdded.emit(['Keystore lades till', 'Tillagd']);
      this.datasource.fetch();
    });
  }
  static ɵfac = function CertificateManagerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CertificateManagerComponent)(i0.ɵɵdirectiveInject(DialogService), i0.ɵɵdirectiveInject(IdentityDataSource), i0.ɵɵdirectiveInject(TlsService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CertificateManagerComponent,
    selectors: [["certificate-manager"]],
    viewQuery: function CertificateManagerComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.identityForm = _t.first);
      }
    },
    outputs: {
      identityDeleted: "identityDeleted",
      changeActive: "changeActive",
      identityAdded: "identityAdded",
      groupDeleted: "groupDeleted"
    },
    standalone: false,
    decls: 7,
    vars: 3,
    consts: [["identityForm", ""], [1, "columns"], [1, "column", "box"], [1, "box-title"], ["id", "add-key-group", "class", "button is-primary is-small", 3, "click", 4, "ngIf"], [3, "groups", "identityRequest", "cancel", 4, "ngIf"], [4, "ngIf"], ["id", "add-key-group", 1, "button", "is-primary", "is-small", 3, "click"], [1, "icon"], [1, "fas", "fa-plus"], [3, "identityRequest", "cancel", "groups"], ["id", "keymanager-column-box", "class", "column box", "style", "margin: 0.75rem 0", 4, "ngFor", "ngForOf"], ["id", "keymanager-column-box", 1, "column", "box", 2, "margin", "0.75rem 0"], [3, "delete", "download", "changeActive", "group"], [1, "flex", "flex-row"], ["id", "delete-key-group", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash-alt"]],
    template: function CertificateManagerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
        i0.ɵɵtext(3, "Nyckel Grupper");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CertificateManagerComponent_a_4_Template, 5, 0, "a", 4)(5, CertificateManagerComponent_identity_form_5_Template, 2, 1, "identity-form", 5)(6, CertificateManagerComponent_div_6_Template, 3, 3, "div", 6);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.edit);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.edit);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.edit);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, IdentityFormComponent, IdentityTableComponent, i2.AsyncPipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CertificateManagerComponent, [{
    type: Component,
    args: [{
      selector: 'certificate-manager',
      template: "<div class=\"columns\">\n  <div class=\"column box\">\n    <div class=\"box-title\">Nyckel Grupper</div>\n    <a id=\"add-key-group\" *ngIf=\"!edit\" class=\"button is-primary is-small\" (click)=\"importIdentity()\">\n      <span class=\"icon\">\n        <span class=\"fas fa-plus\"></span>\n      </span>\n      <span>L\u00E4gg till</span>\n    </a>\n    <identity-form *ngIf=\"edit\" #identityForm [groups]=\"groups$\" (identityRequest)=\"submitIdentity($event)\" (cancel)=\"cancel()\">\n    </identity-form>\n\n    <div *ngIf=\"!edit\">\n      <div id=\"keymanager-column-box\" class=\"column box\" style=\"margin: 0.75rem 0\" *ngFor=\"let group of groups$ | async; let first = first\">\n        <div class=\"box-title\">{{ group.groupName }}</div>\n        <identity-table [group]=\"group\" (delete)=\"deleteIdentity($event)\" (download)=\"downloadIdentity($event)\"\n          (changeActive)=\"changeActiveIdentity($event)\"></identity-table>\n        <div class=\"flex flex-row\">\n          <button id=\"delete-key-group\" class=\"button is-small\" (click)=\"deleteGroup(group)\">\n            <span class=\"icon\">\n              <span class=\"fas fa-trash-alt\"></span>\n            </span>\n            <span>Ta bort grupp</span>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"
    }]
  }], () => [{
    type: DialogService
  }, {
    type: IdentityDataSource
  }, {
    type: TlsService
  }], {
    identityForm: [{
      type: ViewChild,
      args: ['identityForm']
    }],
    identityDeleted: [{
      type: Output
    }],
    changeActive: [{
      type: Output
    }],
    identityAdded: [{
      type: Output
    }],
    groupDeleted: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ModalComponent {
  title = '';
  options;
  rightButton;
  leftButton;
  rightButtonClicked = new EventEmitter();
  leftButtonClicked = new EventEmitter();
  closeButtonClicked = new EventEmitter();
  active = false;
  internalOptions = {
    rightButtonText: 'Ok',
    leftButtonText: 'Avbryt',
    showRightButton: true,
    showLeftButton: true,
    showCloseButton: true,
    closeOnAction: true,
    keyboardNav: true
  };
  closeKey(event) {
    if (!this.active || !this.internalOptions.keyboardNav) {
      return;
    }
    if (event.key === 'Esc' || event.key === 'Escape') {
      this.close();
    } else if (event.key === 'ArrowLeft') {
      this.focusLeftButton();
    } else if (event.key === 'ArrowRight') {
      this.focusRightButton();
    }
  }
  ngOnChanges(changes) {
    if (changes['options']) {
      this.internalOptions = Object.assign(this.internalOptions, changes['options'].currentValue);
    }
  }
  open() {
    this.active = true;
    setTimeout(() => {
      this.focusRightButton();
    }, 10);
  }
  close() {
    this.active = false;
  }
  closeAction() {
    this.closeButtonClicked.emit();
    if (this.internalOptions.closeOnAction) {
      this.close();
    }
  }
  rightAction() {
    this.rightButtonClicked.emit();
    if (this.internalOptions.closeOnAction) {
      this.close();
    }
  }
  leftAction() {
    this.leftButtonClicked.emit();
    if (this.internalOptions.closeOnAction) {
      this.close();
    }
  }
  focusRightButton() {
    if (!this.internalOptions.keyboardNav) {
      return;
    }
    if (this.rightButtonClicked && this.internalOptions.showRightButton) {
      this.rightButton.nativeElement.focus();
    } else {
      this.focusLeftButton();
    }
  }
  focusLeftButton() {
    if (!this.internalOptions.keyboardNav) {
      return;
    }
    if (this.leftButton) {
      this.leftButton.nativeElement.focus();
    }
  }
  static ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalComponent,
    selectors: [["modal"]],
    viewQuery: function ModalComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c4, 5);
        i0.ɵɵviewQuery(_c5, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rightButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.leftButton = _t.first);
      }
    },
    hostBindings: function ModalComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function ModalComponent_keydown_HostBindingHandler($event) {
          return ctx.closeKey($event);
        }, false, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      title: "title",
      options: "options"
    },
    outputs: {
      rightButtonClicked: "rightButtonClicked",
      leftButtonClicked: "leftButtonClicked",
      closeButtonClicked: "closeButtonClicked"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c6,
    decls: 12,
    vars: 7,
    consts: [["leftButton", ""], ["rightButton", ""], [1, "modal"], [1, "modal-background"], [1, "modal-content"], [1, "card"], [1, "card-header"], [1, "card-header-title"], ["class", "close", 4, "ngIf"], [1, "card-content", "modal-inner-content"], [1, "content"], ["class", "card-footer", 4, "ngIf"], [1, "close"], ["aria-label", "close", 1, "delete", 3, "click"], [1, "card-footer"], ["class", "button modal-button is-fullwidth", 3, "click", 4, "ngIf"], [1, "button", "modal-button", "is-fullwidth", 3, "click"]],
    template: function ModalComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 2);
        i0.ɵɵelement(1, "div", 3);
        i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "header", 6)(5, "p", 7);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, ModalComponent_div_7_Template, 2, 0, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 9)(9, "div", 10);
        i0.ɵɵprojection(10);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(11, ModalComponent_footer_11_Template, 3, 2, "footer", 11);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("is-active", ctx.active);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("width", ctx.internalOptions == null ? null : ctx.internalOptions.width);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.internalOptions.showCloseButton);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.internalOptions.showRightButton || ctx.internalOptions.showLeftButton);
      }
    },
    dependencies: [i2.NgIf],
    styles: [".close[_ngcontent-%COMP%]{display:flex;flex:0 0 48px;align-items:center;justify-content:center}.modal-inner-content[_ngcontent-%COMP%]{max-height:70vh;overflow-y:auto;position:relative}.modal-content[_ngcontent-%COMP%]{overflow:hidden}.modal-button[_ngcontent-%COMP%]{height:45px;font-size:16px;border:1px solid #dbdbdb}.modal-button[_ngcontent-%COMP%]:focus{border:1px solid #009c9a}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalComponent, [{
    type: Component,
    args: [{
      selector: 'modal',
      template: "<div class=\"modal\" [class.is-active]=\"active\">\n  <div class=\"modal-background\"></div>\n  <div [style.width]=\"internalOptions?.width\" class=\"modal-content\">\n    <div class=\"card\">\n      <header class=\"card-header\">\n        <p class=\"card-header-title\">\n          {{ title }}\n        </p>\n        <div class=\"close\" *ngIf=\"internalOptions.showCloseButton\">\n          <button class=\"delete\" aria-label=\"close\" (click)=\"closeAction()\"></button>\n        </div>\n      </header>\n      <div class=\"card-content modal-inner-content\">\n        <div class=\"content\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <footer class=\"card-footer\" *ngIf=\"internalOptions.showRightButton || internalOptions.showLeftButton\">\n        <button #leftButton (click)=\"leftAction()\" class=\"button modal-button is-fullwidth\" *ngIf=\"internalOptions.showLeftButton\">\n          {{ internalOptions.leftButtonText}}\n        </button>\n        <button #rightButton (click)=\"rightAction()\" class=\"button modal-button is-fullwidth\" *ngIf=\"internalOptions.showRightButton\">\n          {{ internalOptions.rightButtonText }}\n        </button>\n      </footer>\n    </div>\n  </div>\n</div>",
      styles: [".close{display:flex;flex:0 0 48px;align-items:center;justify-content:center}.modal-inner-content{max-height:70vh;overflow-y:auto;position:relative}.modal-content{overflow:hidden}.modal-button{height:45px;font-size:16px;border:1px solid #dbdbdb}.modal-button:focus{border:1px solid #009c9a}\n"]
    }]
  }], null, {
    title: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    rightButton: [{
      type: ViewChild,
      args: ['rightButton']
    }],
    leftButton: [{
      type: ViewChild,
      args: ['leftButton']
    }],
    rightButtonClicked: [{
      type: Output
    }],
    leftButtonClicked: [{
      type: Output
    }],
    closeButtonClicked: [{
      type: Output
    }],
    closeKey: [{
      type: HostListener,
      args: ['document:keydown', ['$event']]
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ModalModule {
  static ɵfac = function ModalModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ModalModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [ModalComponent],
      exports: [ModalComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class UploadModule {
  static ɵfac = function UploadModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UploadModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: UploadModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UploadModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [UploadComponent],
      exports: [UploadComponent],
      providers: []
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DataSortPipe {
  transform(value, valOrderBy, valReverse) {
    if (!valOrderBy || valReverse === undefined) {
      return value;
    }
    value.sort((a, b) => {
      if (a[valOrderBy] === b[valOrderBy]) {
        return 0;
      }
      if (valReverse) {
        if (a[valOrderBy] < b[valOrderBy] || !a) {
          return 1;
        } else {
          return -1;
        }
      } else {
        if (a[valOrderBy] < b[valOrderBy] || !a) {
          return -1;
        } else {
          return 1;
        }
      }
    });
    return value;
  }
  static ɵfac = function DataSortPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DataSortPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "dataSort",
    type: DataSortPipe,
    pure: true,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataSortPipe, [{
    type: Pipe,
    args: [{
      name: 'dataSort',
      pure: true
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TrustDataSource {
  tlsService;
  trusts = new BehaviorSubject([]);
  constructor(tlsService) {
    this.tlsService = tlsService;
    this.fetch();
  }
  fetch() {
    this.tlsService.getTrusts().subscribe(result => {
      this.trusts.next(result);
    });
  }
  connect() {
    return this.trusts.asObservable();
  }
  static ɵfac = function TrustDataSource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TrustDataSource)(i0.ɵɵinject(TlsService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TrustDataSource,
    factory: TrustDataSource.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrustDataSource, [{
    type: Injectable
  }], () => [{
    type: TlsService
  }], null);
})();
class PaginationBase {
  activePages = [];
  activePage = 0;
  nrOfPages = 0;
  isFirstPage = true;
  isLastPage = false;
  pages = [];
  first(data, options, dataSize) {
    this.selectPage(0, data, options, dataSize);
  }
  last(data, options, dataSize) {
    this.selectPage(this.pages[this.pages.length - 1] - 1, data, options, dataSize);
  }
  next(data, options, dataSize) {
    this.selectPage(this.activePage + 1, data, options, dataSize);
  }
  previous(data, options, dataSize) {
    this.selectPage(this.activePage - 1, data, options, dataSize);
  }
  isLast() {
    return this.activePage === this.nrOfPages - 1;
  }
  isFirst() {
    return this.activePage === 0 ? true : null;
  }
  selectPage(index, data, options, dataSize) {
    if (index >= 0 && index < this.nrOfPages) {
      this.activePage = index;
      this.isFirstPage = this.isFirst();
      this.isLastPage = this.isLast();
      this.update(data, options, dataSize);
    }
  }
  update(data, options, dataSize) {
    this.activePages = this.getActivePages(this.activePage, options.maxPages, this.pages);
    if (data) {
      const indexSpan = this.getIndexSpan(this.activePage, options.pageSize, data);
      const pageData = data.slice(indexSpan[0], indexSpan[1]);
      this.emitData(pageData);
    } else if (dataSize) {
      this.emitPage();
    }
  }
  getIndexSpan(page, pageSize, data) {
    let startIndex = page * pageSize;
    if (startIndex > data.length) {
      startIndex = data.length;
    }
    let endIndex = startIndex + pageSize;
    if (endIndex > data.length) {
      endIndex = data.length;
    }
    return [startIndex, endIndex];
  }
  getPages(nrOfPages) {
    const pages = [];
    for (let i = 1; i <= nrOfPages; i++) {
      pages.push(i);
    }
    return pages;
  }
  getActivePages(activePage, maxPages, pages) {
    if (maxPages > pages.length) {
      return this.pages.slice(0, pages.length);
    }
    const offset = Math.floor(maxPages / 2);
    let start = activePage - offset;
    if (start < 0) {
      start = 0;
    }
    const end = start + maxPages;
    if (end > pages.length) {
      start = pages.length - maxPages;
    }
    return this.pages.slice(start, end);
  }
}

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class PaginationComponent extends PaginationBase {
  data;
  dataSize;
  options = {
    pageSize: 15,
    maxPages: 5
  };
  paginatedData = new EventEmitter();
  selectedPage = new EventEmitter();
  constructor() {
    super();
  }
  ngOnChanges() {
    if (!this.options || !this.data && this.dataSize == null) {
      return;
    }
    if (this.data) {
      this.nrOfPages = Math.ceil(this.data.length / this.options.pageSize);
    } else if (this.dataSize != null) {
      this.nrOfPages = Math.ceil(this.dataSize / this.options.pageSize);
      this.first(this.data, this.options, this.dataSize);
    }
    this.pages = this.getPages(this.nrOfPages);
    const ref = setTimeout(() => {
      this.update(this.data, this.options, this.dataSize);
      clearTimeout(ref);
    }, 0);
  }
  emitPage() {
    this.selectedPage.emit(this.activePage + 1);
  }
  emitData(pageData) {
    this.paginatedData.emit(pageData);
  }
  static ɵfac = function PaginationComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PaginationComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PaginationComponent,
    selectors: [["pagination"]],
    inputs: {
      data: "data",
      dataSize: "dataSize",
      options: "options"
    },
    outputs: {
      paginatedData: "paginatedData",
      selectedPage: "selectedPage"
    },
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
    decls: 1,
    vars: 1,
    consts: [["class", "pagination is-centered is-small", "role", "navigation", "aria-label", "pagination", 4, "ngIf"], ["role", "navigation", "aria-label", "pagination", 1, "pagination", "is-centered", "is-small"], [1, "pagination-list"], [4, "ngIf"], [4, "ngFor", "ngForOf"], ["disabled", "", 1, "pagination-link"], ["aria-label", "Till b\xF6rjan", 1, "fa", "fa-angle-double-left"], ["aria-label", "F\xF6reg\xE5ende", 1, "fa", "fa-angle-left"], [1, "pagination-link", 3, "click"], ["aria-label", "N\xE4sta", 1, "fa", "fa-angle-right"], ["aria-label", "Till slutet", 1, "fa", "fa-angle-double-right"]],
    template: function PaginationComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, PaginationComponent_nav_0_Template, 7, 5, "nav", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.nrOfPages > 1);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf],
    styles: [".pagination-link.is-current[_ngcontent-%COMP%]{background-color:#00a9a7;border-color:#00a9a7}.pagination[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
    type: Component,
    args: [{
      selector: 'pagination',
      template: "<nav class=\"pagination is-centered is-small\" role=\"navigation\" aria-label=\"pagination\" *ngIf=\"nrOfPages > 1\">\n  <ul class=\"pagination-list\">\n    <ng-container *ngIf=\"isFirstPage\">\n      <li>\n        <a class=\"pagination-link\" disabled>\n          <i aria-label=\"Till b\u00F6rjan\" class=\"fa fa-angle-double-left\"></i>\n        </a>\n      </li>\n      <li>\n        <a class=\"pagination-link\" disabled>\n          <i aria-label=\"F\u00F6reg\u00E5ende\" class=\"fa fa-angle-left\"></i>\n        </a>\n      </li>\n    </ng-container>\n    <ng-container *ngIf=\"!isFirstPage\">\n      <li>\n        <a class=\"pagination-link\" (click)=\"first(data, options, dataSize)\">\n          <i aria-label=\"Till b\u00F6rjan\" class=\"fa fa-angle-double-left\"></i>\n        </a>\n      </li>\n      <li>\n        <a class=\"pagination-link\" (click)=\"previous(data, options, dataSize)\">\n          <i aria-label=\"F\u00F6reg\u00E5ende\" class=\"fa fa-angle-left\"></i>\n        </a>\n      </li>\n    </ng-container>\n    <li *ngFor=\"let page of activePages\">\n      <a class=\"pagination-link\" (click)=\"selectPage(page - 1, data, options, dataSize)\" [class.is-current]=\"page === activePage + 1\">\n        {{ page }}\n      </a>\n    </li>\n    <ng-container *ngIf=\"isLastPage\">\n      <li>\n        <a class=\"pagination-link\" disabled>\n          <i aria-label=\"N\u00E4sta\" class=\"fa fa-angle-right\"></i>\n        </a>\n      </li>\n      <li>\n        <a class=\"pagination-link\" disabled>\n          <i aria-label=\"Till slutet\" class=\"fa fa-angle-double-right\"></i>\n        </a>\n      </li>\n    </ng-container>\n    <ng-container *ngIf=\"!isLastPage\">\n      <li>\n        <a class=\"pagination-link\" (click)=\"next(data, options, dataSize)\">\n          <i aria-label=\"N\u00E4sta\" class=\"fa fa-angle-right\"></i>\n        </a>\n      </li>\n      <li>\n        <a class=\"pagination-link\" (click)=\"last(data, options, dataSize)\">\n          <i aria-label=\"Till slutet\" class=\"fa fa-angle-double-right\"></i>\n        </a>\n      </li>\n    </ng-container>\n  </ul>\n</nav>\n",
      styles: [".pagination-link.is-current{background-color:#00a9a7;border-color:#00a9a7}.pagination ul{list-style:none}\n"]
    }]
  }], () => [], {
    data: [{
      type: Input
    }],
    dataSize: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    paginatedData: [{
      type: Output
    }],
    selectedPage: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CertificateFormComponent {
  formBuilder;
  certificate;
  save = new EventEmitter();
  update = new EventEmitter();
  cancel = new EventEmitter();
  name;
  thumbPrint;
  validTo;
  certificateForm;
  options = {
    validFileTypes: ['.pem, .cer, .key, .crt'],
    showImport: false,
    small: true
  };
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.load();
  }
  ngOnChanges() {
    this.load(this.certificate);
  }
  load(certificate) {
    this.certificateForm = this.formBuilder.group({
      caCertFile: [null, Validators.required]
    });
    this.name = null;
    this.thumbPrint = null;
    if (certificate) {
      this.name = certificate.name;
      this.thumbPrint = certificate.thumbPrint;
      this.validTo = certificate.validTo;
    }
  }
  onEnter(event) {
    event.preventDefault();
  }
  fileUploaded(file) {
    this.certificateForm.get('caCertFile').setValue(file);
  }
  onSave() {
    if (this.certificate) {
      const trust = Object.assign({}, this.certificateForm.value, {
        thumbPrint: this.thumbPrint
      });
      delete trust['caCertFile'];
      this.update.emit(trust);
    } else {
      const certificate = Object.assign({}, this.certificateForm.value);
      this.save.emit(certificate);
    }
  }
  onCancel() {
    this.cancel.emit();
  }
  static ɵfac = function CertificateFormComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CertificateFormComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CertificateFormComponent,
    selectors: [["certificate-form"]],
    inputs: {
      certificate: "certificate"
    },
    outputs: {
      save: "save",
      update: "update",
      cancel: "cancel"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 16,
    vars: 6,
    consts: [["fileupload", ""], [3, "keydown.enter", "formGroup"], ["class", "field is-horizontal is-grouped", 4, "ngIf"], [1, "flex", "flex-row", "flex-end", 2, "margin-top", "20px"], ["id", "certifactes-cancel", "type", "button", 1, "button", "is-small", "margin-right", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-times"], ["id", "certifactes-save", "type", "button", 1, "button", "is-small", "is-primary", 3, "click", "disabled"], [1, "fas", "fa-save"], [1, "field", "is-horizontal", "is-grouped"], [1, "field-label"], [1, "label"], [1, "field-body"], [1, "field"], [1, "control"], ["dropzone", "", 1, "dropzone", 3, "filesOutput"], ["id", "uploadfilecert", 3, "uploaded", "options"]],
    template: function CertificateFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 1);
        i0.ɵɵlistener("keydown.enter", function CertificateFormComponent_Template_form_keydown_enter_0_listener($event) {
          return ctx.onEnter($event);
        });
        i0.ɵɵtemplate(1, CertificateFormComponent_div_1_Template, 9, 1, "div", 2)(2, CertificateFormComponent_div_2_Template, 9, 1, "div", 2)(3, CertificateFormComponent_div_3_Template, 10, 4, "div", 2)(4, CertificateFormComponent_div_4_Template, 11, 1, "div", 2);
        i0.ɵɵelementStart(5, "div", 3)(6, "button", 4);
        i0.ɵɵlistener("click", function CertificateFormComponent_Template_button_click_6_listener() {
          return ctx.onCancel();
        });
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵelement(8, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "span");
        i0.ɵɵtext(10, "Avbryt");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "button", 7);
        i0.ɵɵlistener("click", function CertificateFormComponent_Template_button_click_11_listener() {
          return ctx.onSave();
        });
        i0.ɵɵelementStart(12, "span", 5);
        i0.ɵɵelement(13, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "span");
        i0.ɵɵtext(15, "Spara");
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.certificateForm);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.certificate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.certificate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.certificate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.certificate);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", !ctx.certificateForm.valid && !ctx.certificate);
      }
    },
    dependencies: [i2.NgIf, i1$2.ɵNgNoValidate, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, UploadComponent, DropzoneDirective, i2.DatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CertificateFormComponent, [{
    type: Component,
    args: [{
      selector: 'certificate-form',
      template: "<form (keydown.enter)=\"onEnter($event)\" [formGroup]=\"certificateForm\">\n\n  <div class=\"field is-horizontal is-grouped\" *ngIf=\"certificate\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>Namn</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control\">\n          {{ name }}\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"field is-horizontal is-grouped\" *ngIf=\"certificate\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>Id</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control\">\n          {{ thumbPrint }}\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"field is-horizontal is-grouped\" *ngIf=\"certificate\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>Giltig till</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control\">\n          {{ (validTo | date : \"YYYY-MM-dd\") ?? 'Ej angivet' }}\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"field is-horizontal is-grouped\" *ngIf=\"!certificate\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>Certifikat-fil</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control\">\n          <div dropzone (filesOutput)=\"fileupload.uploadFileList($event)\" class=\"dropzone\">\n            <file-upload id=\"uploadfilecert\" [options]=\"options\" (uploaded)=\"fileUploaded($event)\" #fileupload></file-upload>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"flex flex-row flex-end\" style=\"margin-top: 20px;\">\n    <button id=\"certifactes-cancel\" type=\"button\" (click)=\"onCancel()\" class=\"button is-small margin-right\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-times\"></span>\n      </span>\n      <span>Avbryt</span>\n    </button>\n    <button id=\"certifactes-save\" type=\"button\" (click)=\"onSave()\" class=\"button is-small is-primary\"\n      [disabled]=\"!certificateForm.valid && !certificate\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-save\"></span>\n      </span>\n      <span>Spara</span>\n    </button>\n  </div>\n</form>"
    }]
  }], () => [{
    type: i1$2.FormBuilder
  }], {
    certificate: [{
      type: Input
    }],
    save: [{
      type: Output
    }],
    update: [{
      type: Output
    }],
    cancel: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TrustManagerComponent {
  dialogService;
  datasource;
  tlsService;
  certificateImported = new EventEmitter();
  certificateUpdated = new EventEmitter();
  certificateDeleted = new EventEmitter();
  selectedCertificate;
  fileType = '.crt,.cer,';
  trusts;
  paginatedData = [];
  filteredData = [];
  filterInput = '';
  sortOrderBy = '';
  sortReverse = false;
  edit = false;
  dataSortPipe = new DataSortPipe();
  paginationOptions = {
    maxPages: 5,
    pageSize: 15
  };
  constructor(dialogService, datasource, tlsService) {
    this.dialogService = dialogService;
    this.datasource = datasource;
    this.tlsService = tlsService;
  }
  ngOnInit() {
    this.datasource.connect().subscribe(it => {
      this.trusts = it;
      this.filteredData = this.filterData();
    });
  }
  select(certificate) {
    this.edit = true;
    this.selectedCertificate = certificate;
  }
  add() {
    this.edit = true;
    this.selectedCertificate = null;
  }
  save(certificate) {
    this.edit = false;
    this.tlsService.importCertificate(certificate).subscribe(() => {
      this.datasource.fetch();
      this.certificateImported.emit(['Certifikat har importerats', 'Importerad']);
    });
  }
  update(certificate) {
    this.edit = false;
    this.tlsService.updateCertificate(certificate).subscribe(() => {
      this.datasource.fetch();
      this.certificateUpdated.emit(['Certifikat har updaterats', 'Updaterad']);
    });
  }
  cancel() {
    this.edit = false;
  }
  onDelete(trust) {
    this.dialogService.open({
      title: 'Radera',
      message: 'Vill du ta bort certifikat med id ' + trust.thumbPrint + '?'
    }).subscribe(confirmed => {
      if (confirmed) {
        this.tlsService.deleteCertificate(trust.thumbPrint).subscribe(() => {
          this.datasource.fetch();
          this.certificateDeleted.emit(['Certifikat har tagits bort', 'Borttagen']);
        });
      }
    });
  }
  setPagination(value) {
    this.paginatedData = value;
  }
  export(trust) {
    this.tlsService.exportCertificate(trust.thumbPrint);
  }
  onFilterChange(event) {
    this.filterInput = event.target.value;
    this.filteredData = Object.assign([], this.filterData());
  }
  setOrderBy(orderBy) {
    if (this.sortOrderBy === orderBy) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortOrderBy = orderBy;
      this.sortReverse = false;
    }
    this.filteredData = Object.assign([], this.dataSortPipe.transform(this.filteredData, this.sortOrderBy, this.sortReverse));
  }
  filter(value, filter) {
    let result = [];
    result = value.filter(item => {
      if (this.comparator(item, 'name', filter)) {
        return true;
      }
      return false;
    });
    return Object.assign([], result);
  }
  comparator(item, property, filter) {
    if (item[property] && item[property].toLowerCase().match(filter.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }
  filterData() {
    if (this.filterInput !== '') {
      return this.filter(this.trusts, this.filterInput);
    }
    return this.trusts;
  }
  needsRenewal(validTo) {
    return DateUtil.needsRenewal(validTo);
  }
  isExpired(validTo) {
    return DateUtil.isExpired(validTo);
  }
  getWarnTooltip(validTo) {
    return DateUtil.getWarnTooltip(validTo);
  }
  static ɵfac = function TrustManagerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TrustManagerComponent)(i0.ɵɵdirectiveInject(DialogService), i0.ɵɵdirectiveInject(TrustDataSource), i0.ɵɵdirectiveInject(TlsService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TrustManagerComponent,
    selectors: [["trust-manager"]],
    outputs: {
      certificateImported: "certificateImported",
      certificateUpdated: "certificateUpdated",
      certificateDeleted: "certificateDeleted"
    },
    standalone: false,
    decls: 2,
    vars: 2,
    consts: [["class", "columns", 4, "ngIf"], [1, "columns"], [1, "column", "box"], [1, "box-title"], [1, "flex", "flex-end", "columns"], [1, "column", "is-8"], ["id", "add-button", 1, "button", "is-primary", "is-small", 3, "click"], [1, "icon"], [1, "fa", "fa-plus"], [1, "column", "is-4"], ["id", "table-filter", "type", "text", "placeholder", "Filter", 1, "input", "filter-input", "is-small", 3, "keyup", "value", "disabled"], [1, "columns-table"], [1, "columns", "columns-table-head", "is-mobile"], [1, "column", "is-hidden-mobile", "is-clickable", "is-4", 3, "click"], ["class", "fas", 3, "fa-sort-down", "fa-sort-up", 4, "ngIf"], [1, "column", "is-hidden-mobile", "is-clickable", "is-5", 3, "click"], [1, "column", "is-hidden-mobile", "is-clickable", "is-2", 3, "click"], [1, "column", "is-1", "is-hidden-mobile", "has-text-centered"], [1, "fas", "fa-cog"], ["id", "table-body-columns", "class", "columns-table-body columns is-multiline is-tablet is-clickable", 4, "ngFor", "ngForOf"], [3, "paginatedData", "options", "data"], [1, "fas"], ["id", "table-body-columns", 1, "columns-table-body", "columns", "is-multiline", "is-tablet", "is-clickable"], [1, "column", "is-4", 3, "click"], [1, "column", "is-5", 3, "click"], [1, "column", "is-2", 3, "click"], ["class", "tooltip is-tooltip-left is-tooltip-multiline", "style", "float: right;", 4, "ngIf"], [1, "column", "is-1", "has-text-centered"], ["type", "button", "id", "table-export", "title", "Exportera", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-download"], ["type", "button", "id", "table-delete", "title", "Ta bort", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"], [1, "tooltip", "is-tooltip-left", "is-tooltip-multiline", 2, "float", "right"], [1, "fas", "fa-exclamation-triangle"], [3, "cancel", "save", "update", "certificate"]],
    template: function TrustManagerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, TrustManagerComponent_div_0_Template, 28, 8, "div", 0)(1, TrustManagerComponent_div_1_Template, 5, 1, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.edit);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.edit);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, PaginationComponent, CertificateFormComponent, i2.DatePipe],
    styles: [".trust-cell[_ngcontent-%COMP%]{background-color:#e496a2;border-left:1px solid #fff;border-top:1px solid #fff}.trust-cell.trust-active[_ngcontent-%COMP%]{background-color:#8ed285!important}.columns-table[_ngcontent-%COMP%]   .columns-table-body[_ngcontent-%COMP%]:nth-of-type(2)   .trust-cell[_ngcontent-%COMP%]{border-left:1px solid #d8d8d8;border-top:1px solid #d8d8d8}.needs-renewal[_ngcontent-%COMP%]{background-color:#f6a519;color:#fff;padding-right:10px}.expired[_ngcontent-%COMP%]{background-color:#e81d38!important;color:#fff;padding-right:10px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrustManagerComponent, [{
    type: Component,
    args: [{
      selector: 'trust-manager',
      template: "<div *ngIf=\"!edit\" class=\"columns\">\n  <div class=\"column box\">\n    <div class=\"box-title\">Utf\u00E4rdare</div>\n\n    <div class=\"flex flex-end columns\">\n      <div class=\"column is-8\">\n        <a id=\"add-button\" class=\"button is-primary is-small\" (click)=\"add()\">\n          <span class=\"icon\">\n            <span class=\"fa fa-plus\"></span>\n          </span>\n          <span>L\u00E4gg till</span>\n        </a>\n      </div>\n\n      <div class=\"column is-4\">\n        <input id=\"table-filter\" class=\"input filter-input is-small\" type=\"text\" [value]=\"filterInput\"\n          (keyup)=\"onFilterChange($event)\" placeholder=\"Filter\" [disabled]=\"!trusts\">\n      </div>\n    </div>\n\n    <div class=\"columns-table\">\n      <div class=\"columns columns-table-head is-mobile\">\n\n        <div class=\"column is-hidden-mobile is-clickable is-4\" (click)=\"setOrderBy('name')\">\n          Namn\n          <span *ngIf=\"sortOrderBy === 'name'\" class=\"fas\" [class.fa-sort-down]=\"!sortReverse\"\n            [class.fa-sort-up]=\"sortReverse\"></span>\n        </div>\n\n        <div class=\"column is-hidden-mobile is-clickable is-5\" (click)=\"setOrderBy('thumbPrint')\">\n          Id\n          <span *ngIf=\"sortOrderBy === 'thumbPrint'\" class=\"fas\" [class.fa-sort-down]=\"!sortReverse\"\n            [class.fa-sort-up]=\"sortReverse\">\n          </span>\n        </div>\n\n        <div class=\"column is-hidden-mobile is-clickable is-2\" (click)=\"setOrderBy('expiration')\">\n          Giltig till\n          <span *ngIf=\"sortOrderBy === 'expiration'\" class=\"fas\" [class.fa-sort-down]=\"!sortReverse\"\n            [class.fa-sort-up]=\"sortReverse\">\n          </span>\n        </div>\n\n        <div class=\"column is-1 is-hidden-mobile has-text-centered\">\n          <span class=\"fas fa-cog\"></span>\n        </div>\n      </div>\n\n      <div id=\"table-body-columns\" class=\"columns-table-body columns is-multiline is-tablet is-clickable\"\n        *ngFor=\"let entity of paginatedData\">\n        <div class=\"column is-4\" (click)=\"select(entity)\">\n          {{ entity.name }}\n        </div>\n\n        <div class=\"column is-5\" (click)=\"select(entity)\">\n          {{ entity.thumbPrint }}\n        </div>\n        <div class=\"column is-2\" (click)=\"select(entity)\" [class.needs-renewal]=\"needsRenewal(entity.validTo)\"\n          [class.expired]=\"isExpired(entity.validTo)\">\n          {{ (entity.validTo | date : 'YYYY-MM-dd') ?? 'Ej angivet'}}\n          <span *ngIf=\"needsRenewal(entity.validTo)\" class=\"tooltip is-tooltip-left is-tooltip-multiline\"\n          [attr.data-tooltip]=\"getWarnTooltip(entity.validTo)\" style=\"float: right;\">\n          <span class=\"fas fa-exclamation-triangle\"></span>\n        </span>\n        </div>\n\n        <div class=\"column is-1 has-text-centered\">\n          <button type=\"button\" id=\"table-export\" class=\"button is-small\" (click)=\"export(entity)\" title=\"Exportera\">\n            <span class=\"fas fa-download\"></span>\n          </button>\n\n          <button type=\"button\" id=\"table-delete\" class=\"button is-small\" (click)=\"onDelete(entity)\" title=\"Ta bort\">\n            <span class=\"fas fa-trash\"></span>\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <pagination (paginatedData)=\"setPagination($event)\" [options]=\"paginationOptions\" [data]=\"filteredData\">\n    </pagination>\n\n  </div>\n</div>\n\n<div *ngIf=\"edit\" class=\"columns\">\n  <div class=\"column box\">\n    <div class=\"box-title\">Certifikat</div>\n    <certificate-form [certificate]=\"selectedCertificate\" (cancel)=\"cancel()\" (save)=\"save($event)\"\n      (update)=\"update($event)\">\n    </certificate-form>\n  </div>\n</div>",
      styles: [".trust-cell{background-color:#e496a2;border-left:1px solid #fff;border-top:1px solid #fff}.trust-cell.trust-active{background-color:#8ed285!important}.columns-table .columns-table-body:nth-of-type(2) .trust-cell{border-left:1px solid #d8d8d8;border-top:1px solid #d8d8d8}.needs-renewal{background-color:#f6a519;color:#fff;padding-right:10px}.expired{background-color:#e81d38!important;color:#fff;padding-right:10px}\n"]
    }]
  }], () => [{
    type: DialogService
  }, {
    type: TrustDataSource
  }, {
    type: TlsService
  }], {
    certificateImported: [{
      type: Output
    }],
    certificateUpdated: [{
      type: Output
    }],
    certificateDeleted: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class AsyncPaginationComponent extends PaginationBase {
  data;
  dataSize;
  options = {
    pageSize: 15,
    maxPages: 5
  };
  paginatedData = new EventEmitter();
  selectedPage = new EventEmitter();
  constructor() {
    super();
  }
  ngOnInit() {
    this.data.subscribe(data => {
      const oldNrPages = this.nrOfPages;
      if (!this.options || !data && this.dataSize === undefined) {
        return;
      }
      if (data) {
        this.nrOfPages = Math.ceil(data.length / this.options.pageSize);
      } else if (this.dataSize !== undefined) {
        this.nrOfPages = Math.ceil(this.dataSize / this.options.pageSize);
        this.first(data, this.options, this.dataSize);
      }
      this.pages = this.getPages(this.nrOfPages);
      if (oldNrPages !== this.nrOfPages) {
        this.first(data, this.options, this.dataSize);
      }
      const ref = setTimeout(() => {
        this.update(data, this.options, this.dataSize);
        clearTimeout(ref);
      }, 0);
    });
  }
  emitPage() {
    this.selectedPage.emit(this.activePage + 1);
  }
  emitData(pageData) {
    this.paginatedData.emit(pageData);
  }
  static ɵfac = function AsyncPaginationComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AsyncPaginationComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AsyncPaginationComponent,
    selectors: [["async-pagination"]],
    inputs: {
      data: "data",
      dataSize: "dataSize",
      options: "options"
    },
    outputs: {
      paginatedData: "paginatedData",
      selectedPage: "selectedPage"
    },
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 1,
    vars: 1,
    consts: [["class", "pagination is-centered is-small", "role", "navigation", "aria-label", "pagination", 4, "ngIf"], ["role", "navigation", "aria-label", "pagination", 1, "pagination", "is-centered", "is-small"], ["class", "pagination-list", 4, "ngIf"], [1, "pagination-list"], [4, "ngIf"], [4, "ngFor", "ngForOf"], ["disabled", "", 1, "pagination-link"], ["aria-label", "Till b\xF6rjan", 1, "fa", "fa-angle-double-left"], ["aria-label", "F\xF6reg\xE5ende", 1, "fa", "fa-angle-left"], [1, "pagination-link", 3, "click"], ["aria-label", "N\xE4sta", 1, "fa", "fa-angle-right"], ["aria-label", "Till slutet", 1, "fa", "fa-angle-double-right"]],
    template: function AsyncPaginationComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, AsyncPaginationComponent_nav_0_Template, 3, 3, "nav", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.nrOfPages > 1);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i2.AsyncPipe],
    styles: [_c7]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsyncPaginationComponent, [{
    type: Component,
    args: [{
      selector: 'async-pagination',
      template: "<nav class=\"pagination is-centered is-small\" role=\"navigation\" aria-label=\"pagination\" *ngIf=\"nrOfPages > 1\">\n  <ul *ngIf=\"data | async as asyncData\" class=\"pagination-list\">\n    <ng-container *ngIf=\"isFirstPage\">\n      <li>\n        <a class=\"pagination-link\" disabled>\n          <i aria-label=\"Till b\u00F6rjan\" class=\"fa fa-angle-double-left\"></i>\n        </a>\n      </li>\n      <li>\n        <a class=\"pagination-link\" disabled>\n          <i aria-label=\"F\u00F6reg\u00E5ende\" class=\"fa fa-angle-left\"></i>\n        </a>\n      </li>\n    </ng-container>\n    <ng-container *ngIf=\"!isFirstPage\">\n      <li>\n        <a class=\"pagination-link\" (click)=\"first(asyncData, options, dataSize)\">\n          <i aria-label=\"Till b\u00F6rjan\" class=\"fa fa-angle-double-left\"></i>\n        </a>\n      </li>\n      <li>\n        <a class=\"pagination-link\" (click)=\"previous(asyncData, options, dataSize)\">\n          <i aria-label=\"F\u00F6reg\u00E5ende\" class=\"fa fa-angle-left\"></i>\n        </a>\n      </li>\n    </ng-container>\n    <li *ngFor=\"let page of activePages\">\n      <a class=\"pagination-link\" (click)=\"selectPage(page - 1, asyncData, options, dataSize)\" [class.is-current]=\"page === activePage + 1\">\n        {{ page }}\n      </a>\n    </li>\n    <ng-container *ngIf=\"isLastPage\">\n      <li>\n        <a class=\"pagination-link\" disabled>\n          <i aria-label=\"N\u00E4sta\" class=\"fa fa-angle-right\"></i>\n        </a>\n      </li>\n      <li>\n        <a class=\"pagination-link\" disabled>\n          <i aria-label=\"Till slutet\" class=\"fa fa-angle-double-right\"></i>\n        </a>\n      </li>\n    </ng-container>\n    <ng-container *ngIf=\"!isLastPage\">\n      <li>\n        <a class=\"pagination-link\" (click)=\"next(asyncData, options, dataSize)\">\n          <i aria-label=\"N\u00E4sta\" class=\"fa fa-angle-right\"></i>\n        </a>\n      </li>\n      <li>\n        <a class=\"pagination-link\" (click)=\"last(asyncData, options, dataSize)\">\n          <i aria-label=\"Till slutet\" class=\"fa fa-angle-double-right\"></i>\n        </a>\n      </li>\n    </ng-container>\n  </ul>\n</nav>\n\n",
      styles: [".pagination-link.is-current{background-color:#00a9a7;border-color:#00a9a7}.pagination ul{list-style:none}\n"]
    }]
  }], () => [], {
    data: [{
      type: Input
    }],
    dataSize: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    paginatedData: [{
      type: Output
    }],
    selectedPage: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class PaginationModule {
  static ɵfac = function PaginationModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PaginationModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PaginationModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [PaginationComponent, AsyncPaginationComponent],
      exports: [PaginationComponent, AsyncPaginationComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class UtilModule {
  static ɵfac = function UtilModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UtilModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: UtilModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [DataSortPipe],
      exports: [DataSortPipe],
      providers: []
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CollapsibleComponent {
  collapsibleId;
  hidden;
  collapseComponent(collapse) {
    this.hidden = collapse;
  }
  static ɵfac = function CollapsibleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CollapsibleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CollapsibleComponent,
    selectors: [["collapsible"]],
    inputs: {
      collapsibleId: "collapsibleId",
      hidden: "hidden"
    },
    standalone: false,
    ngContentSelectors: _c6,
    decls: 3,
    vars: 2,
    consts: [[1, "collapsible-wrapper"], [1, "collapsible"]],
    template: function CollapsibleComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("collapsed", ctx.hidden);
      }
    },
    styles: ["div.collapsible[_ngcontent-%COMP%]{width:100%}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapsibleComponent, [{
    type: Component,
    args: [{
      selector: 'collapsible',
      template: "<div class=\"collapsible-wrapper\" [class.collapsed]=\"hidden\">\r\n  <div class=\"collapsible\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n",
      styles: ["div.collapsible{width:100%}\n"]
    }]
  }], null, {
    collapsibleId: [{
      type: Input
    }],
    hidden: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TrustHolderDataSource {
  tlsService;
  trustHolders = new BehaviorSubject([]);
  constructor(tlsService) {
    this.tlsService = tlsService;
    this.fetch();
  }
  fetch() {
    this.tlsService.getTrustHolders().subscribe(result => {
      this.trustHolders.next(result);
    });
  }
  connect() {
    return this.trustHolders.asObservable();
  }
  static ɵfac = function TrustHolderDataSource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TrustHolderDataSource)(i0.ɵɵinject(TlsService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TrustHolderDataSource,
    factory: TrustHolderDataSource.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrustHolderDataSource, [{
    type: Injectable
  }], () => [{
    type: TlsService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CollapsibleButtonComponent {
  collapsibleId;
  hidden;
  hiddenEvent = new EventEmitter();
  setHidden() {
    if (this.hidden) {
      this.hidden = false;
    } else {
      this.hidden = true;
    }
    this.hiddenEvent.emit({
      hidden: this.hidden,
      id: this.collapsibleId.toString()
    });
  }
  static ɵfac = function CollapsibleButtonComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CollapsibleButtonComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CollapsibleButtonComponent,
    selectors: [["collapsible-button"]],
    inputs: {
      collapsibleId: "collapsibleId",
      hidden: "hidden"
    },
    outputs: {
      hiddenEvent: "hiddenEvent"
    },
    standalone: false,
    decls: 4,
    vars: 2,
    consts: [["type", "button", 1, "button", "is-small", 3, "click"], [1, "icon"], ["class", "fas fa-angle-down", 4, "ngIf"], ["class", "fas fa-angle-up", 4, "ngIf"], [1, "fas", "fa-angle-down"], [1, "fas", "fa-angle-up"]],
    template: function CollapsibleButtonComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function CollapsibleButtonComponent_Template_button_click_0_listener() {
          return ctx.setHidden();
        });
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵtemplate(2, CollapsibleButtonComponent_i_2_Template, 1, 0, "i", 2)(3, CollapsibleButtonComponent_i_3_Template, 1, 0, "i", 3);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hidden);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.hidden);
      }
    },
    dependencies: [i2.NgIf],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapsibleButtonComponent, [{
    type: Component,
    args: [{
      selector: 'collapsible-button',
      template: `
  <button class="button is-small" type="button" (click)="setHidden()">
    <span class="icon">
      <i *ngIf="hidden" class="fas fa-angle-down"></i>
      <i *ngIf="!hidden" class="fas fa-angle-up"></i>
    </span>
  </button>
  `
    }]
  }], null, {
    collapsibleId: [{
      type: Input
    }],
    hidden: [{
      type: Input
    }],
    hiddenEvent: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TrustHolderFormComponent {
  formBuilder;
  trusts;
  trustHolder;
  cancel = new EventEmitter();
  trustHolderRequest = new EventEmitter();
  trustHolderForm;
  selectedTrustThumbPrint = null;
  trustsCopy = [];
  selectedTrusts = [];
  holderFormSubmitted = false;
  formSubmitted = false;
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
  }
  ngOnInit() {
    this.trustsCopy = Object.assign(this.trustsCopy, this.trusts);
    this.createForm();
  }
  onEnter(event) {
    event.preventDefault();
  }
  assignSelectedTrust(event) {
    this.selectedTrustThumbPrint = event;
  }
  createForm() {
    if (this.trustHolder !== null) {
      this.trustHolderForm = this.formBuilder.group({
        trustHolderName: [this.trustHolder.trustHolderName, Validators.required],
        description: [this.trustHolder.description, Validators.required]
      });
      // add the already selected items
      const caList = this.trustHolder.caList;
      this.selectedTrusts = caList;
      // remove from available trusts the already selected trusts
      const temp = [];
      for (const trust of this.trustsCopy) {
        let alreadySelected = false;
        for (const ca of caList) {
          if (ca.thumbPrint === trust.thumbPrint) {
            alreadySelected = true;
            break;
          }
        }
        if (!alreadySelected) {
          temp.push(trust);
        }
      }
      this.trustsCopy = temp;
    } else {
      this.trustHolderForm = this.formBuilder.group({
        trustHolderName: [null, Validators.required],
        description: [null, Validators.required]
      });
    }
  }
  onCancel() {
    this.cancel.emit();
  }
  onSave() {
    this.holderFormSubmitted = true;
    if (!this.trustHolderForm.valid) {
      return;
    }
    const request = {
      trustHolderEntityId: this.trustHolder !== null ? this.trustHolder.trustHolderEntityId : null,
      trustHolderName: this.trustHolderForm.get('trustHolderName').value,
      description: this.trustHolderForm.get('description').value,
      caList: this.selectedTrusts
    };
    this.trustHolderRequest.emit(request);
    this.holderFormSubmitted = false;
  }
  addTrust() {
    if (this.selectedTrustThumbPrint == null || this.selectedTrustThumbPrint === '') {
      this.formSubmitted = true;
      return;
    }
    if (this.selectedTrustThumbPrint !== null) {
      const trustItem = this.getTrustWithThumbPrint(this.selectedTrustThumbPrint);
      this.selectedTrusts.push(this.convert(trustItem));
      this.trustsCopy = this.trustsCopy.filter(trust => trust !== trustItem);
      this.selectedTrustThumbPrint = null;
      this.formSubmitted = false;
    }
  }
  onChangeStatus(extendedTrust) {
    if (extendedTrust.active) {
      extendedTrust.active = false;
    } else {
      extendedTrust.active = true;
    }
  }
  onDelete(trustToDelete) {
    this.selectedTrusts = this.selectedTrusts.filter(trusts => trusts !== trustToDelete);
    this.trustsCopy.push({
      name: trustToDelete.name,
      thumbPrint: trustToDelete.thumbPrint
    });
  }
  convert(trust) {
    return {
      name: trust.name,
      thumbPrint: trust.thumbPrint,
      active: false
    };
  }
  getTrustWithThumbPrint(thumbPrint) {
    return this.trustsCopy.filter(trust => trust.thumbPrint === thumbPrint)[0];
  }
  static ɵfac = function TrustHolderFormComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TrustHolderFormComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TrustHolderFormComponent,
    selectors: [["trust-holder-form"]],
    inputs: {
      trusts: "trusts",
      trustHolder: "trustHolder"
    },
    outputs: {
      cancel: "cancel",
      trustHolderRequest: "trustHolderRequest"
    },
    standalone: false,
    decls: 62,
    vars: 10,
    consts: [[3, "keydown.enter", "formGroup"], [1, "field", "is-horizontal", "is-grouped"], [1, "field-label"], [1, "label"], [1, "field-body"], [1, "field"], [1, "control"], ["id", "trust-holder-name", "type", "text", "name", "trustHolderName", "formControlName", "trustHolderName", 1, "input", "is-small", 3, "placeholder"], ["class", "help is-danger", 4, "ngIf"], ["id", "trust-holder-description", "rows", "8", "name", "description", "formControlName", "description", 1, "textarea", 3, "placeholder"], [1, "field", "is-horizontal", "is-grouped", "has-top-padding"], [1, "select", "is-primary", "is-small"], [3, "change"], [3, "value"], [3, "value", 4, "ngFor", "ngForOf"], ["type", "button", 1, "button", "is-primary", "is-small", 3, "click"], [1, "icon"], [1, "fa", "fa-plus"], [1, "columns-table", "column-padding"], [1, "columns", "columns-table-head", "is-mobile"], [1, "column", "is-hidden-mobile", "is-clickable", "is-6"], [1, "column", "is-hidden-mobile", "is-clickable", "is-4"], [1, "column", "is-hidden-mobile", "is-clickable", "is-1", "has-text-centered"], [1, "fas", "fa-cog"], ["class", "columns-table-body columns is-multiline is-tablet", 4, "ngFor", "ngForOf"], [1, "flex", "flex-row", "flex-end", "button-set-margin"], ["type", "button", 1, "button", "is-small", "margin-right", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-times"], ["type", "button", 1, "button", "is-small", "is-primary", 3, "click", "disabled"], [1, "fas", "fa-save"], [1, "help", "is-danger"], [1, "columns-table-body", "columns", "is-multiline", "is-tablet"], [1, "column", "is-6"], [1, "column", "is-4"], [1, "column", "is-1", "has-text-centered"], ["type", "checkbox", 1, "checkbox", 3, "change", "checked"], ["type", "button", "title", "Ta bort", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"]],
    template: function TrustHolderFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵlistener("keydown.enter", function TrustHolderFormComponent_Template_form_keydown_enter_0_listener($event) {
          return ctx.onEnter($event);
        });
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "label", 3)(4, "span");
        i0.ɵɵtext(5, "Namn");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 4)(7, "div", 5)(8, "div", 6);
        i0.ɵɵelement(9, "input", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, TrustHolderFormComponent_p_10_Template, 2, 0, "p", 8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "div", 1)(12, "div", 2)(13, "label", 3)(14, "span");
        i0.ɵɵtext(15, "Beskrivning");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(16, "div", 4)(17, "div", 5)(18, "div", 6);
        i0.ɵɵelement(19, "textarea", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(20, TrustHolderFormComponent_p_20_Template, 2, 0, "p", 8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(21, "div", 10)(22, "div", 2)(23, "label", 3)(24, "span");
        i0.ɵɵtext(25, "Certifikatsutf\xE4rdare");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(26, "div", 4)(27, "div", 5)(28, "div", 6)(29, "div", 11)(30, "select", 12);
        i0.ɵɵlistener("change", function TrustHolderFormComponent_Template_select_change_30_listener($event) {
          return ctx.assignSelectedTrust($event.target.value);
        });
        i0.ɵɵelementStart(31, "option", 13);
        i0.ɵɵtext(32, "[V\xE4lj certifikatsutf\xE4rdare]");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(33, TrustHolderFormComponent_option_33_Template, 2, 2, "option", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(34, "button", 15);
        i0.ɵɵlistener("click", function TrustHolderFormComponent_Template_button_click_34_listener() {
          return ctx.addTrust();
        });
        i0.ɵɵelementStart(35, "span", 16);
        i0.ɵɵelement(36, "span", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "span");
        i0.ɵɵtext(38, "L\xE4gg till");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(39, TrustHolderFormComponent_p_39_Template, 2, 0, "p", 8);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(40, "div", 18)(41, "div", 19)(42, "div", 20);
        i0.ɵɵtext(43, " Namn ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div", 21);
        i0.ɵɵtext(45, " Id ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 22);
        i0.ɵɵtext(47, " Aktiv ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "div", 22);
        i0.ɵɵelement(49, "span", 23);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(50, TrustHolderFormComponent_div_50_Template, 10, 3, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "div", 25)(52, "button", 26);
        i0.ɵɵlistener("click", function TrustHolderFormComponent_Template_button_click_52_listener() {
          return ctx.onCancel();
        });
        i0.ɵɵelementStart(53, "span", 27);
        i0.ɵɵelement(54, "span", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "span");
        i0.ɵɵtext(56, "Avbryt");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(57, "button", 29);
        i0.ɵɵlistener("click", function TrustHolderFormComponent_Template_button_click_57_listener() {
          return ctx.onSave();
        });
        i0.ɵɵelementStart(58, "span", 27);
        i0.ɵɵelement(59, "span", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(60, "span");
        i0.ɵɵtext(61, "Spara");
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.trustHolderForm);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("placeholder", "Namn");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.trustHolderForm.controls["trustHolderName"].hasError("required") && ctx.holderFormSubmitted);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("placeholder", "Beskrivning");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.trustHolderForm.controls["description"].hasError("required") && ctx.holderFormSubmitted);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("value", "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.trustsCopy);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", (ctx.selectedTrustThumbPrint === null || ctx.selectedTrustThumbPrint === "") && ctx.formSubmitted);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("ngForOf", ctx.selectedTrusts);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", (ctx.selectedTrusts == null ? null : ctx.selectedTrusts.length) === 0);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i1$2.ɵNgNoValidate, i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i1$2.FormControlName],
    styles: ["[_nghost-%COMP%]   .has-top-padding[_ngcontent-%COMP%]{padding-top:20px}[_nghost-%COMP%]   .button-set-margin[_ngcontent-%COMP%]{margin-top:20px}[_nghost-%COMP%]   .column-padding[_ngcontent-%COMP%]{padding-top:12px;padding-bottom:20px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrustHolderFormComponent, [{
    type: Component,
    args: [{
      selector: 'trust-holder-form',
      template: "<form (keydown.enter)=\"onEnter($event)\" [formGroup]=\"trustHolderForm\">\r\n\r\n  <div class=\"field is-horizontal is-grouped\">\r\n    <div class=\"field-label\">\r\n      <label class=\"label\">\r\n        <span>Namn</span>\r\n      </label>\r\n    </div>\r\n    <div class=\"field-body\">\r\n      <div class=\"field\">\r\n        <div class=\"control\">\r\n          <input id=\"trust-holder-name\" type=\"text\" class=\"input is-small\" name=\"trustHolderName\" formControlName=\"trustHolderName\"\r\n            [placeholder]=\"'Namn'\">\r\n        </div>\r\n        <p *ngIf=\"trustHolderForm.controls['trustHolderName'].hasError('required') && holderFormSubmitted\" class=\"help is-danger\">\r\n          Namn m\u00E5ste anges.\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"field is-horizontal is-grouped\">\r\n    <div class=\"field-label\">\r\n      <label class=\"label\">\r\n        <span>Beskrivning</span>\r\n      </label>\r\n    </div>\r\n    <div class=\"field-body\">\r\n      <div class=\"field\">\r\n        <div class=\"control\">\r\n          <textarea id=\"trust-holder-description\" rows=\"8\" class=\"textarea\" name=\"description\" formControlName=\"description\"\r\n            [placeholder]=\"'Beskrivning'\"></textarea>\r\n        </div>\r\n        <p *ngIf=\"trustHolderForm.controls['description'].hasError('required') && holderFormSubmitted\" class=\"help is-danger\">\r\n          Beskrivning m\u00E5ste anges.\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"field is-horizontal is-grouped has-top-padding\">\r\n    <div class=\"field-label\">\r\n      <label class=\"label\">\r\n        <span>Certifikatsutf\u00E4rdare</span>\r\n      </label>\r\n    </div>\r\n    <div class=\"field-body\">\r\n      <div class=\"field\">\r\n        <div class=\"control\">\r\n          <div class=\"select is-primary is-small\">\r\n            <select (change)=\"assignSelectedTrust($event.target.value)\">\r\n              <option [value]=\"''\">[V\u00E4lj certifikatsutf\u00E4rdare]</option>\r\n              <option *ngFor=\"let trust of trustsCopy\" [value]=\"trust.thumbPrint\">{{ trust.name }}\r\n              </option>\r\n            </select>\r\n          </div>\r\n          <button type=\"button\" (click)=\"addTrust()\" class=\"button is-primary is-small\">\r\n            <span class=\"icon\">\r\n              <span class=\"fa fa-plus\"></span>\r\n            </span>\r\n            <span>L\u00E4gg till</span>\r\n          </button>\r\n          <p *ngIf=\"(selectedTrustThumbPrint === null || selectedTrustThumbPrint === '') && formSubmitted\" class=\"help is-danger\">\r\n            Certifikatsutf\u00E4rdare m\u00E5ste v\u00E4ljas.\r\n          </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"columns-table column-padding\">\r\n    <div class=\"columns columns-table-head is-mobile\">\r\n\r\n      <div class=\"column is-hidden-mobile is-clickable is-6\">\r\n        Namn\r\n      </div>\r\n\r\n      <div class=\"column is-hidden-mobile is-clickable is-4\">\r\n        Id\r\n      </div>\r\n\r\n      <div class=\"column is-hidden-mobile is-clickable is-1 has-text-centered\">\r\n        Aktiv\r\n      </div>\r\n\r\n      <div class=\"column is-hidden-mobile is-clickable is-1 has-text-centered\">\r\n        <span class=\"fas fa-cog\"></span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"columns-table-body columns is-multiline is-tablet\" *ngFor=\"let trust of selectedTrusts\">\r\n      <div class=\"column is-6\">\r\n        {{ trust.name }}\r\n      </div>\r\n\r\n      <div class=\"column is-4\">\r\n        {{ trust.thumbPrint }}\r\n      </div>\r\n\r\n      <div class=\"column is-1 has-text-centered\">\r\n        <input type=\"checkbox\" class=\"checkbox\" [checked]=\"trust.active\" (change)=\"onChangeStatus(trust)\">\r\n      </div>\r\n\r\n      <div class=\"column is-1 has-text-centered\">\r\n        <button type=\"button\" class=\"button is-small\" (click)=\"onDelete(trust)\" title=\"Ta bort\">\r\n          <span class=\"fas fa-trash\"></span>\r\n        </button>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"flex flex-row flex-end button-set-margin\">\r\n    <button type=\"button\" (click)=\"onCancel()\" class=\"button is-small margin-right\">\r\n      <span class=\"icon is-small\">\r\n        <span class=\"fas fa-times\"></span>\r\n      </span>\r\n      <span>Avbryt</span>\r\n    </button>\r\n    <button type=\"button\" (click)=\"onSave()\" class=\"button is-small is-primary\" [disabled]=\"selectedTrusts?.length === 0\">\r\n      <span class=\"icon is-small\">\r\n        <span class=\"fas fa-save\"></span>\r\n      </span>\r\n      <span>Spara</span>\r\n    </button>\r\n  </div>\r\n</form>\r\n",
      styles: [":host .has-top-padding{padding-top:20px}:host .button-set-margin{margin-top:20px}:host .column-padding{padding-top:12px;padding-bottom:20px}\n"]
    }]
  }], () => [{
    type: i1$2.FormBuilder
  }], {
    trusts: [{
      type: Input
    }],
    trustHolder: [{
      type: Input
    }],
    cancel: [{
      type: Output
    }],
    trustHolderRequest: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TrustHolderTableComponent {
  trustHolder;
  needsRenewal(validTo) {
    return DateUtil.needsRenewal(validTo);
  }
  isExpired(validTo) {
    return DateUtil.isExpired(validTo);
  }
  getWarnTooltip(validTo) {
    return DateUtil.getWarnTooltip(validTo);
  }
  static ɵfac = function TrustHolderTableComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TrustHolderTableComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TrustHolderTableComponent,
    selectors: [["trust-holder-table"]],
    inputs: {
      trustHolder: "trustHolder"
    },
    standalone: false,
    decls: 11,
    vars: 1,
    consts: [[1, "columns-table"], [1, "columns", "column-table-head", "is-mobile"], [1, "column", "is-hidden-mobile", "is-clickable", "is-4", "has-text-weight-bold"], [1, "column", "is-hidden-mobile", "is-clickable", "is-5", "has-text-weight-bold"], [1, "column", "is-hidden-mobile", "is-clickable", "is-2", "has-text-weight-bold"], [1, "column", "is-1", "is-hidden-mobile", "has-text-centered", "has-text-weight-bold"], ["class", "columns-table-body columns is-multiline is-tablet", 4, "ngFor", "ngForOf"], [1, "columns-table-body", "columns", "is-multiline", "is-tablet"], [1, "column", "is-4"], [1, "column", "is-5"], [1, "column", "is-2"], ["class", "tooltip is-tooltip-left is-tooltip-multiline", "style", "float: right;", 4, "ngIf"], [1, "column", "is-1", "is-hidden-mobile", "has-text-centered"], [1, "tooltip", "is-tooltip-left", "is-tooltip-multiline", 2, "float", "right"], [1, "fas", "fa-exclamation-triangle"]],
    template: function TrustHolderTableComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, " Namn ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtext(5, " Id ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵtext(7, " Giltig till ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵtext(9, " Aktiv ");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(10, TrustHolderTableComponent_div_10_Template, 11, 12, "div", 6);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngForOf", ctx.trustHolder.caList);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i2.DatePipe],
    styles: [_c8]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrustHolderTableComponent, [{
    type: Component,
    args: [{
      selector: 'trust-holder-table',
      template: "<div class=\"columns-table\">\n  <div class=\"columns column-table-head is-mobile\">\n    <div class=\"column is-hidden-mobile is-clickable is-4 has-text-weight-bold\">\n      Namn\n    </div>\n    <div class=\"column is-hidden-mobile is-clickable is-5 has-text-weight-bold\">\n      Id\n    </div>\n    <div class=\"column is-hidden-mobile is-clickable is-2 has-text-weight-bold\">\n      Giltig till\n    </div>\n    <div class=\"column is-1 is-hidden-mobile has-text-centered has-text-weight-bold\">\n      Aktiv\n    </div>\n  </div>\n  <div class=\"columns-table-body columns is-multiline is-tablet\" *ngFor=\"let trust of trustHolder.caList\">\n    <div class=\"column is-4\">\n      {{ trust.name }}\n    </div>\n    <div class=\"column is-5\">\n      {{ trust.thumbPrint }}\n    </div>\n    <div class=\"column is-2\" [class.needs-renewal]=\"needsRenewal(trust.validTo)\"\n      [class.expired]=\"isExpired(trust.validTo)\">\n      {{ (trust.validTo | date : \"YYYY-MM-dd\") ?? \"Ej angivet\"}}\n      <span *ngIf=\"needsRenewal(trust.validTo)\" class=\"tooltip is-tooltip-left is-tooltip-multiline\"\n      [attr.data-tooltip]=\"getWarnTooltip(trust.validTo)\" style=\"float: right;\">\n      <span class=\"fas fa-exclamation-triangle\"></span>\n    </span>\n    </div>\n    <div class=\"column is-1 is-hidden-mobile has-text-centered\">\n      {{ trust.active ? 'Ja' : 'Nej' }}\n    </div>\n  </div>\n</div>",
      styles: [".needs-renewal{background-color:#f6a519;color:#fff;padding-right:10px}.expired{background-color:#e81d38!important;color:#fff;padding-right:10px}\n"]
    }]
  }], null, {
    trustHolder: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TrustHolderManagerComponent {
  tlsService;
  trustDataSource;
  trustHolderDataSource;
  dialogService;
  collapsibleItems;
  trustHolderSaved = new EventEmitter();
  trustHolderDeleted = new EventEmitter();
  // collapse by default
  hidden = true;
  edit = false;
  allTrusts;
  trustHolderToEdit;
  confirmationModalOptions = {
    buttonPrimary: 'Ta bort'
  };
  trustHolders$;
  constructor(tlsService, trustDataSource, trustHolderDataSource, dialogService) {
    this.tlsService = tlsService;
    this.trustDataSource = trustDataSource;
    this.trustHolderDataSource = trustHolderDataSource;
    this.dialogService = dialogService;
  }
  ngOnInit() {
    this.trustDataSource.connect().subscribe(it => {
      this.allTrusts = it;
    });
    this.trustHolders$ = this.trustHolderDataSource.connect();
  }
  handleHiddenEvent(hideEvent) {
    const result = this.collapsibleItems.find(item => item.collapsibleId === hideEvent.id);
    result.collapseComponent(hideEvent.hidden);
  }
  doEdit(trustHolder) {
    this.edit = true;
    this.trustHolderToEdit = trustHolder;
  }
  cancel() {
    this.edit = false;
  }
  saveTrustHolder(request) {
    this.tlsService.addTrustHolder(request).subscribe(() => {
      this.cancel();
      this.trustHolderDataSource.fetch();
      this.trustHolderSaved.emit(['Förtroendekällan har sparats', 'Sparad']);
    });
  }
  deleteTrustHolder(trustHolderToDelete) {
    this.dialogService.open({
      title: 'Ta bort förtroendekälla',
      message: 'Vill du ta bort förtroendekällan ' + trustHolderToDelete.trustHolderName
    }).subscribe(result => {
      if (result) {
        this.tlsService.deleteTrustHolder(trustHolderToDelete.trustHolderEntityId).subscribe(() => {
          this.trustHolderDataSource.fetch();
          this.trustHolderDeleted.emit(['Förtroendekällan har tagits bort', 'Borttagen']);
        });
      }
    });
  }
  static ɵfac = function TrustHolderManagerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TrustHolderManagerComponent)(i0.ɵɵdirectiveInject(TlsService), i0.ɵɵdirectiveInject(TrustDataSource), i0.ɵɵdirectiveInject(TrustHolderDataSource), i0.ɵɵdirectiveInject(DialogService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TrustHolderManagerComponent,
    selectors: [["trustholder-manager"]],
    viewQuery: function TrustHolderManagerComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c9, 5, CollapsibleComponent);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.collapsibleItems = _t);
      }
    },
    outputs: {
      trustHolderSaved: "trustHolderSaved",
      trustHolderDeleted: "trustHolderDeleted"
    },
    standalone: false,
    decls: 7,
    vars: 3,
    consts: [["collapsibleItem", ""], [1, "columns"], [1, "column", "box"], [1, "box-title"], ["id", "add-key-group", "class", "button is-primary is-small", 3, "click", 4, "ngIf"], [3, "trusts", "trustHolder", "trustHolderRequest", "cancel", 4, "ngIf"], [4, "ngIf"], ["id", "add-key-group", 1, "button", "is-primary", "is-small", 3, "click"], [1, "icon"], [1, "fas", "fa-plus"], [3, "trustHolderRequest", "cancel", "trusts", "trustHolder"], ["class", "column box has-margin", 4, "ngFor", "ngForOf"], [1, "column", "box", "has-margin"], [1, "column"], [1, "buttons", "is-pulled-right"], [1, "button", "is-small", 3, "click"], [1, "fas", "fa-edit"], [1, "fas", "fa-trash-alt"], [3, "hiddenEvent", "collapsibleId", "hidden"], [1, "has-bottom-padding"], [3, "collapsibleId", "hidden"], [3, "trustHolder"]],
    template: function TrustHolderManagerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
        i0.ɵɵtext(3, "F\xF6rtroendek\xE4llor");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, TrustHolderManagerComponent_a_4_Template, 5, 0, "a", 4)(5, TrustHolderManagerComponent_trust_holder_form_5_Template, 1, 2, "trust-holder-form", 5)(6, TrustHolderManagerComponent_div_6_Template, 3, 3, "div", 6);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.edit);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.edit);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.edit);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, CollapsibleComponent, CollapsibleButtonComponent, TrustHolderFormComponent, TrustHolderTableComponent, i2.AsyncPipe],
    styles: ["[_nghost-%COMP%]   .has-margin[_ngcontent-%COMP%]{margin:.75rem 0}[_nghost-%COMP%]   .has-bottom-padding[_ngcontent-%COMP%]{padding-bottom:18px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrustHolderManagerComponent, [{
    type: Component,
    args: [{
      selector: 'trustholder-manager',
      template: "<div class=\"columns\">\r\n  <div class=\"column box\">\r\n    <div class=\"box-title\">F\u00F6rtroendek\u00E4llor</div>\r\n    <a id=\"add-key-group\" *ngIf=\"!edit\" class=\"button is-primary is-small\" (click)=\"doEdit(null)\">\r\n      <span class=\"icon\">\r\n        <span class=\"fas fa-plus\"></span>\r\n      </span>\r\n      <span>L\u00E4gg till</span>\r\n    </a>\r\n\r\n    <trust-holder-form [trusts]=\"allTrusts\" [trustHolder]=\"trustHolderToEdit\" *ngIf=\"edit\" (trustHolderRequest)=\"saveTrustHolder($event)\"\r\n      (cancel)=\"cancel()\"></trust-holder-form>\r\n\r\n    <div *ngIf=\"!edit\">\r\n      <div class=\"column box has-margin\" *ngFor=\"let trustHolder of trustHolders$ | async; index as i\">\r\n\r\n        <div class=\"columns\">\r\n          <div class=\"column\">\r\n            <div class=\"box-title\">{{ trustHolder.trustHolderName }} </div>\r\n          </div>\r\n\r\n          <div class=\"column\">\r\n            <div class=\"buttons is-pulled-right\">\r\n              <button class=\"button is-small\" (click)=\"doEdit(trustHolder)\">\r\n                <span class=\"icon\">\r\n                  <span class=\"fas fa-edit\"></span>\r\n                </span>\r\n                <span>Editera</span>\r\n              </button>\r\n              <button class=\"button is-small\" (click)=\"deleteTrustHolder(trustHolder)\">\r\n                <span class=\"icon\">\r\n                  <span class=\"fas fa-trash-alt\"></span>\r\n                </span>\r\n                <span>Ta bort f\u00F6rtroendek\u00E4lla</span>\r\n              </button>\r\n              <collapsible-button [collapsibleId]=\"'collapsible-'+i\" [hidden]=\"hidden\" (hiddenEvent)=\"handleHiddenEvent($event)\">\r\n              </collapsible-button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"has-bottom-padding\">{{ trustHolder.description }}</div>\r\n\r\n        <collapsible #collapsibleItem [collapsibleId]=\"'collapsible-'+i\" [hidden]=\"hidden\">\r\n          <trust-holder-table [trustHolder]=\"trustHolder\"></trust-holder-table>\r\n        </collapsible>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
      styles: [":host .has-margin{margin:.75rem 0}:host .has-bottom-padding{padding-bottom:18px}\n"]
    }]
  }], () => [{
    type: TlsService
  }, {
    type: TrustDataSource
  }, {
    type: TrustHolderDataSource
  }, {
    type: DialogService
  }], {
    collapsibleItems: [{
      type: ViewChildren,
      args: ['collapsibleItem', {
        read: CollapsibleComponent
      }]
    }],
    trustHolderSaved: [{
      type: Output
    }],
    trustHolderDeleted: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CollapsibleModule {
  static ɵfac = function CollapsibleModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CollapsibleModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CollapsibleModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapsibleModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [CollapsibleComponent, CollapsibleButtonComponent],
      exports: [CollapsibleComponent, CollapsibleButtonComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DropzoneModule {
  static ɵfac = function DropzoneModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropzoneModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DropzoneModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropzoneModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [DropzoneDirective],
      exports: [DropzoneDirective]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CertificateManagerModule {
  static ɵfac = function CertificateManagerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CertificateManagerModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CertificateManagerModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [TlsService, IdentityDataSource, TrustDataSource, TrustHolderDataSource],
    imports: [CommonModule, ReactiveFormsModule, ModalModule, UploadModule, PaginationModule, UtilModule, CollapsibleModule, DropzoneModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CertificateManagerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, ModalModule, UploadModule, PaginationModule, UtilModule, CollapsibleModule, DropzoneModule],
      declarations: [TrustManagerComponent, TrustHolderManagerComponent, CertificateManagerComponent, IdentityFormComponent, IdentityTableComponent, CertificateFormComponent, TrustHolderFormComponent, TrustHolderTableComponent],
      exports: [TrustManagerComponent, TrustHolderManagerComponent, CertificateManagerComponent],
      providers: [TlsService, IdentityDataSource, TrustDataSource, TrustHolderDataSource]
    }]
  }], null, null);
})();
class MonitoredCertificateService {
  http;
  apiUrl;
  constructor(http) {
    this.http = http;
    this.apiUrl = '/api/pkix';
  }
  getMonitoredCertificates() {
    return this.http.get(`${this.apiUrl}/monitored-certificates`);
  }
  getMailReceivers() {
    return this.http.get(`${this.apiUrl}/mail-receivers`);
  }
  deleteMailReceiver(mailReceiverEntityId) {
    return this.http.delete(`${this.apiUrl}/delete-mail-receiver?mailReceiverId=${mailReceiverEntityId}`);
  }
  addMailReceiver(mailReceiver) {
    return this.http.post(`${this.apiUrl}/add-mail-receivers`, mailReceiver);
  }
  static ɵfac = function MonitoredCertificateService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MonitoredCertificateService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MonitoredCertificateService,
    factory: MonitoredCertificateService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonitoredCertificateService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class MonitoredCertificateDataSource {
  monitoredCertificateService;
  monitoredCertificates = new BehaviorSubject([]);
  constructor(monitoredCertificateService) {
    this.monitoredCertificateService = monitoredCertificateService;
    this.fetch();
  }
  fetch() {
    this.monitoredCertificateService.getMonitoredCertificates().subscribe(result => {
      this.monitoredCertificates.next(result);
    });
  }
  connect() {
    return this.monitoredCertificates.asObservable();
  }
  static ɵfac = function MonitoredCertificateDataSource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MonitoredCertificateDataSource)(i0.ɵɵinject(MonitoredCertificateService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MonitoredCertificateDataSource,
    factory: MonitoredCertificateDataSource.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonitoredCertificateDataSource, [{
    type: Injectable
  }], () => [{
    type: MonitoredCertificateService
  }], null);
})();

/*
 * Copyright (C) 2020 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CertificateMonitorComponent {
  datasource;
  monitoredCertificates;
  sortOrderBy = null;
  sortReverse = false;
  dataSortPipe = new DataSortPipe();
  constructor(datasource) {
    this.datasource = datasource;
  }
  ngOnInit() {
    this.datasource.connect().subscribe(it => {
      this.monitoredCertificates = it;
    });
  }
  setOrderBy(orderBy) {
    if (this.sortOrderBy === orderBy) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortOrderBy = orderBy;
      this.sortReverse = false;
    }
    this.monitoredCertificates = this.dataSortPipe.transform(this.monitoredCertificates, this.sortOrderBy, this.sortReverse);
  }
  hasExpired(validStatus) {
    return validStatus === 'EXPIRED';
  }
  determineIconColor(validStatus) {
    let iconString = '';
    if (validStatus === 'OK') {
      iconString = 'icon has-text-success';
    } else if (validStatus === 'WARNING') {
      iconString = 'icon has-text-warning';
    } else if (validStatus === 'EXPIRED') {
      iconString = 'icon has-text-danger';
    }
    return iconString;
  }
  formatDuration(unformattedDuration) {
    const duration = moment.duration(unformattedDuration);
    let durationString = '';
    if (duration.years() !== 0) {
      durationString += duration.years() + 'å ';
    }
    if (duration.months() !== 0) {
      durationString += duration.months() + 'm ';
    }
    if (duration.days() !== 0) {
      durationString += duration.days() + 'd';
    }
    return durationString;
  }
  static ɵfac = function CertificateMonitorComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CertificateMonitorComponent)(i0.ɵɵdirectiveInject(MonitoredCertificateDataSource));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CertificateMonitorComponent,
    selectors: [["certificate-monitor"]],
    standalone: false,
    decls: 6,
    vars: 2,
    consts: [[1, "columns"], [1, "column", "box"], [1, "box-title"], ["class", "columns-table", 4, "ngIf"], [4, "ngIf"], [1, "columns-table"], [1, "columns", "column-table-head", "is-mobile"], [1, "column", "is-hidden-mobile", "is-clickable", "is-4", 3, "click"], [1, "column", "is-hidden-mobile", "is-clickable", "is-1", 3, "click"], [1, "column", "is-hidden-mobile", "is-clickable", "is-2", 3, "click"], ["id", "monitored-certificate-table-row", "class", "columns-table-body columns is-multiline is-tablet", 4, "ngFor", "ngForOf"], ["id", "monitored-certificate-table-row", 1, "columns-table-body", "columns", "is-multiline", "is-tablet"], [1, "column", "is-4"], [1, "column", "is-1"], [1, "column", "is-2"], [3, "ngClass"], [1, "fas", "fa-circle"]],
    template: function CertificateMonitorComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, "\xD6vervakade certifikat");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CertificateMonitorComponent_div_4_Template, 13, 1, "div", 3)(5, CertificateMonitorComponent_div_5_Template, 3, 0, "div", 4);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.monitoredCertificates.length > 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.monitoredCertificates.length <= 0);
      }
    },
    dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CertificateMonitorComponent, [{
    type: Component,
    args: [{
      selector: 'certificate-monitor',
      template: "<div class=\"columns\">\n  <div class=\"column box\">\n    <div class=\"box-title\">\u00D6vervakade certifikat</div>\n\n    <div *ngIf=\"monitoredCertificates.length > 0\" class=\"columns-table\">\n      <div class=\"columns column-table-head is-mobile\">\n        <div class=\"column is-hidden-mobile is-clickable is-4\" (click)=\"setOrderBy('subjectCN')\">\n          Namn\n        </div>\n        <div class=\" column is-hidden-mobile is-clickable is-4\" (click)=\"setOrderBy('issuerCN')\">\n          Utf\u00E4rdare\n        </div>\n        <div class=\"column is-hidden-mobile is-clickable is-1\" (click)=\"setOrderBy('validFrom')\">\n          Giltigt fr\u00E5n\n        </div>\n        <div class=\"column is-hidden-mobile is-clickable is-1\" (click)=\"setOrderBy('validTo')\">\n          Giltigt till\n        </div>\n        <div class=\"column is-hidden-mobile is-clickable is-2\" (click)=\"setOrderBy('validTo')\">\n          Tid till utg\u00E5ngsdatum\n        </div>\n      </div>\n      <div id=\"monitored-certificate-table-row\" class=\"columns-table-body columns is-multiline is-tablet\"\n        *ngFor=\"let monitoredCertificate of monitoredCertificates\">\n        <div class=\"column is-4\">\n          {{ monitoredCertificate.subjectCN }}\n        </div>\n        <div class=\"column is-4\">\n          {{ monitoredCertificate.issuerCN }}\n        </div>\n        <div class=\"column is-1\">\n          {{ monitoredCertificate.validFrom }}\n        </div>\n        <div class=\"column is-1\">\n          {{ monitoredCertificate.validTo }}\n        </div>\n        <div class=\"column is-2\">\n          <span [ngClass]=\"determineIconColor(monitoredCertificate.validStatus)\">\n            <em class=\"fas fa-circle\"></em>\n          </span>\n          {{ hasExpired(monitoredCertificate.validStatus) ? 'Utg\u00E5nget' : formatDuration(monitoredCertificate.timeToExpiration) }}\n        </div>\n      </div>\n    </div>\n\n    <div *ngIf=\"monitoredCertificates.length <= 0\">\n      <p>Inga certifikat tillagda f\u00F6r \u00F6vervakning.</p>\n    </div>\n\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: MonitoredCertificateDataSource
  }], null);
})();

/*
 * Copyright (C) 2020 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class MailReceiverDatasource {
  monitoredCertificateService;
  mailReceivers = new BehaviorSubject([]);
  constructor(monitoredCertificateService) {
    this.monitoredCertificateService = monitoredCertificateService;
    this.fetch();
  }
  fetch() {
    this.monitoredCertificateService.getMailReceivers().subscribe(result => {
      this.mailReceivers.next(result);
    });
  }
  connect() {
    return this.mailReceivers.asObservable();
  }
  static ɵfac = function MailReceiverDatasource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MailReceiverDatasource)(i0.ɵɵinject(MonitoredCertificateService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MailReceiverDatasource,
    factory: MailReceiverDatasource.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailReceiverDatasource, [{
    type: Injectable
  }], () => [{
    type: MonitoredCertificateService
  }], null);
})();

/*
 * Copyright (C) 2020 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class MailReceiverFormComponent {
  formBuilder;
  cancel = new EventEmitter();
  mailReceiverRequest = new EventEmitter();
  mailReceiverForm;
  mailReceiverFormSubmitted = false;
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
  }
  ngOnInit() {
    this.createForm();
  }
  onEnter(event) {
    event.preventDefault();
  }
  createForm() {
    this.mailReceiverForm = this.formBuilder.group({
      mailReceiverMailAddress: [null, Validators.email]
    });
  }
  onSave() {
    this.mailReceiverFormSubmitted = true;
    if (!this.mailReceiverForm.valid) {
      return;
    }
    const request = {
      mailReceiverEntityId: null,
      mailAddress: this.mailReceiverForm.get('mailReceiverMailAddress').value
    };
    this.mailReceiverRequest.emit(request);
    this.mailReceiverFormSubmitted = false;
  }
  onCancel() {
    this.cancel.emit();
  }
  static ɵfac = function MailReceiverFormComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MailReceiverFormComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MailReceiverFormComponent,
    selectors: [["mail-receiver-form"]],
    outputs: {
      cancel: "cancel",
      mailReceiverRequest: "mailReceiverRequest"
    },
    standalone: false,
    decls: 22,
    vars: 3,
    consts: [[3, "keydown.enter", "formGroup"], [1, "field", "is-horizontal"], [1, "field-label"], [1, "label"], [1, "field-body"], [1, "field"], [1, "control"], ["id", "mail-receiver-mail-address", "type", "email", "name", "mailReceiverMailAddress", "formControlName", "mailReceiverMailAddress", 1, "input", "is-small", 3, "placeholder"], ["class", "help is-danger", 4, "ngIf"], [1, "flex", "flex-row", "flex-end", "button-set-margin"], ["type", "button", 1, "button", "is-small", "margin-right", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-times"], ["type", "button", 1, "button", "is-small", "is-primary", 3, "click"], [1, "fas", "fa-save"], [1, "help", "is-danger"]],
    template: function MailReceiverFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵlistener("keydown.enter", function MailReceiverFormComponent_Template_form_keydown_enter_0_listener($event) {
          return ctx.onEnter($event);
        });
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "label", 3)(4, "span");
        i0.ɵɵtext(5, "Mailadress");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 4)(7, "div", 5)(8, "div", 6);
        i0.ɵɵelement(9, "input", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, MailReceiverFormComponent_p_10_Template, 2, 0, "p", 8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "div", 9)(12, "button", 10);
        i0.ɵɵlistener("click", function MailReceiverFormComponent_Template_button_click_12_listener() {
          return ctx.onCancel();
        });
        i0.ɵɵelementStart(13, "span", 11);
        i0.ɵɵelement(14, "span", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "span");
        i0.ɵɵtext(16, "Avbryt");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(17, "button", 13);
        i0.ɵɵlistener("click", function MailReceiverFormComponent_Template_button_click_17_listener() {
          return ctx.onSave();
        });
        i0.ɵɵelementStart(18, "span", 11);
        i0.ɵɵelement(19, "span", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "span");
        i0.ɵɵtext(21, "Spara");
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.mailReceiverForm);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("placeholder", "Mailadress");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.mailReceiverForm.controls["mailReceiverMailAddress"].hasError("email") && ctx.mailReceiverFormSubmitted);
      }
    },
    dependencies: [i2.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i1$2.FormControlName],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailReceiverFormComponent, [{
    type: Component,
    args: [{
      selector: 'mail-receiver-form',
      template: "<form (keydown.enter)=\"onEnter($event)\" [formGroup]=\"mailReceiverForm\">\n  <div class=\"field is-horizontal\">\n    <div class=\"field-label\">\n      <label class=\"label\">\n        <span>Mailadress</span>\n      </label>\n    </div>\n    <div class=\"field-body\">\n      <div class=\"field\">\n        <div class=\"control\">\n          <input id=\"mail-receiver-mail-address\" type=\"email\" class=\"input is-small\" name=\"mailReceiverMailAddress\"\n            formControlName=\"mailReceiverMailAddress\" [placeholder]=\"'Mailadress'\">\n        </div>\n        <p *ngIf=\"mailReceiverForm.controls['mailReceiverMailAddress'].hasError('email') && mailReceiverFormSubmitted\"\n          class=\"help is-danger\">\n          Mailadress m\u00E5ste anges.\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"flex flex-row flex-end button-set-margin\">\n    <button type=\"button\" (click)=\"onCancel()\" class=\"button is-small margin-right\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-times\"></span>\n      </span>\n      <span>Avbryt</span>\n    </button>\n    <button type=\"button\" (click)=\"onSave()\" class=\"button is-small is-primary\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-save\"></span>\n      </span>\n      <span>Spara</span>\n    </button>\n  </div>\n\n</form>\n"
    }]
  }], () => [{
    type: i1$2.FormBuilder
  }], {
    cancel: [{
      type: Output
    }],
    mailReceiverRequest: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2020 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class MailReceiverManagerComponent {
  datasource;
  monitoredCertificateService;
  dialogService;
  confirmationModal;
  mailReceiverSaved = new EventEmitter();
  mailReceiverDeleted = new EventEmitter();
  mailReceivers;
  sortOrderBy = '';
  sortReverse = false;
  edit = false;
  mailReceiverToEdit;
  confirmationModalOptions = {
    buttonPrimary: 'Ta bort'
  };
  dataSortPipe = new DataSortPipe();
  constructor(datasource, monitoredCertificateService, dialogService) {
    this.datasource = datasource;
    this.monitoredCertificateService = monitoredCertificateService;
    this.dialogService = dialogService;
  }
  ngOnInit() {
    this.datasource.connect().subscribe(it => {
      this.mailReceivers = it;
    });
  }
  setOrderBy(orderBy) {
    if (this.sortOrderBy === orderBy) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortOrderBy = orderBy;
      this.sortReverse = false;
    }
    this.dataSortPipe.transform(this.mailReceivers, this.sortOrderBy, this.sortReverse);
  }
  addMailReceiver(mailReceiver) {
    this.edit = true;
    this.mailReceiverToEdit = mailReceiver;
  }
  saveMailReceiver(mailReceiver) {
    this.monitoredCertificateService.addMailReceiver(mailReceiver).subscribe(() => {
      this.cancel();
      this.datasource.fetch();
      this.mailReceiverSaved.emit(['Mailadressen har sparats', 'Sparad']);
    });
  }
  cancel() {
    this.edit = false;
  }
  deleteMailReceiver(mailReceiverToDelete) {
    this.dialogService.open({
      title: 'Ta bort mailadress',
      message: 'Vill du ta bort mailadressen ' + mailReceiverToDelete.mailAddress
    }).subscribe(result => {
      if (result) {
        this.monitoredCertificateService.deleteMailReceiver(mailReceiverToDelete.mailReceiverEntityId).subscribe(() => {
          this.datasource.fetch();
          this.mailReceiverDeleted.emit(['Mailadressen har tagits bort', 'Borttagen']);
        });
      }
    });
  }
  static ɵfac = function MailReceiverManagerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MailReceiverManagerComponent)(i0.ɵɵdirectiveInject(MailReceiverDatasource), i0.ɵɵdirectiveInject(MonitoredCertificateService), i0.ɵɵdirectiveInject(DialogService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MailReceiverManagerComponent,
    selectors: [["mail-receiver-manager"]],
    viewQuery: function MailReceiverManagerComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c10, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmationModal = _t.first);
      }
    },
    outputs: {
      mailReceiverSaved: "mailReceiverSaved",
      mailReceiverDeleted: "mailReceiverDeleted"
    },
    standalone: false,
    decls: 8,
    vars: 4,
    consts: [[1, "columns"], [1, "column", "box"], [1, "box-title"], ["id", "add-key-group", "class", "button is-primary is-small has-margin", 3, "click", 4, "ngIf"], [3, "mailReceiverRequest", "cancel", 4, "ngIf"], ["class", "columns-table", 4, "ngIf"], [4, "ngIf"], ["id", "add-key-group", 1, "button", "is-primary", "is-small", "has-margin", 3, "click"], [1, "icon"], [1, "fas", "fa-plus"], [3, "mailReceiverRequest", "cancel"], [1, "columns-table"], [1, "columns", "columns-table-head", "is-mobile"], [1, "column", "is-hidden-mobile", "is-clickable", "is-11", 3, "click"], ["class", "fas", 3, "fa-sort-down", "fa-sort-up", 4, "ngIf"], [1, "column", "is-1", "is-hidden-mobile", "has-text-centered"], [1, "fas", "fa-cog"], ["id", "table-body-columns", "class", "columns-table-body columns is-multiline is-tablet", 4, "ngFor", "ngForOf"], [1, "fas"], ["id", "table-body-columns", 1, "columns-table-body", "columns", "is-multiline", "is-tablet"], [1, "column", "is-11"], [1, "column", "is-1", "has-text-centered"], ["type", "button", "id", "table-delete", "title", "Ta bort", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"]],
    template: function MailReceiverManagerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3, "Kontaktlista");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MailReceiverManagerComponent_a_4_Template, 5, 0, "a", 3)(5, MailReceiverManagerComponent_mail_receiver_form_5_Template, 1, 0, "mail-receiver-form", 4)(6, MailReceiverManagerComponent_div_6_Template, 8, 2, "div", 5)(7, MailReceiverManagerComponent_div_7_Template, 3, 0, "div", 6);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.edit);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.edit);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.edit && ctx.mailReceivers.length > 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.edit && ctx.mailReceivers.length <= 0);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, MailReceiverFormComponent],
    styles: [_c11]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailReceiverManagerComponent, [{
    type: Component,
    args: [{
      selector: 'mail-receiver-manager',
      template: "<div class=\"columns\">\n  <div class=\"column box\">\n    <div class=\"box-title\">Kontaktlista</div>\n    <a id=\"add-key-group\" *ngIf=\"!edit\" class=\"button is-primary is-small has-margin\" (click)=\"addMailReceiver(null)\">\n      <span class=\"icon\">\n        <span class=\"fas fa-plus\"></span>\n      </span>\n      <span>L\u00E4gg till</span>\n    </a>\n\n    <mail-receiver-form *ngIf=\"edit\" (mailReceiverRequest)=\"saveMailReceiver($event)\" (cancel)=\"cancel()\">\n    </mail-receiver-form>\n\n    <div class=\"columns-table\" *ngIf=\"!edit && mailReceivers.length > 0\">\n      <div class=\"columns columns-table-head is-mobile\">\n\n        <div class=\"column is-hidden-mobile is-clickable is-11\" (click)=\"setOrderBy('mailAddress')\">\n          Mailadress\n          <span *ngIf=\"sortOrderBy === 'mailAddress'\" class=\"fas\" [class.fa-sort-down]=\"!sortReverse\"\n            [class.fa-sort-up]=\"sortReverse\"></span>\n        </div>\n\n        <div class=\"column is-1 is-hidden-mobile has-text-centered\">\n          <span class=\"fas fa-cog\"></span>\n        </div>\n      </div>\n\n      <div id=\"table-body-columns\" class=\"columns-table-body columns is-multiline is-tablet\"\n        *ngFor=\"let mailReceiver of mailReceivers\">\n        <div class=\"column is-11\">\n          {{ mailReceiver.mailAddress }}\n        </div>\n\n        <div class=\"column is-1 has-text-centered\">\n          <button type=\"button\" id=\"table-delete\" class=\"button is-small\" (click)=\"deleteMailReceiver(mailReceiver)\"\n            title=\"Ta bort\">\n            <span class=\"fas fa-trash\"></span>\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <div *ngIf=\"!edit && mailReceivers.length <= 0\">\n      <p>Inga kontakter tillagda.</p>\n    </div>\n\n  </div>\n</div>\n",
      styles: [":host .has-margin{margin:.75rem 0}:host .has-bottom-padding{padding-bottom:18px}\n"]
    }]
  }], () => [{
    type: MailReceiverDatasource
  }, {
    type: MonitoredCertificateService
  }, {
    type: DialogService
  }], {
    confirmationModal: [{
      type: ViewChild,
      args: ['confirmationModal']
    }],
    mailReceiverSaved: [{
      type: Output
    }],
    mailReceiverDeleted: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2020 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CertificateMonitorManagerModule {
  static ɵfac = function CertificateMonitorManagerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CertificateMonitorManagerModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CertificateMonitorManagerModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [MonitoredCertificateService, MonitoredCertificateDataSource, MailReceiverDatasource],
    imports: [CommonModule, ReactiveFormsModule, ModalModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CertificateMonitorManagerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, ModalModule],
      exports: [CertificateMonitorComponent, MailReceiverManagerComponent],
      declarations: [CertificateMonitorComponent, MailReceiverManagerComponent, MailReceiverFormComponent],
      providers: [MonitoredCertificateService, MonitoredCertificateDataSource, MailReceiverDatasource]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class SanitizeHtmlPipe {
  sanitizer;
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
  }
  transform(value) {
    return this.sanitizer.sanitize(SecurityContext.HTML, value);
  }
  static ɵfac = function SanitizeHtmlPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SanitizeHtmlPipe)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer, 16));
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "sanitizeHtml",
    type: SanitizeHtmlPipe,
    pure: true,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SanitizeHtmlPipe, [{
    type: Pipe,
    args: [{
      name: 'sanitizeHtml'
    }]
  }], () => [{
    type: i1$3.DomSanitizer
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CliComponent {
  el;
  promptContainer;
  promptEl;
  execute = new EventEmitter();
  options;
  promptLoading = false;
  progressLoader;
  progressInterval;
  cmdHistory = [];
  historyIndex = -1;
  promptHistory = [];
  opts = {
    prompt: '$',
    background: '#000',
    color: '#eee',
    cmdColor: '#ccc'
  };
  constructor(el) {
    this.el = el;
  }
  ngOnChanges(changes) {
    if (changes['options'].currentValue !== undefined) {
      this.opts = Object.assign(this.opts, this.options);
    }
  }
  handleKey(keyEvent) {
    switch (keyEvent.key) {
      case 'Enter':
        {
          this.executeCmd();
          break;
        }
      case 'ArrowUp':
        {
          this.handleArrowKeyHistory(this.nextHistory());
          break;
        }
      case 'ArrowDown':
        {
          this.handleArrowKeyHistory(this.prevHistory());
          break;
        }
      default:
        break;
    }
  }
  handlePaste(pasteEvent) {
    pasteEvent.preventDefault();
    const text = pasteEvent.clipboardData.getData('text/plain').trim();
    this.gotoEnd();
    document.execCommand('insertHTML', false, text);
  }
  executeCmd() {
    const cmd = this.promptEl.nativeElement.textContent;
    const cliCmd = this.parseCommand(cmd);
    if (cliCmd && cliCmd.command && cliCmd.command.length > 0) {
      this.promptHistory.push(`${this.opts.prompt} ${cliCmd.command} ${cliCmd.arguments.join(' ')}`);
      this.cmdHistory.unshift(`${cliCmd.command} ${cliCmd.arguments.join(' ')}`);
      this.historyIndex = -1;
      this.promptLoading = true;
      this.startProgressIndicator();
      this.execute.emit(cliCmd);
    } else {
      this.promptHistory.push(`${this.opts.prompt} ${''} ${cliCmd.arguments.join(' ')}`);
    }
    this.promptEl.nativeElement.innerText = '';
    this.scrollToPrompt();
  }
  scrollToPrompt() {
    setTimeout(() => {
      this.promptEl.nativeElement.scrollIntoView(true);
    }, 50);
  }
  nextHistory() {
    this.historyIndex += 1;
    if (this.historyIndex > this.cmdHistory.length - 1) {
      this.historyIndex = 0;
    }
    return this.cmdHistory[this.historyIndex];
  }
  prevHistory() {
    this.historyIndex -= 1;
    if (this.historyIndex < 0) {
      this.historyIndex = this.cmdHistory.length - 1;
    }
    return this.cmdHistory[this.historyIndex];
  }
  handleArrowKeyHistory(command) {
    if (command && command.length) {
      this.promptEl.nativeElement.innerText = command;
    }
    this.gotoEnd();
  }
  parseCommand(command) {
    const cmd = {
      command: '',
      arguments: []
    };
    // Remove newline, carriage return, tab and &nbsp; split to extract command and arguments, filter out whitespaces.
    const cmdArr = command.trim().replace(/\r?\n|\r|\t|\s/g, ' ').split(' ').filter(it => it.trim() !== '');
    cmd.command = cmdArr.shift();
    cmd.arguments = cmdArr;
    return cmd;
  }
  startProgressIndicator() {
    const progressIntervalItems = ['|', '/', '-', '\\', '|', '/', '-', '\\'];
    let currentItemIndex = -1;
    this.progressInterval = setInterval(() => {
      currentItemIndex++;
      if (currentItemIndex > progressIntervalItems.length - 1) {
        currentItemIndex = 0;
      }
      this.progressLoader = progressIntervalItems[currentItemIndex];
    }, 250);
  }
  stopProgressIndicator() {
    clearInterval(this.progressInterval);
  }
  clickHandler(event) {
    this.focusOnPrompt(event.srcElement);
  }
  focusOnPrompt(target) {
    if (!target.classList.contains('prompt')) {
      this.promptEl.nativeElement.focus();
      this.gotoEnd();
    }
  }
  gotoEnd() {
    const range = document.createRange();
    const selection = window.getSelection();
    range.selectNodeContents(this.promptEl.nativeElement);
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
  }
  appendLines(lines) {
    this.promptHistory.push(...lines);
    this.scrollToPrompt();
  }
  appendLinesAndFinishExecution(lines) {
    this.appendLines(lines);
    this.finishExecution();
  }
  appendLine(line) {
    this.promptHistory.push(line);
    this.scrollToPrompt();
  }
  appendLineAndFinishExecution(line) {
    this.appendLine(line);
    this.finishExecution();
  }
  finishExecution() {
    this.promptLoading = false;
    this.stopProgressIndicator();
    setTimeout(() => {
      this.promptContainer.nativeElement.click();
    }, 100);
  }
  startExecution() {
    this.promptLoading = true;
    this.startProgressIndicator();
  }
  static ɵfac = function CliComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CliComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CliComponent,
    selectors: [["cli"]],
    viewQuery: function CliComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c12, 5);
        i0.ɵɵviewQuery(_c13, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.promptContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.promptEl = _t.first);
      }
    },
    inputs: {
      options: "options"
    },
    outputs: {
      execute: "execute"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 8,
    vars: 8,
    consts: [["promptContainer", ""], ["promptEl", ""], [1, "cli-container", 3, "click"], ["class", "history", 3, "color", "innerHTML", 4, "ngFor", "ngForOf"], [1, "prompt-container"], [4, "ngIf"], [1, "prompt", 3, "keyup", "paste", "contentEditable"], [1, "history", 3, "innerHTML"]],
    template: function CliComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2, 0);
        i0.ɵɵlistener("click", function CliComponent_Template_div_click_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.clickHandler($event));
        });
        i0.ɵɵtemplate(2, CliComponent_p_2_Template, 2, 5, "p", 3);
        i0.ɵɵelementStart(3, "div", 4);
        i0.ɵɵtemplate(4, CliComponent_span_4_Template, 2, 1, "span", 5)(5, CliComponent_span_5_Template, 2, 1, "span", 5);
        i0.ɵɵelementStart(6, "p", 6, 1);
        i0.ɵɵlistener("keyup", function CliComponent_Template_p_keyup_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.handleKey($event));
        })("paste", function CliComponent_Template_p_paste_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.handlePaste($event));
        });
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵstyleProp("background", ctx.opts.background)("color", ctx.opts.color);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.promptHistory);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.promptLoading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.promptLoading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("contentEditable", !ctx.promptLoading);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, SanitizeHtmlPipe],
    styles: ["[_nghost-%COMP%]{display:flex;flex:1 1 auto;border:1px solid #000;font-family:Lucida Console,Monaco,monospace;margin-bottom:1rem}[_nghost-%COMP%]   .cli-container[_ngcontent-%COMP%]{position:relative;display:flex;flex:1 1 auto;flex-direction:column;overflow-y:auto;padding:0 .5rem}[_nghost-%COMP%]   .prompt-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex:0 0 auto;width:100%;margin-bottom:.5rem}[_nghost-%COMP%]   .prompt-container[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:flex;flex:0 0 1rem;font-weight:600}[_nghost-%COMP%]   .prompt-container[_ngcontent-%COMP%]   .prompt[_ngcontent-%COMP%]{display:flex;flex:1 1 auto}[_nghost-%COMP%]   [contenteditable][_ngcontent-%COMP%]:focus{outline:0px solid transparent}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CliComponent, [{
    type: Component,
    args: [{
      selector: 'cli',
      template: "<div class=\"cli-container\" [style.background]=\"opts.background\" [style.color]=\"opts.color\" (click)=\"clickHandler($event)\" #promptContainer>\n  <p class=\"history\" *ngFor=\"let line of promptHistory\" [style.color]=\"opts.cmdColor\" [innerHTML]=\"line | sanitizeHtml\"></p>\n\n  <div class=\"prompt-container\">\n    <span *ngIf=\"!promptLoading\">{{ opts.prompt }}</span>\n    <span *ngIf=\"promptLoading\">{{ progressLoader }}</span>\n    <p class=\"prompt\" [contentEditable]=\"!promptLoading\" (keyup)=\"handleKey($event)\" (paste)=\"handlePaste($event)\" #promptEl></p>\n  </div>\n</div>\n",
      styles: [":host{display:flex;flex:1 1 auto;border:1px solid #000;font-family:Lucida Console,Monaco,monospace;margin-bottom:1rem}:host .cli-container{position:relative;display:flex;flex:1 1 auto;flex-direction:column;overflow-y:auto;padding:0 .5rem}:host .prompt-container{display:flex;flex-direction:row;flex:0 0 auto;width:100%;margin-bottom:.5rem}:host .prompt-container span{display:flex;flex:0 0 1rem;font-weight:600}:host .prompt-container .prompt{display:flex;flex:1 1 auto}:host [contenteditable]:focus{outline:0px solid transparent}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    promptContainer: [{
      type: ViewChild,
      args: ['promptContainer']
    }],
    promptEl: [{
      type: ViewChild,
      args: ['promptEl']
    }],
    execute: [{
      type: Output
    }],
    options: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CliModule {
  static ɵfac = function CliModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CliModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CliModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CliModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      exports: [CliComponent],
      declarations: [CliComponent, SanitizeHtmlPipe]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
var DateView;
(function (DateView) {
  DateView[DateView["day"] = 0] = "day";
  DateView[DateView["month"] = 1] = "month";
  DateView[DateView["year"] = 2] = "year";
})(DateView || (DateView = {}));

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DatepickerPipe {
  transform(value, format) {
    let returnValue = '';
    if (value && value !== '') {
      const date = moment(value);
      if (date.isValid()) {
        let returnFormat = '';
        if (format && format.length) {
          returnFormat = format;
        } else {
          returnFormat = 'YYYY-MM-DD';
        }
        returnValue = date.format(returnFormat);
      }
    }
    return returnValue;
  }
  static ɵfac = function DatepickerPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DatepickerPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "datePicker",
    type: DatepickerPipe,
    pure: true,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerPipe, [{
    type: Pipe,
    args: [{
      name: 'datePicker'
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DatepickerComponent {
  el;
  disabled = false;
  options = {
    small: false,
    fixed: false,
    nullable: false,
    allowShortFormats: false
  };
  placeholder = '';
  valid = true;
  calendarContainer;
  activeView = DateView.day;
  overlay = false;
  shadowDate;
  dateObj;
  canChangePrevMonth = true;
  canChangeNextMonth = true;
  showDatepicker = false;
  weekDays;
  monthDates;
  yearDates;
  yearSpanDates;
  header = '';
  displayFormat;
  yearSpanSize = 12;
  inputEl;
  onChange = date => {
    // do nothing
  };
  onTouched = () => {
    // do nothing
  };
  clickout(event) {
    if (this.el && this.calendarContainer && !this.isInside(this.el.nativeElement, event) && !this.isInside(this.calendarContainer.nativeElement, event)) {
      this.hide();
    }
  }
  constructor(el) {
    this.el = el;
  }
  ngOnInit() {
    this.inputEl = this.el.nativeElement.getElementsByClassName('input')[0];
    this.weekDays = this.getDayNames();
    this.dateObj = moment();
    this.shadowDate = moment();
    this.updateCalendar();
    fromEvent(this.el.nativeElement, 'keyup').subscribe(event => {
      this.updateValue();
    });
  }
  next() {
    if (this.activeView === DateView.day) {
      this.changeMonth(1);
    } else if (this.activeView === DateView.month) {
      this.changeYear(1);
    } else if (this.activeView === DateView.year) {
      this.changeYearSpan(1);
    }
  }
  previous() {
    if (this.activeView === DateView.day) {
      this.changeMonth(-1);
    } else if (this.activeView === DateView.month) {
      this.changeYear(-1);
    } else if (this.activeView === DateView.year) {
      this.changeYearSpan(-1);
    }
  }
  nextView() {
    if (this.activeView === DateView.day && this.options.yearActive) {
      this.switchView(DateView.month);
    } else if (this.activeView === DateView.month && this.options.yearSpanActive) {
      this.switchView(DateView.year);
    }
  }
  writeValue(event) {
    let activeDate;
    if (this.options.nullable && event === null) {
      activeDate = null;
      this.inputEl.value = '';
    } else if (event !== undefined) {
      activeDate = moment(event);
      if (!activeDate.isValid()) {
        activeDate = moment();
      }
    } else {
      activeDate = moment();
    }
    this.dateObj = activeDate;
    if (this.dateObj !== null) {
      this.shadowDate = this.dateObj.clone();
      this.updateCalendar();
    }
    this.updateDisplayFormat(activeDate);
    this.onChange(activeDate);
  }
  updateDisplayFormat(date) {
    if (!date || !this.options.allowShortFormats) {
      return;
    }
    const creationData = date.creationData();
    if (creationData && creationData.format) {
      this.displayFormat = creationData.format.toString();
    } else if (creationData && creationData.input) {
      const inputString = creationData.input.toString();
      if (inputString.length === 4 && parseInt(inputString, 10)) {
        this.displayFormat = 'YYYY';
      }
    } else {
      this.displayFormat = 'YYYY-MM-DD';
    }
  }
  updateValue() {
    if (this.isValidDateFormat(this.inputEl.value)) {
      const momentObject = moment(this.inputEl.value, true);
      if (momentObject && momentObject.isValid()) {
        this.writeValue(momentObject);
      }
    }
    if (this.options.nullable && this.inputEl.value.length === 0) {
      this.clearDate();
    } else {
      this.onChange(moment(this.inputEl.value, this.options.allowShortFormats ? null : 'YYYY-MM-DD', true));
    }
  }
  clearDate() {
    if (!this.options.nullable) {
      return;
    }
    this.inputEl.value = '';
    this.writeValue(null);
    this.hide();
  }
  selectDate(event) {
    this.writeValue(event.date);
    this.hide();
  }
  selectMonth(date) {
    this.writeValue(date);
    this.switchView(DateView.day);
  }
  selectYear(date) {
    this.writeValue(date);
    this.switchView(DateView.month);
  }
  changeMonth(direction) {
    if (direction > 0) {
      this.shadowDate.add(1, 'month');
    } else {
      this.shadowDate.subtract(1, 'month');
    }
    this.updateCalendar();
  }
  changeYear(direction) {
    if (direction > 0) {
      this.shadowDate.add(1, 'year');
    } else {
      this.shadowDate.subtract(1, 'year');
    }
    this.updateCalendar();
  }
  changeYearSpan(direction) {
    if (direction > 0) {
      this.shadowDate.add(this.yearSpanSize, 'year');
    } else {
      this.shadowDate.subtract(this.yearSpanSize, 'year');
    }
    this.updateCalendar();
  }
  show() {
    if (!this.disabled) {
      this.showDatepicker = true;
    }
  }
  hide() {
    this.showDatepicker = false;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  setValidState(isValid) {
    this.valid = isValid;
  }
  validate() {
    if (this.options.nullable && this.dateObj === null || this.dateObj && this.dateObj.isValid()) {
      return null;
    } else {
      return {
        InvalidDateError: 'The date is invalid.'
      };
    }
  }
  headerIsClickable() {
    if (this.activeView === DateView.day && this.options.yearActive || this.activeView === DateView.month && this.options.yearSpanActive) {
      return true;
    }
    return false;
  }
  switchView(view) {
    this.activeView = view;
    this.updateCalendar();
  }
  updateCalendar() {
    if (this.dateObj) {
      if (!this.dateObj.isValid()) {
        if (this.options.nullable) {
          this.writeValue(null);
        } else {
          this.dateObj = moment();
          this.writeValue(this.dateObj);
        }
      }
    }
    this.monthDates = this.generateMonth(this.shadowDate);
    this.yearDates = this.generateYearDates(this.shadowDate);
    this.yearSpanDates = this.generateYearSpanDates(this.shadowDate);
    this.updateHeader(this.shadowDate);
  }
  generateYearSpanDates(date) {
    const yearSpanDates = [];
    const year = date.get('year');
    const order = year % this.yearSpanSize;
    for (let i = 0; i < this.yearSpanSize; i++) {
      yearSpanDates.push(date.clone().set('year', year + (i - order)));
    }
    return yearSpanDates;
  }
  generateYearDates(date) {
    const yearDates = [];
    for (let i = 0; i < 12; i++) {
      yearDates.push(date.clone().set('month', i));
    }
    return yearDates;
  }
  getDayNames() {
    const weekDays = [];
    for (let i = 0; i < 7; i++) {
      weekDays[i] = moment().weekday(i).format('ddd');
    }
    return weekDays;
  }
  updateHeader(date) {
    if (this.activeView === DateView.day) {
      this.header = date.format('MMMM');
    } else if (this.activeView === DateView.month) {
      this.header = date.format('YYYY');
    } else if (this.activeView === DateView.year) {
      this.header = this.yearSpanDates[0].format('YYYY') + '-' + this.yearSpanDates[this.yearSpanSize - 1].format('YYYY');
    }
  }
  generateMonth(date) {
    // Get first day of the month in current month;
    const currentMonth = moment(date).startOf('month');
    const startDay = currentMonth.format('e');
    const dateArr = [];
    // What day does the month start on? prepend the days from monday if monday isn't the first date.
    if (Number(startDay) !== 0) {
      const prevMonth = currentMonth.clone().subtract(1, 'month').endOf('month');
      for (let i = 0; i < Number(startDay); i++) {
        const calendarDate = {
          date: prevMonth.clone().subtract(Number(startDay) - (i + 1), 'day'),
          inMonth: false,
          selectable: false,
          selected: false
        };
        dateArr.push(calendarDate);
      }
    }
    // How many days is the month? Append to array;
    const lastDay = currentMonth.clone().endOf('month').format('D');
    for (let i = 0; i < Number(lastDay); i++) {
      const calendarDate = {
        date: moment().set({
          year: date.year(),
          month: date.month(),
          date: i + 1
        }),
        inMonth: true,
        selectable: true,
        selected: false
      };
      dateArr.push(calendarDate);
    }
    // What day does the month end? if not on Sunday, append next month days till Sunday.
    const lastWeekDay = currentMonth.clone().endOf('month').format('e');
    if (Number(lastWeekDay) !== 6) {
      const appendDays = 7 - Number(lastWeekDay);
      for (let i = 1; i < appendDays; i++) {
        const calendarDate = {
          date: moment().set({
            year: date.year(),
            month: date.month(),
            date: i
          }).add(1, 'month'),
          inMonth: false,
          selectable: false,
          selected: false
        };
        dateArr.push(calendarDate);
      }
    }
    return dateArr;
  }
  isInside(element, event) {
    const rect = element.getBoundingClientRect();
    return rect.left < event.clientX && rect.left + rect.width > event.clientX && rect.top < event.clientY && rect.top + rect.height > event.clientY;
  }
  isOutOfMinMaxDateRange(date) {
    if (this.options.minDate && this.options.minDate.isValid()) {
      if (date.startOf('day').isBefore(this.options.minDate.format('YYYY-MM-DD'))) {
        return true;
      }
    }
    if (this.options.maxDate && this.options.maxDate.isValid()) {
      if (date.startOf('day').isAfter(this.options.maxDate.format('YYYY-MM-DD'))) {
        return true;
      }
    }
    return false;
  }
  isValidDateFormat(date) {
    const yyyyPattern = /^\d{4}$/;
    const yyyymmPattern = /^\d{4}-(0[1-9]|1[012])$/;
    const yyyymmddPattern = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
    if (this.options.allowShortFormats) {
      return yyyyPattern.test(date) || yyyymmPattern.test(date) || yyyymmddPattern.test(date);
    } else {
      return yyyymmddPattern.test(date);
    }
  }
  static ɵfac = function DatepickerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DatepickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DatepickerComponent,
    selectors: [["datepicker"]],
    viewQuery: function DatepickerComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c14, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarContainer = _t.first);
      }
    },
    hostBindings: function DatepickerComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function DatepickerComponent_click_HostBindingHandler($event) {
          return ctx.clickout($event);
        }, false, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      disabled: "disabled",
      options: "options",
      placeholder: "placeholder",
      valid: "valid"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true
    }, {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true
    }])],
    decls: 6,
    vars: 13,
    consts: [["calendarContainer", ""], [1, "control", "has-icons-right", 3, "click"], ["type", "text", 1, "input", "is-datepicker", 3, "change", "placeholder", "value", "disabled"], [1, "icon", "is-small", "is-right"], [1, "fas", "fa-calendar-alt"], ["class", "datepicker is-active", 3, "modal", "is-small", 4, "ngIf"], [1, "datepicker", "is-active"], ["class", "modal-background", 4, "ngIf"], [1, "calendar"], [1, "calendar-nav"], [1, "calendar-nav-month"], ["type", "button", 1, "calendar-nav-previous-month", "button", "is-small", "is-text", 3, "click"], [1, "fa", "fa-chevron-left"], [1, "calendar-month", "is-capitalized", 3, "click"], ["type", "button", 1, "calendar-nav-next-month", "button", "is-small", "is-text", 3, "click"], [1, "fa", "fa-chevron-right"], ["class", "calendar-container inset-border", 4, "ngIf"], [4, "ngIf"], [1, "modal-background"], [1, "calendar-container", "inset-border"], [1, "calendar-header"], ["class", "calendar-date", 4, "ngFor", "ngForOf"], [1, "calendar-body"], ["class", "calendar-date", 3, "is-disabled", 4, "ngFor", "ngForOf"], [1, "calendar-date"], ["type", "button", "class", "date-item", 3, "is-active", "click", 4, "ngIf"], ["type", "button", "class", "date-item", 3, "click", 4, "ngIf"], ["type", "button", 1, "date-item", 3, "click"], ["class", "calendar-date month", 4, "ngFor", "ngForOf"], [1, "calendar-date", "month"], ["type", "button", "class", "date-item month", 3, "is-active", "click", 4, "ngIf"], ["type", "button", "class", "date-item month", 3, "click", 4, "ngIf"], ["type", "button", 1, "date-item", "month", 3, "click"], ["type", "button", 1, "button", "is-outlined", "is-fullwidth", "is-danger", 3, "click"], [1, "fas", "fa-calendar-times"]],
    template: function DatepickerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵlistener("click", function DatepickerComponent_Template_div_click_0_listener() {
          return ctx.show();
        });
        i0.ɵɵelementStart(1, "input", 2);
        i0.ɵɵpipe(2, "datePicker");
        i0.ɵɵlistener("change", function DatepickerComponent_Template_input_change_1_listener() {
          return ctx.updateValue();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(5, DatepickerComponent_div_5_Template, 16, 14, "div", 5);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("is-small", ctx.options.small);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("is-danger", !ctx.valid)("is-small", ctx.options.small);
        i0.ɵɵproperty("placeholder", ctx.placeholder)("value", i0.ɵɵpipeBind2(2, 10, ctx.dateObj, ctx.displayFormat))("disabled", ctx.disabled);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showDatepicker);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, DatepickerPipe],
    styles: ["[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]{max-width:240px;min-width:240px;position:absolute}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar.fixed[_ngcontent-%COMP%]{position:fixed}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-nav[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{background-color:transparent}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-date[_ngcontent-%COMP%]{padding:0}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-date.month[_ngcontent-%COMP%]{padding:10px 0;flex:0 0 25%;max-width:25%}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-date[_ngcontent-%COMP%]   .date-item[_ngcontent-%COMP%]{width:28px;height:28px;margin:5px;line-height:10px}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-date[_ngcontent-%COMP%]   .date-item.month[_ngcontent-%COMP%]{width:40px;height:40px}[_nghost-%COMP%]   .inset-border[_ngcontent-%COMP%]{box-shadow:0 0 1px #00000054 inset}[_nghost-%COMP%]   .clickable[_ngcontent-%COMP%]{cursor:pointer}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerComponent, [{
    type: Component,
    args: [{
      selector: 'datepicker',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatepickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => DatepickerComponent),
        multi: true
      }],
      template: "<div class=\"control has-icons-right\" [class.is-small]=\"options.small\" (click)=\"show()\">\n  <input type=\"text\" class=\"input is-datepicker\" [placeholder]=\"placeholder\" [class.is-danger]=\"!valid\"\n    [class.is-small]=\"options.small\" [value]=\"dateObj | datePicker: displayFormat\" (change)=\"updateValue()\"\n    [disabled]=\"disabled\">\n  <span class=\"icon is-small is-right\">\n    <span class=\"fas fa-calendar-alt\"></span>\n  </span>\n</div>\n\n<div *ngIf=\"showDatepicker\" [class.modal]=\"overlay\" [class.is-small]=\"options.small\" class=\"datepicker is-active\">\n  <div *ngIf=\"overlay\" class=\"modal-background\"></div>\n  <div #calendarContainer class=\"calendar\" [class.fixed]=\"options.fixed\">\n\n    <div class=\"calendar-nav\">\n      <div class=\"calendar-nav-month\">\n        <button type=\"button\" class=\"calendar-nav-previous-month button is-small is-text\" (click)=\"previous()\">\n          <span class=\"fa fa-chevron-left\"></span>\n        </button>\n        <div (click)=\"nextView()\" [class.clickable]=\"headerIsClickable()\" class=\"calendar-month is-capitalized\">{{\n          header }}</div>\n        <button type=\"button\" class=\"calendar-nav-next-month button is-small is-text\" (click)=\"next()\">\n          <span class=\"fa fa-chevron-right\"></span>\n        </button>\n      </div>\n    </div>\n\n    <!-- DAY -->\n    <div class=\"calendar-container inset-border\" *ngIf=\"activeView === 0\">\n      <div class=\"calendar-header\">\n        <div class=\"calendar-date\" *ngFor=\"let day of weekDays\">\n          {{ day }}\n        </div>\n      </div>\n\n      <div class=\"calendar-body\">\n        <div *ngFor=\"let date of monthDates\" class=\"calendar-date\"\n          [class.is-disabled]=\"!date.inMonth || isOutOfMinMaxDateRange(date.date)\">\n          <button *ngIf=\"dateObj\" type=\"button\" class=\"date-item\"\n            [class.is-active]=\"date.date.format('YYYY-MM-DD') === dateObj.format('YYYY-MM-DD')\"\n            (click)=\"selectDate(date)\">{{ date.date.format('D') }}</button>\n          <button *ngIf=\"!dateObj\" type=\"button\" class=\"date-item\" (click)=\"selectDate(date)\">{{ date.date.format('D')\n            }}</button>\n        </div>\n      </div>\n    </div>\n\n    <!-- MONTH -->\n    <div class=\"calendar-container inset-border\" *ngIf=\"activeView === 1\">\n      <div class=\"calendar-body\">\n        <div *ngFor=\"let monthDate of yearDates\" class=\"calendar-date month\">\n          <button *ngIf=\"dateObj\" type=\"button\" class=\"date-item month\"\n            [class.is-active]=\"monthDate.format('MMM') === dateObj.format('MMM')\" (click)=\"selectMonth(monthDate)\">{{\n            monthDate.format('MMM') }}</button>\n          <button *ngIf=\"!dateObj\" type=\"button\" class=\"date-item month\" (click)=\"selectMonth(monthDate)\">{{\n            monthDate.format('MMM') }}</button>\n        </div>\n      </div>\n    </div>\n\n    <!-- YEAR -->\n    <div class=\"calendar-container inset-border\" *ngIf=\"activeView === 2\">\n      <div class=\"calendar-body\">\n        <div *ngFor=\"let year of yearSpanDates\" class=\"calendar-date month\">\n          <button *ngIf=\"dateObj\" type=\"button\" class=\"date-item month\"\n            [class.is-active]=\"year.format('YYYY') === dateObj.format('YYYY')\" (click)=\"selectYear(year)\">{{\n            year.format('YYYY') }}</button>\n          <button *ngIf=\"!dateObj\" type=\"button\" class=\"date-item month\" (click)=\"selectYear(year)\">{{\n            year.format('YYYY') }}</button>\n        </div>\n      </div>\n    </div>\n\n    <div *ngIf=\"options.nullable\">\n      <button type=\"button\" class=\"button is-outlined is-fullwidth is-danger\" (click)=\"clearDate()\">\n        <span class=\"fas fa-calendar-times\"></span>\n      </button>\n    </div>\n  </div>\n\n</div>",
      styles: [":host .datepicker .calendar{max-width:240px;min-width:240px;position:absolute}:host .datepicker .calendar.fixed{position:fixed}:host .datepicker .calendar .calendar-nav .button{background-color:transparent}:host .datepicker .calendar .calendar-date{padding:0}:host .datepicker .calendar .calendar-date.month{padding:10px 0;flex:0 0 25%;max-width:25%}:host .datepicker .calendar .calendar-date .date-item{width:28px;height:28px;margin:5px;line-height:10px}:host .datepicker .calendar .calendar-date .date-item.month{width:40px;height:40px}:host .inset-border{box-shadow:0 0 1px #00000054 inset}:host .clickable{cursor:pointer}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    disabled: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    valid: [{
      type: Input
    }],
    calendarContainer: [{
      type: ViewChild,
      args: ['calendarContainer']
    }],
    clickout: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DatepickerModule {
  static ɵfac = function DatepickerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DatepickerModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DatepickerModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [DatepickerComponent, DatepickerPipe],
      exports: [DatepickerComponent],
      providers: []
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DialogComponent {
  dialogService;
  dialogModal;
  dialogTitle;
  dialogMessage;
  dialogOptions = {
    rightButtonText: 'Bekräfta',
    showCloseButton: false
  };
  constructor(dialogService) {
    this.dialogService = dialogService;
  }
  ngOnInit() {
    this.dialogService.connect().subscribe(dialog => {
      if (!dialog) {
        return;
      }
      this.dialogTitle = dialog.title;
      this.dialogMessage = dialog.message;
      this.dialogModal.open();
    });
  }
  modalConfirmed(confirmed) {
    this.dialogService.dialogSelection$.next(confirmed);
  }
  static ɵfac = function DialogComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DialogComponent)(i0.ɵɵdirectiveInject(DialogService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DialogComponent,
    selectors: [["dialog-container"]],
    viewQuery: function DialogComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c15, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogModal = _t.first);
      }
    },
    standalone: false,
    decls: 4,
    vars: 3,
    consts: [["dialogModal", ""], [3, "leftButtonClicked", "rightButtonClicked", "title", "options"]],
    template: function DialogComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "modal", 1, 0);
        i0.ɵɵlistener("leftButtonClicked", function DialogComponent_Template_modal_leftButtonClicked_0_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.modalConfirmed(false));
        })("rightButtonClicked", function DialogComponent_Template_modal_rightButtonClicked_0_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.modalConfirmed(true));
        });
        i0.ɵɵelementStart(2, "p");
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("title", ctx.dialogTitle)("options", ctx.dialogOptions);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.dialogMessage);
      }
    },
    dependencies: [ModalComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogComponent, [{
    type: Component,
    args: [{
      selector: 'dialog-container',
      template: "<modal [title]=\"dialogTitle\" [options]=\"dialogOptions\" #dialogModal (leftButtonClicked)=\"modalConfirmed(false)\"\n  (rightButtonClicked)=\"modalConfirmed(true)\">\n  <p>{{ dialogMessage }}</p>\n</modal>"
    }]
  }], () => [{
    type: DialogService
  }], {
    dialogModal: [{
      type: ViewChild,
      args: ['dialogModal']
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class DialogModule {
  static ɵfac = function DialogModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DialogModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DialogModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [DialogService],
    imports: [CommonModule, ModalModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ModalModule],
      declarations: [DialogComponent],
      exports: [DialogComponent],
      providers: [DialogService]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CommonHttpInterceptor {
  errorHandlerService;
  constructor(errorHandlerService) {
    this.errorHandlerService = errorHandlerService;
  }
  intercept(req, next) {
    return next.handle(req).pipe(catchError((err, caught) => this.onError(err, caught)));
  }
  onError(err, caught) {
    return this.errorHandlerService.error(err);
  }
}

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ErrorHandlerService {
  getDisplayValues(error) {
    const displayValues = {
      error: this.getDefaultError(error.status),
      messages: [this.getDefaultMessage(error.status)]
    };
    if (this.isArrayBufferError(error.error)) {
      const dataString = String.fromCharCode.apply(null, new Uint8Array(error.error));
      const decodedDataString = decodeURIComponent(escape(dataString));
      error.error = JSON.parse(decodedDataString);
    }
    if (this.isApiError(error.error)) {
      const apiError = error.error;
      displayValues.error = apiError.error;
      if (!apiError.messages.includes('No message available')) {
        displayValues.messages = apiError.messages;
      }
    } else if (this.isMessageError(error.error)) {
      const messageError = error.error;
      displayValues.messages = [messageError.message];
    } else if (this.isMessageError(error)) {
      const messageError = error;
      displayValues.messages = [messageError.message];
    }
    return displayValues;
  }
  isApiError(error) {
    try {
      return 'dateTime' in error && 'status' in error && 'error' in error;
    } catch (e) {
      return false;
    }
  }
  isMessageError(error) {
    try {
      return 'message' in error;
    } catch (e) {
      return false;
    }
  }
  isArrayBufferError(error) {
    return error instanceof ArrayBuffer;
  }
  getDefaultError(status) {
    switch (status) {
      case 400:
        return 'Felaktigt anrop';
      case 401:
        return 'Otillåten åtkomst';
      case 403:
        return 'Åtkomst förbjuden';
      case 404:
        return 'Resurs ej hittad';
      case 412:
        return 'Förutsättning ej uppfylld';
      case 417:
        return 'Förväntningar uppfylls ej';
      case 422:
        return 'Felaktigt format';
      case 500:
        return 'Internt systemfel';
      default:
        return 'Okänt fel';
    }
  }
  getDefaultMessage(status) {
    switch (status) {
      case 400:
        return 'Anropet till tjänsten är felaktigt formaterad.';
      case 401:
        return 'Du har inte behörighet att hämta resursen.';
      case 403:
        return 'Resursen kan inte hämtas utan korrekt inloggning.';
      case 404:
        return 'Resursen du begärde med ditt anrop kunde inte hittas';
      case 412:
        return 'Förutsättningar för att slutföra din begäran är ej uppfyllda';
      case 417:
        return 'Förväntningarna för att slutföra din begäran uppfylls ej';
      case 422:
        return 'Någon parameter i anropet har felaktigt format.';
      case 500:
        return 'Ett oväntat fel har inträffad på servern.';
      default:
        return 'Ett okänt fel har inträffat. Vänligen pröva igen.';
    }
  }
  static ɵfac = function ErrorHandlerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ErrorHandlerService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ErrorHandlerService,
    factory: ErrorHandlerService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorHandlerService, [{
    type: Injectable
  }], null, null);
})();
class ErrorComponent {
  activatedRoute;
  router;
  status = '404';
  error = 'Sidan kunde inte hittas';
  message;
  hideRedirect = false;
  constructor(activatedRoute, router) {
    this.activatedRoute = activatedRoute;
    this.router = router;
    this.activatedRoute.data.subscribe(data => {
      if (typeof data.redirect !== 'undefined' && !this.hideRedirect) {
        this.hideRedirect = !data.redirect;
      }
    });
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.status && params.status !== '') {
        this.status = params.status;
      }
      if (params.error) {
        this.error = decodeURIComponent(params.error);
      }
      if (params.message && params.status !== '') {
        this.message = decodeURIComponent(params.message);
      }
      if (params.redirect && params.redirect !== '' && !this.hideRedirect) {
        this.hideRedirect = params.redirect === 'false';
      }
    });
  }
  return() {
    this.router.navigateByUrl('');
  }
  static ɵfac = function ErrorComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ErrorComponent)(i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1$1.Router));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ErrorComponent,
    selectors: [["error-component"]],
    standalone: false,
    decls: 7,
    vars: 4,
    consts: [[1, "full-page-msg"], [1, "error"], [4, "ngIf"], ["tabindex", "0", "class", "button is-primary", 3, "click", 4, "ngIf"], ["tabindex", "0", 1, "button", "is-primary", 3, "click"]],
    template: function ErrorComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 0)(1, "header");
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "p", 1);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ErrorComponent_p_5_Template, 2, 1, "p", 2)(6, ErrorComponent_button_6_Template, 2, 0, "button", 3);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.status, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.error, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.message);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.hideRedirect);
      }
    },
    dependencies: [i2.NgIf],
    styles: [".full-page-msg[_ngcontent-%COMP%]{width:100vw;align-items:center;display:flex;flex:1 1 auto;flex-direction:column;height:100%;justify-content:center}.full-page-msg[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000}.full-page-msg[_ngcontent-%COMP%]   header[_ngcontent-%COMP%]{font-size:30vh}.full-page-msg[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:18px;word-break:break-word}.full-page-msg[_ngcontent-%COMP%]   p.error[_ngcontent-%COMP%]{font-weight:700;margin-bottom:.75rem}.full-page-msg[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{margin-top:1.5rem}.full-page-msg[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]{font-size:18px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorComponent, [{
    type: Component,
    args: [{
      selector: 'error-component',
      template: "<section class=\"full-page-msg\">\n  <header>\n    {{ status }}\n  </header>\n  <p class=\"error\">\n    {{ error }}\n  </p>\n  <p *ngIf=\"message\">\n    {{ message }}\n  </p>\n\n  <button *ngIf=\"!hideRedirect\" tabindex=\"0\" class=\"button is-primary\" (click)=\"return()\">\u00C5terg\u00E5 till start</button>\n</section>",
      styles: [".full-page-msg{width:100vw;align-items:center;display:flex;flex:1 1 auto;flex-direction:column;height:100%;justify-content:center}.full-page-msg a{color:#000}.full-page-msg header{font-size:30vh}.full-page-msg p{font-size:18px;word-break:break-word}.full-page-msg p.error{font-weight:700;margin-bottom:.75rem}.full-page-msg .button{margin-top:1.5rem}.full-page-msg footer{font-size:18px}\n"]
    }]
  }], () => [{
    type: i1$1.ActivatedRoute
  }, {
    type: i1$1.Router
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ErrorHandlerModule {
  static ɵfac = function ErrorHandlerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ErrorHandlerModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ErrorHandlerModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [{
      provide: HTTP_INTERCEPTORS,
      useClass: CommonHttpInterceptor,
      deps: [ErrorHandlerService],
      multi: true
    }],
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorHandlerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [ErrorComponent],
      exports: [ErrorComponent],
      providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: CommonHttpInterceptor,
        deps: [ErrorHandlerService],
        multi: true
      }]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
var ToastType;
(function (ToastType) {
  ToastType["ERROR"] = "danger";
  ToastType["WARNING"] = "warning";
  ToastType["SUCCESS"] = "success";
  ToastType["INFO"] = "info";
  ToastType["PRIMARY"] = "primary";
})(ToastType || (ToastType = {}));

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ToastService {
  toasts = new BehaviorSubject([]);
  idCounter = 0;
  resumeTtl = 2000;
  connect() {
    return this.toasts.asObservable();
  }
  addToast(toast) {
    const toasts = this.toasts.value;
    let ttl;
    toast.id = this.idCounter;
    toast.destroy = false;
    switch (toast.type) {
      case ToastType.ERROR:
        {
          ttl = 15000;
          break;
        }
      case ToastType.WARNING:
        {
          ttl = 10000;
          break;
        }
      case ToastType.SUCCESS:
        {
          ttl = 5000;
          break;
        }
      default:
        {
          ttl = 10000;
        }
    }
    if (!toast.sticky) {
      toast.timeout = setTimeout(() => {
        this.removeToast(toast);
      }, ttl);
    }
    toasts.push(toast);
    this.toasts.next(toasts);
    this.idCounter++;
  }
  removeToast(toast) {
    const toasts = this.toasts.value;
    clearTimeout(toast.timeout);
    toast.destroy = true;
    toast.timeout = setTimeout(() => {
      clearTimeout(toast.timeout);
      toasts.splice(toasts.indexOf(toast), 1);
    }, 500);
    this.toasts.next(toasts);
  }
  killTimer(toast) {
    const toasts = this.toasts.value;
    clearTimeout(toast.timeout);
    this.toasts.next(toasts);
  }
  resumeTimer(toast) {
    if (!toast.sticky) {
      const toasts = this.toasts.value;
      toast.timeout = setTimeout(() => {
        this.removeToast(toast);
      }, this.resumeTtl);
      this.toasts.next(toasts);
    }
  }
  static ɵfac = function ToastService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ToastService,
    factory: ToastService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastService, [{
    type: Injectable
  }], null, null);
})();
class DefaultErrorHandlerService extends ErrorHandlerService {
  router;
  toastService;
  constructor(router, toastService) {
    super();
    this.router = router;
    this.toastService = toastService;
  }
  error(error) {
    const displayValues = this.getDisplayValues(error);
    switch (error.status) {
      case 401:
        {
          let loggedOutMessage;
          if (displayValues.messages.includes('No HTTP session')) {
            displayValues.error = 'Ingen session';
            displayValues.messages = ['Du har ingen giltig session.'];
            loggedOutMessage = 'nosession';
          } else if (displayValues.messages.includes('Session expired')) {
            displayValues.error = 'Session utgången';
            displayValues.messages = ['Sessionen har gått ut.'];
            loggedOutMessage = 'sessionexpired';
          } else {
            displayValues.error = 'Otillåten åtkomst';
            displayValues.messages = ['Du har blivit utloggad.'];
            loggedOutMessage = 'logout';
          }
          this.toastService.addToast({
            type: 'danger',
            message: displayValues.messages,
            title: displayValues.error
          });
          this.router.navigate(['/loggedout'], {
            queryParams: {
              message: loggedOutMessage
            }
          });
          break;
        }
      case 422:
        {
          this.toastService.addToast({
            type: 'warning',
            message: displayValues.messages,
            title: displayValues.error
          });
          break;
        }
      default:
        {
          this.toastService.addToast({
            type: 'danger',
            message: displayValues.messages,
            title: displayValues.error
          });
          break;
        }
    }
    return throwError(displayValues);
  }
  static ɵfac = function DefaultErrorHandlerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DefaultErrorHandlerService)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(ToastService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DefaultErrorHandlerService,
    factory: DefaultErrorHandlerService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DefaultErrorHandlerService, [{
    type: Injectable
  }], () => [{
    type: i1$1.Router
  }, {
    type: ToastService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class CommonValidators {
  static yyyy = '(1[8-9]|2[0-1])[0-9]{2}';
  static mm = `(0[1-9]|1[0-2])`;
  static dd = `(0[1-9]|[12][0-9]|3[01])`;
  static patternInvalid = 'Pattern invalid';
  static checkdigitInvalid = 'Checkdigit invalid';
  static getIdentityNumberValidatorByOid(oid, maxLength, required) {
    const regionValidators = {
      '1.2.752.129.2.1.3.1': this.personIdentityNumberValidator(),
      '1.2.752.129.2.1.3.3': this.coordinationIdentityNumberValidator(),
      '1.2.752.74.9.6': this.reserveNumberRHValidator(),
      '1.2.752.266.1.1.2': this.reserveNumberRSKValidator(),
      '1.2.752.266.1.1.1': this.reserveNumberRSRValidator(),
      '1.2.752.74.9.8': this.reserveNumberRDValidator(),
      '1.2.752.269.1.1': this.reserveNumberVNValidator(),
      '1.2.752.74.9.5': this.reserveNumberRBValidator(),
      '1.2.752.74.9.2': this.reserveNumberLiVValidator(),
      '1.2.752.219.1.10.10.1': this.reserveNumberRSValidator(),
      '1.2.752.74.9.3': this.reserveNumberROLValidator(),
      '1.2.752.129.2.1.3.2': this.reserveNumberCLNKValidator(),
      '1.2.752.97.3.1.3': this.reserveNumberSLLValidator(),
      '1.2.752.113.11.0.2.1.1.1': this.reserveNumberVGRValidator(),
      '1.2.752.74.9.7': this.reserveNumberRVValidator(),
      '1.2.752.74.9.9': this.reserveNumberRGValidator(),
      '1.2.752.113.11.0.2.1.1.4': this.reserveNumberVGRGRID(),
      '1.2.752.74.9.10': this.reserveNumberRNValidator()
    };
    const validators = [];
    if (regionValidators[oid] != null) {
      validators.push(regionValidators[oid]);
    }
    if (maxLength > 0) {
      validators.push(Validators.maxLength(maxLength));
    }
    if (required) {
      validators.push(Validators.required);
    }
    return Validators.compose(validators);
  }
  /**
  * Validate that url is using https://
  *
  * Matches
  * ```typescript
  * https://.+
  * ```
  *
  */
  static httpSecureValidator() {
    return Validators.pattern(`https://.+`);
  }
  /**
  * Validate that string matches "https?://.+"
  *
  * Matches
  * ```typescript
  * https?://.+
  * ```
  *
  */
  static urlValidator() {
    return Validators.pattern('https?://.+');
  }
  /**
  * Check of valid reserve number for Västra Götalandsregionen
  * Format: yyyymmddGggC
  *
  * yyyy = Year
  * mm = Month
  * dd = Day
  * G = Gender marker, uppercase 'K' = woman, uppercase 'M' = man and uppercase 'X' = unknown
  * gg = Gender supplement, two digits
  *       00-05 Not used
  *       06-79 Serial number when G is either 'K' or 'M', 'K' => even number  and 'M' => uneven
  *       80-89 Serial number when G is 'X'
  *       90-99 Not used
  * C = Check digit (Luhn 10)
  *      'K' = 5, 'M' = 7 and 'X' = 8
  */
  static reserveNumberVGRValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let valueClone = control.value;
      let error = Validators.pattern(`^${this.yyyy}${this.mm}${this.dd}(K(0[6,8]|[1-7][0,2,4,6,8])[0-9]|M(0[7,9]|[1-7][1,3,5,7,9])[0-9]|X8[0-9]{2})$`)(control);
      if (error === null) {
        valueClone = valueClone.replace('M', '7');
        valueClone = valueClone.replace('K', '5');
        valueClone = valueClone.replace('X', '8');
        if (!this.luhn10(valueClone.substr(2))) {
          error = {
            reserveId: this.checkdigitInvalid
          };
        }
      } else {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Inera Carelink
  * Format yyyymmddNNNC
  *
  * yyyy = Year
  * mm = Month
  * dd = Day (32-59)
  * NNN = Serial number
  * C = Check digit (Luhn 10)
  *
  */
  static reserveNumberCLNKValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^${this.yyyy}${this.mm}(3[2-9]|[45][0-9])[0-9]{3}[0-9]$`)(control);
      if (error === null) {
        if (!this.luhn10(control.value.substr(2))) {
          error = {
            reserveId: this.checkdigitInvalid
          };
        }
      } else {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Landstinget i Värmland
  * Format: yyyymmddABNC
  *
  * yyyy = Year
  * mm = Month
  * dd = Day
  * A = Region, uppercase 'S' = Värmland
  * B = Type, uppercase F|U|X|P|L where:
  *   F = known date of birth
  *   U = no date of birth
  *   X = unknown
  *   P = no identity number or coordination number
  *   L = identity for lab test
  * N = Gender: 2,4,6,8 for women and 3,5,7,9 for men. 0 and 1 for gender unknown
  * C = Serial: A-Z (except V). Numeric for test environment, 1-9
  */
  static reserveNumberLiVValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^${this.yyyy}${this.mm}${this.dd}S[F,U,X,P,L][0-9](([1-9])|((?![V])[A-Z]))$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Region Örebro Län
  * Format: aaaaaaaaBcde
  *
  * aaaaaaaa = 8 digits 0-9
  * B = Uppercase 'T'
  * c = Uppercase A-Z or 0-9
  * d = 1 digit 0-9
  * e = Uppercase A-Z or 0-9
  */
  static reserveNumberROLValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^${this.yyyy}${this.mm}${this.dd}T[A-Z][0-9][A-J]$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Region Skåne
  *
  * 12 tecken
  * Format: ssyymmddABCD
  * ss = sekel
  * yy = årtal
  * mm = månad
  * dd = dag
  * Ovanstående ska vara ett giltigt datum enl. svensk kalender.
  *
  * A = Första positionen kan vara D, E eller F.
  * B = Andra positionen är vanligen A eller B. Kan vara A - Z.
  * C = Tredje positionen är 0 (noll = jämn) för kvinnor, eller 1 (ett = ojämn) för män.
  * D = Fjärde positionen är löpande A, B, C osv - för varje födelsetid. Kan vara A – Z.
  *
  * Exempel: 19810829DA1B och 20030829DZ0G
  *
  * Regex: ^(\\d{8})[D|E|F][A-Z][0|1][A-Z]$
  */
  static reserveNumberRSValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^(\\d{8})[D|E|F][A-Z][0|1][A-Z]$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Region Blekinge
  *
  * Format: ÅÅÅÅMMDDAANA
  *
  * ÅÅÅÅ Patientens födelsedatum (om det är känt)
  * MM = Month
  * DD = Day
  * AA = statiska bokstäver. Ändras i princip aldrig
  * N  = en könssiffra som är ojämn för män och jämn för kvinnor och räknas upp efter antalet reservnummer uttagna aktuellt datum.
  * A  = en bokstav som räknas upp i alfabetisk ordning efter det att antalet könssiffror  ”tagit slut”.
  *      Om t ex en kvinnlig patient fått reservnummer 20200501AA8A så får nästa kvinnliga patient aktuellt datum reservnummer
  *      20200501AA0B. Bokstaven används alltså ej som kontrollbokstav, endast för att göra reservnumret unikt vid ett stort
  *      antal uttagna reservnummer aktuellt datum.
  */
  static reserveNumberRBValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^(1[8-9]|2[0-1])[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z]{2}[0-9][A-Z]$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Region Västernorrland
  *
  * Format: SSÅÅMMDDnnKR
  *
  * SSÅÅ Patientens födelsedatum (om det är känt)
  * MM = Month
  * DD = Day
  * nn = löpnummer
  * K  = Siffra som representerar könet (jämn=kvinna/udda=man)
  * R  = Konstant bokstav 'R'
  *
  */
  static reserveNumberVNValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^(1[8-9]|2[0-1])[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}R$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Region Dalarna
  *
  * Format: ÅÅÅÅMMDDAXXC
  *
  * ÅÅÅÅ Patientens födelsedatum (om det är känt)
  * MM = Month
  * DD = Day
  * A = Bokstav. Tidigare 'Y', sedan några år 'Z'
  * XX =  Löpnummer: Näst sista siffran är en Kön-siffra (Jämn=Kvinna)
  * C	= Checksiffra? Okänd algoritm.
  *
  */
  static reserveNumberRDValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^(1[8-9]|2[0-1])[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z][0-9]{3}$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Stockholms Läns Landsting
  * Format: 99yyyyNNNNNC
  *
  * yyyy = Year
  * NNNNN = Serial number
  * C = Check digit (Luhn 10)
  */
  static reserveNumberSLLValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^99${this.yyyy}[0-9]{6}$`)(control);
      if (error === null) {
        if (!this.luhn10(control.value.substr(4))) {
          error = {
            reserveId: this.checkdigitInvalid
          };
        }
      } else {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Region Sörmland, LRID 1
  * Kortnamn: RSR
  * OID: 1.2.752.266.1.1.1
  * Längd: 12 tecken
  * Format: ÅÅÅÅMMDDBBKB
  * Regex: ^(1[8-9]|2[0-1])[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z]{2}[0-9][A-Z]$
  *
  * ÅÅÅÅ = Årtal
  * MM = Månad
  * DD = Dag
  * Ovanstående ska vara ett giltigt datum enl. svensk kalender.
  * (ÅÅÅÅMMDD = Födelsedatum)
  *
  * BB = Bokstäver (A-Z)
  * K = Siffra som representerar könet (jämn=kvinna/udda=man)
  * B = Bokstav (A-Z)
  */
  static reserveNumberRSRValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^(1[8-9]|2[0-1])[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z]{2}[0-9][A-Z]$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Region Sörmland, LRID 2 (katastrofnummer)
  * Kortnamn: RSK
  * OID:  1.2.752.266.1.1.2
  * Längd 12 tecken
  * Format: PPPPPPPPBNNN
  * Regex: ^(18500101|18600101|18900101)[MNKPD](0{2}[1-9]|[0-9][1-9][0-9]|[1-9][0-9][0-9])$
  *
  * Exempel: 18500101N123 – katastrofnummer, 18500101K234 – katastrofnummer
  *
  * PPPPPPPP = Prefix 18500101, 18600101 eller 18900101
  * B = Bokstav (M, N, K, P, D) som representerar det sjukhus eller primärvård serien tillhör
  * NNN = Löpnummer (001-999)
  */
  static reserveNumberRSKValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^(18500101|18600101|18900101)[MNKPD](0{2}[1-9]|[0-9][1-9][0-9]|[1-9][0-9][0-9])$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  *
  * Check of valid reserve number for Region Halland
  * Format: YYYYRRRRNNNC
  * YYYY = År för utgivning av reservnummer
  * RRRR = Värde mellan 0532 - 0545
  * NNN  = Löpnummer 0 - 9 varav tredje siffran är udda (1,3,5,7,9) för män och jämn (0,2,4,6,8) för kvinnor
  * C    = Kontrollsiffra enligt Luhn (position 3 till 11 inkluderas i beräkning av kontrollsiffran)
  *
  */
  static reserveNumberRHValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^(1[7-9]|20)\\d{2}(0[1-9]|1[0-2])(3[2-9]|[4-5]\\d)\\d{4}$`)(control);
      if (error === null) {
        if (!this.luhn10(control.value.substr(2))) {
          error = {
            reserveId: this.checkdigitInvalid
          };
        }
      } else {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
   * Check of valid reserve number for Region Västerbotten
   * Format:  YYYYMMDDXNNN
   * YYYY:    År för födelsedatum
   * MM:      Månad för födelsadatum
   * DD:      Dag för födelsedatum
   * X:       Delserie Giltiga värden (R|E|K|A)
   * NNN:     Löpnummer
   */
  static reserveNumberRVValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^(1[8-9]|2[0-1])\\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01])[REKA]\\d{3}$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
   * Check of valid reserve number for Region Gävleborg
   * Format: YYYYMMDD-NNKX
   * MM = Månad
   * DD = Dag
   * NN = Löpnummer
   * K  = Kön (M, K eller X)
   * X  = Löpnummer
   */
  static reserveNumberRGValidator() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^\\d{8}-\\d{2}[MKX]\\d$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
   * Check of valid reserve number for Region Gävleborg
   * Format: nnnnnnnnGnnn
   * n  = Siffra 0-9
   * G = Bokstav, giltiga värden är A, B, C, D, E, F, H, J, K, k, L, M, m, N, P, R, S, T, U, V, W, X, x, Y
   */
  static reserveNumberVGRGRID() {
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(`^\\d{8}[ABCDEFHJKkLMmNPRSTUVWXxY]\\d{3}$`)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Check of valid reserve number for Region Norrbotten
  * Format: YYYYMMDDAXCX
  *
  * YYYYMMDD = Födelsedatum (år, månad, dag) om det är känt. Om okänt kommer annat datum vara angivet.
  * A = Löpnummertecken mellan A-Z eller a-z.
  * X (två positioner) = Löpnummersiffra.
  * C = Löpnummersiffra, jämn för Kvinna, udda för Man.
  */
  static reserveNumberRNValidator() {
    const regex = `^(((\\d{4})(0[13578]|10|12)(0[1-9]|[12][0-9]|3[01])|((\\d{4})(0[469]|11)(0[1-9]|[12][0-9]|30))|((\\d{4})(02)` + `(0[1-9]|1[0-9]|2[0-8]))|([0-9][0-9][02468]40229)|([0-9][0-9][02468]80229)|([0-9][0-9][13579]20229)|([0-9][0-9][13579]60229)` + `|([0-9][0-9][02468]00229))([A-Za-z])(\\d)([02468]|[13579])(\\d))$`;
    const func = control => {
      if (!this.isString(control.value)) {
        return null;
      }
      let error = Validators.pattern(regex)(control);
      if (error !== null) {
        error = {
          reserveId: this.patternInvalid
        };
      }
      return error;
    };
    return func;
  }
  /**
  * Checks if the entered string matches a personal identity number
  * Patterns: YYMMDDXXXX / YYYYMMDDXXXX / YYMMDD-XXXX / YYMMDD+XXXX
  */
  static personIdentityNumberValidator() {
    const func = control => {
      const fieldValue = control.value.trim();
      const inputLength = fieldValue.length;
      if (!inputLength) {
        return null;
      }
      const pnrPattern = /^(1[8-9]|2[0-1])?([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])((00[1-9]|0[1-9][0-9]|[1-9][0-9][0-9])[0-9])$/;
      const shortPnrPattern = /^([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(-|\+)?((00[1-9]|0[1-9][0-9]|[1-9][0-9][0-9])[0-9])$/;
      if (!pnrPattern.test(fieldValue) && !shortPnrPattern.test(fieldValue)) {
        return {
          pnrPattern: true
        };
      }
      const strippedInput = fieldValue.replace(/-|\+/g, '');
      let luhnString;
      if (fieldValue.length === 12) {
        luhnString = strippedInput.substring(2, 12);
      } else {
        luhnString = strippedInput;
      }
      if (!this.luhn10(luhnString)) {
        return {
          pnrPattern: true
        };
      }
      return null;
    };
    return func;
  }
  /**
   * Checks if the entered string matches a coordination identity number
   * Patterns: YYMMDDXXXX / YYYYMMDDXXXX / YYMMDD-XXXX / YYMMDD+XXXX
   */
  static coordinationIdentityNumberValidator() {
    const func = control => {
      const fieldValue = control.value.trim();
      const inputLength = fieldValue.length;
      if (!inputLength) {
        return null;
      }
      const snrPattern = /^(1[8-9]|2[0-1])?([0-9]{2})(0[1-9]|1[0-2])(6[1-9]|[78]\d|9[01])((00[1-9]|0[1-9][0-9]|[1-9][0-9][0-9])[0-9])$/;
      const shortSnrPattern = /^([0-9]{2})(0[1-9]|1[0-2])(6[1-9]|[78]\d|9[01])(-|\+)?((00[1-9]|0[1-9][0-9]|[1-9][0-9][0-9])[0-9])$/;
      if (!snrPattern.test(fieldValue) && !shortSnrPattern.test(fieldValue)) {
        return {
          snrPattern: true
        };
      }
      const strippedInput = fieldValue.replace(/-|\+/g, '');
      let luhnString;
      if (fieldValue.length === 12) {
        luhnString = strippedInput.substring(2, 12);
      } else {
        luhnString = strippedInput;
      }
      if (!this.luhn10(luhnString)) {
        return {
          snrPattern: true
        };
      }
      return null;
    };
    return func;
  }
  /**
   * Checks if the entered string matches the NRID pattern (XXYYMMDD-NNGC)
   * XX: 23-99 (unknown birthday: 00)
   * YY: 00-99 (unknown birthday: 00)
   * MM: 01-12 (unknown birthday: 20-99)
   * DD: 01-31 (unknown birthday: 40-59)
   * NN: A-Z except IOQVW
   * G: female: 0, 2, 4, 6, 8 / male: 1, 3, 5, 7, 9 (unknown gender: A-Z except IOQVW)
   * C: Check digit (Luhn 10)
   */
  static nridValidator() {
    const func = control => {
      const fieldValue = control.value.trim();
      if (!fieldValue.length) {
        return null;
      }
      // tslint:disable-next-line
      const nridPattern = /^(00|2[2-9]|[3-9][0-9])([0-9]{2})(((0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))|(([2-9][0-9])([4-5][0-9])))(((?![IOQVWioqvw])[a-zA-Z]){2})([0-9]|((?![IOQVWioqvw])[a-zA-Z]))([0-9])$/;
      if (!nridPattern.test(fieldValue)) {
        return {
          nridPattern: true
        };
      }
      if (!this.luhn10(fieldValue)) {
        return {
          nridPattern: true
        };
      }
      return null;
    };
    return func;
  }
  static luhn10(value) {
    let even = false;
    let nCheck = 0;
    for (let i = value.length - 1; i >= 0; i--) {
      const cDigit = value.charAt(i);
      let nDigit = parseInt(cDigit, 10);
      if (isNaN(nDigit)) {
        let asciiDecimalValue = value.charCodeAt(i);
        if (asciiDecimalValue) {
          if (even) {
            asciiDecimalValue *= 2;
          }
          const asciiDecimalStringValue = asciiDecimalValue.toString();
          for (let k = asciiDecimalStringValue.length - 1; k >= 0; k--) {
            const asciiDigit = asciiDecimalStringValue.charAt(k);
            nCheck += parseInt(asciiDigit, 10);
          }
        }
      } else {
        if (even) {
          nDigit *= 2;
          if (nDigit > 9) {
            nDigit -= 9;
          }
        }
        nCheck += nDigit;
      }
      even = !even;
    }
    return nCheck % 10 === 0;
  }
  static isString(value) {
    return typeof value === 'string' || value instanceof String;
  }
}
class HsaCareProviderIdService {
  http;
  apiUrl = '/api';
  constructor(http) {
    this.http = http;
  }
  getHsaCareProviders() {
    return this.http.get(`${this.apiUrl}/hsa-care-providers`);
  }
  static ɵfac = function HsaCareProviderIdService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HsaCareProviderIdService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HsaCareProviderIdService,
    factory: HsaCareProviderIdService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HsaCareProviderIdService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2022 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class HsaCareProviderIdDatasource {
  hsaCareProviderService;
  hsaCareProviders;
  constructor(hsaCareProviderService) {
    this.hsaCareProviderService = hsaCareProviderService;
    this.fetch();
  }
  fetch() {
    this.hsaCareProviderService.getHsaCareProviders().subscribe(result => this.hsaCareProviders = result);
  }
  getNameForId(id) {
    const matchingCareProvider = this.hsaCareProviders?.find(careProvider => careProvider.id === id);
    return matchingCareProvider !== undefined ? matchingCareProvider.name : '';
  }
  static ɵfac = function HsaCareProviderIdDatasource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HsaCareProviderIdDatasource)(i0.ɵɵinject(HsaCareProviderIdService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HsaCareProviderIdDatasource,
    factory: HsaCareProviderIdDatasource.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HsaCareProviderIdDatasource, [{
    type: Injectable
  }], () => [{
    type: HsaCareProviderIdService
  }], null);
})();

/*
 * Copyright (C) 2022 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class HsaLookupModule {
  static ɵfac = function HsaLookupModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HsaLookupModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: HsaLookupModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [HsaCareProviderIdService, HsaCareProviderIdDatasource],
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HsaLookupModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [],
      exports: [],
      providers: [HsaCareProviderIdService, HsaCareProviderIdDatasource]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2022 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class HttpHeaderInterceptor {
  intercept(request, next) {
    if (!request.headers.has('xhr')) {
      const clonedRequest = request.clone({
        headers: request.headers.append('xhr', 'true')
      });
      return next.handle(clonedRequest);
    }
    return next.handle(request);
  }
}

/*
 * Copyright (C) 2022 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class HttpHeaderModule {
  static ɵfac = function HttpHeaderModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HttpHeaderModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: HttpHeaderModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [{
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeaderInterceptor,
      multi: true
    }],
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpHeaderModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: HttpHeaderInterceptor,
        multi: true
      }]
    }]
  }], null, null);
})();
var InfoMessageType;
(function (InfoMessageType) {
  InfoMessageType["WARNING"] = "warning";
  InfoMessageType["PRIMARY"] = "primary";
  InfoMessageType["INFO"] = "info";
  InfoMessageType["SUCCESS"] = "success";
  InfoMessageType["ERROR"] = "error";
})(InfoMessageType || (InfoMessageType = {}));
class InfoMessageComponent {
  options;
  evaluateMaterialIcon() {
    let icon = '';
    if (!this.options) {
      return icon;
    }
    switch (this.options.messageType) {
      case InfoMessageType.ERROR:
        icon = 'error';
        break;
      case InfoMessageType.WARNING:
        icon = 'warning';
        break;
      case InfoMessageType.SUCCESS:
        icon = 'check_circle';
        break;
      case InfoMessageType.INFO:
        icon = 'info';
        break;
      default:
        break;
    }
    return icon;
  }
  static ɵfac = function InfoMessageComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InfoMessageComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: InfoMessageComponent,
    selectors: [["info-message"]],
    inputs: {
      options: "options"
    },
    standalone: false,
    decls: 4,
    vars: 20,
    consts: [[1, "info-message"], [1, "message-container"], [4, "ngIf"], [1, "content", 3, "innerHtml"], ["class", "fa-icon", 4, "ngIf"], ["class", "material-icon", 4, "ngIf"], [1, "fa-icon"], ["aria-label", "Meddelandets ikon", 1, "fas", "fa-lg"], [1, "material-icon"], ["aria-label", "Meddelandets ikon", 1, "material-icons"]],
    template: function InfoMessageComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, InfoMessageComponent_div_2_Template, 3, 2, "div", 2);
        i0.ɵɵelement(3, "div", 3);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵstyleProp("width", ctx.options == null ? null : ctx.options.width)("max-width", ctx.options == null ? null : ctx.options.maxWidth);
        i0.ɵɵadvance();
        i0.ɵɵstyleProp("width", ctx.options == null ? null : ctx.options.width)("max-width", ctx.options == null ? null : ctx.options.maxWidth);
        i0.ɵɵclassProp("warning", ctx.options.messageType === "warning")("error", ctx.options.messageType === "error")("primary", ctx.options.messageType === "primary")("info", ctx.options.messageType === "info")("success", ctx.options.messageType === "success");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.options.messageType !== "primary");
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerHtml", ctx.options.messageContent, i0.ɵɵsanitizeHtml);
      }
    },
    dependencies: [i2.NgIf],
    styles: ["[_nghost-%COMP%]{display:flex}[_nghost-%COMP%]   .message-container[_ngcontent-%COMP%]{min-height:50px;display:inline-flex;align-items:center}[_nghost-%COMP%]   .message-container[_ngcontent-%COMP%]   .fa-icon[_ngcontent-%COMP%], [_nghost-%COMP%]   .message-container[_ngcontent-%COMP%]   .material-icon[_ngcontent-%COMP%]{text-align:center;width:24px;height:24px;margin:15px 0 15px 15px}[_nghost-%COMP%]   .message-container[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{margin:5px 15px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InfoMessageComponent, [{
    type: Component,
    args: [{
      selector: 'info-message',
      template: "<div class=\"info-message\" [style.width]=\"options?.width\" [style.max-width]=\"options?.maxWidth\">\n  <div class=\"message-container\" [class.warning]=\"options.messageType === 'warning'\"\n    [class.error]=\"options.messageType === 'error'\" [class.primary]=\"options.messageType === 'primary'\"\n    [class.info]=\"options.messageType === 'info'\" [class.success]=\"options.messageType === 'success'\"\n    [style.width]=\"options?.width\" [style.max-width]=\"options?.maxWidth\">\n\n    <div *ngIf=\"options.messageType !== 'primary'\">\n      <div class=\"fa-icon\" *ngIf=\"options.useFaIcon\">\n        <i aria-label=\"Meddelandets ikon\" class=\"fas fa-lg\" \n          [class.fa-info-circle]=\"options.messageType === 'info'\"\n          [class.fa-check-circle]=\"options.messageType === 'success'\"\n          [class.fa-exclamation-circle]=\"options.messageType === 'warning'\"\n          [class.fa-exclamation-triangle]=\"options.messageType === 'error'\"></i>\n      </div>\n\n      <div class=\"material-icon\" *ngIf=\"options.useMaterialIcon\">\n        <i aria-label=\"Meddelandets ikon\" class=\"material-icons\">{{ evaluateMaterialIcon() }}</i>\n      </div>\n    </div>\n    <div class=\"content\" [innerHtml]=\"options.messageContent\"></div>\n  </div>\n</div>",
      styles: [":host{display:flex}:host .message-container{min-height:50px;display:inline-flex;align-items:center}:host .message-container .fa-icon,:host .message-container .material-icon{text-align:center;width:24px;height:24px;margin:15px 0 15px 15px}:host .message-container .content{margin:5px 15px}\n"]
    }]
  }], null, {
    options: [{
      type: Input
    }]
  });
})();
class InfoMessageModule {
  static ɵfac = function InfoMessageModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InfoMessageModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: InfoMessageModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InfoMessageModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [InfoMessageComponent],
      exports: [InfoMessageComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2021 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
var ServiceStatus;
(function (ServiceStatus) {
  ServiceStatus["UP"] = "UP";
  ServiceStatus["DOWN"] = "DOWN";
})(ServiceStatus || (ServiceStatus = {}));

/*
 * Copyright (C) 2021 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class HealthCheckStatusUtil {
  static serviceIsDown(serviceStatus) {
    return serviceStatus === ServiceStatus.DOWN;
  }
}
class IntegrationHealthCheckService {
  http;
  apiUrl = '/api';
  constructor(http) {
    this.http = http;
  }
  getHealthCheckStatus() {
    return this.http.get(`${this.apiUrl}/health-check-statuses`);
  }
  static ɵfac = function IntegrationHealthCheckService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationHealthCheckService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationHealthCheckService,
    factory: IntegrationHealthCheckService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntegrationHealthCheckService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2021 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class IntegrationHealthCheckDatasource {
  healthCheckStatusService;
  healthCheckStatuses = new BehaviorSubject([]);
  constructor(healthCheckStatusService) {
    this.healthCheckStatusService = healthCheckStatusService;
  }
  connect() {
    return this.healthCheckStatuses.asObservable();
  }
  fetch() {
    this.healthCheckStatusService.getHealthCheckStatus().subscribe(result => this.healthCheckStatuses.next(result));
  }
  static ɵfac = function IntegrationHealthCheckDatasource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationHealthCheckDatasource)(i0.ɵɵinject(IntegrationHealthCheckService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationHealthCheckDatasource,
    factory: IntegrationHealthCheckDatasource.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntegrationHealthCheckDatasource, [{
    type: Injectable
  }], () => [{
    type: IntegrationHealthCheckService
  }], null);
})();
class UserIdleService {
  userActionTimeoutSeconds = 150;
  lastUserActionTime;
  userIsIdle() {
    if (!this.lastUserActionTime) {
      this.lastUserActionTime = moment();
    }
    const timeSinceLastAction = moment().unix() - this.lastUserActionTime.unix();
    return timeSinceLastAction > this.userActionTimeoutSeconds;
  }
  setLastUserActionTime(actionTime) {
    this.lastUserActionTime = actionTime;
  }
  setUserActionTimeoutSeconds(userActionTimeoutSeconds) {
    this.userActionTimeoutSeconds = userActionTimeoutSeconds;
  }
  static ɵfac = function UserIdleService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UserIdleService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserIdleService,
    factory: UserIdleService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserIdleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2021 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class IntegrationHealthCheckComponent {
  integrationHealthCheckDatasource;
  userIdleService;
  options = {
    intervalInSeconds: 60
  };
  healthCheckStatuses;
  milliSecondFactor = 1000;
  externalSystemsInfoMessageOptions = {
    messageContent: '',
    messageType: InfoMessageType.WARNING,
    useFaIcon: true
  };
  constructor(integrationHealthCheckDatasource, userIdleService) {
    this.integrationHealthCheckDatasource = integrationHealthCheckDatasource;
    this.userIdleService = userIdleService;
  }
  ngOnInit() {
    this.healthCheckStatuses = this.integrationHealthCheckDatasource.connect();
    this.startFetchingHealthChecks();
  }
  someServiceIsDown(statuses) {
    if (statuses !== null) {
      return statuses.some(status => HealthCheckStatusUtil.serviceIsDown(status.serviceStatus));
    }
    return true;
  }
  setInfoMessage(serviceNames) {
    this.externalSystemsInfoMessageOptions.messageContent = 'Just nu har vi problem med att nå följande externa system: ' + serviceNames + '. Funktionaliteten på sidan kan därför vara begränsad.';
  }
  getServiceNames(statuses) {
    let serviceNames = '';
    if (statuses !== null) {
      const serviceNameArray = statuses.filter(status => status.serviceStatus === ServiceStatus.DOWN).map(status => status.serviceName);
      serviceNames = serviceNameArray.join(', ');
    }
    return serviceNames;
  }
  startFetchingHealthChecks() {
    timer(0, this.getInterval()).subscribe(() => {
      if (!this.userIdleService.userIsIdle()) {
        this.integrationHealthCheckDatasource.fetch();
      }
    });
  }
  getInterval() {
    return this.options.intervalInSeconds * this.milliSecondFactor;
  }
  static ɵfac = function IntegrationHealthCheckComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationHealthCheckComponent)(i0.ɵɵdirectiveInject(IntegrationHealthCheckDatasource), i0.ɵɵdirectiveInject(UserIdleService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IntegrationHealthCheckComponent,
    selectors: [["integration-health-check"]],
    inputs: {
      options: "options"
    },
    standalone: false,
    decls: 2,
    vars: 3,
    consts: [[4, "ngIf"], [1, "integration-health-check"], [3, "options"]],
    template: function IntegrationHealthCheckComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, IntegrationHealthCheckComponent_ng_container_0_Template, 5, 8, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.someServiceIsDown(i0.ɵɵpipeBind1(1, 1, ctx.healthCheckStatuses)));
      }
    },
    dependencies: [i2.NgIf, InfoMessageComponent, i2.AsyncPipe],
    styles: ["[_nghost-%COMP%]   .integration-health-check[_ngcontent-%COMP%]   info-message[_ngcontent-%COMP%]{font-size:.8em;border:1px solid rgb(236,191,94);display:inline-flex}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntegrationHealthCheckComponent, [{
    type: Component,
    args: [{
      selector: 'integration-health-check',
      template: "<ng-container *ngIf=\"someServiceIsDown(healthCheckStatuses | async)\">\n  <div class=\"integration-health-check\" [style.width]=\"options?.width\" [style.max-width]=\"options?.maxWidth\">\n    {{ setInfoMessage(getServiceNames(healthCheckStatuses | async)) }}\n    <info-message [options]=\"externalSystemsInfoMessageOptions\"></info-message>\n  </div>\n</ng-container>",
      styles: [":host .integration-health-check info-message{font-size:.8em;border:1px solid rgb(236,191,94);display:inline-flex}\n"]
    }]
  }], () => [{
    type: IntegrationHealthCheckDatasource
  }, {
    type: UserIdleService
  }], {
    options: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2021 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class IntegrationHealthCheckModule {
  static ɵfac = function IntegrationHealthCheckModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationHealthCheckModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: IntegrationHealthCheckModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IntegrationHealthCheckService, IntegrationHealthCheckDatasource],
    imports: [CommonModule, InfoMessageModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntegrationHealthCheckModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, InfoMessageModule],
      declarations: [IntegrationHealthCheckComponent],
      exports: [IntegrationHealthCheckComponent],
      providers: [IntegrationHealthCheckService, IntegrationHealthCheckDatasource]
    }]
  }], null, null);
})();
class JobStatusService {
  http;
  apiUrl = '/api';
  constructor(http) {
    this.http = http;
  }
  getJobStatuses() {
    return this.http.get(`${this.apiUrl}/job-statuses`);
  }
  static ɵfac = function JobStatusService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || JobStatusService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: JobStatusService,
    factory: JobStatusService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobStatusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2021 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class JobStatusDatasource {
  jobStatusService;
  jobStatuses = new BehaviorSubject([]);
  loading = new BehaviorSubject(false);
  constructor(jobStatusService) {
    this.jobStatusService = jobStatusService;
  }
  connect() {
    return this.jobStatuses.asObservable();
  }
  connectLoading() {
    return this.loading.asObservable();
  }
  fetch() {
    this.loading.next(true);
    this.jobStatusService.getJobStatuses().subscribe(result => {
      this.loading.next(false);
      this.jobStatuses.next(result);
    }, () => this.loading.next(false));
  }
  static ɵfac = function JobStatusDatasource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || JobStatusDatasource)(i0.ɵɵinject(JobStatusService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: JobStatusDatasource,
    factory: JobStatusDatasource.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobStatusDatasource, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: JobStatusService
  }], null);
})();

/*
 * Copyright (C) 2021 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class JobStatusComponent {
  jobStatusDatasource;
  jobStatuses;
  loading;
  constructor(jobStatusDatasource) {
    this.jobStatusDatasource = jobStatusDatasource;
  }
  ngOnInit() {
    this.loading = this.jobStatusDatasource.connectLoading();
    this.jobStatuses = this.jobStatusDatasource.connect();
    this.fetchData();
  }
  fetchData() {
    this.jobStatusDatasource.fetch();
  }
  static ɵfac = function JobStatusComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || JobStatusComponent)(i0.ɵɵdirectiveInject(JobStatusDatasource));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: JobStatusComponent,
    selectors: [["job-status"]],
    standalone: false,
    decls: 13,
    vars: 9,
    consts: [[1, "columns"], [1, "box", "column"], [1, "flex", "flex-fill"], [1, "flex", "box-title", "page-title"], [1, "loading-indicator-container-small", "flex-align-center"], ["class", "loading-indicator-small", 4, "ngIf"], [1, "button", "is-small", "is-pulled-right", 3, "click", "disabled"], ["class", "job-status-section", 4, "ngFor", "ngForOf"], [1, "loading-indicator-small"], [1, "job-status-section"], [1, "box-title", "job-title"], [1, "columns-table"], [1, "columns-table-body", "columns"], [1, "column", "is-9"], [1, "column", "is-3"], ["class", "columns-table-body columns", 4, "ngFor", "ngForOf"]],
    template: function JobStatusComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtext(4, "Jobbstatus");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, JobStatusComponent_div_6_Template, 1, 0, "div", 5);
        i0.ɵɵpipe(7, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "button", 6);
        i0.ɵɵpipe(9, "async");
        i0.ɵɵlistener("click", function JobStatusComponent_Template_button_click_8_listener() {
          return ctx.fetchData();
        });
        i0.ɵɵtext(10, "Uppdatera sidan");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(11, JobStatusComponent_div_11_Template, 27, 11, "div", 7);
        i0.ɵɵpipe(12, "async");
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 3, ctx.loading));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(9, 5, ctx.loading));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(12, 7, ctx.jobStatuses));
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i2.AsyncPipe, i2.DatePipe, i2.KeyValuePipe],
    styles: [".page-title[_ngcontent-%COMP%]{padding-bottom:1.3em}.job-status-section[_ngcontent-%COMP%]{margin-bottom:2.5em}.job-title[_ngcontent-%COMP%]{padding-bottom:.5em}.loading-indicator-container-small[_ngcontent-%COMP%]{display:flex;width:1em;margin:0 .8em .8em}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobStatusComponent, [{
    type: Component,
    args: [{
      selector: 'job-status',
      template: "<div class=\"columns\">\n  <div class=\"box column\">\n\n    <div class=\"flex flex-fill\">\n      <div class=\"flex box-title page-title\">Jobbstatus</div>\n      <div class=\"loading-indicator-container-small flex-align-center\">\n        <div *ngIf=\"loading | async\" class=\"loading-indicator-small\"></div>\n      </div>\n      <button class=\"button is-small is-pulled-right\" [disabled]=\"loading | async\" (click)=\"fetchData()\">Uppdatera\n        sidan</button>\n    </div>\n\n    <div *ngFor=\"let jobStatus of jobStatuses | async\" class=\"job-status-section\">\n      <div class=\"box-title job-title\">{{ jobStatus.name }}</div>\n\n      <div class=\"columns-table\">\n        <div class=\"columns-table-body columns\">\n          <div class=\"column is-9\">\n            Jobb aktivt\n          </div>\n          <div class=\"column is-3\">\n            {{ jobStatus.active ? 'Ja' : 'Nej' }}\n          </div>\n        </div>\n        <div class=\"columns-table-body columns\">\n          <div class=\"column is-9\">\n            Tidsintervall\n          </div>\n          <div class=\"column is-3\">\n            {{ jobStatus.interval ? jobStatus.interval : 'N/A' }}\n          </div>\n        </div>\n        <div class=\"columns-table-body columns\">\n          <div class=\"column is-9\">\n            Senaste jobbk\u00F6rning\n          </div>\n          <div class=\"column is-3\">\n            {{ jobStatus.lastTimestamp ? ( jobStatus.lastTimestamp | date:'yyyy-MM-dd HH:mm' ) : 'N/A' }}\n          </div>\n        </div>\n        <div class=\"columns-table-body columns\">\n          <div class=\"column is-9\">\n            Status vid senaste jobbk\u00F6rning\n          </div>\n          <div class=\"column is-3\">\n            {{ jobStatus.lastStatus ? jobStatus.lastStatus : 'N/A' }}\n          </div>\n        </div>\n        <div *ngFor=\"let information of jobStatus.customInformation | keyvalue\" class=\"columns-table-body columns\">\n          <div class=\"column is-9\">\n            {{ information.key }}\n          </div>\n          <div class=\"column is-3\">\n            {{ information.value }}\n          </div>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>",
      styles: [".page-title{padding-bottom:1.3em}.job-status-section{margin-bottom:2.5em}.job-title{padding-bottom:.5em}.loading-indicator-container-small{display:flex;width:1em;margin:0 .8em .8em}\n"]
    }]
  }], () => [{
    type: JobStatusDatasource
  }], null);
})();

/*
 * Copyright (C) 2021 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class JobStatusModule {
  static ɵfac = function JobStatusModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || JobStatusModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: JobStatusModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [JobStatusService, JobStatusDatasource],
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobStatusModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [JobStatusComponent],
      exports: [JobStatusComponent],
      providers: [JobStatusService, JobStatusDatasource]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class NavAreaDirective {
  el;
  focusClass = 'focused-keynav-area';
  focusItemClass = 'focused-keynav-item';
  currentIndex = 0;
  numItems = 0;
  navItems = [];
  focused$;
  blured$;
  keyDown$;
  clicked$;
  touched$;
  focusSub;
  clickedSub;
  touchedSub;
  blurSub;
  keySub;
  clickedActive = false;
  constructor(el) {
    this.el = el;
  }
  ngOnInit() {
    this.focused$ = fromEvent(this.el.nativeElement, 'focus');
    this.blured$ = fromEvent(this.el.nativeElement, 'blur');
    this.keyDown$ = fromEvent(document, 'keydown');
    this.clicked$ = fromEvent(this.el.nativeElement, 'mousedown');
    this.touched$ = fromEvent(this.el.nativeElement, 'touchstart');
    this.clickedSub = this.clicked$.subscribe(ev => {
      this.handleClick(ev);
    });
    this.touchedSub = this.touched$.subscribe(ev => {
      this.handleTouch(ev);
    });
    this.focusSub = this.focused$.pipe(delay(250)).subscribe(ev => {
      this.handleFocus(ev);
    });
    this.blurSub = this.blured$.subscribe(ev => {
      this.handleBlur(ev);
    });
  }
  addItem(navItem) {
    navItem.setFocusClass(this.focusItemClass);
    this.navItems.push(navItem);
    this.numItems += 1;
  }
  removeItem(navItem) {
    this.navItems.splice(this.navItems.indexOf(navItem), 1);
    this.numItems -= 1;
  }
  selectFirst() {
    this.currentIndex = 0;
    this.selectItem(this.currentIndex);
  }
  selectNext() {
    if (this.currentIndex < this.numItems - 1) {
      this.currentIndex += 1;
    } else {
      this.currentIndex = 0;
    }
    this.selectItem(this.currentIndex);
  }
  selectPrevious() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1;
    } else {
      this.currentIndex = this.numItems - 1;
    }
    this.selectItem(this.currentIndex);
  }
  selectItem(index) {
    this.deselectAll();
    this.navItems[index].focusItem();
  }
  deselectAll() {
    for (const navItem of this.navItems) {
      if (navItem.focused) {
        navItem.blurItem();
      }
    }
  }
  handleClick(ev) {
    this.clickedActive = true;
    timer(500).subscribe(result => {
      this.clickedActive = false;
    });
  }
  handleTouch(ev) {
    this.clickedActive = true;
    timer(200).subscribe(result => {
      this.el.nativeElement.blur();
    });
  }
  handleFocus(ev) {
    if (!this.clickedActive) {
      if (this.keySub) {
        this.keySub.unsubscribe();
      }
      this.el.nativeElement.classList.add('focused-keynav-area');
      this.selectFirst();
      this.keySub = this.keyDown$.subscribe(keyEvent => {
        this.handleKey(keyEvent);
      });
    }
  }
  handleBlur(ev) {
    this.el.nativeElement.classList.remove('focused-keynav-area');
    this.deselectAll();
    if (this.keySub) {
      this.keySub.unsubscribe();
    }
  }
  handleKey(ev) {
    if (ev.key !== 'Tab') {
      ev.preventDefault();
    }
    switch (ev.key) {
      case 'ArrowUp':
      case 'ArrowLeft':
      case 'Up':
      case 'KeyW':
        this.selectPrevious();
        break;
      case 'ArrowDown':
      case 'ArrowRight':
      case 'Down':
      case 'KeyS':
        this.selectNext();
        break;
      default:
        break;
    }
  }
  ngOnDestroy() {
    if (this.focusSub) {
      this.focusSub.unsubscribe();
    }
    if (this.blurSub) {
      this.blurSub.unsubscribe();
    }
    if (this.keySub) {
      this.keySub.unsubscribe();
    }
    if (this.clickedSub) {
      this.clickedSub.unsubscribe();
    }
  }
  static ɵfac = function NavAreaDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavAreaDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: NavAreaDirective,
    selectors: [["", "nav-area", ""]],
    inputs: {
      focusClass: "focusClass",
      focusItemClass: "focusItemClass"
    },
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavAreaDirective, [{
    type: Directive,
    args: [{
      selector: '[nav-area]'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    focusClass: [{
      type: Input
    }],
    focusItemClass: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class NavItemDirective {
  navArea;
  el;
  triggered = new EventEmitter();
  focused = false;
  focusClass = 'focused-keynav-item';
  keyDown$;
  keySubscription;
  constructor(navArea, el) {
    this.navArea = navArea;
    this.el = el;
  }
  ngOnInit() {
    this.navArea.addItem(this);
    this.keyDown$ = fromEvent(document, 'keydown');
  }
  setFocusClass(className) {
    this.focusClass = className;
  }
  focusItem() {
    this.el.nativeElement.classList.add(this.focusClass);
    this.el.nativeElement.focus();
    this.el.nativeElement.scrollIntoView(false);
    this.focused = true;
    this.keySubscription = this.keyDown$.subscribe(keyEvent => {
      this.handleKey(keyEvent);
    });
  }
  blurItem() {
    this.el.nativeElement.classList.remove(this.focusClass);
    this.el.nativeElement.blur();
    this.focused = false;
    this.keySubscription.unsubscribe();
  }
  handleKey(keyEvent) {
    if (keyEvent.key === 'Space' || keyEvent.key === 'Enter' || keyEvent.keyCode === 32) {
      this.triggered.emit(this);
    }
  }
  ngOnDestroy() {
    if (this.keySubscription) {
      this.keySubscription.unsubscribe();
    }
    this.navArea.removeItem(this);
  }
  static ɵfac = function NavItemDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavItemDirective)(i0.ɵɵdirectiveInject(NavAreaDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: NavItemDirective,
    selectors: [["", "nav-item", ""]],
    outputs: {
      triggered: "triggered"
    },
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavItemDirective, [{
    type: Directive,
    args: [{
      selector: '[nav-item]'
    }]
  }], () => [{
    type: NavAreaDirective
  }, {
    type: i0.ElementRef
  }], {
    triggered: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class KeynavModule {
  static ɵfac = function KeynavModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || KeynavModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: KeynavModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KeynavModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [NavAreaDirective, NavItemDirective],
      exports: [NavAreaDirective, NavItemDirective]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ListComponent {
  newValueInput;
  showAddField = false;
  newValue = '';
  items = [];
  disabled = false;
  value = [];
  onChange;
  onTouched;
  compareWith;
  writeValue(value) {
    if (value && Array.isArray(value)) {
      if (Array.isArray(value)) {
        this.items = value;
      }
    }
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  addNewValue() {
    this.newValue = '';
    setTimeout(() => {
      this.newValueInput.nativeElement.focus();
    }, 0);
  }
  delete(value) {
    if (!this.disabled) {
      const index = this.items.indexOf(value);
      if (index !== -1) {
        this.items.splice(index, 1);
        this.onChange(this.items);
      }
    }
  }
  addWithEnter(value) {
    this.add(value);
    this.newValue = '';
  }
  add(value) {
    if (value && value !== '') {
      this.items.push(value);
      this.onChange(this.items);
      this.newValue = null;
    }
    this.onTouched();
  }
  showAdd() {
    this.showAddField = true;
  }
  onListItemChange(index, event) {
    this.editDisabledState(event, true);
    this.items[index] = this.getParentFirstChildElementByEvent(event).value;
    this.onChange(this.items);
  }
  editDisabledState(event, state) {
    const elem = this.getParentFirstChildElementByEvent(event);
    elem.readOnly = state;
    if (!state) {
      elem.className = 'list-item.enabled';
      elem.focus();
    } else {
      elem.className = 'list-item';
    }
  }
  getParentFirstChildElementByEvent(event) {
    return event.target.parentElement.firstChild;
  }
  static ɵfac = function ListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ListComponent,
    selectors: [["list"]],
    viewQuery: function ListComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c16, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.newValueInput = _t.first);
      }
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ListComponent),
      multi: true
    }])],
    decls: 4,
    vars: 3,
    consts: [["newValueInput", ""], ["class", "list-row", "style", "display: flex; align-items: center;", 3, "enabled", 4, "ngFor", "ngForOf"], ["class", "input is-small", "type", "text", 3, "disabled", "ngModel", "blur", "ngModelChange", "keydown.enter", 4, "ngIf"], ["type", "button", 1, "button", "is-small", "fas", "fa-plus", "margin-top", 3, "click", "disabled"], [1, "list-row", 2, "display", "flex", "align-items", "center"], ["readonly", "true", 1, "list-item", 2, "border", "none", "width", "100%", 3, "dblclick", "keydown.enter", "blur", "disabled", "value"], ["type", "button", "class", "button is-small fas fa-edit", 3, "click", 4, "ngIf"], ["type", "button", "class", "button is-small fas fa-times", 3, "click", 4, "ngIf"], ["type", "button", 1, "button", "is-small", "fas", "fa-edit", 3, "click"], ["type", "button", 1, "button", "is-small", "fas", "fa-times", 3, "click"], ["type", "text", 1, "input", "is-small", 3, "blur", "ngModelChange", "keydown.enter", "disabled", "ngModel"]],
    template: function ListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, ListComponent_div_0_Template, 4, 6, "div", 1);
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵtemplate(2, ListComponent_input_2_Template, 2, 2, "input", 2);
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function ListComponent_Template_button_click_3_listener() {
          return ctx.addNewValue();
        });
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.items);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.newValue !== null);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", ctx.disabled);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgModel],
    styles: [".list-row[_ngcontent-%COMP%]{color:#7a7a7a;margin-bottom:3px;font-size:.75rem}.list-row.enabled[_ngcontent-%COMP%]{border:1px solid #ccc;background-color:#f5f5f5}.list-item[_ngcontent-%COMP%]{display:inline-block;padding:4px;background-color:#ebebe4}.list-item.enabled[_ngcontent-%COMP%]{border-left:1px solid #ccc;background-color:#fff}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListComponent, [{
    type: Component,
    args: [{
      selector: 'list',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ListComponent),
        multi: true
      }],
      template: "<div [class.enabled]=\"!disabled\" class=\"list-row\" *ngFor=\"let item of items; let i=index\" style=\"display: flex; align-items: center;\">\n    <input [disabled]=\"disabled\" readonly=\"true\" class=\"list-item\" style=\"border: none; width:100%;\"\n        (dblclick)=\"editDisabledState($event, false)\" (keydown.enter)=\"onListItemChange(i, $event)\" [value]=\"item\"\n        (blur)=\"onListItemChange(i, $event)\" />\n    <button *ngIf=\"!disabled\" (click)=\"editDisabledState($event, false)\" type=\"button\" class=\"button is-small fas fa-edit\"></button>\n    <button *ngIf=\"!disabled\" (click)=\"delete(item)\" type=\"button\" class=\"button is-small fas fa-times\"></button>\n</div>\n\n<div>\n    <input #newValueInput *ngIf=\"newValue !== null\" [disabled]=\"disabled\" (blur)=\"add(newValue); onTouched()\" [(ngModel)]=\"newValue\"\n        (keydown.enter)=\"addWithEnter(newValue)\" class=\"input is-small\" type=\"text\">\n    <button [disabled]=\"disabled\" type=\"button\" class=\"button is-small fas fa-plus margin-top\" (click)=\"addNewValue()\"></button>\n</div>",
      styles: [".list-row{color:#7a7a7a;margin-bottom:3px;font-size:.75rem}.list-row.enabled{border:1px solid #ccc;background-color:#f5f5f5}.list-item{display:inline-block;padding:4px;background-color:#ebebe4}.list-item.enabled{border-left:1px solid #ccc;background-color:#fff}\n"]
    }]
  }], null, {
    newValueInput: [{
      type: ViewChild,
      args: ['newValueInput']
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ListModule {
  static ɵfac = function ListModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ListModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, FormsModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule],
      declarations: [ListComponent],
      exports: [ListComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class X509CertificateUtil {
  static getPredefinedItems() {
    const predefinedItems = [{
      name: 'SITHS attribute OID',
      oid: '1.2.752.34.2.1'
    }, {
      name: 'Certificate Policies',
      oid: '2.5.29.32'
    }];
    return predefinedItems;
  }
  static getX509Fields() {
    const items = this.getPredefinedItems();
    return items.sort((a, b) => a.name > b.name ? 1 : -1);
  }
  static oidExists(oid) {
    const items = this.getPredefinedItems();
    const filteredItems = items.filter(x => x.oid === oid);
    return filteredItems.length >= 1;
  }
  static getNameOfOid(oid) {
    if (oid === null) {
      return null;
    }
    const items = this.getPredefinedItems().filter(x => x.oid === oid);
    if (items.length >= 1) {
      return items[0].name;
    } else {
      return oid;
    }
  }
}

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LoaCertificateService {
  http;
  apiUrl;
  constructor(http) {
    this.http = http;
    this.apiUrl = '/api/loa';
  }
  getLoaCertificates() {
    return this.http.get(`${this.apiUrl}/loa-trusts`);
  }
  save(loaCertificate) {
    return this.http.post(`${this.apiUrl}/save-loa`, loaCertificate);
  }
  deleteLoaRule(id) {
    return this.http.delete(`${this.apiUrl}/delete-loa?loaId=${id}`);
  }
  static ɵfac = function LoaCertificateService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoaCertificateService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LoaCertificateService,
    factory: LoaCertificateService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaCertificateService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LoaRuleFormComponent {
  fb;
  certificate;
  loaRuleToEdit;
  loaRuleSaved = new EventEmitter();
  loaRuleEdited = new EventEmitter();
  loaRuleDeleted = new EventEmitter();
  certificateLoaLevelChanged = new EventEmitter();
  editCancelled = new EventEmitter();
  levelOfAssuranceValues = [2, 3, 4];
  ruleForm;
  fieldSelectValues = [];
  formSubmitted = false;
  constructor(fb) {
    this.fb = fb;
  }
  ngOnInit() {
    this.buildSelectValues();
    this.initForm();
    this.resetForm();
  }
  ngOnChanges(changes) {
    this.resetForm();
    this.buildSelectValues();
    if (changes['loaRuleToEdit'] && this.loaRuleToEdit) {
      this.patchForm();
    }
  }
  addValueRow() {
    const control = this.ruleForm.get('ruleValues');
    control.push(this.patchValue(null, this.levelOfAssuranceValues[0]));
    this.ruleForm.markAsDirty();
  }
  removeValueRow(index) {
    const control = this.ruleForm.get('ruleValues');
    control.removeAt(index);
    this.ruleForm.markAsDirty();
  }
  onChangeLoaLevel() {
    const choosenLoaLevel = this.ruleForm.get('defaultLevelOfAssurance').value;
    this.certificateLoaLevelChanged.emit(choosenLoaLevel);
  }
  submitForm() {
    this.formSubmitted = true;
    if (!this.ruleForm.valid) {
      return;
    }
    const ruleValues = this.ruleForm.get('ruleValues');
    const ruleFieldSelect = this.ruleForm.get('ruleFieldSelect').value;
    const rules = [];
    for (const rule of ruleValues.controls) {
      const ruleValue = rule.get('ruleValue').value;
      const ruleValueLevelOfAssurance = rule.get('ruleValueLevelOfAssurance').value;
      rules.push({
        value: ruleValue,
        levelOfAssurance: ruleValueLevelOfAssurance
      });
    }
    const loaRule = {
      field: ruleFieldSelect,
      rules: rules
    };
    this.fieldSelectValues = this.fieldSelectValues.filter(field => field.oid !== ruleFieldSelect);
    this.resetForm();
    if (this.loaRuleToEdit) {
      this.loaRuleEdited.emit(loaRule);
    } else {
      this.loaRuleSaved.emit(loaRule);
    }
  }
  // ---- private methods ----
  buildSelectValues() {
    const inUseFields = [];
    const allFields = X509CertificateUtil.getX509Fields();
    if (this.certificate.loaMetadata?.loaFieldRules) {
      this.certificate.loaMetadata?.loaFieldRules.forEach(fieldRule => {
        inUseFields.push(fieldRule.field);
      });
    }
    const filtered = [];
    for (const extension of allFields) {
      const inUse = inUseFields.find(inUseField => extension.oid === inUseField);
      if (!inUse) {
        filtered.push(extension);
      }
    }
    this.fieldSelectValues = filtered;
  }
  patchSelectValues(fieldToAdd) {
    const allFields = X509CertificateUtil.getX509Fields();
    const matchedField = allFields.find(field => field.oid === fieldToAdd);
    this.fieldSelectValues.push(matchedField);
  }
  initForm() {
    this.ruleForm = this.fb.group({
      ruleFieldSelect: [null, Validators.required],
      defaultLevelOfAssurance: this.levelOfAssuranceValues[0],
      ruleValues: this.fb.array([this.fb.group({
        ruleValue: [null, Validators.minLength(1)],
        ruleValueLevelOfAssurance: [this.levelOfAssuranceValues[0]]
      })])
    });
  }
  patchForm() {
    if (!this.ruleForm) {
      this.initForm();
    }
    this.patchSelectValues(this.loaRuleToEdit.field);
    this.ruleForm.patchValue({
      defaultLevelOfAssurance: this.certificate.loaMetadata.defaultLevelOfAssurance
    });
    this.ruleForm.get('ruleFieldSelect').setValue(this.loaRuleToEdit.field);
    const ruleValuesControl = this.ruleForm.get('ruleValues');
    for (const rule of this.loaRuleToEdit.rules) {
      ruleValuesControl.push(this.fb.group({
        ruleValue: [rule.value, Validators.minLength(1)],
        ruleValueLevelOfAssurance: [rule.levelOfAssurance]
      }));
    }
  }
  cancelEdit() {
    this.resetForm();
    this.editCancelled.emit();
  }
  resetForm() {
    if (!this.ruleForm) {
      this.initForm();
    }
    this.formSubmitted = false;
    this.ruleForm.patchValue({
      defaultLevelOfAssurance: this.certificate.loaMetadata.defaultLevelOfAssurance,
      ruleFieldSelect: null
    });
    const control = this.ruleForm.get('ruleValues');
    control.clear();
    this.ruleForm.get('ruleFieldSelect').setValue(null);
    this.ruleForm.markAsPristine();
  }
  patchValue(value, loa) {
    return this.fb.group({
      ruleValue: [value],
      ruleValueLevelOfAssurance: [loa]
    });
  }
  static ɵfac = function LoaRuleFormComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoaRuleFormComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LoaRuleFormComponent,
    selectors: [["loa-rule-form"]],
    inputs: {
      certificate: "certificate",
      loaRuleToEdit: "loaRuleToEdit"
    },
    outputs: {
      loaRuleSaved: "loaRuleSaved",
      loaRuleEdited: "loaRuleEdited",
      loaRuleDeleted: "loaRuleDeleted",
      certificateLoaLevelChanged: "certificateLoaLevelChanged",
      editCancelled: "editCancelled"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 41,
    vars: 10,
    consts: [[1, "column", "box"], [1, "title", "is-5"], [1, "flex", "flex-fill"], [1, "flex", "flex-start"], [1, "label"], [3, "formGroup"], [1, "field"], [1, "label", "is-small"], [1, "control"], [1, "select", "is-small"], ["formControlName", "defaultLevelOfAssurance", 3, "change"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["data-tooltip", "OID:en f\xF6r f\xE4ltet i certifikatet", 1, "is-pulled-right", "tooltip", "is-tooltip-left", "is-tooltip-multiline", "tooltip-break-line"], [1, "fas", "fa-question-circle"], [1, "control", "is-expanded", "select", "is-small", "full-width"], ["formControlName", "ruleFieldSelect", 1, "input"], [3, "value"], ["class", "help is-danger", 4, "ngIf"], ["formArrayName", "ruleValues", 1, "field"], ["data-tooltip", "V\xE4rdet som certifikatsf\xE4ltet m\xE5ste matcha f\xF6r att regeln skall anv\xE4ndas. Kan anges som Regex.", 1, "is-pulled-right", "tooltip", "is-tooltip-left", "is-tooltip-multiline", "tooltip-break-line"], [4, "ngFor", "ngForOf"], [1, "button", "is-small", "add-value-button", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-plus"], [1, "columns"], [1, "buttons-container", "flex", "flex-row", "flex-end"], ["class", "button is-small margin-right", 3, "click", 4, "ngIf"], [1, "button", "is-small", "is-primary", 3, "click"], [3, "ngValue"], [1, "help", "is-danger"], [1, "field", "has-addons", 3, "formGroupName"], [1, "control", "is-expanded"], ["formControlName", "ruleValue", "type", "text", 1, "input", "is-small"], [1, "control", "select", "is-small"], ["formControlName", "ruleValueLevelOfAssurance"], [3, "value", 4, "ngFor", "ngForOf"], [1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"], [1, "button", "is-small", "margin-right", 3, "click"]],
    template: function LoaRuleFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h1", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "label", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(7, "form", 5)(8, "div", 6)(9, "label", 7);
        i0.ɵɵtext(10, "Level of Assurance");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8)(12, "div", 9)(13, "select", 10);
        i0.ɵɵlistener("change", function LoaRuleFormComponent_Template_select_change_13_listener() {
          return ctx.onChangeLoaLevel();
        });
        i0.ɵɵtemplate(14, LoaRuleFormComponent_option_14_Template, 2, 2, "option", 11);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(15, "div", 6)(16, "label", 7);
        i0.ɵɵtext(17, " Certifikatsf\xE4lt ");
        i0.ɵɵelementStart(18, "div", 12);
        i0.ɵɵelement(19, "span", 13);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(20, "div", 14)(21, "select", 15)(22, "option", 16);
        i0.ɵɵtext(23, "V\xE4lj f\xE4lt");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, LoaRuleFormComponent_option_24_Template, 2, 3, "option", 11);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(25, LoaRuleFormComponent_p_25_Template, 2, 0, "p", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 18)(27, "label", 7);
        i0.ɵɵtext(28, " V\xE4rde / Regex ");
        i0.ɵɵelementStart(29, "div", 19);
        i0.ɵɵelement(30, "span", 13);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(31, LoaRuleFormComponent_div_31_Template, 11, 2, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 6)(33, "a", 21);
        i0.ɵɵlistener("click", function LoaRuleFormComponent_Template_a_click_33_listener() {
          return ctx.addValueRow();
        });
        i0.ɵɵelementStart(34, "span", 22);
        i0.ɵɵelement(35, "span", 23);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(36, "div", 24)(37, "div", 25);
        i0.ɵɵtemplate(38, LoaRuleFormComponent_button_38_Template, 2, 0, "button", 26);
        i0.ɵɵelementStart(39, "button", 27);
        i0.ɵɵlistener("click", function LoaRuleFormComponent_Template_button_click_39_listener() {
          return ctx.submitForm();
        });
        i0.ɵɵtext(40);
        i0.ɵɵelementEnd()()()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.certificate.name);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.loaRuleToEdit ? "Redigera regel" : "Skapa ny regel");
        i0.ɵɵadvance();
        i0.ɵɵproperty("formGroup", ctx.ruleForm);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngForOf", ctx.levelOfAssuranceValues);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("value", null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.fieldSelectValues);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.formSubmitted && (ctx.ruleForm.get("ruleFieldSelect").value === null || ctx.ruleForm.get("ruleFieldSelect").value.length === 0));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.ruleForm.get("ruleValues")["controls"]);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.loaRuleToEdit);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.loaRuleToEdit ? "Uppdatera" : "L\xE4gg till");
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i1$2.ɵNgNoValidate, i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption, i1$2.DefaultValueAccessor, i1$2.SelectControlValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i1$2.FormControlName, i1$2.FormGroupName, i1$2.FormArrayName],
    styles: [".add-value-button[_ngcontent-%COMP%]{cursor:pointer;width:100%}.full-width[_ngcontent-%COMP%]{width:100%}.buttons-container[_ngcontent-%COMP%]{padding:.75rem}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaRuleFormComponent, [{
    type: Component,
    args: [{
      selector: 'loa-rule-form',
      template: "<div class=\"column box\">\n  <h1 class=\"title is-5\">{{ certificate.name }}</h1>\n  <div class=\"flex flex-fill\">\n    <div class=\"flex flex-start\">\n      <label class=\"label\">{{ loaRuleToEdit ? 'Redigera regel' : 'Skapa ny regel' }}</label>\n    </div>\n  </div>\n\n  <form [formGroup]=\"ruleForm\">\n    <div class=\"field\">\n      <label class=\"label is-small\">Level of Assurance</label>\n\n      <div class=\"control\">\n        <div class=\"select is-small\">\n          <select formControlName=\"defaultLevelOfAssurance\" (change)=\"onChangeLoaLevel()\">\n            <option *ngFor=\"let level of levelOfAssuranceValues\" [ngValue]=\"level\">{{ level }}</option>\n          </select>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"field\">\n      <label class=\"label is-small\">\n        Certifikatsf\u00E4lt\n        <div class=\"is-pulled-right tooltip is-tooltip-left is-tooltip-multiline tooltip-break-line\"\n          data-tooltip=\"OID:en f\u00F6r f\u00E4ltet i certifikatet\">\n          <span class=\"fas fa-question-circle\"></span>\n        </div>\n      </label>\n\n      <div class=\"control is-expanded select is-small full-width\">\n        <select class=\"input\" formControlName=\"ruleFieldSelect\">\n          <option [value]=\"null\">V\u00E4lj f\u00E4lt</option>\n          <option *ngFor=\"let value of fieldSelectValues\" [ngValue]=\"value.oid\">{{ value.name }} ({{value.oid}})\n          </option>\n        </select>\n      </div>\n      <p *ngIf=\"formSubmitted && (ruleForm.get('ruleFieldSelect').value === null || ruleForm.get('ruleFieldSelect').value.length === 0)\"\n        class=\"help is-danger\">\n        F\u00E4ltet m\u00E5ste vara ifyllt.\n      </p>\n    </div>\n\n    <div class=\"field\" formArrayName=\"ruleValues\">\n      <label class=\"label is-small\">\n        V\u00E4rde / Regex\n        <div class=\"is-pulled-right tooltip is-tooltip-left is-tooltip-multiline tooltip-break-line\"\n          data-tooltip=\"V\u00E4rdet som certifikatsf\u00E4ltet m\u00E5ste matcha f\u00F6r att regeln skall anv\u00E4ndas. Kan anges som Regex.\">\n          <span class=\"fas fa-question-circle\"></span>\n        </div>\n      </label>\n\n      <div *ngFor=\"let child of ruleForm.get('ruleValues')['controls']; let i = index\">\n        <div class=\"field has-addons\" [formGroupName]=\"i\">\n          <div class=\"control is-expanded\">\n            <input formControlName=\"ruleValue\" class=\"input is-small\" type=\"text\">\n          </div>\n          <div class=\"control select is-small\">\n            <select formControlName=\"ruleValueLevelOfAssurance\">\n              <option *ngFor=\"let level of levelOfAssuranceValues\" [value]=\"level\">{{ level }}</option>\n            </select>\n          </div>\n          <div class=\"control\">\n            <a class=\"button is-small\" (click)=\"removeValueRow(i)\">\n              <span class=\"icon is-small\">\n                <span class=\"fas fa-trash\"></span>\n              </span>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"field\">\n      <a class=\"button is-small add-value-button\" (click)=\"addValueRow()\">\n        <span class=\"icon is-small\">\n          <span class=\"fas fa-plus\"></span>\n        </span>\n      </a>\n    </div>\n\n    <div class=\"columns\">\n      <div class=\"buttons-container flex flex-row flex-end\">\n        <button *ngIf=\"loaRuleToEdit\" class=\"button is-small margin-right\" (click)=\"cancelEdit()\">Avbryt</button>\n        <button class=\"button is-small is-primary\" (click)=\"submitForm()\">{{ loaRuleToEdit ? 'Uppdatera' : 'L\u00E4gg till' }}</button>\n      </div>\n    </div>\n  </form>\n</div>",
      styles: [".add-value-button{cursor:pointer;width:100%}.full-width{width:100%}.buttons-container{padding:.75rem}\n"]
    }]
  }], () => [{
    type: i1$2.FormBuilder
  }], {
    certificate: [{
      type: Input
    }],
    loaRuleToEdit: [{
      type: Input
    }],
    loaRuleSaved: [{
      type: Output
    }],
    loaRuleEdited: [{
      type: Output
    }],
    loaRuleDeleted: [{
      type: Output
    }],
    certificateLoaLevelChanged: [{
      type: Output
    }],
    editCancelled: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LoaCertificateComponent {
  loaCertificate;
  dialogService;
  certificate;
  loaRulesChanged = new EventEmitter();
  loaRuleForm;
  loaRules = [];
  loaRuleToEdit;
  loaRulesToDelete = [];
  rulesEdited = false;
  tempDefaultLoaLevel = 0;
  constructor(loaCertificate, dialogService) {
    this.loaCertificate = loaCertificate;
    this.dialogService = dialogService;
  }
  ngOnChanges(changes) {
    if (changes['certificate']) {
      this.rulesEdited = false;
      this.loaRuleToEdit = null;
      if (this.certificate.loaMetadata.loaFieldRules) {
        this.loaRules = this.certificate.loaMetadata.loaFieldRules;
      } else {
        this.loaRules = [];
        this.loaRulesToDelete = [];
      }
    }
  }
  defaultLoaLevelChanged(loaLevel) {
    this.tempDefaultLoaLevel = loaLevel;
    this.rulesEdited = true;
  }
  getNameOfOid(oid) {
    return X509CertificateUtil.getNameOfOid(oid);
  }
  editRule(loaRule) {
    this.loaRuleToEdit = loaRule;
  }
  removeRule(loaRule) {
    const index = this.loaRules.findIndex(item => item === loaRule);
    this.loaRules.splice(index, 1);
    this.loaRulesToDelete.push(loaRule);
    this.rulesEdited = true;
    // callback
    this.loaRuleForm.buildSelectValues();
  }
  saveChanges() {
    if (this.tempDefaultLoaLevel > 0) {
      this.certificate.loaMetadata.defaultLevelOfAssurance = this.tempDefaultLoaLevel;
    }
    this.certificate.loaMetadata.loaFieldRules = this.loaRules;
    this.loaCertificate.save(this.certificate).subscribe(it => {
      this.reset();
    });
  }
  loaRuleSaved(loaRule) {
    this.loaRules.push(loaRule);
    this.rulesEdited = true;
  }
  loaRuleEdited(loaRule) {
    const index = this.loaRules.indexOf(this.loaRuleToEdit);
    if (index > -1) {
      this.loaRules.splice(index, 1);
    }
    this.loaRules.push(loaRule);
    this.loaRuleToEdit = null;
    this.rulesEdited = true;
  }
  editCancelled(event) {
    this.loaRuleToEdit = null;
  }
  // ---- private methods ----
  reset() {
    this.loaRulesToDelete = [];
    this.rulesEdited = false;
    this.loaRulesChanged.emit();
  }
  static ɵfac = function LoaCertificateComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoaCertificateComponent)(i0.ɵɵdirectiveInject(LoaCertificateService), i0.ɵɵdirectiveInject(DialogService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LoaCertificateComponent,
    selectors: [["loa-certificate"]],
    viewQuery: function LoaCertificateComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c17, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loaRuleForm = _t.first);
      }
    },
    inputs: {
      certificate: "certificate"
    },
    outputs: {
      loaRulesChanged: "loaRulesChanged"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 6,
    vars: 4,
    consts: [["loaRuleForm", ""], ["class", "column", 4, "ngIf"], [3, "certificateLoaLevelChanged", "loaRuleSaved", "loaRuleEdited", "editCancelled", "certificate", "loaRuleToEdit"], [1, "column"], [1, "float-right", "is-primary", "button", "is-small", 3, "click", "disabled"], [1, "columns-table", "table-margin"], [1, "columns", "columns-table-head", "is-mobile"], [1, "column", "is-hidden-mobile"], [1, "column", "is-2", "is-hidden-mobile", "has-text-centered"], [1, "fas", "fa-cog"], ["id", "table-body-columns", "class", "columns-table-body columns is-multiline is-tablet", 4, "ngFor", "ngForOf"], ["id", "table-body-columns", 1, "columns-table-body", "columns", "is-multiline", "is-tablet"], ["class", "break-word", 4, "ngFor", "ngForOf"], [1, "column", "is-2", "has-text-centered"], ["title", "Redigera", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-edit"], ["title", "Ta bort", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"], [1, "break-word"]],
    template: function LoaCertificateComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵtemplate(0, LoaCertificateComponent_div_0_Template, 10, 1, "div", 1);
        i0.ɵɵelementStart(1, "loa-rule-form", 2, 0);
        i0.ɵɵlistener("certificateLoaLevelChanged", function LoaCertificateComponent_Template_loa_rule_form_certificateLoaLevelChanged_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.defaultLoaLevelChanged($event));
        })("loaRuleSaved", function LoaCertificateComponent_Template_loa_rule_form_loaRuleSaved_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.loaRuleSaved($event));
        })("loaRuleEdited", function LoaCertificateComponent_Template_loa_rule_form_loaRuleEdited_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.loaRuleEdited($event));
        })("editCancelled", function LoaCertificateComponent_Template_loa_rule_form_editCancelled_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.editCancelled($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3)(4, "button", 4);
        i0.ɵɵlistener("click", function LoaCertificateComponent_Template_button_click_4_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.saveChanges());
        });
        i0.ɵɵtext(5, "Spara \xE4ndringar");
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.loaRules && ctx.loaRules.length > 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("certificate", ctx.certificate)("loaRuleToEdit", ctx.loaRuleToEdit);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", !ctx.rulesEdited);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, LoaRuleFormComponent],
    styles: [".table-margin[_ngcontent-%COMP%]{margin:12px 4px}.break-word[_ngcontent-%COMP%]{word-break:break-word}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaCertificateComponent, [{
    type: Component,
    args: [{
      selector: 'loa-certificate',
      template: "<div class=\"column\" *ngIf=\"loaRules && loaRules.length > 0\">\n  <div class=\"columns-table table-margin\">\n    <div class=\"columns columns-table-head is-mobile\">\n      <div class=\"column is-hidden-mobile\">\n        F\u00E4ltregler\n      </div>\n\n      <div class=\"column is-hidden-mobile\">\n        Level of Assurance:Regex/V\u00E4rde\n      </div>\n\n      <div class=\"column is-2 is-hidden-mobile has-text-centered\">\n        <span class=\"fas fa-cog\"></span>\n      </div>\n    </div>\n\n    <div id=\"table-body-columns\" class=\"columns-table-body columns is-multiline is-tablet\" *ngFor=\"let loaRule of loaRules\">\n      <div class=\"column\">\n        {{loaRule.field}}\n      </div>\n\n      <div class=\"column\">\n        <div class=\"break-word\" *ngFor=\"let rule of loaRule.rules\">{{rule.levelOfAssurance}} => {{rule.value}}</div>\n      </div>\n\n      <div class=\"column is-2 has-text-centered\">\n        <button title=\"Redigera\" class=\"button is-small\" (click)=\"editRule(loaRule)\">\n          <span class=\"fas fa-edit\"></span>\n        </button>\n        <button title=\"Ta bort\" class=\"button is-small\" (click)=\"removeRule(loaRule)\">\n          <span class=\"fas fa-trash\"></span>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<loa-rule-form #loaRuleForm [certificate]=\"certificate\" [loaRuleToEdit]=\"loaRuleToEdit\"\n  (certificateLoaLevelChanged)=\"defaultLoaLevelChanged($event)\" (loaRuleSaved)=\"loaRuleSaved($event)\"\n  (loaRuleEdited)=\"loaRuleEdited($event)\" (editCancelled)=\"editCancelled($event)\"></loa-rule-form>\n\n<div class=\"column\">\n  <button class=\"float-right is-primary button is-small\" (click)=\"saveChanges()\" [disabled]=\"!rulesEdited\">Spara \u00E4ndringar</button>\n</div>",
      styles: [".table-margin{margin:12px 4px}.break-word{word-break:break-word}\n"]
    }]
  }], () => [{
    type: LoaCertificateService
  }, {
    type: DialogService
  }], {
    certificate: [{
      type: Input
    }],
    loaRulesChanged: [{
      type: Output
    }],
    loaRuleForm: [{
      type: ViewChild,
      args: ['loaRuleForm']
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
var TreeMode;
(function (TreeMode) {
  TreeMode[TreeMode["NoSelect"] = 0] = "NoSelect";
  TreeMode[TreeMode["SingleSelect"] = 1] = "SingleSelect";
  TreeMode[TreeMode["MultiSelect"] = 2] = "MultiSelect";
})(TreeMode || (TreeMode = {}));

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LoaCertificateDataSource {
  loaCertificateService;
  loaCertificates = new BehaviorSubject([]);
  constructor(loaCertificateService) {
    this.loaCertificateService = loaCertificateService;
    this.fetch();
  }
  fetch() {
    this.loaCertificateService.getLoaCertificates().subscribe(result => {
      this.loaCertificates.next(result);
    });
  }
  connect() {
    return this.loaCertificates.asObservable();
  }
  static ɵfac = function LoaCertificateDataSource_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoaCertificateDataSource)(i0.ɵɵinject(LoaCertificateService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LoaCertificateDataSource,
    factory: LoaCertificateDataSource.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaCertificateDataSource, [{
    type: Injectable
  }], () => [{
    type: LoaCertificateService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
var NodeSelectedState;
(function (NodeSelectedState) {
  NodeSelectedState[NodeSelectedState["checked"] = 0] = "checked";
  NodeSelectedState[NodeSelectedState["unChecked"] = 1] = "unChecked";
  NodeSelectedState[NodeSelectedState["indeterminate"] = 2] = "indeterminate";
})(NodeSelectedState || (NodeSelectedState = {}));

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TreeUtil {
  static initState(parent, nodeItem, options) {
    const nodeState = {
      parent: parent,
      children: [],
      filteredChildren: [],
      hasFilteredChildren: false,
      nodeItem: nodeItem,
      expanded: nodeItem.expanded !== false,
      disabled: this.getDisabled(nodeItem, options),
      markSelected: this.getMarkSelected(nodeItem, options),
      selectedState: NodeSelectedState.unChecked,
      selected: false,
      showCheckBox: options.checkboxes
    };
    return nodeState;
  }
  static getMarkSelected(nodeItem, options) {
    if ((!nodeItem.children || nodeItem.children.length === 0 || options.mode === TreeMode.SingleSelect) && !options.checkboxes) {
      return true;
    } else {
      return false;
    }
  }
  static getDisabled(nodeItem, options) {
    return nodeItem.disabled || options.onlyRootSelect && nodeItem.type > 0;
  }
}

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TreeService {
  options;
  callbacks = {};
  treeState = [];
  treeRoot;
  nodeItems;
  selectedItems = [];
  selectedStates = [];
  filterValue = '';
  selectedItemsSubject = new BehaviorSubject(this.selectedItems);
  filterChangeSubject = new BehaviorSubject(this.filterValue);
  idIndex = 0;
  constructor() {
    this.filterChangeSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe(it => {
      this.filterTraverse(this.treeState, this.filterValue, true);
    });
  }
  getId() {
    return crypto.randomUUID();
  }
  toggleSelected(state) {
    this.toggleSelectedState(state, false);
    if (this.callbacks.toggle) {
      this.callbacks.toggle(state.nodeItem);
    }
  }
  toggleSelectedState(state, ignoreDisabled) {
    if (this.isDisabled(state, ignoreDisabled)) {
      return;
    }
    if (state.selectedState === NodeSelectedState.unChecked) {
      if (this.options.mode === TreeMode.SingleSelect) {
        this.clear();
        this.setChecked(state, false, true, ignoreDisabled);
      } else {
        this.setChecked(state, true, false, ignoreDisabled);
      }
    } else if (state.selectedState === NodeSelectedState.checked) {
      if (this.options.mode === TreeMode.SingleSelect) {
        this.setUnchecked(state, false, true, ignoreDisabled);
      } else {
        this.setUnchecked(state, true, false, ignoreDisabled);
      }
    } else {
      if (this.anyActiveSelected(state) && !state.selected) {
        this.setUnchecked(state, true, false, ignoreDisabled);
      } else {
        this.setChecked(state, true, false, ignoreDisabled);
      }
    }
    if (state.parent && this.options.mode !== TreeMode.SingleSelect) {
      this.childStateChanged(state.parent);
    }
  }
  setInitialState() {
    this.setInitialSelectedState(this.treeState);
  }
  childStateChanged(state) {
    if (this.anyChildSelected(state)) {
      if (this.allChildrenSelected(state)) {
        this.setChecked(state, false);
      } else {
        this.setIndeterminate(state);
      }
    } else {
      this.setUnchecked(state, false);
    }
    if (state.parent) {
      this.childStateChanged(state.parent);
    }
  }
  reEvaluateSelectedState(state) {
    if (this.options.mode !== TreeMode.SingleSelect) {
      if (!this.hasNoChildren(state)) {
        this.childStateChanged(state);
        for (const child of state.children) {
          this.reEvaluateSelectedState(child);
        }
      }
    }
  }
  nameClick(state) {
    if (this.callbacks.nameClick) {
      this.callbacks.nameClick(state.nodeItem);
    }
    if (this.canToggleChildrenOnName(state)) {
      this.toggleSelected(state);
    }
  }
  toggleExpanded(value) {
    this.toggleExpandedTraverse(this.treeState, value);
  }
  clear() {
    for (const state of this.selectedStates) {
      state.selected = false;
      state.selectedState = NodeSelectedState.unChecked;
    }
    this.selectedItems.length = 0;
    this.selectedStates.length = 0;
  }
  addNodeById(nodeState, id) {
    if (id == null) {
      this.treeState.push(nodeState);
      this.nodeItems.push(nodeState.nodeItem);
    } else {
      const result = this.getNodeState(this.treeState, id, this.findById);
      if (result) {
        if (!result.children) {
          result.children = [];
        }
        this.addNewNode(nodeState, result);
        if (result.nodeItem.item && this.options.mode === TreeMode.MultiSelect) {
          this.removeSelected(result.nodeItem.item);
        }
      }
    }
    this.filterTraverse(this.treeState, this.filterValue, true);
  }
  deleteById(id) {
    const result = this.getNodeState(this.treeState, id, this.findById);
    if (result) {
      this.deleteByState(result);
    }
  }
  selectById(id, expand) {
    const result = this.getNodeState(this.treeState, id, this.findById);
    if (result) {
      this.toggleSelected(result);
      if (expand) {
        this.toggleExpandedTraverseAsc(result, true);
      }
    }
  }
  getParentById(id) {
    const result = this.getNodeState(this.treeState, id, this.findById);
    if (result) {
      return result.parent.nodeItem;
    }
    return null;
  }
  deleteByState(state) {
    this.delete(state);
    this.childStateChanged(state);
    this.filterTraverse(this.treeState, this.filterValue, true);
  }
  filterChanged(value) {
    this.filterValue = value;
    this.filterChangeSubject.next(value);
  }
  canToggleChildrenOnName(state) {
    if (this.options.checkboxes === false) {
      if (this.options.mode === TreeMode.SingleSelect || this.options.mode === TreeMode.MultiSelect) {
        return true;
      }
    }
    return false;
  }
  isDisabled(state, ignoreDisabled) {
    return this.options.mode === TreeMode.NoSelect || state.disabled && !ignoreDisabled;
  }
  addNewNode(nodeState, parent) {
    nodeState.parent = parent;
    parent.children.push(nodeState);
    parent.nodeItem.children.push(nodeState.nodeItem);
    parent.markSelected = TreeUtil.getMarkSelected(parent.nodeItem, this.options);
    if (this.options.mode === TreeMode.MultiSelect) {
      this.childStateChanged(parent);
    }
  }
  setInitialSelectedState(nodeStates) {
    for (const state of nodeStates) {
      if (this.options.mode === TreeMode.MultiSelect) {
        if (state.nodeItem.selected && (!state.children || state.children.length === 0)) {
          this.toggleSelectedState(state, true);
        }
      } else {
        if (state.nodeItem.selected) {
          this.toggleSelectedState(state, true);
        }
      }
      this.setInitialSelectedState(state.children);
    }
  }
  delete(state) {
    while (state.children.length > 0) {
      this.delete(state.children.pop());
    }
    this.removeSelected(state.nodeItem.item);
    this.remove(state);
    if (!state.parent) {
      this.deleteRoot(state, this.treeState, this.nodeItems);
    }
  }
  toggleExpandedTraverse(nodeStates, value) {
    for (const state of nodeStates) {
      state.expanded = value;
      this.toggleExpandedTraverse(state.children, value);
    }
  }
  toggleExpandedTraverseAsc(nodeState, value) {
    nodeState.expanded = value;
    if (nodeState.parent) {
      this.toggleExpandedTraverseAsc(nodeState.parent, value);
    }
  }
  deleteRoot(state, nodeStates, nodeItems) {
    const itemIndex = nodeItems.indexOf(state.nodeItem);
    if (itemIndex !== -1) {
      nodeItems.splice(itemIndex, 1);
    }
    const index = nodeStates.indexOf(state);
    if (index !== -1) {
      nodeStates.splice(index, 1);
    }
  }
  remove(state) {
    if (state.parent) {
      state.parent.hasFilteredChildren = false;
      const itemIndex = state.parent.nodeItem.children.indexOf(state.nodeItem);
      if (itemIndex !== -1) {
        state.parent.nodeItem.children.splice(itemIndex, 1);
      }
      const index = state.parent.children.indexOf(state);
      if (index !== -1) {
        state.parent.children.splice(index, 1);
      }
      const filteredIndex = state.parent.filteredChildren.indexOf(state);
      if (filteredIndex !== -1) {
        state.parent.filteredChildren.splice(filteredIndex, 1);
      }
    }
  }
  anyChildSelected(state) {
    return state.children.find(it => {
      return it.selectedState === NodeSelectedState.checked || it.selectedState === NodeSelectedState.indeterminate;
    }) != null;
  }
  allChildrenSelected(state) {
    return state.children.every(it => it.selectedState === NodeSelectedState.checked) && state.children.length === state.nodeItem.children.length;
  }
  setUnchecked(state, propogate, force, ignoreDisabled) {
    if (state.disabled && !ignoreDisabled) {
      return;
    }
    state.selectedState = NodeSelectedState.unChecked;
    state.selected = false;
    if (this.hasNoChildren(state) || force) {
      this.removeSelected(state.nodeItem.item);
      if (this.options.alwaysEmitSelected === true) {
        this.selectedItemsSubject.next(this.selectedItems);
      }
      if (this.callbacks.unSelect) {
        this.callbacks.unSelect(state.nodeItem);
      }
    } else if (propogate === true) {
      for (const child of state.children) {
        this.setUnchecked(child, propogate, force, ignoreDisabled);
      }
    }
  }
  hasNoChildren(state) {
    return !state.children || state.children.length === 0;
  }
  anyActiveSelected(state) {
    let result = state.children.filter(it => !it.disabled && it.selected).length > 0;
    for (const child of state.children) {
      if (!this.hasNoChildren(child) && this.anyActiveSelected(child)) {
        result = true;
      }
    }
    return result;
  }
  setChecked(state, propogate, force, ignoreDisabled) {
    if (state.disabled && !ignoreDisabled) {
      return;
    }
    state.selectedState = NodeSelectedState.checked;
    state.selected = true;
    if (this.hasNoChildren(state) || force) {
      this.addSelected(state);
    } else if (propogate === true) {
      for (const child of state.children) {
        this.setChecked(child, propogate, force, ignoreDisabled);
      }
    }
  }
  setIndeterminate(state) {
    state.selectedState = NodeSelectedState.indeterminate;
    state.selected = false;
  }
  addSelected(state) {
    this.selectedItems.push(state.nodeItem.item);
    this.selectedStates.push(state);
    if (this.options.alwaysEmitSelected === true) {
      this.selectedItemsSubject.next(this.selectedItems);
    }
    if (this.callbacks.select) {
      this.callbacks.select(state.nodeItem);
    }
  }
  removeSelected(item) {
    const index = this.selectedItems.indexOf(item);
    if (index !== -1) {
      this.selectedItems.splice(index, 1);
    }
  }
  findById(state, arg) {
    return state.nodeItem.id === arg;
  }
  getNodeState(nodeStates, arg, compare) {
    let result = nodeStates.find(it => compare(it, arg));
    if (result) {
      return result;
    } else {
      for (const state of nodeStates) {
        result = this.getNodeState(state.children, arg, compare);
        if (result) {
          return result;
        }
      }
    }
    return result;
  }
  connect() {
    return this.selectedItemsSubject.asObservable();
  }
  forceFilter() {
    this.filterTraverse(this.treeState, this.filterValue, true);
  }
  applyFilter(state, filter) {
    state.filteredChildren = this.filter(state.children, filter);
    return state.filteredChildren.length > 0;
  }
  filter(states, value) {
    return states.filter(it => it.hasFilteredChildren || value === '' || it.nodeItem.name.toLowerCase().indexOf(value) !== -1);
  }
  filterRoot(nodeState, filter) {
    this.filterTraverse(nodeState.children, filter, true);
  }
  filterTraverse(states, filter, root) {
    const results = [];
    for (const state of states) {
      if (state.children.length > 0) {
        state.hasFilteredChildren = this.filterTraverse(state.children, filter, false);
        const res = this.applyFilter(state, filter);
        if (res) {
          state.hasFilteredChildren = true;
        } else if (root) {
          state.hasFilteredChildren = filter === '' || state.nodeItem.name.toLowerCase().indexOf(filter) !== -1;
        }
        results.push(state.hasFilteredChildren);
      } else if (root) {
        state.hasFilteredChildren = filter === '' || state.nodeItem.name.toLowerCase().indexOf(filter) !== -1;
      }
    }
    return results.some(it => it === true);
  }
  static ɵfac = function TreeService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TreeService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TreeService,
    factory: TreeService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TreeService, [{
    type: Injectable
  }], () => [], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class NodeNameComponent {
  treeService;
  state;
  nodeNameTemplate;
  _this = this;
  active = false;
  constructor(treeService) {
    this.treeService = treeService;
  }
  ngOnChanges(changes) {
    if (changes.state) {
      this.active = this.treeService.canToggleChildrenOnName(this.state);
    }
  }
  nameClick() {
    this.treeService.nameClick(this.state);
  }
  delete() {
    this.treeService.deleteByState(this.state);
  }
  static ɵfac = function NodeNameComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NodeNameComponent)(i0.ɵɵdirectiveInject(TreeService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NodeNameComponent,
    selectors: [["node-name"]],
    inputs: {
      state: "state",
      nodeNameTemplate: "nodeNameTemplate"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 11,
    consts: [[1, "node-name", 3, "click"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
    template: function NodeNameComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function NodeNameComponent_Template_div_click_0_listener() {
          return ctx.nameClick();
        });
        i0.ɵɵtemplate(1, NodeNameComponent_ng_container_1_Template, 3, 3, "ng-container", 1)(2, NodeNameComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("markSelected", ctx.state.markSelected && ctx.state.selected)("nodeDisabled", ctx.state.disabled);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.nodeNameTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngTemplateOutlet", ctx.nodeNameTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(7, _c18, ctx.state.nodeItem, ctx.state.nodeItem, ctx._this));
      }
    },
    dependencies: [i2.NgIf, i2.NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NodeNameComponent, [{
    type: Component,
    args: [{
      selector: 'node-name',
      template: "<div (click)=\"nameClick()\" [class.markSelected]=\"state.markSelected && state.selected\" [class.nodeDisabled]=\"state.disabled\"\n  class=\"node-name\">\n  <ng-container *ngIf=\"!nodeNameTemplate\">\n    <span [class.active]=\"active\">{{state.nodeItem.name}}</span>\n  </ng-container>\n\n  <ng-container *ngTemplateOutlet=\"nodeNameTemplate; context: { $implicit: state.nodeItem, node: state.nodeItem, context: _this }\">\n  </ng-container>\n</div>\n"
    }]
  }], () => [{
    type: TreeService
  }], {
    state: [{
      type: Input
    }],
    nodeNameTemplate: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class NodeIconWrapperComponent {
  state;
  nodeCollapsibleTemplate;
  _this = this;
  toggleExpand() {
    this.state.expanded = !this.state.expanded;
  }
  static ɵfac = function NodeIconWrapperComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NodeIconWrapperComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NodeIconWrapperComponent,
    selectors: [["node-icon-wrapper"]],
    inputs: {
      state: "state",
      nodeCollapsibleTemplate: "nodeCollapsibleTemplate"
    },
    standalone: false,
    decls: 3,
    vars: 8,
    consts: [[1, "node-icon-wrapper", 3, "click"], [4, "ngIf"], ["class", "arrow-right", 4, "ngIf"], ["class", "arrow-down", 4, "ngIf"], [1, "arrow-right"], [1, "arrow-down"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
    template: function NodeIconWrapperComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function NodeIconWrapperComponent_Template_div_click_0_listener() {
          return ctx.state.expanded = !ctx.state.expanded;
        });
        i0.ɵɵtemplate(1, NodeIconWrapperComponent_ng_container_1_Template, 2, 1, "ng-container", 1)(2, NodeIconWrapperComponent_ng_container_2_Template, 2, 5, "ng-container", 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("disabled", (ctx.state.nodeItem == null ? null : ctx.state.nodeItem.children == null ? null : ctx.state.nodeItem.children.length) === 0)("collapsable", (ctx.state.nodeItem == null ? null : ctx.state.nodeItem.children == null ? null : ctx.state.nodeItem.children.length) > 0)("iconCheckbox", ctx.state.showCheckBox);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.nodeCollapsibleTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", (ctx.state.nodeItem == null ? null : ctx.state.nodeItem.children == null ? null : ctx.state.nodeItem.children.length) > 0);
      }
    },
    dependencies: [i2.NgIf, i2.NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NodeIconWrapperComponent, [{
    type: Component,
    args: [{
      selector: 'node-icon-wrapper',
      template: "<div class=\"node-icon-wrapper\" [class.disabled]=\"state.nodeItem?.children?.length === 0\"\n  [class.collapsable]=\"state.nodeItem?.children?.length > 0\" [class.iconCheckbox]=\"state.showCheckBox\"\n  (click)=\"state.expanded = !state.expanded;\">\n  <ng-container *ngIf=\"!nodeCollapsibleTemplate\">\n    <ng-container *ngIf=\"state.nodeItem?.children?.length > 0\">\n      <i *ngIf=\"!state.expanded\" class=\"arrow-right\"></i>\n      <i *ngIf=\"state.expanded\" class=\"arrow-down\"></i>\n    </ng-container>\n  </ng-container>\n\n  <ng-container *ngIf=\"state.nodeItem?.children?.length > 0\">\n    <ng-container *ngTemplateOutlet=\"nodeCollapsibleTemplate; context: { expanded: state.expanded, context: _this }\">\n    </ng-container>\n  </ng-container>\n</div>\n"
    }]
  }], null, {
    state: [{
      type: Input
    }],
    nodeCollapsibleTemplate: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class NodeComponent {
  treeService;
  nodeCheckbox;
  state;
  selectedState;
  nodeNameTemplate;
  nodeCollapsibleTemplate;
  _this = this;
  id;
  constructor(treeService) {
    this.treeService = treeService;
    this.id = this.treeService.getId();
  }
  ngOnChanges(changes) {
    if (changes.selectedState) {
      this.selectedStateChanged();
    }
  }
  ngAfterViewInit() {
    this.selectedStateChanged();
  }
  selectedStateChanged() {
    if (this.nodeCheckbox) {
      if (this.selectedState === NodeSelectedState.indeterminate) {
        this.nodeCheckbox.nativeElement.indeterminate = true;
      } else {
        this.nodeCheckbox.nativeElement.indeterminate = false;
      }
    }
  }
  toggleSelected() {
    this.treeService.toggleSelected(this.state);
    setTimeout(() => {
      this.treeService.reEvaluateSelectedState(this.state);
    }, 1);
  }
  static ɵfac = function NodeComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NodeComponent)(i0.ɵɵdirectiveInject(TreeService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NodeComponent,
    selectors: [["node"]],
    viewQuery: function NodeComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c20, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeCheckbox = _t.first);
      }
    },
    inputs: {
      state: "state",
      selectedState: "selectedState",
      nodeNameTemplate: "nodeNameTemplate",
      nodeCollapsibleTemplate: "nodeCollapsibleTemplate"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 7,
    vars: 10,
    consts: [["nodeCheckbox", ""], [1, "node"], [1, "node-container"], [3, "state", "nodeCollapsibleTemplate"], ["class", "is-checkradio has-background-color", "type", "checkbox", 3, "id", "disabled", "checked", "click", 4, "ngIf"], [1, "checkbox-label", 3, "for"], [3, "state", "nodeNameTemplate"], ["class", "collapsible-wrapper", 3, "collapsed", 4, "ngIf"], ["type", "checkbox", 1, "is-checkradio", "has-background-color", 3, "click", "id", "disabled", "checked"], [1, "collapsible-wrapper"], [1, "collapsible"], ["class", "node-offset", 3, "state", "selectedState", "nodeCollapsibleTemplate", "nodeNameTemplate", 4, "ngFor", "ngForOf"], [1, "node-offset", 3, "state", "selectedState", "nodeCollapsibleTemplate", "nodeNameTemplate"]],
    template: function NodeComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
        i0.ɵɵelement(2, "node-icon-wrapper", 3);
        i0.ɵɵtemplate(3, NodeComponent_input_3_Template, 2, 4, "input", 4);
        i0.ɵɵelementStart(4, "label", 5);
        i0.ɵɵelement(5, "node-name", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(6, NodeComponent_div_6_Template, 3, 3, "div", 7);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("state", ctx.state)("nodeCollapsibleTemplate", ctx.nodeCollapsibleTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.showCheckBox);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("no-after", ctx.state.selectedState === 1);
        i0.ɵɵpropertyInterpolate1("for", "chkbx", ctx.id, "");
        i0.ɵɵadvance();
        i0.ɵɵproperty("state", ctx.state)("nodeNameTemplate", ctx.nodeNameTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.nodeItem.children);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, NodeComponent, NodeNameComponent, NodeIconWrapperComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NodeComponent, [{
    type: Component,
    args: [{
      selector: 'node',
      template: "<div class=\"node\">\n  <div class=\"node-container\">\n    <node-icon-wrapper [state]=\"state\" [nodeCollapsibleTemplate]=\"nodeCollapsibleTemplate\"></node-icon-wrapper>\n    <input #nodeCheckbox *ngIf=\"state.showCheckBox\" id=\"chkbx{{id}}\" class=\"is-checkradio has-background-color\" (click)=\"toggleSelected()\" [disabled]=\"state.disabled\" [checked]=\"state.selected\" type=\"checkbox\">\n    <label class=\"checkbox-label\" [class.no-after]=\"state.selectedState === 1\" for=\"chkbx{{id}}\">\n      <node-name [state]=\"state\" [nodeNameTemplate]=\"nodeNameTemplate\"></node-name>\n    </label>\n  </div>\n  <div *ngIf=\"state.nodeItem.children\" class=\"collapsible-wrapper\" [class.collapsed]=\"!state.expanded && state.nodeItem.children.length > 0 && state.filteredChildren.length > 0\">\n    <div class=\"collapsible\">\n      <node class=\"node-offset\" [state]=\"child\" [selectedState]=\"child.selectedState\" [nodeCollapsibleTemplate]=\"nodeCollapsibleTemplate\" [nodeNameTemplate]=\"nodeNameTemplate\" *ngFor=\"let child of state.filteredChildren\"></node>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: TreeService
  }], {
    nodeCheckbox: [{
      type: ViewChild,
      args: ['nodeCheckbox']
    }],
    state: [{
      type: Input
    }],
    selectedState: [{
      type: Input
    }],
    nodeNameTemplate: [{
      type: Input
    }],
    nodeCollapsibleTemplate: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TreeNgxComponent {
  treeService;
  nodeNameTemplate;
  nodeCollapsibleTemplate;
  subscription;
  defaultOptions = {
    mode: TreeMode.SingleSelect,
    checkboxes: false,
    alwaysEmitSelected: false,
    onlyRootSelect: false
  };
  options = this.defaultOptions;
  callbacks;
  nodeItems;
  filter = '';
  selectedItems = new EventEmitter();
  constructor(treeService) {
    this.treeService = treeService;
    this.callbacks = this.treeService.callbacks;
  }
  ngOnInit() {
    this.subscription = this.treeService.connect().subscribe(it => {
      const sub = timer(0).subscribe(() => {
        this.selectedItems.emit(it);
        sub.unsubscribe();
      });
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  ngOnChanges(changes) {
    if (changes.filter) {
      this.treeService.filterChanged(this.filter.toLowerCase());
    }
    if (changes.options) {
      this.setOptions();
    }
    if (changes.callbacks) {
      this.treeService.callbacks = this.callbacks;
    }
    if (changes.nodeItems) {
      this.initialize();
      this.treeService.forceFilter();
    }
  }
  addNodeById(nodeItem, id) {
    const newNodeState = TreeUtil.initState(null, nodeItem, this.options);
    this.treeService.addNodeById(newNodeState, id);
  }
  deleteById(id) {
    this.treeService.deleteById(id);
  }
  selectById(id, expand) {
    this.treeService.selectById(id, expand);
  }
  getParentById(id) {
    return this.treeService.getParentById(id);
  }
  expandAll() {
    this.treeService.toggleExpanded(true);
  }
  collapseAll() {
    this.treeService.toggleExpanded(false);
  }
  initialize() {
    this.setOptions();
    this.treeService.callbacks = this.callbacks;
    if (this.nodeItems == null) {
      this.treeService.nodeItems = [];
    } else {
      this.treeService.nodeItems = this.nodeItems;
    }
    this.treeService.treeState = this.initTreeStructure(null, this.treeService.nodeItems, this.treeService.options);
    this.treeService.clear();
    this.treeService.setInitialState();
  }
  initTreeStructure(parent, nodeItems, options) {
    const treeStructure = [];
    for (const nodeItem of nodeItems) {
      const nodeState = TreeUtil.initState(parent, nodeItem, options);
      if (nodeItem.children) {
        nodeState.children = this.initTreeStructure(nodeState, nodeItem.children, options);
        nodeState.filteredChildren = nodeState.children;
      }
      treeStructure.push(nodeState);
    }
    return treeStructure;
  }
  setOptions() {
    if (this.options.mode === TreeMode.NoSelect) {
      this.treeService.options = {
        ...this.options,
        checkboxes: false
      };
    } else {
      this.treeService.options = {
        ...this.options
      };
    }
  }
  static ɵfac = function TreeNgxComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TreeNgxComponent)(i0.ɵɵdirectiveInject(TreeService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TreeNgxComponent,
    selectors: [["tree-ngx"]],
    contentQueries: function TreeNgxComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, _c21, 5);
        i0.ɵɵcontentQuery(dirIndex, _c22, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeNameTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeCollapsibleTemplate = _t.first);
      }
    },
    inputs: {
      options: "options",
      callbacks: "callbacks",
      nodeItems: "nodeItems",
      filter: "filter"
    },
    outputs: {
      selectedItems: "selectedItems"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([TreeService]), i0.ɵɵNgOnChangesFeature],
    decls: 2,
    vars: 1,
    consts: [[1, "tree-ngx"], [4, "ngFor", "ngForOf"], ["class", "node-root", 3, "state", "selectedState", "nodeCollapsibleTemplate", "nodeNameTemplate", 4, "ngIf"], [1, "node-root", 3, "state", "selectedState", "nodeCollapsibleTemplate", "nodeNameTemplate"]],
    template: function TreeNgxComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, TreeNgxComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.treeService.treeState);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, NodeComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TreeNgxComponent, [{
    type: Component,
    args: [{
      selector: 'tree-ngx',
      providers: [TreeService],
      template: "<div class=\"tree-ngx\">\n  <ng-container *ngFor=\"let state of treeService.treeState\">\n    <node class=\"node-root\" [state]=\"state\" [selectedState]=\"state.selectedState\" [nodeCollapsibleTemplate]=\"nodeCollapsibleTemplate\"\n      [nodeNameTemplate]=\"nodeNameTemplate\" *ngIf=\"state.hasFilteredChildren\"></node>\n  </ng-container>\n</div>\n"
    }]
  }], () => [{
    type: TreeService
  }], {
    nodeNameTemplate: [{
      type: ContentChild,
      args: ['nodeNameTemplate']
    }],
    nodeCollapsibleTemplate: [{
      type: ContentChild,
      args: ['nodeCollapsibleTemplate']
    }],
    options: [{
      type: Input
    }],
    callbacks: [{
      type: Input
    }],
    nodeItems: [{
      type: Input
    }],
    filter: [{
      type: Input
    }],
    selectedItems: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LoaRulesComponent {
  loaCertificateDataSource;
  resourceTree;
  selectedNodeId;
  loaCertificates;
  items = [];
  filter = '';
  callbacks = {
    toggle: this.unSelectNode()
  };
  selected;
  options = {
    alwaysEmitSelected: false,
    checkboxes: false,
    mode: TreeMode.SingleSelect,
    onlyRootSelect: true
  };
  constructor(loaCertificateDataSource) {
    this.loaCertificateDataSource = loaCertificateDataSource;
  }
  ngOnInit() {
    this.loaCertificateDataSource.fetch();
    this.loaCertificateDataSource.connect().subscribe(it => {
      this.loaCertificates = it;
      this.items = this.initTree(this.loaCertificates);
      if (this.selectedNodeId) {
        setTimeout(() => {
          this.selected = null;
          this.resourceTree.selectById(this.selectedNodeId, true);
        }, 10);
      }
    });
  }
  filterChange(event) {
    this.filter = event.target.value;
  }
  refreshCertificates() {
    this.loaCertificateDataSource.fetch();
  }
  loaRuleDeleted() {
    this.selected = null;
    this.selectedNodeId = null;
    this.refreshCertificates();
  }
  // ----- private methods ----
  unSelectNode() {
    return item => {
      if (item.type === 0) {
        if (this.selected && this.selected.id === item.id) {
          this.selected = null;
        } else {
          this.selected = item;
          this.selectedNodeId = item.id;
        }
      }
    };
  }
  initTree(loaCertificates) {
    const nodeItems = [];
    for (const loaCertificate of loaCertificates) {
      const nodeItem = {
        name: loaCertificate.name,
        expanded: false,
        id: loaCertificate.thumbPrint,
        children: this.initLoaLevel(loaCertificate),
        item: loaCertificate,
        type: 0,
        selected: false
      };
      nodeItems.push(nodeItem);
    }
    return nodeItems;
  }
  initLoaLevel(loaCertificate) {
    const childNodeItems = [];
    const nodeItem = {
      name: 'LOA ' + loaCertificate.loaMetadata.defaultLevelOfAssurance,
      expanded: false,
      id: loaCertificate.thumbPrint + loaCertificate.name,
      item: loaCertificate,
      children: this.initFields(loaCertificate.thumbPrint, loaCertificate.loaMetadata.loaFieldRules),
      type: 1,
      selected: false
    };
    childNodeItems.push(nodeItem);
    return childNodeItems;
  }
  initFields(thumbPrint, loaFieldRules) {
    if (!loaFieldRules || loaFieldRules === null) {
      return null;
    }
    const childNodeItems = [];
    for (const loaRule of loaFieldRules) {
      const nodeItem = {
        name: loaRule.field,
        expanded: false,
        id: thumbPrint + loaRule.field,
        item: loaRule,
        children: this.initRules(thumbPrint, loaRule.rules),
        type: 2,
        selected: false
      };
      childNodeItems.push(nodeItem);
    }
    return childNodeItems;
  }
  initRules(thumbPrint, rules) {
    if (!rules) {
      return null;
    }
    const childNodeItems = [];
    for (const rule of rules) {
      const nodeItem = {
        name: 'LOA ' + rule.levelOfAssurance + ', ' + rule.value,
        expanded: false,
        id: thumbPrint + rule.levelOfAssurance,
        item: rule,
        children: null,
        type: 3,
        selected: false
      };
      childNodeItems.push(nodeItem);
    }
    return childNodeItems;
  }
  static ɵfac = function LoaRulesComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoaRulesComponent)(i0.ɵɵdirectiveInject(LoaCertificateDataSource));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LoaRulesComponent,
    selectors: [["loa-rules"]],
    viewQuery: function LoaRulesComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c23, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourceTree = _t.first);
      }
    },
    standalone: false,
    decls: 14,
    vars: 5,
    consts: [["resourceTree", ""], ["nodeCollapsibleTemplate", ""], [1, "columns", "columns-main"], [1, "column", "box"], [1, "flex", "flex-fill"], [1, "box-title"], ["placeholder", "Filtrera", 1, "filter", "input", "is-small", 3, "keyup"], [1, "noselect", "privilage-tree", 3, "filter", "callbacks", "options", "nodeItems"], [4, "ngIf"], ["class", "expandable fas fa-plus", 4, "ngIf"], ["class", "expandable fas fa-minus", 4, "ngIf"], [1, "expandable", "fas", "fa-plus"], [1, "expandable", "fas", "fa-minus"], [3, "loaRulesChanged", "certificate"]],
    template: function LoaRulesComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "div", 5);
        i0.ɵɵtext(4, "Level of Assurance regler");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "input", 6);
        i0.ɵɵlistener("keyup", function LoaRulesComponent_Template_input_keyup_5_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.filterChange($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "tree-ngx", 7, 0);
        i0.ɵɵtemplate(8, LoaRulesComponent_ng_template_8_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 3)(11, "div", 5);
        i0.ɵɵtext(12, "Redigera");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, LoaRulesComponent_div_13_Template, 2, 1, "div", 8);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("filter", ctx.filter)("callbacks", ctx.callbacks)("options", ctx.options)("nodeItems", ctx.items);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.selected && ctx.selected.type === 0);
      }
    },
    dependencies: [i2.NgIf, TreeNgxComponent, LoaCertificateComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaRulesComponent, [{
    type: Component,
    args: [{
      selector: 'loa-rules',
      template: "<div class=\"columns columns-main\">\n  <div class=\"column box\">\n    <div class=\"flex flex-fill\">\n      <div class=\"box-title\">Level of Assurance regler</div>\n    </div>\n\n    <input class=\"filter input is-small\" placeholder=\"Filtrera\" (keyup)=\"filterChange($event)\">\n    <tree-ngx #resourceTree class=\"noselect privilage-tree\" [filter]=\"filter\" [callbacks]=\"callbacks\" [options]=\"options\"\n      [nodeItems]=\"items\">\n      <ng-template #nodeCollapsibleTemplate let-expanded=\"expanded\">\n        <i *ngIf=\"!expanded\" class=\"expandable fas fa-plus\"></i>\n        <i *ngIf=\"expanded\" class=\"expandable fas fa-minus\"></i>\n      </ng-template>\n    </tree-ngx>\n  </div>\n\n  <div class=\"column box\">\n    <div class=\"box-title\">Redigera</div>\n\n    <div *ngIf=\"selected && selected.type === 0\">\n      <loa-certificate [certificate]=\"selected.item\" (loaRulesChanged)=\"refreshCertificates()\"></loa-certificate>\n    </div>\n\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: LoaCertificateDataSource
  }], {
    resourceTree: [{
      type: ViewChild,
      args: ['resourceTree']
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class TreeNgxModule {
  static ɵfac = function TreeNgxModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TreeNgxModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TreeNgxModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [TreeService],
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TreeNgxModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [TreeNgxComponent, NodeComponent, NodeNameComponent, NodeIconWrapperComponent],
      providers: [TreeService],
      exports: [TreeNgxComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LoaManagerModule {
  static ɵfac = function LoaManagerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LoaManagerModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: LoaManagerModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [LoaCertificateService, LoaCertificateDataSource],
    imports: [CommonModule, ReactiveFormsModule, FormsModule, TreeNgxModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaManagerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, FormsModule, TreeNgxModule],
      declarations: [LoaCertificateComponent, LoaRuleFormComponent, LoaRulesComponent],
      exports: [LoaRulesComponent],
      providers: [LoaCertificateService, LoaCertificateDataSource]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ApplicationInfoService {
  http;
  info = null;
  apiUrl = 'actuator/info';
  constructor(http) {
    this.http = http;
  }
  getConfig() {
    if (this.info === null) {
      return this.http.get(this.apiUrl).pipe(tap(it => this.info = it), map(it => it));
    } else {
      return of(this.info);
    }
  }
  static ɵfac = function ApplicationInfoService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ApplicationInfoService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ApplicationInfoService,
    factory: ApplicationInfoService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApplicationInfoService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
class LogoutReminderComponent {
  static ɵfac = function LogoutReminderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LogoutReminderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: LogoutReminderComponent,
    selectors: [["logout-reminder"]],
    standalone: false,
    decls: 4,
    vars: 0,
    consts: [[1, "container"], [1, "has-text-centered"]],
    template: function LogoutReminderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "p");
        i0.ɵɵtext(3, "F\xF6r din s\xE4kerhet, gl\xF6m inte att logga ut n\xE4r du vill avsluta.");
        i0.ɵɵelementEnd()()();
      }
    },
    styles: [".container[_ngcontent-%COMP%]{position:absolute;bottom:0;width:100%;height:26px;background-color:#fff;border:1px solid #cec6bf;border-top:0px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutReminderComponent, [{
    type: Component,
    args: [{
      selector: 'logout-reminder',
      template: "<div class=\"container\">\n    <div class=\"has-text-centered\">\n        <p>F\u00F6r din s\u00E4kerhet, gl\u00F6m inte att logga ut n\u00E4r du vill avsluta.</p>\n    </div>\n</div>",
      styles: [".container{position:absolute;bottom:0;width:100%;height:26px;background-color:#fff;border:1px solid #cec6bf;border-top:0px}\n"]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2020 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class LogoutReminderModule {
  static ɵfac = function LogoutReminderModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LogoutReminderModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: LogoutReminderModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutReminderModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [LogoutReminderComponent],
      exports: [LogoutReminderComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class IdService {
  id = 0;
  getId() {
    return this.id++;
  }
  static ɵfac = function IdService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IdService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IdService,
    factory: IdService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class MultiSelectComponent {
  idService;
  items;
  options;
  id;
  value = [];
  onChange;
  onTouched;
  compareWith;
  allSelected = false;
  disableAllSelected = false;
  internalOptions = {
    small: false,
    enableSelectAll: false
  };
  selectedItems = [];
  constructor(idService) {
    this.idService = idService;
    this.id = this.idService.getId();
  }
  ngOnChanges(changes) {
    if (changes['options']) {
      this.internalOptions = Object.assign(this.internalOptions, changes['options'].currentValue);
    }
  }
  writeValue(value) {
    if (value) {
      this.selectedItems = value;
      this.updateAllSelectedState();
    }
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  select(selectedValue) {
    if (this.isSelected(selectedValue)) {
      const index = this.selectedItems.indexOf(selectedValue);
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(selectedValue);
    }
    if (this.internalOptions.enableSelectAll) {
      this.updateAllSelectedState();
    }
    this.onTouched();
    this.onChange(this.selectedItems);
  }
  toggleSelectAll() {
    this.allSelected = !this.allSelected;
    if (this.allSelected) {
      for (const item of this.items) {
        if (!this.isSelected(item.item)) {
          this.selectedItems.push(item.item);
        }
      }
    } else {
      this.selectedItems.splice(0, this.selectedItems.length);
    }
    this.onTouched();
    this.onChange(this.selectedItems);
  }
  updateAllSelectedState() {
    this.checkAllSelected();
    this.checkDisableAllSelected();
  }
  checkAllSelected() {
    let allSelected = true;
    for (const item of this.items) {
      if (!this.isSelected(item.item)) {
        allSelected = false;
      }
    }
    this.allSelected = allSelected;
  }
  checkDisableAllSelected() {
    this.disableAllSelected = this.items.filter(item => item != null && item.disabled).length > 0;
  }
  isSelected(value) {
    if (this.selectedItems.indexOf(value) !== -1) {
      return true;
    } else {
      return false;
    }
  }
  static ɵfac = function MultiSelectComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectComponent)(i0.ɵɵdirectiveInject(IdService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MultiSelectComponent,
    selectors: [["multi-select"]],
    inputs: {
      items: "items",
      options: "options"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectComponent),
      multi: true
    }]), i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 2,
    consts: [[1, "field"], [4, "ngIf"], [4, "ngFor", "ngForOf"], ["type", "checkbox", 1, "is-checkradio", "has-background-color", 3, "change", "id", "checked", "disabled"], [3, "for"]],
    template: function MultiSelectComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, MultiSelectComponent_div_1_Template, 4, 8, "div", 1)(2, MultiSelectComponent_div_2_Template, 4, 13, "div", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.internalOptions.enableSelectAll);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.items);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectComponent, [{
    type: Component,
    args: [{
      selector: 'multi-select',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MultiSelectComponent),
        multi: true
      }],
      template: "<div class=\"field\">\r\n  <div *ngIf=\"internalOptions.enableSelectAll\">\r\n    <input class=\"is-checkradio has-background-color\" [class.is-small]=\"internalOptions.small\" id=\"selectAll{{id}}\" type=\"checkbox\"\r\n      (change)=\"toggleSelectAll()\" [checked]=\"allSelected\" [disabled]=\"disableAllSelected\">\r\n    <label for=\"selectAll{{id}}\">V\u00E4lj alla</label>\r\n  </div>\r\n  <div *ngFor=\"let item of items; let i = index;\">\r\n    <input class=\"is-checkradio has-background-color\" [class.is-small]=\"internalOptions.small\" id=\"id{{ id }}ind{{ i }}\" type=\"checkbox\"\r\n      (change)=\"select(item.item)\" [checked]=\"selectedItems.indexOf(item.item) !== -1\" [disabled]=\"item.disabled\">\r\n    <label [class]=\"item.customstyle\" for=\"id{{ id }}ind{{ i }}\">{{ item.name }}</label>\r\n  </div>\r\n</div>\r\n"
    }]
  }], () => [{
    type: IdService
  }], {
    items: [{
      type: Input
    }],
    options: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class MultiSelectModule {
  static ɵfac = function MultiSelectModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MultiSelectModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [MultiSelectComponent],
      exports: [MultiSelectComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
var PrivilegeType;
(function (PrivilegeType) {
  PrivilegeType[PrivilegeType["Privilege"] = 0] = "Privilege";
  PrivilegeType[PrivilegeType["Action"] = 1] = "Action";
  PrivilegeType[PrivilegeType["Condition"] = 2] = "Condition";
  PrivilegeType[PrivilegeType["Value"] = 3] = "Value";
})(PrivilegeType || (PrivilegeType = {}));

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class PrivilegeService {
  httpClient;
  apiUrl = '/api/privilege';
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  getAll() {
    return this.httpClient.get(this.apiUrl);
  }
  getActions() {
    return this.httpClient.get(this.apiUrl + '/actions');
  }
  save(privileges) {
    return this.httpClient.put(this.apiUrl, privileges);
  }
  static ɵfac = function PrivilegeService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PrivilegeService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PrivilegeService,
    factory: PrivilegeService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrivilegeService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class PrivilegeDataSourceService {
  privilegeService;
  privilages$ = new BehaviorSubject([]);
  actions$ = new BehaviorSubject([]);
  constructor(privilegeService) {
    this.privilegeService = privilegeService;
    this.fetch();
    this.fetchActions();
  }
  fetch() {
    this.privilegeService.getAll().subscribe(it => {
      this.privilages$.next(it);
    });
  }
  fetchActions() {
    this.privilegeService.getActions().subscribe(it => {
      this.actions$.next(it);
    });
  }
  connect() {
    return this.privilages$.asObservable();
  }
  connectActions() {
    return this.actions$.asObservable();
  }
  save(privilages) {
    return this.privilegeService.save(privilages);
  }
  static ɵfac = function PrivilegeDataSourceService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PrivilegeDataSourceService)(i0.ɵɵinject(PrivilegeService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PrivilegeDataSourceService,
    factory: PrivilegeDataSourceService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrivilegeDataSourceService, [{
    type: Injectable
  }], () => [{
    type: PrivilegeService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class UpdateManagerService {
  transientId = 0;
  parent;
  setParent(parent) {
    this.parent = parent;
  }
  addAction(nodeItem) {
    const action = this.newAction();
    nodeItem.item.actions.push(action.item);
    this.parent.resourceTree.addNodeById(action, nodeItem.id);
  }
  addCondition(nodeItem) {
    const condition = {
      attribute: '',
      values: []
    };
    const item = {
      id: String(this.transientId++),
      type: PrivilegeType.Condition,
      item: condition,
      name: condition.attribute,
      children: []
    };
    nodeItem.item.conditions.push(condition);
    this.parent.resourceTree.addNodeById(item, nodeItem.id);
  }
  addValue(nodeItem) {
    const newValue = '';
    const item = {
      id: String(this.transientId++),
      type: PrivilegeType.Value,
      item: newValue,
      name: newValue
    };
    nodeItem.item.values.push(newValue);
    this.parent.resourceTree.addNodeById(item, nodeItem.id);
  }
  deleteAction(parent, nodeItem) {
    this.parent.resourceTree.deleteById(nodeItem.id);
    this.delete(parent.item.actions, nodeItem.item);
  }
  deleteCondition(parent, nodeItem) {
    this.parent.resourceTree.deleteById(nodeItem.id);
    this.delete(parent.item.conditions, nodeItem.item);
  }
  deleteValue(parent, nodeItem) {
    this.parent.resourceTree.deleteById(nodeItem.id);
    this.delete(parent.item.values, nodeItem.item);
  }
  delete(coll, item) {
    const index = coll.indexOf(item);
    if (index !== -1) {
      coll.splice(index, 1);
    }
  }
  newAction() {
    const action = {
      id: null,
      name: 'READ',
      informIfMissing: false,
      conditions: []
    };
    return {
      id: String(this.transientId++),
      type: PrivilegeType.Action,
      name: action.name,
      item: action,
      children: []
    };
  }
  static ɵfac = function UpdateManagerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UpdateManagerService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UpdateManagerService,
    factory: UpdateManagerService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateManagerService, [{
    type: Injectable
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ValueComponent {
  updateManagerService;
  condition;
  constructor(updateManagerService) {
    this.updateManagerService = updateManagerService;
  }
  add() {
    this.updateManagerService.addValue(this.condition);
  }
  update(nodeItem, index, event) {
    nodeItem.item.values[index] = event.target.value;
    nodeItem.children[index].name = event.target.value;
  }
  delete(item) {
    this.updateManagerService.deleteValue(this.condition, item);
  }
  static ɵfac = function ValueComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ValueComponent)(i0.ɵɵdirectiveInject(UpdateManagerService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ValueComponent,
    selectors: [["value-row"]],
    inputs: {
      condition: "condition"
    },
    standalone: false,
    decls: 7,
    vars: 1,
    consts: [[1, "divider"], [4, "ngFor", "ngForOf"], [1, "field", "has-addons", "field-margin-bottom"], [1, "control", "is-expanded"], [1, "button", "is-small", "privilege-button", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-plus"], [1, "field", "has-addons"], ["type", "text", 1, "input", "is-small", 3, "keyup", "value"], [1, "control"], [1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"]],
    template: function ValueComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "hr", 0);
        i0.ɵɵtemplate(1, ValueComponent_ng_container_1_Template, 8, 1, "ng-container", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "a", 4);
        i0.ɵɵlistener("click", function ValueComponent_Template_a_click_4_listener() {
          return ctx.add();
        });
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵelement(6, "span", 6);
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.condition.children);
      }
    },
    dependencies: [i2.NgForOf],
    styles: [".add-row[_ngcontent-%COMP%]{display:flex;justify-content:center;font-size:16px}.add-row[_ngcontent-%COMP%]:hover{color:#f6a519}.cursor[_ngcontent-%COMP%]{cursor:auto}.expandable[_ngcontent-%COMP%]{font-size:12px}[_nghost-%COMP%]{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.privilege-button[_ngcontent-%COMP%]{cursor:pointer;width:100%}.box[_ngcontent-%COMP%]:not(:last-child){margin-bottom:5px}.column[_ngcontent-%COMP%]{height:100%;overflow-y:auto}.column-bottom[_ngcontent-%COMP%]{height:51px;margin-top:10px}.box-button[_ngcontent-%COMP%]{margin-top:-2px}.box-title[_ngcontent-%COMP%]{display:flex;flex:1 1}.filter[_ngcontent-%COMP%]{margin-top:10px}.margin-top[_ngcontent-%COMP%]{margin-top:5px}.margin-right[_ngcontent-%COMP%]{margin-right:10px}.field-margin-bottom[_ngcontent-%COMP%]{margin-bottom:.75rem}.divider[_ngcontent-%COMP%]{margin:.75rem 0;background-color:#f5f5f5}.inform-if-missing-checkbox[_ngcontent-%COMP%]{margin-bottom:.5em}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValueComponent, [{
    type: Component,
    args: [{
      selector: 'value-row',
      template: "<hr class=\"divider\">\n\n<ng-container *ngFor=\"let value of condition.children; let index = index;\">\n\n  <div class=\"field has-addons\">\n    <div class=\"control is-expanded\">\n      <input class=\"input is-small\" type=\"text\" (keyup)=\"update(condition, index, $event)\" [value]=\"value.name\">\n    </div>\n    <div class=\"control\">\n      <a class=\"button is-small\" (click)=\"delete(value)\">\n        <span class=\"icon is-small\">\n          <span class=\"fas fa-trash\"></span>\n        </span>\n      </a>\n    </div>\n  </div>\n</ng-container>\n\n<div class=\"field has-addons field-margin-bottom\">\n  <div class=\"control is-expanded\">\n    <a class=\"button is-small privilege-button\" (click)=\"add()\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-plus\"></span>\n      </span>\n    </a>\n  </div>\n</div>\n",
      styles: [".add-row{display:flex;justify-content:center;font-size:16px}.add-row:hover{color:#f6a519}.cursor{cursor:auto}.expandable{font-size:12px}:host{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.privilege-button{cursor:pointer;width:100%}.box:not(:last-child){margin-bottom:5px}.column{height:100%;overflow-y:auto}.column-bottom{height:51px;margin-top:10px}.box-button{margin-top:-2px}.box-title{display:flex;flex:1 1}.filter{margin-top:10px}.margin-top{margin-top:5px}.margin-right{margin-right:10px}.field-margin-bottom{margin-bottom:.75rem}.divider{margin:.75rem 0;background-color:#f5f5f5}.inform-if-missing-checkbox{margin-bottom:.5em}\n"]
    }]
  }], () => [{
    type: UpdateManagerService
  }], {
    condition: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ConditionComponent {
  updateManager;
  action;
  constructor(updateManager) {
    this.updateManager = updateManager;
  }
  add() {
    this.updateManager.addCondition(this.action);
  }
  update(nodeItem, event) {
    nodeItem.name = event.target.value;
    nodeItem.item.attribute = event.target.value;
  }
  delete(item) {
    this.updateManager.deleteCondition(this.action, item);
  }
  static ɵfac = function ConditionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ConditionComponent)(i0.ɵɵdirectiveInject(UpdateManagerService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ConditionComponent,
    selectors: [["condition"]],
    inputs: {
      action: "action"
    },
    standalone: false,
    decls: 8,
    vars: 1,
    consts: [[4, "ngFor", "ngForOf"], [1, "field", "has-addons", "field-margin-bottom"], [1, "control", "is-expanded"], [1, "button", "is-small", "privilege-button", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-plus"], ["class", "label label-small", 4, "ngIf"], [1, "field", "has-addons"], ["type", "text", 1, "input", "is-small", 3, "keyup", "value"], [1, "control"], [1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"], [3, "condition"], [1, "label", "label-small"]],
    template: function ConditionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, ConditionComponent_ng_container_0_Template, 11, 4, "ng-container", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "a", 3);
        i0.ɵɵlistener("click", function ConditionComponent_Template_a_click_3_listener() {
          return ctx.add();
        });
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵelement(5, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "span");
        i0.ɵɵtext(7, "Nytt villkor");
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.action.children);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, ValueComponent],
    styles: [_c24]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConditionComponent, [{
    type: Component,
    args: [{
      selector: 'condition',
      template: "<ng-container *ngFor=\"let condition of action.children\">\n  <label *ngIf=\"condition.name !== ''\" class=\"label label-small\">{{condition.name}}</label>\n  <label *ngIf=\"condition.name === ''\" class=\"label label-small\">Villkor</label>\n  <div class=\"field has-addons\">\n    <div class=\"control is-expanded\">\n      <input class=\"input is-small\" type=\"text\" (keyup)=\"update(condition, $event)\" [value]=\"condition.name\">\n    </div>\n    <div class=\"control\">\n      <a class=\"button is-small\" (click)=\"delete(condition)\">\n        <span class=\"icon is-small\">\n          <span class=\"fas fa-trash\"></span>\n        </span>\n      </a>\n    </div>\n  </div>\n\n  <value-row [condition]=\"condition\"></value-row>\n</ng-container>\n\n<div class=\"field has-addons field-margin-bottom\">\n  <div class=\"control is-expanded\">\n    <a class=\"button is-small privilege-button\" (click)=\"add()\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-plus\"></span>\n      </span>\n      <span>Nytt villkor</span>\n    </a>\n  </div>\n</div>\n",
      styles: [".add-row{display:flex;justify-content:center;font-size:16px}.add-row:hover{color:#f6a519}.cursor{cursor:auto}.expandable{font-size:12px}:host{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.privilege-button{cursor:pointer;width:100%}.box:not(:last-child){margin-bottom:5px}.column{height:100%;overflow-y:auto}.column-bottom{height:51px;margin-top:10px}.box-button{margin-top:-2px}.box-title{display:flex;flex:1 1}.filter{margin-top:10px}.margin-top{margin-top:5px}.margin-right{margin-right:10px}.field-margin-bottom{margin-bottom:.75rem}.divider{margin:.75rem 0;background-color:#f5f5f5}.inform-if-missing-checkbox{margin-bottom:.5em}\n"]
    }]
  }], () => [{
    type: UpdateManagerService
  }], {
    action: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ActionComponent {
  updateManager;
  actions = [];
  privilege;
  constructor(updateManager) {
    this.updateManager = updateManager;
  }
  add() {
    this.updateManager.addAction(this.privilege);
  }
  update(nodeItem, event) {
    nodeItem.name = event.target.value;
    nodeItem.item.name = event.target.value;
  }
  delete(item) {
    this.updateManager.deleteAction(this.privilege, item);
  }
  toggleInformIfMissing(nodeItem) {
    nodeItem.item.informIfMissing = !nodeItem.item.informIfMissing;
  }
  getInformIfMissing(nodeItem) {
    return nodeItem.item.informIfMissing;
  }
  static ɵfac = function ActionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ActionComponent)(i0.ɵɵdirectiveInject(UpdateManagerService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ActionComponent,
    selectors: [["action"]],
    inputs: {
      actions: "actions",
      privilege: "privilege"
    },
    standalone: false,
    decls: 8,
    vars: 1,
    consts: [[4, "ngFor", "ngForOf"], [1, "field", "has-addons", "field-margin-bottom"], [1, "control", "is-expanded"], [1, "button", "is-small", "privilege-button", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-plus"], [1, "label"], [1, "inform-if-missing-checkbox"], ["type", "checkbox", 1, "is-checkradio", "is-small", 3, "change", "id", "name", "checked"], [3, "for"], [1, "field", "has-addons"], [1, "control", "is-expanded", "select", "is-small"], [1, "input", 3, "change", "value"], ["class", "control", 4, "ngIf"], [3, "action"], [1, "control"], [1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"]],
    template: function ActionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, ActionComponent_ng_container_0_Template, 13, 9, "ng-container", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "a", 3);
        i0.ɵɵlistener("click", function ActionComponent_Template_a_click_3_listener() {
          return ctx.add();
        });
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵelement(5, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "span");
        i0.ɵɵtext(7, "Ny aktion");
        i0.ɵɵelementEnd()()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.privilege.children);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, ConditionComponent],
    styles: [_c24]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ActionComponent, [{
    type: Component,
    args: [{
      selector: 'action',
      template: "<ng-container *ngFor=\"let action of privilege.children; let i = index\">\n  <label class=\"label\">{{action.name}}</label>\n\n  <div class=\"inform-if-missing-checkbox\">\n    <input class=\"is-checkradio is-small\" [id]=\"'action.name' + i\" type=\"checkbox\" [name]=\"'action.name' + i\"\n      [checked]=\"getInformIfMissing(action)\" (change)=\"toggleInformIfMissing(action)\">\n    <label [for]=\"'action.name' + i\">Informera anv\u00E4ndare om\n      beh\u00F6righet saknas</label>\n  </div>\n\n  <div class=\"field has-addons\">\n    <div class=\"control is-expanded select is-small\">\n      <select class=\"input\" (change)=\"update(action, $event)\" [value]=\"action.name\">\n        <option *ngFor=\"let action of actions\">{{action}}</option>\n      </select>\n    </div>\n    <div class=\"control\" *ngIf=\"privilege.children.length > 1\">\n      <a class=\"button is-small\" (click)=\"delete(action)\">\n        <span class=\"icon is-small\">\n          <span class=\"fas fa-trash\"></span>\n        </span>\n      </a>\n    </div>\n  </div>\n\n  <condition [action]=\"action\"></condition>\n</ng-container>\n\n<div class=\"field has-addons field-margin-bottom\">\n  <div class=\"control is-expanded\">\n    <a class=\"button is-small privilege-button\" (click)=\"add()\">\n      <span class=\"icon is-small\">\n        <span class=\"fas fa-plus\"></span>\n      </span>\n      <span>Ny aktion</span>\n    </a>\n  </div>\n</div>",
      styles: [".add-row{display:flex;justify-content:center;font-size:16px}.add-row:hover{color:#f6a519}.cursor{cursor:auto}.expandable{font-size:12px}:host{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.privilege-button{cursor:pointer;width:100%}.box:not(:last-child){margin-bottom:5px}.column{height:100%;overflow-y:auto}.column-bottom{height:51px;margin-top:10px}.box-button{margin-top:-2px}.box-title{display:flex;flex:1 1}.filter{margin-top:10px}.margin-top{margin-top:5px}.margin-right{margin-right:10px}.field-margin-bottom{margin-bottom:.75rem}.divider{margin:.75rem 0;background-color:#f5f5f5}.inform-if-missing-checkbox{margin-bottom:.5em}\n"]
    }]
  }], () => [{
    type: UpdateManagerService
  }], {
    actions: [{
      type: Input
    }],
    privilege: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class SortPrivilegesPipe {
  transform(data) {
    return data.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      }
      return 0;
    });
  }
  static ɵfac = function SortPrivilegesPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SortPrivilegesPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "sortPrivileges",
    type: SortPrivilegesPipe,
    pure: true,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortPrivilegesPipe, [{
    type: Pipe,
    args: [{
      name: 'sortPrivileges'
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class PrivilegeComponent {
  privilegeDataSourceService;
  updateManager;
  resourceTree;
  importError = new EventEmitter();
  privileges;
  items = [];
  options = {
    alwaysEmitSelected: false,
    checkboxes: false,
    mode: TreeMode.SingleSelect,
    onlyRootSelect: false
  };
  callbacks = {
    toggle: this.unSelectNode()
  };
  selected;
  selectedValue;
  selectedType;
  filter = '';
  loading = false;
  actions = [];
  fileOptions = {
    validFileTypes: ['.json'],
    showImport: true,
    small: true
  };
  constructor(privilegeDataSourceService, updateManager) {
    this.privilegeDataSourceService = privilegeDataSourceService;
    this.updateManager = updateManager;
  }
  ngOnInit() {
    this.privilegeDataSourceService.connect().subscribe(it => {
      this.privileges = it;
      this.items = this.initTree(this.privileges);
    });
    this.privilegeDataSourceService.connectActions().subscribe(it => {
      this.actions = it;
    });
  }
  ngAfterViewInit() {
    this.updateManager.setParent(this);
  }
  save() {
    this.loading = true;
    this.privilegeDataSourceService.save(this.privileges).subscribe(it => {
      this.privileges = it;
      this.items = this.initTree(this.privileges);
      this.selected = null;
      this.selectedValue = null;
      this.loading = false;
    }, err => {
      this.loading = false;
    });
  }
  addResource() {
    const id = String(this.updateManager.transientId++);
    const name = '';
    const privilege = {
      actions: [],
      resource: name
    };
    const item = {
      id: id,
      item: privilege,
      type: PrivilegeType.Privilege,
      name: privilege.resource,
      expanded: false,
      children: []
    };
    this.privileges.push(privilege);
    this.resourceTree.addNodeById(item, null);
    this.updateManager.addAction(item);
    this.resourceTree.selectById(id);
  }
  updateName(nodeItem, event) {
    nodeItem.name = event.target.value;
    nodeItem.item.resource = event.target.value;
  }
  filterChange(event) {
    this.filter = event.target.value;
  }
  deleteResource(nodeItem) {
    this.resourceTree.deleteById(nodeItem.id);
    this.selected = null;
    this.selectedValue = null;
    this.updateManager.delete(this.privileges, nodeItem.item);
  }
  reset() {
    this.privilegeDataSourceService.fetch();
    this.selected = null;
    this.selectedValue = null;
  }
  importFile(data) {
    try {
      const privileges = JSON.parse(data);
      this.privileges = privileges;
      this.save();
    } catch (err) {
      this.importError.emit(err);
    }
  }
  exportFile() {
    Util.exportJson(this.privileges, 'privileges');
  }
  initTree(privilages) {
    return this.initNodes(privilages, privilage => ({
      id: String(this.updateManager.transientId++),
      type: PrivilegeType.Privilege,
      name: privilage.resource,
      item: privilage,
      expanded: false,
      children: this.initNodes(privilage.actions, action => ({
        id: String(this.updateManager.transientId++),
        type: PrivilegeType.Action,
        name: action.name,
        item: action,
        expanded: false,
        children: this.initNodes(action.conditions, condition => ({
          id: String(this.updateManager.transientId++),
          type: PrivilegeType.Condition,
          name: condition.attribute,
          item: condition,
          expanded: true,
          children: this.initNodes(condition.values, value => ({
            id: String(this.updateManager.transientId++),
            name: value,
            item: value
          }))
        }))
      }))
    }));
  }
  initNodes(items, add) {
    const nodes = [];
    for (const item of items) {
      nodes.push(add(item));
    }
    return nodes;
  }
  unSelectNode() {
    return item => {
      if (this.selected && this.selected.id === item.id && !this.selectedValue || this.selectedValue && this.selectedValue.id === item.id) {
        this.selected = null;
        this.selectedValue = null;
      } else {
        const type = item.type;
        switch (type) {
          case PrivilegeType.Privilege:
            {
              this.selectedType = PrivilegeType.Privilege;
              break;
            }
          case PrivilegeType.Action:
            {
              this.selectedType = PrivilegeType.Action;
              break;
            }
          case PrivilegeType.Condition:
            {
              this.selectedType = PrivilegeType.Condition;
              break;
            }
          default:
            {
              this.selectedType = PrivilegeType.Value;
            }
        }
        if (this.selectedType === PrivilegeType.Value) {
          this.selected = this.resourceTree.getParentById(item.id);
          this.selectedValue = item;
        } else {
          this.selected = item;
          this.selectedValue = null;
        }
      }
    };
  }
  toggleInformIfMissing(nodeItem) {
    nodeItem.item.informIfMissing = !nodeItem.item.informIfMissing;
  }
  getInformIfMissing(nodeItem) {
    return nodeItem.item.informIfMissing;
  }
  static ɵfac = function PrivilegeComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PrivilegeComponent)(i0.ɵɵdirectiveInject(PrivilegeDataSourceService), i0.ɵɵdirectiveInject(UpdateManagerService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PrivilegeComponent,
    selectors: [["privilege"]],
    viewQuery: function PrivilegeComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c23, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourceTree = _t.first);
      }
    },
    outputs: {
      importError: "importError"
    },
    standalone: false,
    decls: 26,
    vars: 8,
    consts: [["fileupload", ""], ["resourceTree", ""], ["nodeCollapsibleTemplate", ""], [1, "columns", "columns-main"], [1, "column", "box"], [1, "flex", "flex-fill"], [1, "box-title"], ["class", "button box-button is-small float-right", 3, "click", 4, "ngIf"], [4, "ngIf"], ["class", "fa-3x is-loading", 4, "ngIf"], [1, "columns", "column-bottom"], [1, "float-right", "is-primary", "button", "is-small", 3, "click"], [1, "margin-right", "float-right", "button", "is-small", 3, "click"], [3, "import", "options"], [1, "button", "box-button", "is-small", "float-right", 3, "click"], [1, "icon", "is-small"], [1, "fas", "fa-plus"], ["placeholder", "Filtrera", 1, "filter", "input", "is-small", 3, "keyup"], [1, "margin-right", "margin-top", "button", "is-small", "is-outlined", "is-primary", 3, "click"], [1, "margin-top", "button", "is-small", "is-outlined", "is-primary", 3, "click"], [1, "noselect", "privilage-tree", 3, "filter", "callbacks", "options", "nodeItems"], ["class", "expandable fas fa-plus", 4, "ngIf"], ["class", "expandable fas fa-minus", 4, "ngIf"], [1, "expandable", "fas", "fa-plus"], [1, "expandable", "fas", "fa-minus"], [1, "fa-3x", "is-loading"], [1, "fas", "fa-spinner", "fa-spin"], [1, "fas", "fa-trash"], [1, "field"], [1, "label"], [1, "control"], ["type", "text", 1, "input", "is-small", 3, "keyup", "value"], [3, "actions", "privilege"], [1, "inform-if-missing-checkbox"], ["type", "checkbox", 1, "is-checkradio", "is-small", 3, "change", "id", "name", "checked"], [3, "for"], [3, "action"], [3, "condition"]],
    template: function PrivilegeComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "div", 6);
        i0.ɵɵtext(4, "Beh\xF6righeter");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, PrivilegeComponent_a_5_Template, 4, 0, "a", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, PrivilegeComponent_ng_container_6_Template, 11, 6, "ng-container", 8)(7, PrivilegeComponent_div_7_Template, 2, 0, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 4)(9, "div", 5)(10, "div", 6);
        i0.ɵɵtext(11, "Editera");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, PrivilegeComponent_a_12_Template, 4, 0, "a", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, PrivilegeComponent_div_13_Template, 7, 4, "div", 8)(14, PrivilegeComponent_div_14_Template, 8, 6, "div", 8)(15, PrivilegeComponent_div_15_Template, 4, 2, "div", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(16, "div", 10)(17, "div", 4)(18, "button", 11);
        i0.ɵɵlistener("click", function PrivilegeComponent_Template_button_click_18_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.save());
        });
        i0.ɵɵtext(19, "Spara");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "button", 12);
        i0.ɵɵlistener("click", function PrivilegeComponent_Template_button_click_20_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.reset());
        });
        i0.ɵɵtext(21, "\xC5terst\xE4ll");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "button", 12);
        i0.ɵɵlistener("click", function PrivilegeComponent_Template_button_click_22_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.exportFile());
        });
        i0.ɵɵtext(23, "Exportera");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "file-upload", 13, 0);
        i0.ɵɵlistener("import", function PrivilegeComponent_Template_file_upload_import_24_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.importFile($event));
        });
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.selected && ctx.selectedType === 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selected && ctx.selectedType === 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selected && ctx.selectedType === 1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selected && (ctx.selectedType === 2 || ctx.selectedType === 3));
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("options", ctx.fileOptions);
      }
    },
    dependencies: [i2.NgIf, TreeNgxComponent, UploadComponent, ActionComponent, ConditionComponent, ValueComponent, SortPrivilegesPipe],
    styles: [_c24]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrivilegeComponent, [{
    type: Component,
    args: [{
      selector: 'privilege',
      template: "<div class=\"columns columns-main\">\n  <div class=\"column box\">\n    <div class=\"flex flex-fill\">\n      <div class=\"box-title\">Beh\u00F6righeter</div>\n      <a class=\"button box-button is-small float-right\" *ngIf=\"!loading\" (click)=\"addResource()\">\n        <span class=\"icon is-small\">\n          <span class=\"fas fa-plus\"></span>\n        </span>\n        &nbsp; Ny resurs\n      </a>\n    </div>\n\n    <ng-container *ngIf=\"!loading\">\n      <input class=\"filter input is-small\" placeholder=\"Filtrera\" (keyup)=\"filterChange($event)\">\n      <button (click)=\"resourceTree.expandAll()\" class=\"margin-right margin-top button is-small is-outlined is-primary\">Expandera</button>\n      <button (click)=\"resourceTree.collapseAll()\" class=\"margin-top button is-small is-outlined is-primary\">Kollapsa</button>\n      <tree-ngx #resourceTree class=\"noselect privilage-tree\" [filter]=\"filter\" [callbacks]=\"callbacks\" [options]=\"options\"\n        [nodeItems]=\"items | sortPrivileges\">\n        <ng-template #nodeCollapsibleTemplate let-expanded=\"expanded\">\n          <span *ngIf=\"!expanded\" class=\"expandable fas fa-plus\"></span>\n          <span *ngIf=\"expanded\" class=\"expandable fas fa-minus\"></span>\n        </ng-template>\n      </tree-ngx>\n    </ng-container>\n\n    <div class=\"fa-3x is-loading\" *ngIf=\"loading\">\n      <span class=\"fas fa-spinner fa-spin\"></span>\n    </div>\n  </div>\n\n  <div class=\"column box\">\n    <div class=\"flex flex-fill\">\n      <div class=\"box-title\">Editera</div>\n      <a class=\"button box-button is-small float-right\" *ngIf=\"selected && selectedType === 0\" (click)=\"deleteResource(selected)\">\n        <span class=\"icon is-small\">\n          <span class=\"fas fa-trash\"></span>\n        </span>\n        &nbsp; Ta bort\n      </a>\n    </div>\n\n    <!-- RESOURCE -->\n    <div *ngIf=\"selected && selectedType === 0\">\n      <div class=\"field\">\n        <label class=\"label\">{{selected.name}}</label>\n        <div class=\"control\">\n          <input class=\"input is-small\" type=\"text\" (keyup)=\"updateName(selected, $event)\" [value]=\"selected.name\">\n        </div>\n      </div>\n\n      <action [actions]=\"actions\" [privilege]=\"selected\"></action>\n    </div>\n\n    <!-- ACTION -->\n    <div *ngIf=\"selected && selectedType === 1\">\n      <label class=\"label\">{{selected.name}}</label>\n\n      <div class=\"inform-if-missing-checkbox\">\n        <input class=\"is-checkradio is-small\" [id]=\"'selected.name'\" type=\"checkbox\" [name]=\"'selected.name'\"\n          [checked]=\"getInformIfMissing(selected)\" (change)=\"toggleInformIfMissing(selected)\">\n        <label [for]=\"'selected.name'\">Informera anv\u00E4ndare om\n          beh\u00F6righet saknas</label>\n      </div>\n\n      <condition [action]=\"selected\"></condition>\n    </div>\n\n    <!-- CONDITION -->\n    <div *ngIf=\"selected && (selectedType === 2 || selectedType === 3)\">\n      <label class=\"label\">{{selected.name}}</label>\n\n      <value-row [condition]=\"selected\"></value-row>\n    </div>\n\n  </div>\n</div>\n\n<div class=\"columns column-bottom\">\n  <div class=\"column box\">\n    <button class=\"float-right is-primary button is-small\" (click)=\"save()\">Spara</button>\n    <button class=\"margin-right float-right button is-small\" (click)=\"reset()\">\u00C5terst\u00E4ll</button>\n\n    <button class=\"margin-right float-right button is-small\" (click)=\"exportFile()\">Exportera</button>\n    <file-upload [options]=\"fileOptions\" (import)=\"importFile($event)\" #fileupload></file-upload>\n  </div>\n</div>",
      styles: [".add-row{display:flex;justify-content:center;font-size:16px}.add-row:hover{color:#f6a519}.cursor{cursor:auto}.expandable{font-size:12px}:host{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.privilege-button{cursor:pointer;width:100%}.box:not(:last-child){margin-bottom:5px}.column{height:100%;overflow-y:auto}.column-bottom{height:51px;margin-top:10px}.box-button{margin-top:-2px}.box-title{display:flex;flex:1 1}.filter{margin-top:10px}.margin-top{margin-top:5px}.margin-right{margin-right:10px}.field-margin-bottom{margin-bottom:.75rem}.divider{margin:.75rem 0;background-color:#f5f5f5}.inform-if-missing-checkbox{margin-bottom:.5em}\n"]
    }]
  }], () => [{
    type: PrivilegeDataSourceService
  }, {
    type: UpdateManagerService
  }], {
    resourceTree: [{
      type: ViewChild,
      args: ['resourceTree']
    }],
    importError: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class PrivilegeModule {
  static ɵfac = function PrivilegeModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PrivilegeModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PrivilegeModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [PrivilegeDataSourceService, PrivilegeService, UpdateManagerService],
    imports: [CommonModule, TreeNgxModule, UploadModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrivilegeModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, TreeNgxModule, UploadModule],
      declarations: [PrivilegeComponent, ActionComponent, ConditionComponent, ValueComponent, SortPrivilegesPipe],
      exports: [PrivilegeComponent],
      providers: [PrivilegeDataSourceService, PrivilegeService, UpdateManagerService]
    }]
  }], null, null);
})();
class StepperComponent {
  router;
  options;
  constructor(router) {
    this.router = router;
  }
  isBackDisabled() {
    if (!this.options || !this.options.previousRoute) {
      return true;
    }
    return false;
  }
  isForwardDisabled() {
    if (!this.options || !this.options.nextRoute) {
      return true;
    }
    return false;
  }
  goBack() {
    if (!this.options || !this.options.previousRoute || this.options.previousRoute.length === 0) {
      return;
    }
    this.router.navigate([this.options.previousRoute]);
  }
  goForward() {
    if (!this.options || !this.options.nextRoute || this.options.nextRoute.length === 0) {
      return;
    }
    this.router.navigate([this.options.nextRoute]);
  }
  static ɵfac = function StepperComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || StepperComponent)(i0.ɵɵdirectiveInject(i1$1.Router));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: StepperComponent,
    selectors: [["stepper"]],
    inputs: {
      options: "options"
    },
    standalone: false,
    decls: 14,
    vars: 2,
    consts: [[1, "flex", "flex-center"], [1, "columns"], [1, "column", "left"], [1, "button", "is-pulled-right", 3, "click", "disabled"], [1, "icon"], ["aria-label", "F\xF6reg\xE5ende steg", 1, "fa", "fa-chevron-left"], [1, "column", "right"], [1, "button", "is-pulled-left", 3, "click", "disabled"], ["aria-label", "N\xE4sta steg", 1, "fa", "fa-chevron-right"]],
    template: function StepperComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "button", 3);
        i0.ɵɵlistener("click", function StepperComponent_Template_button_click_3_listener() {
          return ctx.goBack();
        });
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵelement(5, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "span");
        i0.ɵɵtext(7, "F\xF6reg\xE5ende steg");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "div", 6)(9, "button", 7);
        i0.ɵɵlistener("click", function StepperComponent_Template_button_click_9_listener() {
          return ctx.goForward();
        });
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11, "N\xE4sta steg");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "span", 4);
        i0.ɵɵelement(13, "i", 8);
        i0.ɵɵelementEnd()()()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.isBackDisabled());
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.isForwardDisabled());
      }
    },
    styles: [".columns[_ngcontent-%COMP%]{width:100%}.columns[_ngcontent-%COMP%]   .column[_ngcontent-%COMP%]{width:50%;padding-left:.25rem;padding-right:.25rem}.columns[_ngcontent-%COMP%]   .column.left[_ngcontent-%COMP%]{float:left}.columns[_ngcontent-%COMP%]   .column.right[_ngcontent-%COMP%]{float:right}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepperComponent, [{
    type: Component,
    args: [{
      selector: 'stepper',
      template: "<div class=\"flex flex-center\">\n\n  <div class=\"columns\">\n    <div class=\"column left\">\n      <button class=\"button is-pulled-right\" (click)=\"goBack()\" [disabled]=\"isBackDisabled()\">\n        <span class=\"icon\">\n          <i aria-label=\"F\u00F6reg\u00E5ende steg\" class=\"fa fa-chevron-left\"></i>\n        </span>\n        <span>F\u00F6reg\u00E5ende steg</span>\n      </button>\n    </div>\n\n    <div class=\"column right\">\n      <button class=\"button is-pulled-left\" (click)=\"goForward()\" [disabled]=\"isForwardDisabled()\">\n        <span>N\u00E4sta steg</span>\n        <span class=\"icon\">\n          <i aria-label=\"N\u00E4sta steg\" class=\"fa fa-chevron-right\"></i>\n        </span>\n      </button>\n    </div>\n  </div>\n\n</div>\n",
      styles: [".columns{width:100%}.columns .column{width:50%;padding-left:.25rem;padding-right:.25rem}.columns .column.left{float:left}.columns .column.right{float:right}\n"]
    }]
  }], () => [{
    type: i1$1.Router
  }], {
    options: [{
      type: Input
    }]
  });
})();
class StepperModule {
  static ɵfac = function StepperModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || StepperModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: StepperModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StepperModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [StepperComponent],
      exports: [StepperComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class GlobalSwipeService {
  swipeEmitter = new Subject();
  touchStart$;
  touchMove$;
  touchEnd$;
  drag$;
  swipe$;
  swipeBreakPoint = 50;
  constructor() {
    this.touchStart$ = fromEvent(document, 'touchstart');
    this.touchMove$ = fromEvent(document, 'touchmove');
    this.touchEnd$ = fromEvent(document, 'touchend');
    this.drag$ = this.touchStart$.pipe(switchMap(start => {
      return this.touchMove$.pipe(map(move => {
        const swipe = {
          startX: start.touches[0].pageX,
          startY: start.touches[0].pageY,
          dY: move.touches[0].pageY - start.touches[0].pageY,
          dX: move.touches[0].pageX - start.touches[0].pageX
        };
        return swipe;
      }), takeUntil(this.touchEnd$), takeLast(1));
    }));
    this.swipe$.subscribe(result => {
      this.swipeEmitter.next(result);
    });
  }
  static ɵfac = function GlobalSwipeService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GlobalSwipeService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GlobalSwipeService,
    factory: GlobalSwipeService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalSwipeService, [{
    type: Injectable
  }], () => [], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class SwipeDirective {
  el;
  touchStart$;
  touchMove$;
  touchEnd$;
  drag$;
  swipe$;
  swipeBreakPoint = 100;
  swipes = new EventEmitter();
  constructor(el) {
    this.el = el;
    this.touchStart$ = fromEvent(this.el.nativeElement, 'touchstart');
    this.touchMove$ = fromEvent(document, 'touchmove');
    this.touchEnd$ = fromEvent(document, 'touchend');
    this.drag$ = this.touchStart$.pipe(switchMap(start => {
      return this.touchMove$.pipe(map(move => {
        const dy = move.touches[0].pageY - start.touches[0].pageY;
        const dx = move.touches[0].pageX - start.touches[0].pageX;
        return {
          dx: dx,
          dy: dy
        };
      }), takeUntil(this.touchEnd$), takeLast(1));
    }));
    this.swipe$ = this.drag$.pipe(map(result => {
      if (Math.max(Math.abs(result.dx), Math.abs(result.dy)) > this.swipeBreakPoint) {
        if (Math.abs(result.dx) > Math.abs(result.dy)) {
          if (result.dx < 0) {
            return 'swipe-left';
          } else {
            return 'swipe-right';
          }
        } else {
          if (result.dy < 0) {
            return 'swipe-up';
          } else {
            return 'swipe-down';
          }
        }
      } else {
        return 'no-swipe';
      }
    }));
    this.swipe$.subscribe(result => {
      this.swipes.emit(result);
    });
  }
  static ɵfac = function SwipeDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SwipeDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SwipeDirective,
    selectors: [["", "swipe", ""]],
    outputs: {
      swipes: "swipes"
    },
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SwipeDirective, [{
    type: Directive,
    args: [{
      selector: '[swipe]'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    swipes: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class SwipeModule {
  static ɵfac = function SwipeModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SwipeModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SwipeModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SwipeModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [SwipeDirective],
      exports: [SwipeDirective]
    }]
  }], null, null);
})();
class TimepickerPipe {
  transform(value, format) {
    let returnValue = '';
    if (value && value !== '') {
      const date = moment(value);
      if (date.isValid()) {
        let returnFormat = '';
        if (format && format.length) {
          returnFormat = format;
        } else {
          returnFormat = 'HH:mm';
        }
        returnValue = date.format(returnFormat);
      }
    }
    return returnValue;
  }
  static ɵfac = function TimepickerPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TimepickerPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "timePicker",
    type: TimepickerPipe,
    pure: true,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimepickerPipe, [{
    type: Pipe,
    args: [{
      name: 'timePicker'
    }]
  }], null, null);
})();
class TimepickerComponent {
  el;
  disabled = false;
  options = {
    small: false,
    nullable: false
  };
  placeholder = '';
  valid = true;
  calendarContainer;
  overlay = false;
  shadowTime;
  timeObj;
  showTimepicker = false;
  header = '';
  displayFormat = 'HH:mm';
  inputEl;
  onChange = time => {
    // do nothing
  };
  onTouched = () => {
    // do nothing
  };
  clickout(event) {
    if (this.el && this.calendarContainer && !this.isInside(this.el.nativeElement, event) && !this.isInside(this.calendarContainer.nativeElement, event)) {
      this.hide();
    }
  }
  constructor(el) {
    this.el = el;
  }
  ngOnInit() {
    this.inputEl = this.el.nativeElement.getElementsByClassName('input')[0];
    this.timeObj = moment();
    this.shadowTime = moment();
    this.updateTime();
    fromEvent(this.el.nativeElement, 'keyup').subscribe(event => {
      this.updateValue();
    });
  }
  writeValue(event) {
    let activeTime;
    if (this.options.nullable && event === null) {
      activeTime = null;
      this.inputEl.value = '';
    } else if (event !== undefined) {
      activeTime = moment(event);
      if (!activeTime.isValid()) {
        activeTime = moment();
      }
    } else {
      activeTime = moment();
    }
    this.timeObj = activeTime;
    if (this.timeObj !== null) {
      this.shadowTime = this.timeObj.clone();
      this.updateTime();
    }
    this.onChange(activeTime);
  }
  updateValue() {
    if (this.isValidTimeFormat(this.inputEl.value)) {
      const momentObject = moment(this.inputEl.value, 'HH:mm');
      if (momentObject && momentObject.isValid()) {
        this.writeValue(momentObject);
      }
    }
    if (this.options.nullable && this.inputEl.value.length === 0) {
      this.clearTime();
    } else {
      this.onChange(moment(this.inputEl.value, 'HH:mm'));
    }
  }
  getHoursValue() {
    if (this.timeObj) {
      return this.timeObj.format('HH');
    }
    return null;
  }
  getMinutesValue() {
    if (this.timeObj) {
      return this.timeObj.format('mm');
    }
    return null;
  }
  changeHours(value) {
    if (!this.timeObj) {
      this.timeObj = moment();
    }
    const adjustedHours = this.ValidateHours(this.timeObj, value);
    const adjustedTimeString = adjustedHours.format('HH') + ':' + this.timeObj.format('mm');
    this.writeValue(moment(adjustedTimeString, 'HH:mm'));
  }
  ValidateHours(timeObj, changeValue) {
    let intValue = parseInt(timeObj.format('HH'), 10) + changeValue;
    if (intValue === 24) {
      intValue = 0;
    } else if (intValue === -1) {
      intValue = 23;
    }
    return moment(intValue, 'HH');
  }
  changeMinutes(value) {
    if (!this.timeObj) {
      this.timeObj = moment();
    }
    const adjustedMinutes = this.validateMinutes(this.timeObj, value);
    const adjustedTimeString = this.timeObj.format('HH') + ':' + adjustedMinutes.format('mm');
    this.writeValue(moment(adjustedTimeString, 'HH:mm'));
  }
  validateMinutes(timeObj, changeValue) {
    let intValue = parseInt(timeObj.format('mm'), 10) + changeValue;
    if (intValue === 60) {
      intValue = 0;
    } else if (intValue === -1) {
      intValue = 59;
    }
    return moment(intValue, 'mm');
  }
  clearTime() {
    if (!this.options.nullable) {
      return;
    }
    this.inputEl.value = '';
    this.writeValue(null);
    this.hide();
  }
  show() {
    if (!this.disabled) {
      this.showTimepicker = true;
    }
  }
  hide() {
    this.showTimepicker = false;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  setValidState(isValid) {
    this.valid = isValid;
  }
  validate() {
    if (this.options.nullable && this.timeObj === null || this.timeObj && this.timeObj.isValid()) {
      return null;
    } else {
      return {
        InvalidDateError: 'The time is invalid.'
      };
    }
  }
  updateTime() {
    if (this.timeObj) {
      if (!this.timeObj.isValid()) {
        if (this.options.nullable) {
          this.writeValue(null);
        } else {
          this.timeObj = moment();
          this.writeValue(this.timeObj);
        }
      }
    }
  }
  isInside(element, event) {
    const rect = element.getBoundingClientRect();
    return rect.left < event.clientX && rect.left + rect.width > event.clientX && rect.top < event.clientY && rect.top + rect.height > event.clientY;
  }
  isValidTimeFormat(time) {
    const hhmmPattern = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return hhmmPattern.test(time);
  }
  static ɵfac = function TimepickerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TimepickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TimepickerComponent,
    selectors: [["timepicker"]],
    viewQuery: function TimepickerComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c25, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendarContainer = _t.first);
      }
    },
    hostBindings: function TimepickerComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function TimepickerComponent_click_HostBindingHandler($event) {
          return ctx.clickout($event);
        }, false, i0.ɵɵresolveDocument);
      }
    },
    inputs: {
      disabled: "disabled",
      options: "options",
      placeholder: "placeholder",
      valid: "valid"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimepickerComponent),
      multi: true
    }, {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TimepickerComponent),
      multi: true
    }])],
    decls: 6,
    vars: 13,
    consts: [["timepickerContainer", ""], [1, "control", "has-icons-right", 3, "click"], ["type", "text", 1, "input", "is-datepicker", 3, "change", "value", "placeholder", "disabled"], [1, "icon", "is-small", "is-right"], [1, "fas", "fa-clock"], ["class", "datepicker is-active", 3, "modal", "is-small", 4, "ngIf"], [1, "datepicker", "is-active"], ["class", "modal-background", 4, "ngIf"], [1, "calendar"], [1, "calendar-container", "inset-border"], [1, "calendar-header"], ["type", "button", 1, "button", "date-item", "month", 3, "click"], [1, "fa", "fa-chevron-up"], [1, "calendar-body"], [1, "calendar-footer"], [1, "fa", "fa-chevron-down"], [4, "ngIf"], [1, "modal-background"], ["type", "button", 1, "button", "is-outlined", "is-fullwidth", "is-danger", 3, "click"], [1, "fas", "fa-times-circle"]],
    template: function TimepickerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵlistener("click", function TimepickerComponent_Template_div_click_0_listener() {
          return ctx.show();
        });
        i0.ɵɵelementStart(1, "input", 2);
        i0.ɵɵpipe(2, "timePicker");
        i0.ɵɵlistener("change", function TimepickerComponent_Template_input_change_1_listener() {
          return ctx.updateValue();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(5, TimepickerComponent_div_5_Template, 23, 10, "div", 5);
      }
      if (rf & 2) {
        i0.ɵɵclassProp("is-small", ctx.options.small);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("is-danger", !ctx.valid)("is-small", ctx.options.small);
        i0.ɵɵproperty("value", i0.ɵɵpipeBind2(2, 10, ctx.timeObj, ctx.displayFormat))("placeholder", ctx.placeholder)("disabled", ctx.disabled);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showTimepicker);
      }
    },
    dependencies: [i2.NgIf, TimepickerPipe],
    styles: ["[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]{max-width:150px;min-width:150px;position:absolute}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar.fixed[_ngcontent-%COMP%]{position:fixed}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-nav[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{background-color:transparent}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-date[_ngcontent-%COMP%]{padding:0}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-date.month[_ngcontent-%COMP%]{padding:10px 0;flex:0 0 25%;max-width:25%}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-date[_ngcontent-%COMP%]   .date-item[_ngcontent-%COMP%]{width:28px;height:28px;margin:5px;line-height:10px}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-date[_ngcontent-%COMP%]   .date-item.month[_ngcontent-%COMP%]{width:40px;height:40px}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-body[_ngcontent-%COMP%]{padding:.25em 1em}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#4a4a4a;font-size:1.5rem;margin:0 .4rem}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-header[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:0 .5em}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-footer[_ngcontent-%COMP%]{padding:0 1em 1em;background:transparent;color:#fff;font-size:.75rem}[_nghost-%COMP%]   .datepicker[_ngcontent-%COMP%]   .calendar[_ngcontent-%COMP%]   .calendar-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:0 .5em}[_nghost-%COMP%]   .inset-border[_ngcontent-%COMP%]{box-shadow:0 0 1px #00000054 inset}[_nghost-%COMP%]   .clickable[_ngcontent-%COMP%]{cursor:pointer}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimepickerComponent, [{
    type: Component,
    args: [{
      selector: 'timepicker',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimepickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => TimepickerComponent),
        multi: true
      }],
      template: "<div class=\"control has-icons-right\" [class.is-small]=\"options.small\" (click)=\"show()\">\n  <input type=\"text\" class=\"input is-datepicker\" [class.is-danger]=\"!valid\" [class.is-small]=\"options.small\"\n    [value]=\"timeObj | timePicker: displayFormat\" [placeholder]=\"placeholder\" (change)=\"updateValue()\"\n    [disabled]=\"disabled\">\n  <span class=\"icon is-small is-right\">\n    <span class=\"fas fa-clock\"></span>\n  </span>\n</div>\n\n<div *ngIf=\"showTimepicker\" [class.modal]=\"overlay\" [class.is-small]=\"options.small\" class=\"datepicker is-active\">\n  <div *ngIf=\"overlay\" class=\"modal-background\"></div>\n  <div #timepickerContainer class=\"calendar\" [class.fixed]=\"options.fixed\">\n\n    <div class=\"calendar-container inset-border\">\n      <div class=\"calendar-header\">\n        <button type=\"button\" class=\"button date-item month\" (click)=\"changeHours(1)\">\n          <span class=\"fa fa-chevron-up\"></span>\n        </button>\n        <button type=\"button\" class=\"button date-item month\" (click)=\"changeMinutes(1)\">\n          <span class=\" fa fa-chevron-up\"></span>\n        </button>\n      </div>\n      <div class=\"calendar-body\">\n        <p>{{ getHoursValue() }}</p>\n        <p>:</p>\n        <p>{{ getMinutesValue() }}</p>\n      </div>\n      <div class=\"calendar-footer\">\n        <button type=\"button\" class=\"button date-item month\" (click)=\"changeHours(-1)\">\n          <span class=\" fa fa-chevron-down\"></span>\n        </button>\n        <button type=\"button\" class=\"button date-item month\" (click)=\"changeMinutes(-1)\">\n          <span class=\" fa fa-chevron-down\"></span>\n        </button>\n      </div>\n    </div>\n\n    <div *ngIf=\"options.nullable\">\n      <button type=\"button\" class=\"button is-outlined is-fullwidth is-danger\" (click)=\"clearTime()\">\n        <span class=\"fas fa-times-circle\"></span>\n      </button>\n    </div>\n  </div>\n\n</div>\n",
      styles: [":host .datepicker .calendar{max-width:150px;min-width:150px;position:absolute}:host .datepicker .calendar.fixed{position:fixed}:host .datepicker .calendar .calendar-nav .button{background-color:transparent}:host .datepicker .calendar .calendar-date{padding:0}:host .datepicker .calendar .calendar-date.month{padding:10px 0;flex:0 0 25%;max-width:25%}:host .datepicker .calendar .calendar-date .date-item{width:28px;height:28px;margin:5px;line-height:10px}:host .datepicker .calendar .calendar-date .date-item.month{width:40px;height:40px}:host .datepicker .calendar .calendar-body{padding:.25em 1em}:host .datepicker .calendar .calendar-body p{color:#4a4a4a;font-size:1.5rem;margin:0 .4rem}:host .datepicker .calendar .calendar-header button{margin:0 .5em}:host .datepicker .calendar .calendar-footer{padding:0 1em 1em;background:transparent;color:#fff;font-size:.75rem}:host .datepicker .calendar .calendar-footer button{margin:0 .5em}:host .inset-border{box-shadow:0 0 1px #00000054 inset}:host .clickable{cursor:pointer}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    disabled: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    valid: [{
      type: Input
    }],
    calendarContainer: [{
      type: ViewChild,
      args: ['timepickerContainer']
    }],
    clickout: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
class TimepickerModule {
  static ɵfac = function TimepickerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TimepickerModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TimepickerModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimepickerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [TimepickerComponent, TimepickerPipe],
      exports: [TimepickerComponent],
      providers: []
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class HoverDirective {
  el;
  mouseEnter$;
  mouseLeave$;
  hoverState = new EventEmitter();
  constructor(el) {
    this.el = el;
  }
  ngOnInit() {
    this.mouseEnter$ = fromEvent(this.el.nativeElement, 'mouseenter');
    this.mouseLeave$ = fromEvent(this.el.nativeElement, 'mouseleave');
    this.mouseEnter$.subscribe(result => {
      this.hoverState.emit('active');
    });
    this.mouseLeave$.subscribe(result => {
      this.hoverState.emit('inactive');
    });
  }
  static ɵfac = function HoverDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HoverDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HoverDirective,
    selectors: [["", "mouseHover", ""]],
    outputs: {
      hoverState: "hoverState"
    },
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HoverDirective, [{
    type: Directive,
    args: [{
      selector: '[mouseHover]'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    hoverState: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ToastComponent {
  toastService;
  toasts$;
  constructor(toastService) {
    this.toastService = toastService;
  }
  ngOnInit() {
    this.toasts$ = this.toastService.connect();
  }
  dismissToast(toast) {
    this.toastService.removeToast(toast);
  }
  swipeAction(action, toast) {
    if (action === 'swipe-right') {
      this.toastService.removeToast(toast);
    }
  }
  handleHover(hoverState, toast) {
    if (hoverState === 'active') {
      this.toastService.killTimer(toast);
    } else {
      this.toastService.resumeTimer(toast);
    }
  }
  isSingle(value) {
    if (typeof value === 'string') {
      return true;
    } else {
      return false;
    }
  }
  static ɵfac = function ToastComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastComponent)(i0.ɵɵdirectiveInject(ToastService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ToastComponent,
    selectors: [["toast-container"]],
    standalone: false,
    decls: 2,
    vars: 3,
    consts: [["swipe", "", "mouseHover", "", "class", "notification", 3, "is-primary", "is-info", "is-success", "is-link", "is-warning", "is-danger", "destroy", "swipes", "hoverState", 4, "ngFor", "ngForOf"], ["swipe", "", "mouseHover", "", 1, "notification", 3, "swipes", "hoverState"], ["aria-label", "Meddelandets ikon", 1, "fas", "fa-lg"], [1, "delete", 3, "click"], [4, "ngIf"], [4, "ngFor", "ngForOf"]],
    template: function ToastComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, ToastComponent_div_0_Template, 9, 27, "div", 0);
        i0.ɵɵpipe(1, "async");
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(1, 1, ctx.toasts$));
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, SwipeDirective, HoverDirective, i2.AsyncPipe],
    styles: ["[_nghost-%COMP%]{align-self:flex-end;bottom:10px;display:flex;flex:0 350px;flex-direction:column;position:absolute;right:10px;transform:translateZ(0);z-index:50}[_nghost-%COMP%]   .notification[_ngcontent-%COMP%]{display:flex;max-width:350px;opacity:.9;position:relative;transition:transform .25s ease-in,opacity .25s ease-in-out}[_nghost-%COMP%]   .notification[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{align-self:center;padding:0 8px 0 0}[_nghost-%COMP%]   .notification[_ngcontent-%COMP%]:hover{opacity:1}[_nghost-%COMP%]   .notification.destroy[_ngcontent-%COMP%]{transform:translate(10px) rotateX(90deg) scale(.1);opacity:0}[_nghost-%COMP%]   .notification[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{word-break:break-word}@media (max-width: 769px){[_nghost-%COMP%]{align-self:flex-end;bottom:10px;flex:1 1 auto;left:10px;right:10px}}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastComponent, [{
    type: Component,
    args: [{
      selector: 'toast-container',
      template: "<div swipe (swipes)=\"swipeAction($event, toast)\" mouseHover (hoverState)=\"handleHover($event, toast)\" class=\"notification\"\n  [class.is-primary]=\"toast.type === 'primary'\"\n  [class.is-info]=\"toast.type === 'info'\"\n  [class.is-success]=\"toast.type === 'success'\"\n  [class.is-link]=\"toast.type === 'link'\"\n  [class.is-warning]=\"toast.type === 'warning'\"\n  [class.is-danger]=\"toast.type === 'danger'\"\n  [class.destroy]=\"toast.destroy\"\n  *ngFor=\"let toast of toasts$ | async\">\n  <i aria-label=\"Meddelandets ikon\" class=\"fas fa-lg\"\n    [class.fa-info-circle]=\"toast.type === 'info'\"\n    [class.fa-check-circle]=\"toast.type === 'success'\"\n    [class.fa-link]=\"toast.type === 'link'\"\n    [class.fa-exclamation-circle]=\"toast.type === 'warning'\"\n    [class.fa-exclamation-triangle]=\"toast.type === 'danger'\">\n  </i>\n  <button class=\"delete\" (click)=\"dismissToast(toast)\"></button>\n  <div>\n    <p>\n      <strong>{{ toast.title }}</strong>\n    </p>\n    <ng-container *ngIf=\"isSingle(toast.message)\">\n      <p>\n        {{ toast.message }}\n      </p>\n    </ng-container>\n    <ng-container *ngIf=\"!isSingle(toast.message)\">\n      <ul *ngFor=\"let msg of toast.message\">\n        <li>\n          <p>{{ msg }}</p>\n        </li>\n      </ul>\n    </ng-container>\n  </div>\n</div>\n",
      styles: [":host{align-self:flex-end;bottom:10px;display:flex;flex:0 350px;flex-direction:column;position:absolute;right:10px;transform:translateZ(0);z-index:50}:host .notification{display:flex;max-width:350px;opacity:.9;position:relative;transition:transform .25s ease-in,opacity .25s ease-in-out}:host .notification .fas{align-self:center;padding:0 8px 0 0}:host .notification:hover{opacity:1}:host .notification.destroy{transform:translate(10px) rotateX(90deg) scale(.1);opacity:0}:host .notification p{word-break:break-word}@media (max-width: 769px){:host{align-self:flex-end;bottom:10px;flex:1 1 auto;left:10px;right:10px}}\n"]
    }]
  }], () => [{
    type: ToastService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ToastModule {
  static ɵfac = function ToastModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ToastModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [ToastService],
    imports: [CommonModule, SwipeModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, SwipeModule],
      declarations: [ToastComponent, HoverDirective],
      exports: [ToastComponent],
      providers: [ToastService]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ValidateAttributePipe {
  transform(value) {
    return value.filter(item => {
      if (Array.isArray(item.value)) {
        return item.value.length !== 0;
      } else if (item.value != null) {
        return true;
      }
      return false;
    });
  }
  static ɵfac = function ValidateAttributePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ValidateAttributePipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "validateAttribute",
    type: ValidateAttributePipe,
    pure: true,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValidateAttributePipe, [{
    type: Pipe,
    args: [{
      name: 'validateAttribute'
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class UserInfoComponent {
  userService;
  options = {
    messageContent: 'Du saknar systembehörigheter. Se tabellen nedan för specifik information.',
    showInfoMessage: true
  };
  user;
  attributes = [];
  paginatedAttributes = [];
  paginationOptions = {
    maxPages: 5,
    pageSize: 15
  };
  noPrivilegesInfoMessageOptions = {
    messageContent: this.options.messageContent,
    messageType: InfoMessageType.WARNING,
    useFaIcon: true
  };
  constructor(userService) {
    this.userService = userService;
  }
  ngOnInit() {
    this.userService.connect().subscribe(it => {
      this.user = it;
      for (const attribute in this.user) {
        if (attribute !== 'privileges' && attribute !== 'missingPrivileges' && this.user[attribute]) {
          this.attributes.push({
            name: attribute,
            value: this.user[attribute]
          });
        }
      }
    });
  }
  export() {
    Util.exportJson(this.user, this.user.employeeHsaId);
  }
  static ɵfac = function UserInfoComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UserInfoComponent)(i0.ɵɵdirectiveInject(UserService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: UserInfoComponent,
    selectors: [["user-info"]],
    inputs: {
      options: "options"
    },
    standalone: false,
    decls: 19,
    vars: 8,
    consts: [["class", "no-privileges-message", 4, "ngIf"], ["class", "columns", 4, "ngIf"], [1, "columns"], [1, "box", "column"], [1, "box-title"], ["class", "columns-table table-spaced-top", 4, "ngIf"], [1, "columns-table", "user-info-table"], ["class", "columns-table-body columns is-multiline is-tablet", 4, "ngFor", "ngForOf"], [3, "paginatedData", "options", "data"], [1, "columns", "column-bottom"], [1, "column", "box", "align-right"], [1, "is-primary", "button", "is-small", 3, "click"], [1, "no-privileges-message"], [3, "options"], [1, "box-title", "mt-4"], ["aria-describedby", "#", 1, "table", "is-narrow", "is-bordered", "is-fullwidth", "missing-privileges-table"], ["scope", "col"], [4, "ngFor", "ngForOf"], [1, "columns-table", "table-spaced-top"], ["class", "columns-table-body columns is-multiline is-tablet", 4, "ngIf"], [1, "columns-table-body", "columns", "is-multiline", "is-tablet"], [1, "column", "is-4"], [1, "column", "is-8", "info-value"]],
    template: function UserInfoComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, UserInfoComponent_div_0_Template, 2, 1, "div", 0)(1, UserInfoComponent_div_1_Template, 17, 1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵtext(5, "Anv\xE4ndarinformation");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, UserInfoComponent_div_6_Template, 5, 4, "div", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 2)(8, "div", 3)(9, "div", 4);
        i0.ɵɵtext(10, "Egenskaper");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 6);
        i0.ɵɵtemplate(12, UserInfoComponent_div_12_Template, 5, 2, "div", 7);
        i0.ɵɵpipe(13, "validateAttribute");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "pagination", 8);
        i0.ɵɵlistener("paginatedData", function UserInfoComponent_Template_pagination_paginatedData_14_listener($event) {
          return ctx.paginatedAttributes = $event;
        });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(15, "div", 9)(16, "div", 10)(17, "button", 11);
        i0.ɵɵlistener("click", function UserInfoComponent_Template_button_click_17_listener() {
          return ctx.export();
        });
        i0.ɵɵtext(18, "Exportera anv\xE4ndarinformation");
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.user && ctx.user.privileges.length === 0 && ctx.options.showInfoMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.user && ctx.user.missingPrivileges.length > 0);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.user);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(13, 6, ctx.paginatedAttributes));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("options", ctx.paginationOptions)("data", ctx.attributes);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, PaginationComponent, InfoMessageComponent, ValidateAttributePipe],
    styles: [".info-value[_ngcontent-%COMP%]{font-style:italic}.align-right[_ngcontent-%COMP%]{text-align:right}table.missing-privileges-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], table.missing-privileges-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:middle;font-size:12.8px}.no-privileges-message[_ngcontent-%COMP%]{margin-bottom:1.8em}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserInfoComponent, [{
    type: Component,
    args: [{
      selector: 'user-info',
      template: "<div *ngIf=\"user && user.privileges.length === 0 && options.showInfoMessage\" class=\"no-privileges-message\">\n  <info-message [options]=\"noPrivilegesInfoMessageOptions\">\n  </info-message>\n</div>\n\n<div class=\"columns\" *ngIf=\"user && user.missingPrivileges.length > 0\">\n  <div class=\"box column\">\n    <div class=\"box-title mt-4\">Saknade beh\u00F6righeter</div>\n\n    <table class=\"table is-narrow is-bordered is-fullwidth missing-privileges-table\" aria-describedby=\"#\">\n      <thead>\n        <tr>\n          <th scope=\"col\">\n            Beh\u00F6righet\n          </th>\n          <th scope=\"col\">\n            Aktion\n          </th>\n          <th scope=\"col\">\n            Villkor\n          </th>\n          <th scope=\"col\">\n            V\u00E4rden\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <ng-container *ngFor=\"let missingPrivilege of user.missingPrivileges\">\n          <tr>\n            <td [attr.rowspan]=\"missingPrivilege.conditions.length + 1\">{{ missingPrivilege.name }}</td>\n            <td [attr.rowspan]=\"missingPrivilege.conditions.length + 1\">{{ missingPrivilege.action }}</td>\n          </tr>\n          <tr *ngFor=\"let condition of missingPrivilege.conditions;\">\n            <td>{{ condition.attribute }}</td>\n            <td>\n              <ul *ngFor=\"let value of condition.values\">\n                <li>\n                  {{ value }}\n                </li>\n              </ul>\n            </td>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </div>\n</div>\n\n<div class=\"columns\">\n  <div class=\"box column\">\n    <div class=\"box-title\">Anv\u00E4ndarinformation</div>\n\n    <div class=\"columns-table table-spaced-top\" *ngIf=\"user\">\n      <div class=\"columns-table-body columns is-multiline is-tablet\" *ngIf=\"user.name\">\n        <div class=\"column is-4\">\n          Namn\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ user.name }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\" *ngIf=\"user.employeeHsaId\">\n        <div class=\"column is-4\">\n          Id\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ user.employeeHsaId }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\" *ngIf=\"user.issuer\">\n        <div class=\"column is-4\">\n          Utf\u00E4rdare\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ user.issuer }}\n        </div>\n      </div>\n\n      <div class=\"columns-table-body columns is-multiline is-tablet\" *ngIf=\"user.organizationName\">\n        <div class=\"column is-4\">\n          Organisation\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ user.organizationName }}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"columns\">\n  <div class=\"box column\">\n    <div class=\"box-title\">Egenskaper</div>\n\n    <div class=\"columns-table user-info-table\">\n      <div class=\"columns-table-body columns is-multiline is-tablet\"\n        *ngFor=\"let attribute of paginatedAttributes | validateAttribute\">\n        <div class=\"column is-4\">\n          {{ attribute.name }}\n        </div>\n        <div class=\"column is-8 info-value\">\n          {{ attribute.value }}\n        </div>\n      </div>\n    </div>\n    <pagination (paginatedData)=\"paginatedAttributes = $event\" [options]=\"paginationOptions\" [data]=\"attributes\">\n    </pagination>\n  </div>\n</div>\n\n<div class=\"columns column-bottom\">\n  <div class=\"column box align-right\">\n    <button class=\"is-primary button is-small\" (click)=\"export()\">Exportera anv\u00E4ndarinformation</button>\n  </div>\n</div>",
      styles: [".info-value{font-style:italic}.align-right{text-align:right}table.missing-privileges-table th,table.missing-privileges-table td{vertical-align:middle;font-size:12.8px}.no-privileges-message{margin-bottom:1.8em}\n"]
    }]
  }], () => [{
    type: UserService
  }], {
    options: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class UserInfoModule {
  static ɵfac = function UserInfoModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UserInfoModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: UserInfoModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, PaginationModule, InfoMessageModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserInfoModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, PaginationModule, InfoMessageModule],
      declarations: [UserInfoComponent, ValidateAttributePipe],
      exports: [UserInfoComponent],
      providers: []
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ViewChangesGuard {
  dialogService;
  constructor(dialogService) {
    this.dialogService = dialogService;
  }
  canDeactivate(component) {
    const result = component.canDeactivate ? component.canDeactivate() : true;
    if (!result) {
      const dialog = {
        title: 'Vill du verkligen lämna sidan?',
        message: 'Du har osparade ändringar som kommer gå förlorade ifall du inte sparar dem!'
      };
      return this.dialogService.open(dialog);
    } else {
      return of(true);
    }
  }
  static ɵfac = function ViewChangesGuard_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ViewChangesGuard)(i0.ɵɵinject(DialogService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ViewChangesGuard,
    factory: ViewChangesGuard.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewChangesGuard, [{
    type: Injectable
  }], () => [{
    type: DialogService
  }], null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class MetadataService {
  http;
  apiBase = '/api/ws/metadata';
  constructor(http) {
    this.http = http;
  }
  getMetadata() {
    return this.http.get(`${this.apiBase}/ws-clients`);
  }
  postMetadata(data) {
    return this.http.post(`${this.apiBase}/save-ws-client`, data);
  }
  deleteMetadata(id) {
    return this.http.delete(`${this.apiBase}/delete-ws-client/${id}`);
  }
  getServicePlatforms() {
    return this.http.get(`${this.apiBase}/service-platforms`);
  }
  saveServicePlatform(data) {
    return this.http.post(`${this.apiBase}/save-service-platform-client`, data);
  }
  deleteServicePlatform(id) {
    return this.http.delete(`${this.apiBase}/delete-serviceplatform-client/${id}`);
  }
  certPin(file) {
    const form = new FormData();
    form.append('certFile', file);
    return this.http.post(`${this.apiBase}/certpin`, form);
  }
  static ɵfac = function MetadataService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MetadataService)(i0.ɵɵinject(i1.HttpClient));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MetadataService,
    factory: MetadataService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MetadataService, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }], null);
})();
class CertPinningFormComponent {
  fb;
  metadataService;
  readOnly;
  currentCertPins;
  certificateForm;
  certPinning = [];
  options = {
    validFileTypes: ['.pem, .cer, .key, .crt'],
    showImport: true,
    small: true
  };
  constructor(fb, metadataService) {
    this.fb = fb;
    this.metadataService = metadataService;
  }
  ngOnInit() {
    if (this.currentCertPins) {
      this.certPinning = this.currentCertPins;
    }
    this.certificateForm = this.fb.group({
      certFile: [null, Validators.required]
    });
  }
  importFile() {
    this.metadataService.certPin(this.certificateForm.get('certFile').value).subscribe(certPin => {
      if (!this.certPinning.some(it => it.sha256Thumbprint === certPin.sha256Thumbprint)) {
        this.certPinning.push(certPin);
        this.certificateForm.get('certFile').patchValue(null);
      }
    });
  }
  fileUploaded(file) {
    this.certificateForm.get('certFile').setValue(file);
  }
  onDelete(certPin) {
    this.certPinning = this.certPinning.filter(c => c.sha256Thumbprint !== certPin.sha256Thumbprint);
  }
  static ɵfac = function CertPinningFormComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CertPinningFormComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(MetadataService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CertPinningFormComponent,
    selectors: [["cert-pinning"]],
    inputs: {
      readOnly: "readOnly",
      currentCertPins: "currentCertPins"
    },
    standalone: false,
    decls: 17,
    vars: 7,
    consts: [["fileupload", ""], [1, "columns"], [1, "column", "box"], [1, "box-title"], [3, "options", "import", "uploaded", 4, "ngIf"], [1, "columns-table", "column-padding"], [1, "columns", "columns-table-head", "is-mobile"], [1, "column", "is-hidden-mobile", "is-clickable", "is-3"], [1, "column", "is-hidden-mobile", "is-clickable", "is-1", "has-text-centered"], [1, "column", "is-hidden-mobile", "is-clickable", "has-text-centered"], ["class", "column is-hidden-mobile is-clickable is-1 has-text-centered", 4, "ngIf"], ["class", "columns-table-body columns is-multiline is-tablet", 4, "ngFor", "ngForOf"], [3, "import", "uploaded", "options"], [1, "fas", "fa-cog"], [1, "columns-table-body", "columns", "is-multiline", "is-tablet"], [1, "column", "is-3"], [1, "column", "is-1"], [1, "column"], ["class", "column is-1 has-text-centered", 4, "ngIf"], [1, "column", "is-1", "has-text-centered"], ["type", "button", "title", "Ta bort", 1, "button", "is-small", 3, "click"], [1, "fas", "fa-trash"]],
    template: function CertPinningFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
        i0.ɵɵtext(3, "Till\xE5tna klientcertifikat");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CertPinningFormComponent_file_upload_4_Template, 2, 1, "file-upload", 4);
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6)(7, "div", 7);
        i0.ɵɵtext(8, " Subjekt ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵtext(10, " Giltigt till ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵtext(12, " Senast anv\xE4nd ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵtext(14, " SHA256 Thumprint ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, CertPinningFormComponent_div_15_Template, 2, 0, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, CertPinningFormComponent_div_16_Template, 10, 9, "div", 11);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance(9);
        i0.ɵɵclassProp("is-7", ctx.readOnly)("is-6", !ctx.readOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.certPinning);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, UploadComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CertPinningFormComponent, [{
    type: Component,
    args: [{
      selector: 'cert-pinning',
      template: "<div class=\"columns\">\r\n  <div class=\"column box\">\r\n    <div class=\"box-title\">Till\u00E5tna klientcertifikat</div>\r\n    <file-upload *ngIf=\"!readOnly\" [options]=\"options\" (import)=\"importFile()\" (uploaded)=\"fileUploaded($event)\" #fileupload>\r\n    </file-upload>\r\n    <div class=\"columns-table column-padding\">\r\n      <div class=\"columns columns-table-head is-mobile\">\r\n        <div class=\"column is-hidden-mobile is-clickable is-3\">\r\n          Subjekt\r\n        </div>\r\n\r\n        <div class=\"column is-hidden-mobile is-clickable is-1 has-text-centered\">\r\n          Giltigt till\r\n        </div>\r\n\r\n        <div class=\"column is-hidden-mobile is-clickable is-1 has-text-centered\">\r\n          Senast anv\u00E4nd\r\n        </div>\r\n\r\n        <div class=\"column is-hidden-mobile is-clickable has-text-centered\" [class.is-7]=\"readOnly\" [class.is-6]=\"!readOnly\">\r\n          SHA256 Thumprint\r\n        </div>\r\n\r\n        <div *ngIf=\"!readOnly\" class=\"column is-hidden-mobile is-clickable is-1 has-text-centered\">\r\n          <span class=\"fas fa-cog\"></span>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"columns-table-body columns is-multiline is-tablet\" *ngFor=\"let certPin of certPinning\">\r\n        <div class=\"column is-3\">\r\n          {{ certPin.subject }}\r\n        </div>\r\n\r\n        <div class=\"column is-1\">\r\n          {{ certPin.notAfter }}\r\n        </div>\r\n\r\n        <div class=\"column is-1\">\r\n          {{ certPin.lastUsed }}\r\n        </div>\r\n\r\n        <div class=\"column\" [class.is-7]=\"readOnly\" [class.is-6]=\"!readOnly\">\r\n          {{ certPin.sha256Thumbprint }}\r\n        </div>\r\n\r\n        <div *ngIf=\"!readOnly\" class=\"column is-1 has-text-centered\">\r\n          <button type=\"button\" class=\"button is-small\" (click)=\"onDelete(certPin)\" title=\"Ta bort\">\r\n            <span class=\"fas fa-trash\"></span>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1$2.FormBuilder
  }, {
    type: MetadataService
  }], {
    readOnly: [{
      type: Input
    }],
    currentCertPins: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class WSClientFormComponent {
  fb;
  certPinningFormComponent;
  formSubmitted = new EventEmitter();
  cancel = new EventEmitter();
  metadata;
  readOnly;
  metadataForm;
  submitted = false;
  constructor(fb) {
    this.fb = fb;
  }
  ngOnChanges(changes) {
    this.initForm();
    if (this.readOnly) {
      this.metadataForm.disable();
    }
    this.formatMetadata(changes['metadata'].currentValue);
  }
  toggleDirectCalls() {
    if (!this.readOnly) {
      this.metadataForm.get('directCalls').setValue(!this.metadataForm.get('directCalls').value);
    }
  }
  initForm() {
    this.metadataForm = this.fb.group({
      id: [''],
      systemId: ['', Validators.required],
      systemName: ['', Validators.required],
      directCalls: [false],
      contacts: this.fb.array([this.fb.group({
        name: [''],
        email: [''],
        telephoneNumber: ['']
      })]),
      attributes: this.fb.array([this.fb.group({
        key: [''],
        value: ['']
      })])
    });
    this.submitted = false;
  }
  formatMetadata(metadata) {
    this.metadataForm.patchValue({
      id: metadata.id,
      systemId: metadata.systemId,
      systemName: metadata.systemName,
      directCalls: metadata.directCalls
    });
    if (metadata.contacts.length > 0) {
      const contacts = this.metadataForm.get('contacts');
      contacts.removeAt(0);
      for (const contact of metadata.contacts) {
        contacts.push(this.fb.group({
          name: [contact.name],
          email: [contact.email],
          telephoneNumber: [contact.telephoneNumber]
        }));
      }
    }
    if (metadata.attributes !== undefined || metadata.attributes !== null) {
      const attributes = this.metadataForm.get('attributes');
      let numAttributes = 0;
      attributes.removeAt(0);
      for (const attribute in metadata.attributes) {
        attributes.push(this.fb.group({
          key: attribute,
          value: metadata.attributes[attribute]
        }));
        numAttributes += 1;
      }
      if (numAttributes === 0) {
        this.addAttribute();
      }
    }
  }
  parseForm() {
    const formData = this.metadataForm.value;
    const metadata = {
      id: formData.id,
      systemId: formData.systemId,
      systemName: formData.systemName,
      directCalls: formData.directCalls,
      contacts: [],
      attributes: {},
      certPins: []
    };
    if (this.certPinningFormComponent.certPinning.length > 0) {
      metadata.certPins = this.certPinningFormComponent.certPinning;
    }
    for (const contact of formData.contacts) {
      if (this.isSet(contact.name) || this.isSet(contact.email) || this.isSet(contact.telephoneNumber)) {
        metadata.contacts.push(contact);
      }
    }
    for (const attribute in formData.attributes) {
      const value = formData.attributes[attribute].value;
      const key = formData.attributes[attribute].key;
      if (this.isSet(key) && this.isSet(value)) {
        metadata.attributes[key] = value;
      }
    }
    return metadata;
  }
  isSet(value) {
    if (value) {
      return value.trim() !== '';
    } else {
      return false;
    }
  }
  getContactControls() {
    return this.metadataForm.get('contacts').controls;
  }
  getAttributeControls() {
    return this.metadataForm.get('attributes').controls;
  }
  addContact() {
    const contacts = this.metadataForm.get('contacts');
    const contactGroup = this.fb.group({
      name: [''],
      email: [''],
      telephoneNumber: ['']
    });
    contacts.push(contactGroup);
  }
  removeContact(index) {
    const contacts = this.metadataForm.get('contacts');
    contacts.removeAt(index);
  }
  addAttribute() {
    const attributes = this.metadataForm.get('attributes');
    const attributeGroup = this.fb.group({
      key: [''],
      value: ['']
    });
    attributes.push(attributeGroup);
  }
  removeAttribute(index) {
    const attributes = this.metadataForm.get('attributes');
    attributes.removeAt(index);
  }
  cancelForm() {
    this.cancel.emit();
  }
  submitForm() {
    this.submitted = true;
    if (this.metadataForm.valid) {
      this.formSubmitted.emit(this.parseForm());
    }
  }
  static ɵfac = function WSClientFormComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WSClientFormComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WSClientFormComponent,
    selectors: [["ws-client-form"]],
    viewQuery: function WSClientFormComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(CertPinningFormComponent, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.certPinningFormComponent = _t.first);
      }
    },
    inputs: {
      metadata: "metadata",
      readOnly: "readOnly"
    },
    outputs: {
      formSubmitted: "formSubmitted",
      cancel: "cancel"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 62,
    vars: 15,
    consts: [[1, "columns"], [1, "column", "box"], ["class", "box-title", 4, "ngIf"], [3, "formGroup"], [1, "column", "has-text-right"], [1, "field"], ["label", "", 1, "has-text-weight-semibold"], ["type", "checkbox", "name", "directCalls", "checked", "checked", "formControlName", "directCalls", 1, "switch", "is-outlined", "is-primary"], ["id", "set-active-toggle", 3, "click"], [1, "column"], [1, "label", "is-small"], [1, "control"], ["formControlName", "systemId", "type", "text", "placeholder", "System Id", 1, "input", "is-small"], ["class", "help is-danger", 4, "ngIf"], ["formControlName", "systemName", "type", "text", "placeholder", "Systemnamn", 1, "input", "is-small"], [3, "readOnly", "currentCertPins"], [1, "box-title"], ["class", "box-help tooltip is-tooltip-left is-tooltip-multiline", "data-tooltip", "Minst ett v\xE4rde m\xE5ste fyllas i f\xF6r att en kontaktuppgift skall sparas.", 4, "ngIf"], ["formArrayName", "contacts", "aria-describedby", "#", 1, "table", "is-bordered", "is-narrow", "is-fullwidth", "has-add-button"], ["scope", "col"], ["scope", "col", "class", "has-text-centered is-small-actions-column", 4, "ngIf"], [3, "formGroupName", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["class", "box-help tooltip is-tooltip-left is-tooltip-multiline", "data-tooltip", "B\xE5de nyckel och v\xE4rde m\xE5ste anges f\xF6r att attribut skall sparas.", 4, "ngIf"], ["formArrayName", "attributes", "aria-describedby", "#", 1, "table", "is-bordered", "is-narrow", "is-fullwidth", "has-add-button"], ["class", "columns", 4, "ngIf"], [1, "help", "is-danger"], ["data-tooltip", "Minst ett v\xE4rde m\xE5ste fyllas i f\xF6r att en kontaktuppgift skall sparas.", 1, "box-help", "tooltip", "is-tooltip-left", "is-tooltip-multiline"], [1, "fas", "fa-question-circle"], ["scope", "col", 1, "has-text-centered", "is-small-actions-column"], [1, "fas", "fa-cog"], [3, "formGroupName"], ["formControlName", "name", "type", "text", "placeholder", "Namn", 1, "input", "is-small", 3, "readonly"], ["formControlName", "email", "type", "text", "placeholder", "Epost", 1, "input", "is-small", 3, "readonly"], ["formControlName", "telephoneNumber", "type", "text", "placeholder", "Telefon", 1, "input", "is-small", 3, "readonly"], ["class", "has-text-centered", 4, "ngIf"], [1, "has-text-centered"], ["type", "button", 1, "is-small", "button", "is-table-button", 3, "click"], [1, "fas", "fa-trash"], ["type", "button", 1, "button", "is-small", "is-fullwidth", 3, "click"], [1, "fas", "fa-plus"], ["data-tooltip", "B\xE5de nyckel och v\xE4rde m\xE5ste anges f\xF6r att attribut skall sparas.", 1, "box-help", "tooltip", "is-tooltip-left", "is-tooltip-multiline"], ["formControlName", "key", "type", "text", "placeholder", "Nyckel", 1, "input", "is-small", 3, "readonly"], ["formControlName", "value", "type", "text", "placeholder", "V\xE4rde", 1, "input", "is-small", 3, "readonly"], ["type", "button", 1, "button", "is-small", 3, "click"], ["type", "button", 1, "button", "is-primary", "is-small", "is-pulled-right", 3, "click"]],
    template: function WSClientFormComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, WSClientFormComponent_div_2_Template, 2, 0, "div", 2);
        i0.ɵɵelementStart(3, "form", 3)(4, "div", 0)(5, "div", 4)(6, "div", 5)(7, "span", 6);
        i0.ɵɵtext(8, "Direktanrop \xA0");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "input", 7);
        i0.ɵɵelementStart(10, "label", 8);
        i0.ɵɵlistener("click", function WSClientFormComponent_Template_label_click_10_listener() {
          return ctx.toggleDirectCalls();
        });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(11, "div", 0)(12, "div", 9)(13, "div", 5)(14, "label", 10);
        i0.ɵɵtext(15, "System ID");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 11);
        i0.ɵɵelement(17, "input", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, WSClientFormComponent_p_18_Template, 2, 0, "p", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 5)(20, "label", 10);
        i0.ɵɵtext(21, "Systemnamn");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 11);
        i0.ɵɵelement(23, "input", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, WSClientFormComponent_p_24_Template, 2, 0, "p", 13);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(25, "div", 0)(26, "div", 9);
        i0.ɵɵelement(27, "cert-pinning", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(28, "div", 0)(29, "div", 1)(30, "div", 16);
        i0.ɵɵtext(31, "Kontakter");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(32, WSClientFormComponent_div_32_Template, 2, 0, "div", 17);
        i0.ɵɵelementStart(33, "table", 18)(34, "thead")(35, "th", 19);
        i0.ɵɵtext(36, "Namn");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "th", 19);
        i0.ɵɵtext(38, "Epost");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "th", 19);
        i0.ɵɵtext(40, "Telefon");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(41, WSClientFormComponent_th_41_Template, 2, 0, "th", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "tbody");
        i0.ɵɵtemplate(43, WSClientFormComponent_tr_43_Template, 11, 5, "tr", 21);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(44, WSClientFormComponent_div_44_Template, 3, 0, "div", 22);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(45, "div", 0)(46, "div", 1)(47, "div", 16);
        i0.ɵɵtext(48, "Attribut");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(49, WSClientFormComponent_div_49_Template, 2, 0, "div", 23);
        i0.ɵɵelementStart(50, "table", 24)(51, "thead")(52, "tr")(53, "th", 19);
        i0.ɵɵtext(54, "Nyckel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "th", 19);
        i0.ɵɵtext(56, "V\xE4rde");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(57, WSClientFormComponent_th_57_Template, 2, 0, "th", 20);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(58, "tbody");
        i0.ɵɵtemplate(59, WSClientFormComponent_tr_59_Template, 8, 4, "tr", 21);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(60, WSClientFormComponent_div_60_Template, 3, 0, "div", 22);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(61, WSClientFormComponent_div_61_Template, 7, 0, "div", 25);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("formGroup", ctx.metadataForm);
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("ngIf", ctx.metadataForm.controls["systemId"].errors && ctx.submitted);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.metadataForm.controls["systemName"].errors && ctx.submitted);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("readOnly", ctx.readOnly)("currentCertPins", ctx.metadata.certPins);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.getContactControls());
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.getAttributeControls());
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.readOnly);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.CheckboxControlValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i1$2.FormControlName, i1$2.FormGroupName, i1$2.FormArrayName, CertPinningFormComponent],
    styles: ["[_nghost-%COMP%]{background-color:#000}[_nghost-%COMP%]   .is-table-button[_ngcontent-%COMP%]{font-size:1em;padding:1px .7em;height:2em;margin-left:.2em}[_nghost-%COMP%]   .is-table-button[_ngcontent-%COMP%]:last-child{margin-right:0}[_nghost-%COMP%]   .is-actions-column[_ngcontent-%COMP%]{width:120px}[_nghost-%COMP%]   .is-small-actions-column[_ngcontent-%COMP%]{width:60px}[_nghost-%COMP%]   .has-add-button[_ngcontent-%COMP%]{margin-bottom:0}[_nghost-%COMP%]   .button-icon-margin[_ngcontent-%COMP%]{margin-left:.5em}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WSClientFormComponent, [{
    type: Component,
    args: [{
      selector: 'ws-client-form',
      template: "<div class=\"columns\">\n  <div class=\"column box\">\n    <div *ngIf=\"!readOnly\" class=\"box-title\">Redigera WS klient</div>\n    <form [formGroup]=\"metadataForm\">\n\n      <div class=\"columns\">\n        <div class=\"column has-text-right\">\n          <div class=\"field\">\n            <span label class=\"has-text-weight-semibold\">Direktanrop &nbsp;</span>\n            <input type=\"checkbox\" name=\"directCalls\" class=\"switch is-outlined is-primary\" checked=\"checked\" formControlName=\"directCalls\">\n            <label id=\"set-active-toggle\" (click)=\"toggleDirectCalls()\"></label>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"columns\">\n        <div class=\"column\">\n          <div class=\"field\">\n            <label class=\"label is-small\">System ID</label>\n            <div class=\"control\">\n              <input formControlName=\"systemId\" class=\"input is-small\" type=\"text\" placeholder=\"System Id\">\n            </div>\n            <p *ngIf=\"metadataForm.controls['systemId'].errors && submitted\" class=\"help is-danger\">\n              System ID m\u00E5ste anges.\n            </p>\n          </div>\n          <div class=\"field\">\n            <label class=\"label is-small\">Systemnamn</label>\n            <div class=\"control\">\n              <input formControlName=\"systemName\" class=\"input is-small\" type=\"text\" placeholder=\"Systemnamn\">\n            </div>\n            <p *ngIf=\"metadataForm.controls['systemName'].errors && submitted\" class=\"help is-danger\">\n              Systemnamn m\u00E5ste anges.\n            </p>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"columns\">\n        <div class=\"column\">\n          <cert-pinning [readOnly]=\"readOnly\" [currentCertPins]=\"metadata.certPins\"></cert-pinning>\n        </div>\n      </div>\n\n      <div class=\"columns\">\n        <div class=\"column box\">\n          <div class=\"box-title\">Kontakter</div>\n          <div *ngIf=\"!readOnly\" class=\"box-help tooltip is-tooltip-left is-tooltip-multiline\"\n            data-tooltip=\"Minst ett v\u00E4rde m\u00E5ste fyllas i f\u00F6r att en kontaktuppgift skall sparas.\">\n            <span class=\"fas fa-question-circle\"></span>\n          </div>\n\n          <table formArrayName=\"contacts\" class=\"table is-bordered is-narrow is-fullwidth has-add-button\" aria-describedby=\"#\">\n            <thead>\n              <th scope=\"col\">Namn</th>\n              <th scope=\"col\">Epost</th>\n              <th scope=\"col\">Telefon</th>\n              <th *ngIf=\"!readOnly\" scope=\"col\" class=\"has-text-centered is-small-actions-column\">\n                <span class=\"fas fa-cog\"></span>\n              </th>\n            </thead>\n            <tbody>\n              <tr [formGroupName]=\"i\" *ngFor=\"let metadataContact of getContactControls(); let i = index;\">\n                <td>\n                  <div class=\"control\">\n                    <input formControlName=\"name\" [readonly]=\"readOnly\" class=\"input is-small\" type=\"text\" placeholder=\"Namn\">\n                  </div>\n                </td>\n                <td>\n                  <div class=\"control\">\n                    <input formControlName=\"email\" [readonly]=\"readOnly\" class=\"input is-small\" type=\"text\" placeholder=\"Epost\">\n                  </div>\n                </td>\n                <td>\n                  <div class=\"control\">\n                    <input formControlName=\"telephoneNumber\" [readonly]=\"readOnly\" class=\"input is-small\" type=\"text\" placeholder=\"Telefon\">\n                  </div>\n                </td>\n                <td *ngIf=\"!readOnly\" class=\"has-text-centered\">\n                  <button type=\"button\" class=\"is-small button is-table-button\" (click)=\"removeContact(i)\">\n                    <span class=\"fas fa-trash\"></span>\n                  </button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n          <div *ngIf=\"!readOnly\">\n            <button type=\"button\" class=\"button is-small is-fullwidth\" (click)=\"addContact()\">\n              <span class=\"fas fa-plus\"></span>\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"columns\">\n        <div class=\"column box\">\n          <div class=\"box-title\">Attribut</div>\n          <div *ngIf=\"!readOnly\" class=\"box-help tooltip is-tooltip-left is-tooltip-multiline\"\n            data-tooltip=\"B\u00E5de nyckel och v\u00E4rde m\u00E5ste anges f\u00F6r att attribut skall sparas.\">\n            <span class=\"fas fa-question-circle\"></span>\n          </div>\n\n          <table formArrayName=\"attributes\" class=\"table is-bordered is-narrow is-fullwidth has-add-button\" aria-describedby=\"#\">\n            <thead>\n              <tr>\n                <th scope=\"col\">Nyckel</th>\n                <th scope=\"col\">V\u00E4rde</th>\n                <th *ngIf=\"!readOnly\" scope=\"col\" class=\"has-text-centered is-small-actions-column\">\n                  <span class=\"fas fa-cog\"></span>\n                </th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr [formGroupName]=\"i\" *ngFor=\"let metadata of getAttributeControls(); let i = index;\">\n                <td>\n                  <div class=\"control\">\n                    <input formControlName=\"key\" [readonly]=\"readOnly\" class=\"input is-small\" type=\"text\" placeholder=\"Nyckel\">\n                  </div>\n                </td>\n                <td>\n                  <div class=\"control\">\n                    <input formControlName=\"value\" [readonly]=\"readOnly\" class=\"input is-small\" type=\"text\" placeholder=\"V\u00E4rde\">\n                  </div>\n                </td>\n                <td *ngIf=\"!readOnly\" class=\"has-text-centered\">\n                  <button type=\"button\" class=\"is-small button is-table-button\" (click)=\"removeAttribute(i)\">\n                    <span class=\"fas fa-trash\"></span>\n                  </button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n          <div *ngIf=\"!readOnly\">\n            <button type=\"button\" class=\"button is-small is-fullwidth\" (click)=\"addAttribute()\">\n              <span class=\"fas fa-plus\"></span>\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <div *ngIf=\"!readOnly\" class=\"columns\">\n        <div class=\"column\">\n          <button type=\"button\" class=\"button is-small\" (click)=\"cancelForm()\">\u00C5ngra</button>\n        </div>\n\n        <div class=\"column\">\n          <button type=\"button\" class=\"button is-primary is-small is-pulled-right\" (click)=\"submitForm()\">Spara</button>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>",
      styles: [":host{background-color:#000}:host .is-table-button{font-size:1em;padding:1px .7em;height:2em;margin-left:.2em}:host .is-table-button:last-child{margin-right:0}:host .is-actions-column{width:120px}:host .is-small-actions-column{width:60px}:host .has-add-button{margin-bottom:0}:host .button-icon-margin{margin-left:.5em}\n"]
    }]
  }], () => [{
    type: i1$2.FormBuilder
  }], {
    certPinningFormComponent: [{
      type: ViewChild,
      args: [CertPinningFormComponent]
    }],
    formSubmitted: [{
      type: Output
    }],
    cancel: [{
      type: Output
    }],
    metadata: [{
      type: Input
    }],
    readOnly: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ServicePlatformClientComponent {
  fb;
  addServiceConsumerModal;
  wsClientDetailsModal;
  certPinningFormComponent;
  formSubmitted = new EventEmitter();
  cancel = new EventEmitter();
  metadata;
  metadatas;
  metadataForm;
  submitted = false;
  servicePlatForm = false;
  selectedWSClient;
  selectedWSClients = [];
  serviceConsumerModalOptions = {
    showCloseButton: false,
    showRightButton: false
  };
  wsClientDetailsModalOptions = {
    showLeftButton: false,
    showRightButton: false,
    keyboardNav: false,
    width: '1000px'
  };
  constructor(fb) {
    this.fb = fb;
  }
  ngOnChanges(changes) {
    this.initForm();
    if (changes['metadata'] !== undefined) {
      this.formatMetadata(changes['metadata'].currentValue);
    }
  }
  initForm() {
    this.metadataForm = this.fb.group({
      id: [''],
      systemId: ['', Validators.required],
      systemName: ['', Validators.required],
      enabled: [false],
      attributes: this.fb.array([this.fb.group({
        key: [''],
        value: ['']
      })]),
      serviceConsumers: this.fb.array([this.fb.group({
        systemName: [''],
        systemId: [''],
        persistentId: ['']
      })])
    });
    this.submitted = false;
  }
  formatMetadata(metadata) {
    this.metadataForm.patchValue({
      id: metadata.id,
      systemId: metadata.systemId,
      systemName: metadata.systemName
    });
    if (metadata.attributes) {
      const attributes = this.metadataForm.get('attributes');
      let numAttributes = 0;
      attributes.removeAt(0);
      for (const attribute in metadata.attributes) {
        attributes.push(this.fb.group({
          key: attribute,
          value: metadata.attributes[attribute]
        }));
        numAttributes += 1;
      }
      if (numAttributes === 0) {
        this.addAttribute();
      }
    }
    if (metadata.serviceConsumers !== null && metadata.attributes !== undefined && metadata.serviceConsumers.length > 0) {
      const serviceConsumersFormArray = this.metadataForm.get('serviceConsumers');
      serviceConsumersFormArray.removeAt(0);
      for (const serviceConsumer of metadata.serviceConsumers) {
        const selectedWSClient = this.filterWSClient(serviceConsumer, this.metadatas, true);
        this.selectedWSClients.push(selectedWSClient);
        serviceConsumersFormArray.push(this.fb.group({
          systemName: [selectedWSClient.systemName],
          systemId: [selectedWSClient.systemId],
          persistentId: [selectedWSClient.id]
        }));
      }
    }
  }
  parseForm() {
    const formData = this.metadataForm.value;
    const metadata = {
      id: formData.id,
      systemId: formData.systemId,
      systemName: formData.systemName,
      directCalls: null,
      contacts: [],
      attributes: {},
      serviceConsumers: [],
      certPins: []
    };
    if (this.certPinningFormComponent.certPinning.length > 0) {
      metadata.certPins = this.certPinningFormComponent.certPinning;
    }
    if (formData.serviceConsumers !== null && formData.serviceConsumers.length > 0) {
      for (const serviceConsumer of formData.serviceConsumers) {
        if (this.isSet(serviceConsumer.systemId) && this.isSet(serviceConsumer.systemName)) {
          metadata.serviceConsumers.push(serviceConsumer.persistentId);
        }
      }
    }
    for (const attribute in formData.attributes) {
      const value = formData.attributes[attribute].value;
      const key = formData.attributes[attribute].key;
      if (this.isSet(key) && this.isSet(value)) {
        metadata.attributes[key] = value;
      }
    }
    return metadata;
  }
  getAttributeControls() {
    return this.metadataForm.get('attributes').controls;
  }
  addAttribute() {
    const attributes = this.metadataForm.get('attributes');
    const attributeGroup = this.fb.group({
      key: [''],
      value: ['']
    });
    attributes.push(attributeGroup);
  }
  removeAttribute(index) {
    const attributes = this.metadataForm.get('attributes');
    attributes.removeAt(index);
  }
  getServiceConsumerControls() {
    return this.metadataForm.get('serviceConsumers').controls;
  }
  addServiceConsumer(event) {
    const persistentId = event.target.value;
    const selectedServiceConsumer = this.filterWSClient(persistentId, this.metadatas, true);
    const serviceConsumersFormArray = this.metadataForm.get('serviceConsumers');
    if (this.selectedWSClients.length === 0) {
      // delete the placeholder row
      serviceConsumersFormArray.removeAt(0);
    }
    this.selectedWSClients.push(selectedServiceConsumer);
    const serviceConsumerGroup = this.fb.group({
      systemName: [selectedServiceConsumer.systemName],
      systemId: [selectedServiceConsumer.systemId],
      persistentId: [selectedServiceConsumer.id]
    });
    serviceConsumersFormArray.push(serviceConsumerGroup);
    // close the selection window
    this.addServiceConsumerModal.close();
  }
  removeServiceConsumer(index, wsClient) {
    const serviceConsumersFormArray = this.metadataForm.get('serviceConsumers');
    this.removeSelectedServiceConsumer(wsClient.value.persistentId);
    serviceConsumersFormArray.removeAt(index);
  }
  setSelectedWSClient(wsClient) {
    this.selectedWSClient = this.filterWSClient(wsClient.value.persistentId, this.selectedWSClients, false);
    this.wsClientDetailsModal.open();
  }
  closeWSDetails() {
    this.selectedWSClient = null;
    this.wsClientDetailsModal.close();
  }
  cancelForm() {
    this.cancel.emit();
  }
  submitForm() {
    this.submitted = true;
    if (this.metadataForm.valid) {
      this.formSubmitted.emit(this.parseForm());
    }
  }
  removeSelectedServiceConsumer(persistentId) {
    const deselectedWsClient = this.filterWSClient(persistentId, this.selectedWSClients, true);
    this.metadatas.push(deselectedWsClient);
  }
  isSet(value) {
    if (value) {
      return value.trim() !== '';
    } else {
      return false;
    }
  }
  filterWSClient(persistentId, wsClients, deleteFromArray) {
    const index = wsClients.findIndex(wsClient => wsClient.id === persistentId);
    if (deleteFromArray) {
      return wsClients.splice(index, 1)[0];
    } else {
      return wsClients[index];
    }
  }
  static ɵfac = function ServicePlatformClientComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ServicePlatformClientComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ServicePlatformClientComponent,
    selectors: [["service-platform-client-form"]],
    viewQuery: function ServicePlatformClientComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c26, 5);
        i0.ɵɵviewQuery(_c27, 5);
        i0.ɵɵviewQuery(CertPinningFormComponent, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addServiceConsumerModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wsClientDetailsModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.certPinningFormComponent = _t.first);
      }
    },
    inputs: {
      metadata: "metadata",
      metadatas: "metadatas"
    },
    outputs: {
      formSubmitted: "formSubmitted",
      cancel: "cancel"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 78,
    vars: 14,
    consts: [["addServiceConsumerModal", ""], ["wsClientDetailsModal", ""], [1, "columns"], [1, "column", "box"], [1, "box-title"], [3, "formGroup"], [1, "column"], [1, "field"], [1, "label", "is-small"], [1, "control"], ["formControlName", "systemId", "type", "text", "placeholder", "System Id", 1, "input", "is-small"], ["class", "help is-danger", 4, "ngIf"], ["formControlName", "systemName", "type", "text", "placeholder", "Systemnamn", 1, "input", "is-small"], [3, "readOnly", "currentCertPins"], ["data-tooltip", "Listar tj\xE4nstekonsumenter i vilka specialregler kan konfigureras.\n            Default \xE4r att anv\xE4nda den aktuella tj\xE4nsteplattformens eventuella regler.", 1, "box-help", "tooltip", "is-tooltip-left", "is-tooltip-multiline"], [1, "fas", "fa-question-circle"], ["formArrayName", "serviceConsumers", "summary", "Attributes table", 1, "table", "is-bordered", "is-narrow", "is-fullwidth", "has-add-button"], ["scope", "col"], ["scope", "col", 1, "has-text-centered", "is-actions-column"], [1, "fas", "fa-cog"], [3, "formGroupName", 4, "ngFor", "ngForOf"], ["type", "button", 1, "button", "is-small", "is-fullwidth", 3, "click"], [1, "fas", "fa-plus"], ["data-tooltip", "B\xE5de nyckel och v\xE4rde m\xE5ste anges f\xF6r att attribut skall sparas.", 1, "box-help", "tooltip", "is-tooltip-left", "is-tooltip-multiline"], ["formArrayName", "attributes", "summary", "Attributes table", 1, "table", "is-bordered", "is-narrow", "is-fullwidth", "has-add-button"], ["scope", "col", 1, "has-text-centered", "is-small-actions-column"], ["type", "button", 1, "button", "is-small", 3, "click"], ["type", "button", 1, "button", "is-primary", "is-small", "is-pulled-right", 3, "click"], [3, "title", "options"], [1, "control", "is-expanded"], [1, "select", "is-fullwidth"], [3, "change"], [3, "value"], [3, "value", 4, "ngFor", "ngForOf"], ["class", "column", 4, "ngIf"], [1, "help", "is-danger"], [3, "formGroupName"], ["formControlName", "systemId", "type", "text", "placeholder", "System ID", 1, "input", "is-small", 3, "readonly"], ["formControlName", "systemName", "type", "text", "placeholder", "Systemnamn", 1, "input", "is-small", 3, "readonly"], [1, "has-text-centered"], ["type", "button", 1, "is-small", "button", "is-table-button", 3, "click"], [1, "fas", "fa-info-circle"], [1, "fas", "fa-trash"], ["formControlName", "key", "type", "text", "placeholder", "Nyckel", 1, "input", "is-small"], ["formControlName", "value", "type", "text", "placeholder", "V\xE4rde", 1, "input", "is-small"], [3, "cancel", "metadata", "readOnly"]],
    template: function ServicePlatformClientComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
        i0.ɵɵtext(3, "Redigera tj\xE4nsteplattform klient");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "form", 5)(5, "div", 2)(6, "div", 6)(7, "div", 7)(8, "label", 8);
        i0.ɵɵtext(9, "System ID");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵelement(11, "input", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, ServicePlatformClientComponent_p_12_Template, 2, 0, "p", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 7)(14, "label", 8);
        i0.ɵɵtext(15, "Systemnamn");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 9);
        i0.ɵɵelement(17, "input", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, ServicePlatformClientComponent_p_18_Template, 2, 0, "p", 11);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(19, "div", 2)(20, "div", 6);
        i0.ɵɵelement(21, "cert-pinning", 13);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(22, "div", 2)(23, "div", 3)(24, "div", 4);
        i0.ɵɵtext(25, "Tj\xE4nstekonsumenter");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 14);
        i0.ɵɵelement(27, "i", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "table", 16)(29, "thead")(30, "tr")(31, "th", 17);
        i0.ɵɵtext(32, "System ID");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "th", 17);
        i0.ɵɵtext(34, "Systemnamn");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "th", 18);
        i0.ɵɵelement(36, "i", 19);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(37, "tbody");
        i0.ɵɵtemplate(38, ServicePlatformClientComponent_tr_38_Template, 12, 3, "tr", 20);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(39, "button", 21);
        i0.ɵɵlistener("click", function ServicePlatformClientComponent_Template_button_click_39_listener() {
          i0.ɵɵrestoreView(_r1);
          const addServiceConsumerModal_r7 = i0.ɵɵreference(68);
          return i0.ɵɵresetView(addServiceConsumerModal_r7.open());
        });
        i0.ɵɵelement(40, "i", 22);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(41, "div", 2)(42, "div", 3)(43, "div", 4);
        i0.ɵɵtext(44, "Attribut");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 23);
        i0.ɵɵelement(46, "i", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "table", 24)(48, "thead")(49, "tr")(50, "th", 17);
        i0.ɵɵtext(51, "Nyckel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(52, "th", 17);
        i0.ɵɵtext(53, "V\xE4rde");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "th", 25);
        i0.ɵɵelement(55, "i", 19);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(56, "tbody");
        i0.ɵɵtemplate(57, ServicePlatformClientComponent_tr_57_Template, 10, 1, "tr", 20);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(58, "button", 21);
        i0.ɵɵlistener("click", function ServicePlatformClientComponent_Template_button_click_58_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.addAttribute());
        });
        i0.ɵɵelement(59, "i", 22);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(60, "div", 2)(61, "div", 6)(62, "button", 26);
        i0.ɵɵlistener("click", function ServicePlatformClientComponent_Template_button_click_62_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.cancelForm());
        });
        i0.ɵɵtext(63, "\xC5ngra");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(64, "div", 6)(65, "button", 27);
        i0.ɵɵlistener("click", function ServicePlatformClientComponent_Template_button_click_65_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.submitForm());
        });
        i0.ɵɵtext(66, "Spara");
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementStart(67, "modal", 28, 0)(69, "div", 29)(70, "div", 30)(71, "select", 31);
        i0.ɵɵlistener("change", function ServicePlatformClientComponent_Template_select_change_71_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.addServiceConsumer($event));
        });
        i0.ɵɵelementStart(72, "option", 32);
        i0.ɵɵtext(73, "[V\xE4lj tj\xE4nstekonsument]");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(74, ServicePlatformClientComponent_option_74_Template, 2, 2, "option", 33);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(75, "modal", 28, 1);
        i0.ɵɵtemplate(77, ServicePlatformClientComponent_div_77_Template, 2, 2, "div", 34);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("formGroup", ctx.metadataForm);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.metadataForm.controls["systemId"].errors && ctx.submitted);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.metadataForm.controls["systemName"].errors && ctx.submitted);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("readOnly", false)("currentCertPins", ctx.metadata.certPins);
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("ngForOf", ctx.getServiceConsumerControls());
        i0.ɵɵadvance(19);
        i0.ɵɵproperty("ngForOf", ctx.getAttributeControls());
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("title", "L\xE4gg till tj\xE4nstekonsument")("options", ctx.serviceConsumerModalOptions);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("value", "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.metadatas);
        i0.ɵɵadvance();
        i0.ɵɵproperty("title", "Tj\xE4nstekonsumentsdetaljer")("options", ctx.wsClientDetailsModalOptions);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectedWSClient);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i1$2.ɵNgNoValidate, i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormGroupDirective, i1$2.FormControlName, i1$2.FormGroupName, i1$2.FormArrayName, ModalComponent, WSClientFormComponent, CertPinningFormComponent],
    styles: [_c28]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ServicePlatformClientComponent, [{
    type: Component,
    args: [{
      selector: 'service-platform-client-form',
      template: "<div class=\"columns\">\r\n  <div class=\"column box\">\r\n    <div class=\"box-title\">Redigera tj\u00E4nsteplattform klient</div>\r\n    <form [formGroup]=\"metadataForm\">\r\n      <div class=\"columns\">\r\n        <div class=\"column\">\r\n          <div class=\"field\">\r\n            <label class=\"label is-small\">System ID</label>\r\n            <div class=\"control\">\r\n              <input formControlName=\"systemId\" class=\"input is-small\" type=\"text\" placeholder=\"System Id\">\r\n            </div>\r\n            <p *ngIf=\"metadataForm.controls['systemId'].errors && submitted\" class=\"help is-danger\">\r\n              System ID m\u00E5ste anges.\r\n            </p>\r\n          </div>\r\n          <div class=\"field\">\r\n            <label class=\"label is-small\">Systemnamn</label>\r\n            <div class=\"control\">\r\n              <input formControlName=\"systemName\" class=\"input is-small\" type=\"text\" placeholder=\"Systemnamn\">\r\n            </div>\r\n            <p *ngIf=\"metadataForm.controls['systemName'].errors && submitted\" class=\"help is-danger\">\r\n              Systemnamn m\u00E5ste anges.\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"columns\">\r\n        <div class=\"column\">\r\n          <cert-pinning [readOnly]=\"false\" [currentCertPins]=\"metadata.certPins\"></cert-pinning>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"columns\">\r\n        <div class=\"column box\">\r\n          <div class=\"box-title\">Tj\u00E4nstekonsumenter</div>\r\n\r\n          <div data-tooltip=\"Listar tj\u00E4nstekonsumenter i vilka specialregler kan konfigureras.\r\n            Default \u00E4r att anv\u00E4nda den aktuella tj\u00E4nsteplattformens eventuella regler.\"\r\n            class=\"box-help tooltip is-tooltip-left is-tooltip-multiline\">\r\n            <i class=\"fas fa-question-circle\"></i>\r\n          </div>\r\n\r\n          <table formArrayName=\"serviceConsumers\" class=\"table is-bordered is-narrow is-fullwidth has-add-button\"\r\n            summary=\"Attributes table\">\r\n            <thead>\r\n              <tr>\r\n                <th scope=\"col\">System ID</th>\r\n                <th scope=\"col\">Systemnamn</th>\r\n                <th scope=\"col\" class=\"has-text-centered is-actions-column\"><i class=\"fas fa-cog\"></i></th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr [formGroupName]=\"i\" *ngFor=\"let metadata of getServiceConsumerControls(); let i = index;\">\r\n                <td>\r\n                  <div class=\"control\">\r\n                    <input formControlName=\"systemId\" [readonly]=true class=\"input is-small\" type=\"text\" placeholder=\"System ID\">\r\n                  </div>\r\n                </td>\r\n                <td>\r\n                  <div class=\"control\">\r\n                    <input formControlName=\"systemName\" [readonly]=true class=\"input is-small\" type=\"text\" placeholder=\"Systemnamn\">\r\n                  </div>\r\n                </td>\r\n                <td class=\"has-text-centered\">\r\n                  <button type=\"button\" class=\"is-small button is-table-button\" (click)=\"setSelectedWSClient(metadata)\">\r\n                    <i class=\"fas fa-info-circle\"></i>\r\n                  </button>\r\n                  <button type=\"button\" class=\"is-small button is-table-button\" (click)=\"removeServiceConsumer(i, metadata)\">\r\n                    <i class=\"fas fa-trash\"></i>\r\n                  </button>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n          <button type=\"button\" class=\"button is-small is-fullwidth\" (click)=\"addServiceConsumerModal.open()\">\r\n            <i class=\"fas fa-plus\"></i>\r\n          </button>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"columns\">\r\n        <div class=\"column box\">\r\n          <div class=\"box-title\">Attribut</div>\r\n          <div class=\"box-help tooltip is-tooltip-left is-tooltip-multiline\"\r\n            data-tooltip=\"B\u00E5de nyckel och v\u00E4rde m\u00E5ste anges f\u00F6r att attribut skall sparas.\">\r\n            <i class=\"fas fa-question-circle\"></i>\r\n          </div>\r\n\r\n          <table formArrayName=\"attributes\" class=\"table is-bordered is-narrow is-fullwidth has-add-button\" summary=\"Attributes table\">\r\n            <thead>\r\n              <tr>\r\n                <th scope=\"col\">Nyckel</th>\r\n                <th scope=\"col\">V\u00E4rde</th>\r\n                <th scope=\"col\" class=\"has-text-centered is-small-actions-column\">\r\n                  <i class=\"fas fa-cog\"></i>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr [formGroupName]=\"i\" *ngFor=\"let metadata of getAttributeControls(); let i = index;\">\r\n                <td>\r\n                  <div class=\"control\">\r\n                    <input formControlName=\"key\" class=\"input is-small\" type=\"text\" placeholder=\"Nyckel\">\r\n                  </div>\r\n                </td>\r\n                <td>\r\n                  <div class=\"control\">\r\n                    <input formControlName=\"value\" class=\"input is-small\" type=\"text\" placeholder=\"V\u00E4rde\">\r\n                  </div>\r\n                </td>\r\n                <td class=\"has-text-centered\">\r\n                  <button type=\"button\" class=\"is-small button is-table-button\" (click)=\"removeAttribute(i)\">\r\n                    <i class=\"fas fa-trash\"></i>\r\n                  </button>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n          <button type=\"button\" class=\"button is-small is-fullwidth\" (click)=\"addAttribute()\">\r\n            <i class=\"fas fa-plus\"></i>\r\n          </button>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"columns\">\r\n        <div class=\"column\">\r\n          <button type=\"button\" class=\"button is-small\" (click)=\"cancelForm()\">\u00C5ngra</button>\r\n        </div>\r\n\r\n        <div class=\"column\">\r\n          <button type=\"button\" class=\"button is-primary is-small is-pulled-right\" (click)=\"submitForm()\">Spara</button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</div>\r\n\r\n<modal [title]=\"'L\u00E4gg till tj\u00E4nstekonsument'\" [options]=\"serviceConsumerModalOptions\" #addServiceConsumerModal>\r\n  <div class=\"control is-expanded\">\r\n    <div class=\"select is-fullwidth\">\r\n      <select (change)=\"addServiceConsumer($event)\">\r\n        <option [value]=\"''\">[V\u00E4lj tj\u00E4nstekonsument]</option>\r\n        <option *ngFor=\"let metadata of metadatas\" [value]=\"metadata.id\">{{ metadata.systemName }}\r\n        </option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n</modal>\r\n\r\n<modal [title]=\"'Tj\u00E4nstekonsumentsdetaljer'\" [options]=\"wsClientDetailsModalOptions\" #wsClientDetailsModal>\r\n  <div *ngIf=\"selectedWSClient\" class=\"column\">\r\n    <ws-client-form [metadata]=\"selectedWSClient\" [readOnly]=\"true\" (cancel)=\"closeWSDetails()\"></ws-client-form>\r\n  </div>\r\n</modal>\r\n",
      styles: [":host{background-color:#000}:host .is-table-button{font-size:1em;padding:1px .7em;height:2em;margin-left:.2em}:host .is-table-button:last-child{margin-right:0}:host .is-actions-column{width:120px}:host .is-small-actions-column{width:60px}:host .has-add-button{margin-bottom:0}:host .button-icon-margin{margin-left:.5em}\n"]
    }]
  }], () => [{
    type: i1$2.FormBuilder
  }], {
    addServiceConsumerModal: [{
      type: ViewChild,
      args: ['addServiceConsumerModal']
    }],
    wsClientDetailsModal: [{
      type: ViewChild,
      args: ['wsClientDetailsModal']
    }],
    certPinningFormComponent: [{
      type: ViewChild,
      args: [CertPinningFormComponent]
    }],
    formSubmitted: [{
      type: Output
    }],
    cancel: [{
      type: Output
    }],
    metadata: [{
      type: Input
    }],
    metadatas: [{
      type: Input
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class ServicePlatformComponent {
  dialogService;
  metadataService;
  saveSuccess = new EventEmitter();
  selectedServicePlatform;
  servicePlatforms = [];
  wsClients = [];
  constructor(dialogService, metadataService) {
    this.dialogService = dialogService;
    this.metadataService = metadataService;
  }
  ngOnInit() {
    this.fetchServicePlatforms();
  }
  fetchServicePlatforms() {
    this.metadataService.getServicePlatforms().subscribe(servicePlatforms => {
      this.servicePlatforms = servicePlatforms;
    });
  }
  addServicePlatform() {
    this.selectedServicePlatform = {
      id: '',
      directCalls: null,
      systemId: '',
      systemName: '',
      contacts: [],
      attributes: {},
      serviceConsumers: []
    };
    this.metadataService.getMetadata().subscribe(wsClients => {
      this.wsClients = wsClients;
    });
  }
  onSelect(selected) {
    this.metadataService.getMetadata().subscribe(wsClients => {
      this.wsClients = wsClients;
      this.selectedServicePlatform = selected;
    });
  }
  onDelete(servicePlatform) {
    this.dialogService.open({
      title: 'Radera',
      message: 'Är du säker på att du vill ta bort metadata med System ID ' + servicePlatform.systemId
    }).subscribe(confirmed => {
      if (confirmed) {
        this.deleteServicePlatform(servicePlatform);
      }
    });
  }
  saveServicePlatform(servicePlatform) {
    if (servicePlatform.systemId != null) {
      this.metadataService.saveServicePlatform(servicePlatform).subscribe(result => {
        this.saveSuccess.emit('Tjänsteplattformen sparades.');
        this.cancelServicePlatform();
        this.fetchServicePlatforms();
      });
    }
  }
  deleteServicePlatform(servicePlatform) {
    this.metadataService.deleteServicePlatform(servicePlatform.id).subscribe(result => {
      this.saveSuccess.emit('Tjänsteplattformen borttagen.');
      this.fetchServicePlatforms();
    });
  }
  cancelServicePlatform() {
    this.selectedServicePlatform = null;
  }
  static ɵfac = function ServicePlatformComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ServicePlatformComponent)(i0.ɵɵdirectiveInject(DialogService), i0.ɵɵdirectiveInject(MetadataService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ServicePlatformComponent,
    selectors: [["service-platform-client"]],
    outputs: {
      saveSuccess: "saveSuccess"
    },
    standalone: false,
    decls: 2,
    vars: 2,
    consts: [["class", "columns", 4, "ngIf"], [1, "columns"], [1, "column", "box"], [1, "box-title"], ["summary", "Metadata f\xF6r tj\xE4nsteplattformar", 1, "table", "is-bordered", "is-narrow", "is-striped", "is-fullwidth"], ["scope", "col"], ["scope", "col", 1, "has-text-centered", "is-actions-column"], [1, "fas", "fa-cog"], [4, "ngFor", "ngForOf"], [1, "column"], ["type", "button", 1, "button", "is-small", "is-pulled-right", 3, "click"], [1, "fas", "fa-plus", "button-icon-margin"], [1, "has-text-centered"], ["type", "button", 1, "button", "is-table-button", 3, "click"], [1, "fas", "fa-edit"], [1, "fas", "fa-trash"], [3, "cancel", "formSubmitted", "metadata", "metadatas"]],
    template: function ServicePlatformComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, ServicePlatformComponent_div_0_Template, 20, 1, "div", 0)(1, ServicePlatformComponent_div_1_Template, 3, 2, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.selectedServicePlatform);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selectedServicePlatform);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, ServicePlatformClientComponent],
    styles: [_c28]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ServicePlatformComponent, [{
    type: Component,
    args: [{
      selector: 'service-platform-client',
      template: "<div *ngIf=\"!selectedServicePlatform\" class=\"columns\">\r\n  <div class=\"column box\">\r\n    <div class=\"box-title\">Metadata f\u00F6r tj\u00E4nsteplattformar</div>\r\n\r\n    <table class=\"table is-bordered is-narrow is-striped is-fullwidth\" summary=\"Metadata f\u00F6r tj\u00E4nsteplattformar\">\r\n      <thead>\r\n        <tr>\r\n          <th scope=\"col\">System ID</th>\r\n          <th scope=\"col\">Systemnamn</th>\r\n          <th scope=\"col\" class=\"has-text-centered is-actions-column\"><i class=\"fas fa-cog\"></i></th>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr *ngFor=\"let servicePlatform of servicePlatforms\">\r\n          <td>{{ servicePlatform.systemId }}</td>\r\n          <td>{{ servicePlatform.systemName }}</td>\r\n          <td class=\"has-text-centered\">\r\n            <button type=\"button\" class=\"button is-table-button\" (click)=\"onSelect(servicePlatform)\">\r\n              <i class=\"fas fa-edit\"></i>\r\n            </button>\r\n            <button type=\"button\" class=\"button is-table-button\" (click)=\"onDelete(servicePlatform)\">\r\n              <i class=\"fas fa-trash\"></i>\r\n            </button>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n\r\n    <div class=\"columns\">\r\n      <div class=\"column\">\r\n        <button type=\"button\" class=\"button is-small is-pulled-right\" (click)=\"addServicePlatform()\">\r\n          L\u00E4gg till\r\n          <i class=\"fas fa-plus button-icon-margin\"></i>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"selectedServicePlatform\" class=\"columns\">\r\n  <div class=\"column\">\r\n    <service-platform-client-form [metadata]=\"selectedServicePlatform\" [metadatas]=\"wsClients\" (cancel)=\"cancelServicePlatform()\"\r\n      (formSubmitted)=\"saveServicePlatform($event)\"></service-platform-client-form>\r\n  </div>\r\n</div>\r\n",
      styles: [":host{background-color:#000}:host .is-table-button{font-size:1em;padding:1px .7em;height:2em;margin-left:.2em}:host .is-table-button:last-child{margin-right:0}:host .is-actions-column{width:120px}:host .is-small-actions-column{width:60px}:host .has-add-button{margin-bottom:0}:host .button-icon-margin{margin-left:.5em}\n"]
    }]
  }], () => [{
    type: DialogService
  }, {
    type: MetadataService
  }], {
    saveSuccess: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class WSClientComponent {
  dialogService;
  metadataService;
  saveSuccess = new EventEmitter();
  selectedWSClient;
  clients = [];
  loading = false;
  constructor(dialogService, metadataService) {
    this.dialogService = dialogService;
    this.metadataService = metadataService;
  }
  ngOnInit() {
    this.fetchClients();
  }
  fetchClients() {
    this.loading = true;
    this.metadataService.getMetadata().subscribe(result => {
      this.clients = result;
      this.loading = false;
    });
  }
  addClient() {
    this.selectedWSClient = {
      id: null,
      directCalls: false,
      systemId: '',
      systemName: '',
      contacts: [],
      attributes: {}
    };
  }
  isActive(wsClient) {
    return wsClient.directCalls ? 'Ja' : 'Nej';
  }
  selectClient(selected) {
    this.selectedWSClient = selected;
  }
  saveClient(client) {
    if (client.systemId != null) {
      this.metadataService.postMetadata(client).subscribe(result => {
        this.saveSuccess.emit('WS klient sparades.');
        this.cancelClient();
        this.fetchClients();
      });
    }
  }
  deleteClient(client) {
    this.metadataService.deleteMetadata(client.id).subscribe(result => {
      this.saveSuccess.emit('WS klient borttagen.');
      this.fetchClients();
    });
  }
  onDelete(client) {
    this.dialogService.open({
      title: 'Radera',
      message: 'Är du säker på att du vill ta bort metadata med System ID ' + client.systemId
    }).subscribe(confirmed => {
      if (confirmed) {
        this.deleteClient(client);
      }
    });
  }
  cancelClient() {
    this.selectedWSClient = null;
  }
  static ɵfac = function WSClientComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WSClientComponent)(i0.ɵɵdirectiveInject(DialogService), i0.ɵɵdirectiveInject(MetadataService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WSClientComponent,
    selectors: [["ws-client"]],
    outputs: {
      saveSuccess: "saveSuccess"
    },
    standalone: false,
    decls: 2,
    vars: 2,
    consts: [["class", "columns", 4, "ngIf"], [1, "columns"], [1, "column", "box"], [1, "box-title"], ["aria-describedby", "#", 1, "table", "is-bordered", "is-narrow", "is-striped", "is-fullwidth"], ["scope", "col"], ["scope", "col", 1, "has-text-centered", "is-actions-column"], [1, "fas", "fa-cog"], [4, "ngFor", "ngForOf"], [1, "column"], ["type", "button", 1, "button", "is-small", "is-pulled-right", 3, "click"], [1, "fas", "fa-plus", "button-icon-margin"], [1, "has-text-centered"], ["type", "button", 1, "button", "is-table-button", 3, "click"], [1, "fas", "fa-edit"], [1, "fas", "fa-trash"], [3, "cancel", "formSubmitted", "metadata", "readOnly"]],
    template: function WSClientComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, WSClientComponent_div_0_Template, 22, 1, "div", 0)(1, WSClientComponent_div_1_Template, 3, 2, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.selectedWSClient);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selectedWSClient);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, WSClientFormComponent],
    styles: [_c28]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WSClientComponent, [{
    type: Component,
    args: [{
      selector: 'ws-client',
      template: "<div *ngIf=\"!selectedWSClient\" class=\"columns\">\n  <div class=\"column box\">\n    <div class=\"box-title\">Metadata f\u00F6r webbserviceklienter</div>\n\n    <table class=\"table is-bordered is-narrow is-striped is-fullwidth\" aria-describedby=\"#\">\n      <thead>\n        <tr>\n          <th scope=\"col\">System ID</th>\n          <th scope=\"col\">Systemnamn</th>\n          <th scope=\"col\">Till\u00E5ts direktanrop</th>\n          <th scope=\"col\" class=\"has-text-centered is-actions-column\">\n            <span class=\"fas fa-cog\"></span>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngFor=\"let client of clients\">\n          <td>{{ client.systemId }}</td>\n          <td>{{ client.systemName }}</td>\n          <td>{{ isActive(client) }}</td>\n          <td class=\"has-text-centered\">\n            <button type=\"button\" class=\"button is-table-button\" (click)=\"selectClient(client)\">\n              <span class=\"fas fa-edit\"></span>\n            </button>\n            <button type=\"button\" class=\"button is-table-button\" (click)=\"onDelete(client)\">\n              <span class=\"fas fa-trash\"></span>\n            </button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n    <div class=\"columns\">\n      <div class=\"column\">\n        <button type=\"button\" class=\"button is-small is-pulled-right\" (click)=\"addClient()\">\n          L\u00E4gg till\n          <span class=\"fas fa-plus button-icon-margin\"></span>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"selectedWSClient\" class=\"columns\">\n  <div class=\"column\">\n    <ws-client-form [metadata]=\"selectedWSClient\" [readOnly]=\"false\" (cancel)=\"cancelClient()\" (formSubmitted)=\"saveClient($event)\">\n    </ws-client-form>\n  </div>\n</div>\n",
      styles: [":host{background-color:#000}:host .is-table-button{font-size:1em;padding:1px .7em;height:2em;margin-left:.2em}:host .is-table-button:last-child{margin-right:0}:host .is-actions-column{width:120px}:host .is-small-actions-column{width:60px}:host .has-add-button{margin-bottom:0}:host .button-icon-margin{margin-left:.5em}\n"]
    }]
  }], () => [{
    type: DialogService
  }, {
    type: MetadataService
  }], {
    saveSuccess: [{
      type: Output
    }]
  });
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */
class WSClientModule {
  static ɵfac = function WSClientModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WSClientModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: WSClientModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [MetadataService],
    imports: [CommonModule, ReactiveFormsModule, ModalModule, UploadModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WSClientModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, ModalModule, UploadModule],
      declarations: [ServicePlatformComponent, ServicePlatformClientComponent, WSClientComponent, WSClientFormComponent, CertPinningFormComponent],
      providers: [MetadataService],
      exports: [ServicePlatformComponent, WSClientComponent]
    }]
  }], null, null);
})();

/*
 * Copyright (C) 2019 Inera
 *
 * This file is a part of Inera common library.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApplicationInfoService, AsyncPaginationComponent, AuthenticateGuard, AuthorizeContextDirective, AuthorizeDisableReadDirective, AuthorizeDisableReadWriteDirective, AuthorizeDisableWriteDirective, AuthorizeInfoReadDirective, AuthorizeInfoReadWriteDirective, AuthorizeInfoWriteDirective, AuthorizeModule, AuthorizeReadDirective, AuthorizeReadWriteDirective, AuthorizeStyleReadDirective, AuthorizeStyleReadWriteDirective, AuthorizeStyleWriteDirective, AuthorizeWriteDirective, BrowserGuard, CertificateManagerComponent, CertificateManagerModule, CertificateMonitorComponent, CertificateMonitorManagerModule, CliComponent, CliModule, CollapsibleButtonComponent, CollapsibleComponent, CollapsibleModule, CommonValidators, ContentType, DataSortPipe, DatepickerComponent, DatepickerModule, DefaultErrorHandlerService, DialogComponent, DialogModule, DialogService, DropzoneDirective, DropzoneModule, ErrorComponent, ErrorHandlerModule, ErrorHandlerService, GeneralConfigService, GlobalSwipeService, HsaCareProviderIdDatasource, HsaLookupModule, HttpHeaderModule, IdService, InfoMessageComponent, InfoMessageModule, InfoMessageType, IntegrationHealthCheckComponent, IntegrationHealthCheckModule, JobStatusComponent, JobStatusModule, KeynavModule, LevelOfAssurance, ListComponent, ListModule, LoaManagerModule, LoaRulesComponent, LoginComponent, LoginModule, LoginService, LogoutComponent, LogoutModule, LogoutReminderComponent, LogoutReminderModule, MailReceiverManagerComponent, ModalComponent, ModalModule, MultiSelectComponent, MultiSelectModule, NavAreaDirective, NavItemDirective, PaginationComponent, PaginationModule, PasswordLoginComponent, PasswordLoginGuard, PrivilegeComponent, PrivilegeGuard, PrivilegeModule, RpConfigComponent, RpConfigModule, ServicePlatformClientComponent, ServicePlatformComponent, StepperComponent, StepperModule, SwipeDirective, SwipeModule, TimepickerComponent, TimepickerModule, ToastComponent, ToastModule, ToastService, ToastType, TreeMode, TreeNgxComponent, TreeNgxModule, TrustHolderManagerComponent, TrustManagerComponent, UploadComponent, UploadModule, UserIdleService, UserInfoComponent, UserInfoModule, UserService, Util, UtilModule, ViewChangesGuard, WSClientComponent, WSClientModule };
